import { emptySplitApi as api } from "./empty.api";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUsersMe: build.query<GetUsersMeApiResponse, GetUsersMeApiArg>({
      query: (queryArg) => ({
        url: `/users/me`,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    patchUsersMe: build.mutation<PatchUsersMeApiResponse, PatchUsersMeApiArg>({
      query: (queryArg) => ({
        url: `/users/me`,
        method: "PATCH",
        body: queryArg.body,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    putUsersMe: build.mutation<PutUsersMeApiResponse, PutUsersMeApiArg>({
      query: (queryArg) => ({
        url: `/users/me`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteUsersMe: build.mutation<
      DeleteUsersMeApiResponse,
      DeleteUsersMeApiArg
    >({
      query: () => ({ url: `/users/me`, method: "DELETE" }),
    }),
    patchUsersMeCelebrationPreference: build.mutation<
      PatchUsersMeCelebrationPreferenceApiResponse,
      PatchUsersMeCelebrationPreferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/celebration-preference`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    postUsersMeOrganisationsCurrentAccountsByAccountIdRecommendationsStatus:
      build.mutation<
        PostUsersMeOrganisationsCurrentAccountsByAccountIdRecommendationsStatusApiResponse,
        PostUsersMeOrganisationsCurrentAccountsByAccountIdRecommendationsStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/accounts/${queryArg.accountId}/recommendations/status`,
          method: "POST",
        }),
      }),
    getUsersMeOrganisationsCurrentRecommendationsStatus: build.query<
      GetUsersMeOrganisationsCurrentRecommendationsStatusApiResponse,
      GetUsersMeOrganisationsCurrentRecommendationsStatusApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/recommendations/status`,
      }),
    }),
    postUsersMeOrganisationsCurrentUsers: build.mutation<
      PostUsersMeOrganisationsCurrentUsersApiResponse,
      PostUsersMeOrganisationsCurrentUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/users`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUsersMeInvitationRequests: build.mutation<
      PostUsersMeInvitationRequestsApiResponse,
      PostUsersMeInvitationRequestsApiArg
    >({
      query: () => ({ url: `/users/me/invitation-requests`, method: "POST" }),
    }),
    getUsersMeOrganisationsCurrentInvitationRequests: build.query<
      GetUsersMeOrganisationsCurrentInvitationRequestsApiResponse,
      GetUsersMeOrganisationsCurrentInvitationRequestsApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/invitation-requests`,
      }),
    }),
    deleteUsersMeOrganisationsCurrentInvitationRequestsByUserId: build.mutation<
      DeleteUsersMeOrganisationsCurrentInvitationRequestsByUserIdApiResponse,
      DeleteUsersMeOrganisationsCurrentInvitationRequestsByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/invitation-requests/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    postUsersMeOrganisationsCurrentUsersByUserIdReInvitations: build.mutation<
      PostUsersMeOrganisationsCurrentUsersByUserIdReInvitationsApiResponse,
      PostUsersMeOrganisationsCurrentUsersByUserIdReInvitationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/users/${queryArg.userId}/re-invitations`,
        method: "POST",
      }),
    }),
    getUsersMeOrganisationsCurrentUsersByUserId: build.query<
      GetUsersMeOrganisationsCurrentUsersByUserIdApiResponse,
      GetUsersMeOrganisationsCurrentUsersByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/users/${queryArg.userId}`,
      }),
    }),
    patchUsersMeOrganisationsCurrentUsersByUserId: build.mutation<
      PatchUsersMeOrganisationsCurrentUsersByUserIdApiResponse,
      PatchUsersMeOrganisationsCurrentUsersByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/users/${queryArg.userId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeOrganisationsCurrentUsersByUserId: build.mutation<
      DeleteUsersMeOrganisationsCurrentUsersByUserIdApiResponse,
      DeleteUsersMeOrganisationsCurrentUsersByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/users/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    getUsersMeOrganisationsCurrentTasksProperties: build.query<
      GetUsersMeOrganisationsCurrentTasksPropertiesApiResponse,
      GetUsersMeOrganisationsCurrentTasksPropertiesApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/tasks/properties`,
      }),
    }),
    putUsersMeOrganisationsCurrentTasksPropertiesStatuses: build.mutation<
      PutUsersMeOrganisationsCurrentTasksPropertiesStatusesApiResponse,
      PutUsersMeOrganisationsCurrentTasksPropertiesStatusesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/tasks/properties/statuses`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putUsersMeOrganisationsCurrentTasksPropertiesPriorities: build.mutation<
      PutUsersMeOrganisationsCurrentTasksPropertiesPrioritiesApiResponse,
      PutUsersMeOrganisationsCurrentTasksPropertiesPrioritiesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/tasks/properties/priorities`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putUsersMeOrganisationsCurrentTasksPropertiesEnvironments: build.mutation<
      PutUsersMeOrganisationsCurrentTasksPropertiesEnvironmentsApiResponse,
      PutUsersMeOrganisationsCurrentTasksPropertiesEnvironmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/tasks/properties/environments`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putUsersMeOrganisationsCurrentTasksPropertiesOwners: build.mutation<
      PutUsersMeOrganisationsCurrentTasksPropertiesOwnersApiResponse,
      PutUsersMeOrganisationsCurrentTasksPropertiesOwnersApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/tasks/properties/owners`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putUsersMeOrganisationsCurrentTasksPropertiesActions: build.mutation<
      PutUsersMeOrganisationsCurrentTasksPropertiesActionsApiResponse,
      PutUsersMeOrganisationsCurrentTasksPropertiesActionsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/tasks/properties/actions`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postUsersMeOrganisationsCurrentTasks: build.mutation<
      PostUsersMeOrganisationsCurrentTasksApiResponse,
      PostUsersMeOrganisationsCurrentTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/tasks`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentTasks: build.query<
      GetUsersMeOrganisationsCurrentTasksApiResponse,
      GetUsersMeOrganisationsCurrentTasksApiArg
    >({
      query: () => ({ url: `/users/me/organisations/current/tasks` }),
    }),
    patchUsersMeOrganisationsCurrentTasks: build.mutation<
      PatchUsersMeOrganisationsCurrentTasksApiResponse,
      PatchUsersMeOrganisationsCurrentTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/tasks`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    putUsersMeOrganisationsCurrentTasks: build.mutation<
      PutUsersMeOrganisationsCurrentTasksApiResponse,
      PutUsersMeOrganisationsCurrentTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/tasks`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentTasksByTaskIdActivities: build.query<
      GetUsersMeOrganisationsCurrentTasksByTaskIdActivitiesApiResponse,
      GetUsersMeOrganisationsCurrentTasksByTaskIdActivitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/tasks/${queryArg.taskId}/activities`,
      }),
    }),
    postUsersMeOrganisationsCurrentTasksByTaskIdComments: build.mutation<
      PostUsersMeOrganisationsCurrentTasksByTaskIdCommentsApiResponse,
      PostUsersMeOrganisationsCurrentTasksByTaskIdCommentsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/tasks/${queryArg.taskId}/comments`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    patchUsersMeOrganisationsCurrentTasksByTaskIdCommentsAndCommentId:
      build.mutation<
        PatchUsersMeOrganisationsCurrentTasksByTaskIdCommentsAndCommentIdApiResponse,
        PatchUsersMeOrganisationsCurrentTasksByTaskIdCommentsAndCommentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/tasks/${queryArg.taskId}/comments/${queryArg.commentId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    deleteUsersMeOrganisationsCurrentTasksByTaskIdCommentsAndCommentId:
      build.mutation<
        DeleteUsersMeOrganisationsCurrentTasksByTaskIdCommentsAndCommentIdApiResponse,
        DeleteUsersMeOrganisationsCurrentTasksByTaskIdCommentsAndCommentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/tasks/${queryArg.taskId}/comments/${queryArg.commentId}`,
          method: "DELETE",
        }),
      }),
    postUsersMeAccountAttempts: build.mutation<
      PostUsersMeAccountAttemptsApiResponse,
      PostUsersMeAccountAttemptsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/account-attempts`,
        method: "POST",
        body: queryArg.body,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    getUsersMeAccountAttemptsByAccountAttemptId: build.query<
      GetUsersMeAccountAttemptsByAccountAttemptIdApiResponse,
      GetUsersMeAccountAttemptsByAccountAttemptIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/account-attempts/${queryArg.accountAttemptId}`,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    patchProvidersAwsAccountAttemptsByAccountAttemptId: build.mutation<
      PatchProvidersAwsAccountAttemptsByAccountAttemptIdApiResponse,
      PatchProvidersAwsAccountAttemptsByAccountAttemptIdApiArg
    >({
      query: (queryArg) => ({
        url: `/providers/aws/account-attempts/${queryArg.accountAttemptId}`,
        method: "PATCH",
        body: queryArg.body,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    postProvidersAwsCfnTemplates: build.mutation<
      PostProvidersAwsCfnTemplatesApiResponse,
      PostProvidersAwsCfnTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/providers/aws/cfn-templates`,
        method: "POST",
        headers: { "Content-Type": queryArg["Content-Type"] },
        params: {
          access_type: queryArg.accessType,
          for_sub_account_role: queryArg.forSubAccountRole,
        },
      }),
    }),
    patchUsersMeProvidersAzureAccountAttemptsByAccountAttemptId: build.mutation<
      PatchUsersMeProvidersAzureAccountAttemptsByAccountAttemptIdApiResponse,
      PatchUsersMeProvidersAzureAccountAttemptsByAccountAttemptIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/providers/azure/account-attempts/${queryArg.accountAttemptId}`,
        method: "PATCH",
        body: queryArg.body,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    getUsersMeAccounts: build.query<
      GetUsersMeAccountsApiResponse,
      GetUsersMeAccountsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts`,
        headers: { "Content-Type": queryArg["Content-Type"] },
        params: {
          statuses: queryArg.statuses,
          type: queryArg["type"],
          access_type: queryArg.accessType,
        },
      }),
    }),
    getUsersMeAccountsByAccountId: build.query<
      GetUsersMeAccountsByAccountIdApiResponse,
      GetUsersMeAccountsByAccountIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}`,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    patchUsersMeAccountsByAccountId: build.mutation<
      PatchUsersMeAccountsByAccountIdApiResponse,
      PatchUsersMeAccountsByAccountIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}`,
        method: "PATCH",
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    deleteUsersMeAccountsByAccountId: build.mutation<
      DeleteUsersMeAccountsByAccountIdApiResponse,
      DeleteUsersMeAccountsByAccountIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}`,
        method: "DELETE",
      }),
    }),
    patchUsersMeProvidersByProviderAccountsAndAccountIdAccessMode:
      build.mutation<
        PatchUsersMeProvidersByProviderAccountsAndAccountIdAccessModeApiResponse,
        PatchUsersMeProvidersByProviderAccountsAndAccountIdAccessModeApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/providers/${queryArg.provider}/accounts/${queryArg.accountId}/access-mode`,
          method: "PATCH",
          body: queryArg.body,
          headers: { "Content-Type": queryArg["Content-Type"] },
        }),
      }),
    postUsersMeAccountsByAccountIdFilters: build.mutation<
      PostUsersMeAccountsByAccountIdFiltersApiResponse,
      PostUsersMeAccountsByAccountIdFiltersApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}/filters`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUsersMeAccountsByAccountIdFiltersV2: build.mutation<
      PostUsersMeAccountsByAccountIdFiltersV2ApiResponse,
      PostUsersMeAccountsByAccountIdFiltersV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}/filters/v2`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeAccountsByAccountIdFiltersCurrent: build.query<
      GetUsersMeAccountsByAccountIdFiltersCurrentApiResponse,
      GetUsersMeAccountsByAccountIdFiltersCurrentApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}/filters/current`,
      }),
    }),
    getUsersMeAccountsByAccountIdFiltersCurrentV2: build.query<
      GetUsersMeAccountsByAccountIdFiltersCurrentV2ApiResponse,
      GetUsersMeAccountsByAccountIdFiltersCurrentV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}/filters/current/v2`,
      }),
    }),
    getUsersMeAccountsByAccountIdCosts: build.query<
      GetUsersMeAccountsByAccountIdCostsApiResponse,
      GetUsersMeAccountsByAccountIdCostsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}/costs`,
        params: {
          data_point: queryArg.dataPoint,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentProvidersByProviderBillingStatus: build.query<
      GetUsersMeOrganisationsCurrentProvidersByProviderBillingStatusApiResponse,
      GetUsersMeOrganisationsCurrentProvidersByProviderBillingStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/providers/${queryArg.provider}/billing/status`,
      }),
    }),
    getV2UsersMeOrganisationsCurrentProvidersByProviderBillingStatus:
      build.query<
        GetV2UsersMeOrganisationsCurrentProvidersByProviderBillingStatusApiResponse,
        GetV2UsersMeOrganisationsCurrentProvidersByProviderBillingStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/users/me/organisations/current/providers/${queryArg.provider}/billing/status`,
        }),
      }),
    getUsersMeOrganisationsCurrentProvidersByProviderBillingCurrent:
      build.query<
        GetUsersMeOrganisationsCurrentProvidersByProviderBillingCurrentApiResponse,
        GetUsersMeOrganisationsCurrentProvidersByProviderBillingCurrentApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/providers/${queryArg.provider}/billing/current`,
        }),
      }),
    getUsersMeOrganisationsCurrentResourcesDailyOffHoursRecommendations:
      build.query<
        GetUsersMeOrganisationsCurrentResourcesDailyOffHoursRecommendationsApiResponse,
        GetUsersMeOrganisationsCurrentResourcesDailyOffHoursRecommendationsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resources/daily-off-hours-recommendations`,
          params: { group: queryArg.group, is_dismissed: queryArg.isDismissed },
        }),
      }),
    getUsersMeOrganisationsCurrentResourcesWeeklyOffHoursRecommendations:
      build.query<
        GetUsersMeOrganisationsCurrentResourcesWeeklyOffHoursRecommendationsApiResponse,
        GetUsersMeOrganisationsCurrentResourcesWeeklyOffHoursRecommendationsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resources/weekly-off-hours-recommendations`,
          params: { group: queryArg.group, is_dismissed: queryArg.isDismissed },
        }),
      }),
    postV3UsersMeExecutionLogs: build.mutation<
      PostV3UsersMeExecutionLogsApiResponse,
      PostV3UsersMeExecutionLogsApiArg
    >({
      query: (queryArg) => ({
        url: `/v3/users/me/execution-logs`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUsersMeExecutionLogsDetails: build.mutation<
      PostUsersMeExecutionLogsDetailsApiResponse,
      PostUsersMeExecutionLogsDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/execution-logs/details`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeExecutionLogsMinimumAvailableDate: build.query<
      GetUsersMeExecutionLogsMinimumAvailableDateApiResponse,
      GetUsersMeExecutionLogsMinimumAvailableDateApiArg
    >({
      query: () => ({ url: `/users/me/execution-logs/minimum-available-date` }),
    }),
    getV3UsersMeExecutionLogsByExecutionId: build.query<
      GetV3UsersMeExecutionLogsByExecutionIdApiResponse,
      GetV3UsersMeExecutionLogsByExecutionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v3/users/me/execution-logs/${queryArg.executionId}`,
      }),
    }),
    postUsersMeOrganisationsCurrentByTypeResourcesTagKeys: build.mutation<
      PostUsersMeOrganisationsCurrentByTypeResourcesTagKeysApiResponse,
      PostUsersMeOrganisationsCurrentByTypeResourcesTagKeysApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/${queryArg["type"]}-resources/tag-keys`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentByTypeResourcesPlatforms: build.query<
      GetUsersMeOrganisationsCurrentByTypeResourcesPlatformsApiResponse,
      GetUsersMeOrganisationsCurrentByTypeResourcesPlatformsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/${queryArg["type"]}-resources/platforms`,
      }),
    }),
    getUsersMeOrganisationsCurrentByTypeResourcesTypes: build.query<
      GetUsersMeOrganisationsCurrentByTypeResourcesTypesApiResponse,
      GetUsersMeOrganisationsCurrentByTypeResourcesTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/${queryArg["type"]}-resources/types`,
      }),
    }),
    getResourceTypesByTypeAndFilterKeyType: build.query<
      GetResourceTypesByTypeAndFilterKeyTypeApiResponse,
      GetResourceTypesByTypeAndFilterKeyTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/resource-types/${queryArg["type"]}/${queryArg.filterKeyType}`,
      }),
    }),
    postUsersMeOrganisationsCurrentByTypeResourcesTagValues: build.mutation<
      PostUsersMeOrganisationsCurrentByTypeResourcesTagValuesApiResponse,
      PostUsersMeOrganisationsCurrentByTypeResourcesTagValuesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/${queryArg["type"]}-resources/tag-values`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResources:
      build.query<
        GetUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResourcesApiResponse,
        GetUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResourcesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/accounts/${queryArg.accountId}/providers/${queryArg.provider}/resources`,
          headers: { "Content-Type": queryArg["Content-Type"] },
          params: { resource_id: queryArg.resourceId },
        }),
      }),
    postUsersMeV2OrganisationsCurrentByTypeResources: build.mutation<
      PostUsersMeV2OrganisationsCurrentByTypeResourcesApiResponse,
      PostUsersMeV2OrganisationsCurrentByTypeResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/v2/organisations/current/${queryArg["type"]}-resources`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeProviderUniqueIdentifierMetrics:
      build.query<
        GetUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeProviderUniqueIdentifierMetricsApiResponse,
        GetUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeProviderUniqueIdentifierMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/accounts/${queryArg.accountId}/${queryArg.resourceType}/${queryArg.providerUniqueIdentifier}/metrics`,
        }),
      }),
    postUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeMetrics:
      build.mutation<
        PostUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeMetricsApiResponse,
        PostUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/accounts/${queryArg.accountId}/${queryArg.resourceType}/metrics`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    getUsersMeOrganisationsCurrentKubernetesByResourceTypeFiltersAndFilterTypeValues:
      build.query<
        GetUsersMeOrganisationsCurrentKubernetesByResourceTypeFiltersAndFilterTypeValuesApiResponse,
        GetUsersMeOrganisationsCurrentKubernetesByResourceTypeFiltersAndFilterTypeValuesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/kubernetes/${queryArg.resourceType}-filters/${queryArg.filterType}/values`,
          params: { key: queryArg.key },
        }),
      }),
    postUsersMeOrganisationsCurrentKubernetesByTypeResources: build.mutation<
      PostUsersMeOrganisationsCurrentKubernetesByTypeResourcesApiResponse,
      PostUsersMeOrganisationsCurrentKubernetesByTypeResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/kubernetes/${queryArg["type"]}-resources`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentKubernetesClusters: build.query<
      GetUsersMeOrganisationsCurrentKubernetesClustersApiResponse,
      GetUsersMeOrganisationsCurrentKubernetesClustersApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/kubernetes/clusters`,
      }),
    }),
    getUsersMeOrganisationsCurrentKubernetesByTypeAndResourceIdMetrics:
      build.query<
        GetUsersMeOrganisationsCurrentKubernetesByTypeAndResourceIdMetricsApiResponse,
        GetUsersMeOrganisationsCurrentKubernetesByTypeAndResourceIdMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/kubernetes/${queryArg["type"]}/${queryArg.resourceId}/metrics`,
        }),
      }),
    getUsersMeDynamoDbBackupTypes: build.query<
      GetUsersMeDynamoDbBackupTypesApiResponse,
      GetUsersMeDynamoDbBackupTypesApiArg
    >({
      query: () => ({ url: `/users/me/dynamo_db_backup-types` }),
    }),
    postUsersMeDynamoDbBackupTableNames: build.mutation<
      PostUsersMeDynamoDbBackupTableNamesApiResponse,
      PostUsersMeDynamoDbBackupTableNamesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/dynamo_db_backup-table-names`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeByTypeStorageTiers: build.query<
      GetUsersMeByTypeStorageTiersApiResponse,
      GetUsersMeByTypeStorageTiersApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/${queryArg["type"]}-storage-tiers`,
      }),
    }),
    putUsersMeAccountsByAccountIdResources: build.mutation<
      PutUsersMeAccountsByAccountIdResourcesApiResponse,
      PutUsersMeAccountsByAccountIdResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}/resources`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    patchUsersMeAccountsByAccountIdResources: build.mutation<
      PatchUsersMeAccountsByAccountIdResourcesApiResponse,
      PatchUsersMeAccountsByAccountIdResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}/resources`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getProvidersByProviderRegions: build.query<
      GetProvidersByProviderRegionsApiResponse,
      GetProvidersByProviderRegionsApiArg
    >({
      query: (queryArg) => ({ url: `/providers/${queryArg.provider}/regions` }),
    }),
    getProvidersByProviderFilters: build.query<
      GetProvidersByProviderFiltersApiResponse,
      GetProvidersByProviderFiltersApiArg
    >({
      query: (queryArg) => ({ url: `/providers/${queryArg.provider}/filters` }),
    }),
    getV2Plans: build.query<GetV2PlansApiResponse, GetV2PlansApiArg>({
      query: () => ({ url: `/v2/plans` }),
    }),
    postUsersMeOrganisationsCurrentGcpBillingExportData: build.mutation<
      PostUsersMeOrganisationsCurrentGcpBillingExportDataApiResponse,
      PostUsersMeOrganisationsCurrentGcpBillingExportDataApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/gcp-billing-export-data`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentGcpBillingExportData: build.query<
      GetUsersMeOrganisationsCurrentGcpBillingExportDataApiResponse,
      GetUsersMeOrganisationsCurrentGcpBillingExportDataApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/gcp-billing-export-data`,
      }),
    }),
    getUsersMeSubscriptionsCurrent: build.query<
      GetUsersMeSubscriptionsCurrentApiResponse,
      GetUsersMeSubscriptionsCurrentApiArg
    >({
      query: () => ({ url: `/users/me/subscriptions/current` }),
    }),
    postUsersMeSchedules: build.mutation<
      PostUsersMeSchedulesApiResponse,
      PostUsersMeSchedulesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/schedules`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeSchedules: build.query<
      GetUsersMeSchedulesApiResponse,
      GetUsersMeSchedulesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/schedules`,
        params: { account_id: queryArg.accountId },
      }),
    }),
    getUsersMeSchedulesByScheduleId: build.query<
      GetUsersMeSchedulesByScheduleIdApiResponse,
      GetUsersMeSchedulesByScheduleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/schedules/${queryArg.scheduleId}`,
      }),
    }),
    patchUsersMeSchedulesByScheduleId: build.mutation<
      PatchUsersMeSchedulesByScheduleIdApiResponse,
      PatchUsersMeSchedulesByScheduleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/schedules/${queryArg.scheduleId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getUsersMeWorkflowsByWorkflowIdBatchesAndBatchId: build.query<
      GetUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdApiResponse,
      GetUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/workflows/${queryArg.workflowId}/batches/${queryArg.batchId}`,
      }),
    }),
    getUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdResources: build.query<
      GetUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdResourcesApiResponse,
      GetUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/workflows/${queryArg.workflowId}/batches/${queryArg.batchId}/resources`,
      }),
    }),
    postUsersMeOrganisationsCurrentByProviderAndValidationFilterTypeValidValues:
      build.mutation<
        PostUsersMeOrganisationsCurrentByProviderAndValidationFilterTypeValidValuesApiResponse,
        PostUsersMeOrganisationsCurrentByProviderAndValidationFilterTypeValidValuesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/${queryArg.provider}/${queryArg.validationFilterType}/valid-values`,
          method: "POST",
          body: queryArg.body,
          headers: { "Content-Type": queryArg["Content-Type"] },
          params: { tag_key: queryArg.tagKey },
        }),
      }),
    postUsersMeOrganisationsCurrentBillingPortal: build.mutation<
      PostUsersMeOrganisationsCurrentBillingPortalApiResponse,
      PostUsersMeOrganisationsCurrentBillingPortalApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/billing-portal`,
        method: "POST",
      }),
    }),
    postUsersMeOrganisationsCurrentBillingPortalPlansByPlanId: build.mutation<
      PostUsersMeOrganisationsCurrentBillingPortalPlansByPlanIdApiResponse,
      PostUsersMeOrganisationsCurrentBillingPortalPlansByPlanIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/billing-portal/plans/${queryArg.planId}`,
        method: "POST",
      }),
    }),
    getUsersMeOrganisationsCurrent: build.query<
      GetUsersMeOrganisationsCurrentApiResponse,
      GetUsersMeOrganisationsCurrentApiArg
    >({
      query: () => ({ url: `/users/me/organisations/current` }),
    }),
    patchUsersMeOrganisationsCurrent: build.mutation<
      PatchUsersMeOrganisationsCurrentApiResponse,
      PatchUsersMeOrganisationsCurrentApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    postUsersMeOffHoursSchedules: build.mutation<
      PostUsersMeOffHoursSchedulesApiResponse,
      PostUsersMeOffHoursSchedulesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/off-hours-schedules`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOffHoursSchedules: build.query<
      GetUsersMeOffHoursSchedulesApiResponse,
      GetUsersMeOffHoursSchedulesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/off-hours-schedules`,
        params: { account_id: queryArg.accountId },
      }),
    }),
    getUsersMeOffHoursSchedulesByScheduleId: build.query<
      GetUsersMeOffHoursSchedulesByScheduleIdApiResponse,
      GetUsersMeOffHoursSchedulesByScheduleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/off-hours-schedules/${queryArg.scheduleId}`,
      }),
    }),
    patchUsersMeOffHoursSchedulesByScheduleId: build.mutation<
      PatchUsersMeOffHoursSchedulesByScheduleIdApiResponse,
      PatchUsersMeOffHoursSchedulesByScheduleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/off-hours-schedules/${queryArg.scheduleId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getUsersMeFeatures: build.query<
      GetUsersMeFeaturesApiResponse,
      GetUsersMeFeaturesApiArg
    >({
      query: () => ({ url: `/users/me/features` }),
    }),
    postUsersMeFeatures: build.mutation<
      PostUsersMeFeaturesApiResponse,
      PostUsersMeFeaturesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/features`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeProvidersAwsAccountsByAccountIdMissingPermissions: build.query<
      GetUsersMeProvidersAwsAccountsByAccountIdMissingPermissionsApiResponse,
      GetUsersMeProvidersAwsAccountsByAccountIdMissingPermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/providers/aws/accounts/${queryArg.accountId}/missing-permissions`,
      }),
    }),
    getUsersMeProvidersGcpAccountsByAccountIdMissingRoles: build.query<
      GetUsersMeProvidersGcpAccountsByAccountIdMissingRolesApiResponse,
      GetUsersMeProvidersGcpAccountsByAccountIdMissingRolesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/providers/gcp/accounts/${queryArg.accountId}/missing-roles`,
      }),
    }),
    getUsersMeProvidersGcpAccountsByAccountIdMissingRolesOptions: build.query<
      GetUsersMeProvidersGcpAccountsByAccountIdMissingRolesOptionsApiResponse,
      GetUsersMeProvidersGcpAccountsByAccountIdMissingRolesOptionsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/providers/gcp/accounts/${queryArg.accountId}/missing-roles/options`,
      }),
    }),
    getUsersMeProvidersGcpAccountsByAccountIdMissingApis: build.query<
      GetUsersMeProvidersGcpAccountsByAccountIdMissingApisApiResponse,
      GetUsersMeProvidersGcpAccountsByAccountIdMissingApisApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/providers/gcp/accounts/${queryArg.accountId}/missing-apis`,
      }),
    }),
    getUsersMeProvidersAzureAccountsByAccountIdMissingRoles: build.query<
      GetUsersMeProvidersAzureAccountsByAccountIdMissingRolesApiResponse,
      GetUsersMeProvidersAzureAccountsByAccountIdMissingRolesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/providers/azure/accounts/${queryArg.accountId}/missing-roles`,
      }),
    }),
    getUsersMeProvidersAzureAccountsByAccountIdMissingRolesOptions: build.query<
      GetUsersMeProvidersAzureAccountsByAccountIdMissingRolesOptionsApiResponse,
      GetUsersMeProvidersAzureAccountsByAccountIdMissingRolesOptionsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/providers/azure/accounts/${queryArg.accountId}/missing-roles/options`,
      }),
    }),
    patchUsersMeAccountsByAccountIdPermissions: build.mutation<
      PatchUsersMeAccountsByAccountIdPermissionsApiResponse,
      PatchUsersMeAccountsByAccountIdPermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}/permissions`,
        method: "PATCH",
      }),
    }),
    getUsersMeIntegrations: build.query<
      GetUsersMeIntegrationsApiResponse,
      GetUsersMeIntegrationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/integrations`,
        params: { type: queryArg["type"] },
      }),
    }),
    getUsersMeProviderConnectionsSnowflake: build.query<
      GetUsersMeProviderConnectionsSnowflakeApiResponse,
      GetUsersMeProviderConnectionsSnowflakeApiArg
    >({
      query: () => ({
        url: `/users/me/provider-connections/snowflake`,
      }),
    }),
    postUsersMeProviderConnectionsSnowflake: build.mutation<
      PostUsersMeProviderConnectionsSnowflakeApiResponse,
      PostUsersMeProviderConnectionsSnowflakeApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/provider-connections/snowflake`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeIntegrationsByIntegrationId: build.mutation<
      DeleteUsersMeIntegrationsByIntegrationIdApiResponse,
      DeleteUsersMeIntegrationsByIntegrationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/integrations/${queryArg.integrationId}`,
        method: "DELETE",
      }),
    }),
    postUsersMeByTypeIntegrations: build.mutation<
      PostUsersMeByTypeIntegrationsApiResponse,
      PostUsersMeByTypeIntegrationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/${queryArg["type"]}-integrations`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeByTypeIntegrationsAndIntegrationId: build.query<
      GetUsersMeByTypeIntegrationsAndIntegrationIdApiResponse,
      GetUsersMeByTypeIntegrationsAndIntegrationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/${queryArg["type"]}-integrations/${queryArg.integrationId}`,
      }),
    }),
    putUsersMeByTypeIntegrationsAndIntegrationId: build.mutation<
      PutUsersMeByTypeIntegrationsAndIntegrationIdApiResponse,
      PutUsersMeByTypeIntegrationsAndIntegrationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/${queryArg["type"]}-integrations/${queryArg.integrationId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getUsersMeProviderConnectionsSnowflakeById: build.query<
      GetUsersMeProviderConnectionsSnowflakeByIdApiResponse,
      GetUsersMeProviderConnectionsSnowflakeByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/provider-connections/snowflake/${queryArg.id}`,
      }),
    }),
    deleteUsersMeProviderConnectionsSnowflakeById: build.mutation<
      DeleteUsersMeProviderConnectionsSnowflakeByIdApiResponse,
      DeleteUsersMeProviderConnectionsSnowflakeByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/provider-connections/snowflake/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    postUsersMeSlackIntegrationsByIntegrationIdTestMessages: build.mutation<
      PostUsersMeSlackIntegrationsByIntegrationIdTestMessagesApiResponse,
      PostUsersMeSlackIntegrationsByIntegrationIdTestMessagesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/slack-integrations/${queryArg.integrationId}/test-messages`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUsersMeProvidersAwsAccountsByAccountIdCfnChangeSets: build.mutation<
      PostUsersMeProvidersAwsAccountsByAccountIdCfnChangeSetsApiResponse,
      PostUsersMeProvidersAwsAccountsByAccountIdCfnChangeSetsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/providers/aws/accounts/${queryArg.accountId}/cfn-change-sets`,
        method: "POST",
      }),
    }),
    postUsersMeProvidersAwsAccountsByAccountIdCfnChangeAccessModeChangeSets:
      build.mutation<
        PostUsersMeProvidersAwsAccountsByAccountIdCfnChangeAccessModeChangeSetsApiResponse,
        PostUsersMeProvidersAwsAccountsByAccountIdCfnChangeAccessModeChangeSetsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/providers/aws/accounts/${queryArg.accountId}/cfn-change-access-mode-change-sets`,
          method: "POST",
        }),
      }),
    postUsersMeProvidersAwsSubAccountsByAccountId: build.mutation<
      PostUsersMeProvidersAwsSubAccountsByAccountIdApiResponse,
      PostUsersMeProvidersAwsSubAccountsByAccountIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/providers/aws/sub-accounts/${queryArg.accountId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentProvidersByProviderTotalSavedAmount:
      build.query<
        GetUsersMeOrganisationsCurrentProvidersByProviderTotalSavedAmountApiResponse,
        GetUsersMeOrganisationsCurrentProvidersByProviderTotalSavedAmountApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/providers/${queryArg.provider}/total-saved-amount`,
        }),
      }),
    getUsersMeOrganisationsCurrentSsoOptionsCurrent: build.query<
      GetUsersMeOrganisationsCurrentSsoOptionsCurrentApiResponse,
      GetUsersMeOrganisationsCurrentSsoOptionsCurrentApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/sso-options/current`,
      }),
    }),
    postUsersMeOrganisationsCurrentSso: build.mutation<
      PostUsersMeOrganisationsCurrentSsoApiResponse,
      PostUsersMeOrganisationsCurrentSsoApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/sso`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeOrganisationsCurrentSsoCurrent: build.mutation<
      DeleteUsersMeOrganisationsCurrentSsoCurrentApiResponse,
      DeleteUsersMeOrganisationsCurrentSsoCurrentApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/sso/current`,
        method: "DELETE",
      }),
    }),
    postUsersMeOrganisationsCurrentRoles: build.mutation<
      PostUsersMeOrganisationsCurrentRolesApiResponse,
      PostUsersMeOrganisationsCurrentRolesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/roles`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentRoles: build.query<
      GetUsersMeOrganisationsCurrentRolesApiResponse,
      GetUsersMeOrganisationsCurrentRolesApiArg
    >({
      query: () => ({ url: `/users/me/organisations/current/roles` }),
    }),
    patchUsersMeOrganisationsCurrentRolesByRoleId: build.mutation<
      PatchUsersMeOrganisationsCurrentRolesByRoleIdApiResponse,
      PatchUsersMeOrganisationsCurrentRolesByRoleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/roles/${queryArg.roleId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentRolesByRoleId: build.query<
      GetUsersMeOrganisationsCurrentRolesByRoleIdApiResponse,
      GetUsersMeOrganisationsCurrentRolesByRoleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/roles/${queryArg.roleId}`,
      }),
    }),
    deleteUsersMeOrganisationsCurrentRolesByRoleId: build.mutation<
      DeleteUsersMeOrganisationsCurrentRolesByRoleIdApiResponse,
      DeleteUsersMeOrganisationsCurrentRolesByRoleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/roles/${queryArg.roleId}`,
        method: "DELETE",
      }),
    }),
    patchUsersMeOrganisationsCurrentAssignmentsByAssignmentId: build.mutation<
      PatchUsersMeOrganisationsCurrentAssignmentsByAssignmentIdApiResponse,
      PatchUsersMeOrganisationsCurrentAssignmentsByAssignmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/assignments/${queryArg.assignmentId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getPermissions: build.query<
      GetPermissionsApiResponse,
      GetPermissionsApiArg
    >({
      query: () => ({ url: `/permissions` }),
    }),
    getUsersMeOrganisationsCurrentSettings: build.query<
      GetUsersMeOrganisationsCurrentSettingsApiResponse,
      GetUsersMeOrganisationsCurrentSettingsApiArg
    >({
      query: () => ({ url: `/users/me/organisations/current/settings` }),
    }),
    getUsersMeOrganisationsCurrentSettingsByKey: build.query<
      GetUsersMeOrganisationsCurrentSettingsByKeyApiResponse,
      GetUsersMeOrganisationsCurrentSettingsByKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/settings/${queryArg.key}`,
      }),
    }),
    patchUsersMeOrganisationsCurrentSettingsByKey: build.mutation<
      PatchUsersMeOrganisationsCurrentSettingsByKeyApiResponse,
      PatchUsersMeOrganisationsCurrentSettingsByKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/settings/${queryArg.key}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    postUsersMeOrganisationsCurrentSavingsPlansRecommendationsSummary:
      build.mutation<
        PostUsersMeOrganisationsCurrentSavingsPlansRecommendationsSummaryApiResponse,
        PostUsersMeOrganisationsCurrentSavingsPlansRecommendationsSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/savings-plans/recommendations-summary`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postAiSavingsOpportunities: build.mutation<
      PostAiSavingsOpportunitiesApiResponse,
      PostAiSavingsOpportunitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/ai-savings-opportunities`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getOrganisationsCurrentSavingsOpportunities: build.query<
      GetOrganisationsCurrentSavingsOpportunitiesApiResponse,
      GetOrganisationsCurrentSavingsOpportunitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/organisations/current/savings-opportunities`,
        params: { resource_id: queryArg.resourceId },
      }),
    }),
    postOrganisationsCurrentSavingsOpportunities: build.mutation<
      PostOrganisationsCurrentSavingsOpportunitiesApiResponse,
      PostOrganisationsCurrentSavingsOpportunitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/organisations/current/savings-opportunities`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getOrganisationsCurrentSavingsOpportunitiesAi: build.query<
      GetOrganisationsCurrentSavingsOpportunitiesAiApiResponse,
      GetOrganisationsCurrentSavingsOpportunitiesAiApiArg
    >({
      query: () => ({ url: `/organisations/current/savings-opportunities/ai` }),
    }),
    getUsersMeOrganisationsCurrentSavingsPlansPotentialSavings: build.query<
      GetUsersMeOrganisationsCurrentSavingsPlansPotentialSavingsApiResponse,
      GetUsersMeOrganisationsCurrentSavingsPlansPotentialSavingsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/savings-plans/potential-savings`,
        params: { provider_organisation_id: queryArg.providerOrganisationId },
      }),
    }),
    getV2UsersMeOrganisationsCurrentSavingsPlansPotentialSavings: build.query<
      GetV2UsersMeOrganisationsCurrentSavingsPlansPotentialSavingsApiResponse,
      GetV2UsersMeOrganisationsCurrentSavingsPlansPotentialSavingsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/me/organisations/current/savings-plans/potential-savings`,
        params: { provider_organisation_id: queryArg.providerOrganisationId },
      }),
    }),
    getUsersMeOrganisationsCurrentReservationsPotentialSavings: build.query<
      GetUsersMeOrganisationsCurrentReservationsPotentialSavingsApiResponse,
      GetUsersMeOrganisationsCurrentReservationsPotentialSavingsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/reservations/potential-savings`,
        params: { provider_organisation_id: queryArg.providerOrganisationId },
      }),
    }),
    getUsersMeOrganisationsCurrentCommitmentsPotentialSavings: build.query<
      GetUsersMeOrganisationsCurrentCommitmentsPotentialSavingsApiResponse,
      GetUsersMeOrganisationsCurrentCommitmentsPotentialSavingsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/commitments/potential-savings`,
        params: { provider_organisation_id: queryArg.providerOrganisationId },
      }),
    }),
    getUsersMeOrganisationsCurrentSavingsPlansUtilizationRecommendations:
      build.query<
        GetUsersMeOrganisationsCurrentSavingsPlansUtilizationRecommendationsApiResponse,
        GetUsersMeOrganisationsCurrentSavingsPlansUtilizationRecommendationsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/savings-plans/utilization-recommendations`,
          params: { savings_plan_id: queryArg.savingsPlanId },
        }),
      }),
    getUsersMeOrganisationsCurrentSavingsPlansRecommendations: build.query<
      GetUsersMeOrganisationsCurrentSavingsPlansRecommendationsApiResponse,
      GetUsersMeOrganisationsCurrentSavingsPlansRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/savings-plans/recommendations`,
        params: {
          provider_organisation_id: queryArg.providerOrganisationId,
          account_id: queryArg.accountId,
          resource_type: queryArg.resourceType,
          region: queryArg.region,
          instance_family: queryArg.instanceFamily,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentReservationsUtilizationRecommendations:
      build.query<
        GetUsersMeOrganisationsCurrentReservationsUtilizationRecommendationsApiResponse,
        GetUsersMeOrganisationsCurrentReservationsUtilizationRecommendationsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/reservations/utilization-recommendations`,
          params: { reservation_id: queryArg.reservationId },
        }),
      }),
    getUsersMeOrganisationsCurrentReservationsRecommendations: build.query<
      GetUsersMeOrganisationsCurrentReservationsRecommendationsApiResponse,
      GetUsersMeOrganisationsCurrentReservationsRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/reservations/recommendations`,
        params: {
          provider_organisation_id: queryArg.providerOrganisationId,
          account_id: queryArg.accountId,
          resource_type: queryArg.resourceType,
          region: queryArg.region,
          instance_type: queryArg.instanceType,
          platform: queryArg.platform,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentSavingsPlans: build.query<
      GetUsersMeOrganisationsCurrentSavingsPlansApiResponse,
      GetUsersMeOrganisationsCurrentSavingsPlansApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/savings-plans`,
        params: {
          provider_organisation_id: queryArg.providerOrganisationId,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_label: queryArg.dateLabel,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          data_granularity: queryArg.dataGranularity,
          coverage_grouping: queryArg.coverageGrouping,
          load_chart_data: queryArg.loadChartData,
          load_table_data: queryArg.loadTableData,
          load_totals: queryArg.loadTotals,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentReservations: build.query<
      GetUsersMeOrganisationsCurrentReservationsApiResponse,
      GetUsersMeOrganisationsCurrentReservationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/reservations`,
        params: {
          provider_organisation_id: queryArg.providerOrganisationId,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_label: queryArg.dateLabel,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          data_granularity: queryArg.dataGranularity,
          coverage_grouping: queryArg.coverageGrouping,
          load_chart_data: queryArg.loadChartData,
          load_table_data: queryArg.loadTableData,
          load_totals: queryArg.loadTotals,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentAzureReservations: build.query<
      GetUsersMeOrganisationsCurrentAzureReservationsApiResponse,
      GetUsersMeOrganisationsCurrentAzureReservationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/azure/reservations`,
        params: {
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_label: queryArg.dateLabel,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          data_granularity: queryArg.dataGranularity,
          coverage_grouping: queryArg.coverageGrouping,
          load_chart_data: queryArg.loadChartData,
          load_table_data: queryArg.loadTableData,
          load_totals: queryArg.loadTotals,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentAzureSavingsPlans: build.query<
      GetUsersMeOrganisationsCurrentAzureSavingsPlansApiResponse,
      GetUsersMeOrganisationsCurrentAzureSavingsPlansApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/azure/savings-plans`,
        params: {
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_label: queryArg.dateLabel,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          data_granularity: queryArg.dataGranularity,
          coverage_grouping: queryArg.coverageGrouping,
          load_chart_data: queryArg.loadChartData,
          load_table_data: queryArg.loadTableData,
          load_totals: queryArg.loadTotals,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentCommitments: build.query<
      GetUsersMeOrganisationsCurrentCommitmentsApiResponse,
      GetUsersMeOrganisationsCurrentCommitmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/commitments`,
        params: {
          provider_organisation_id: queryArg.providerOrganisationId,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_label: queryArg.dateLabel,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentAzureCommitments: build.query<
      GetUsersMeOrganisationsCurrentAzureCommitmentsApiResponse,
      GetUsersMeOrganisationsCurrentAzureCommitmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/azure/commitments`,
        params: {
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_label: queryArg.dateLabel,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentSavingsPlansMinimumAvailableDate: build.query<
      GetUsersMeOrganisationsCurrentSavingsPlansMinimumAvailableDateApiResponse,
      GetUsersMeOrganisationsCurrentSavingsPlansMinimumAvailableDateApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/savings-plans/minimum-available-date`,
      }),
    }),
    getUsersMeOrganisationsCurrentReservationsData: build.query<
      GetUsersMeOrganisationsCurrentReservationsDataApiResponse,
      GetUsersMeOrganisationsCurrentReservationsDataApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/reservations-data`,
        params: {
          provider_organisation_id: queryArg.providerOrganisationId,
          type: queryArg["type"],
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_label: queryArg.dateLabel,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          coverage_grouping: queryArg.coverageGrouping,
          resource_type: queryArg.resourceType,
          instance_type: queryArg.instanceType,
          region: queryArg.region,
          platform: queryArg.platform,
          account_id: queryArg.accountId,
          commitment_id: queryArg.commitmentId,
          commitment_type: queryArg.commitmentType,
          data_granularity: queryArg.dataGranularity,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentAzureReservationsData: build.query<
      GetUsersMeOrganisationsCurrentAzureReservationsDataApiResponse,
      GetUsersMeOrganisationsCurrentAzureReservationsDataApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/azure/reservations-data`,
        params: {
          provider_organisation_id: queryArg.providerOrganisationId,
          type: queryArg["type"],
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_label: queryArg.dateLabel,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          coverage_grouping: queryArg.coverageGrouping,
          resource_type: queryArg.resourceType,
          product_name: queryArg.productName,
          region: queryArg.region,
          unit_of_measure: queryArg.unitOfMeasure,
          account_id: queryArg.accountId,
          commitment_id: queryArg.commitmentId,
          data_granularity: queryArg.dataGranularity,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentAzureSavingsPlansData: build.query<
      GetUsersMeOrganisationsCurrentAzureSavingsPlansDataApiResponse,
      GetUsersMeOrganisationsCurrentAzureSavingsPlansDataApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/azure/savings-plans-data`,
        params: {
          provider_organisation_id: queryArg.providerOrganisationId,
          type: queryArg["type"],
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_label: queryArg.dateLabel,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          coverage_grouping: queryArg.coverageGrouping,
          resource_type: queryArg.resourceType,
          product_name: queryArg.productName,
          region: queryArg.region,
          unit_of_measure: queryArg.unitOfMeasure,
          account_id: queryArg.accountId,
          commitment_id: queryArg.commitmentId,
          data_granularity: queryArg.dataGranularity,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentSavingsPlansData: build.query<
      GetUsersMeOrganisationsCurrentSavingsPlansDataApiResponse,
      GetUsersMeOrganisationsCurrentSavingsPlansDataApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/savings-plans-data`,
        params: {
          provider_organisation_id: queryArg.providerOrganisationId,
          type: queryArg["type"],
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_label: queryArg.dateLabel,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          coverage_grouping: queryArg.coverageGrouping,
          resource_type: queryArg.resourceType,
          instance_family: queryArg.instanceFamily,
          region: queryArg.region,
          account_id: queryArg.accountId,
          savings_plan_id: queryArg.savingsPlanId,
          commitment_id: queryArg.commitmentId,
          commitment_type: queryArg.commitmentType,
          data_granularity: queryArg.dataGranularity,
        },
      }),
    }),
    postUsersMeSchedulesNextRunDate: build.mutation<
      PostUsersMeSchedulesNextRunDateApiResponse,
      PostUsersMeSchedulesNextRunDateApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/schedules/next-run-date`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUsersMeOffHoursSchedulesNextRunDate: build.mutation<
      PostUsersMeOffHoursSchedulesNextRunDateApiResponse,
      PostUsersMeOffHoursSchedulesNextRunDateApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/off-hours-schedules/next-run-date`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeAccountsByAccountIdAndTypeResourcesMetadata: build.query<
      GetUsersMeAccountsByAccountIdAndTypeResourcesMetadataApiResponse,
      GetUsersMeAccountsByAccountIdAndTypeResourcesMetadataApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}/${queryArg["type"]}-resources/metadata`,
      }),
    }),
    getUsersMeAccountsByAccountIdMetadata: build.query<
      GetUsersMeAccountsByAccountIdMetadataApiResponse,
      GetUsersMeAccountsByAccountIdMetadataApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg.accountId}/metadata`,
      }),
    }),
    getUsersMeOrganisationsCurrentApiKeys: build.query<
      GetUsersMeOrganisationsCurrentApiKeysApiResponse,
      GetUsersMeOrganisationsCurrentApiKeysApiArg
    >({
      query: () => ({ url: `/users/me/organisations/current/api-keys` }),
    }),
    postUsersMeOrganisationsCurrentApiKeys: build.mutation<
      PostUsersMeOrganisationsCurrentApiKeysApiResponse,
      PostUsersMeOrganisationsCurrentApiKeysApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/api-keys`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeOrganisationsCurrentApiKeysByKeyId: build.mutation<
      DeleteUsersMeOrganisationsCurrentApiKeysByKeyIdApiResponse,
      DeleteUsersMeOrganisationsCurrentApiKeysByKeyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/api-keys/${queryArg.keyId}`,
        method: "DELETE",
      }),
    }),
    getUsersMeAccountByAccountIdDailyOffHoursRecommendationsAndRecommendationId:
      build.query<
        GetUsersMeAccountByAccountIdDailyOffHoursRecommendationsAndRecommendationIdApiResponse,
        GetUsersMeAccountByAccountIdDailyOffHoursRecommendationsAndRecommendationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/account/${queryArg.accountId}/daily-off-hours-recommendations/${queryArg.recommendationId}`,
        }),
      }),
    getUsersMeAccountByAccountIdWeeklyOffHoursRecommendationsAndRecommendationId:
      build.query<
        GetUsersMeAccountByAccountIdWeeklyOffHoursRecommendationsAndRecommendationIdApiResponse,
        GetUsersMeAccountByAccountIdWeeklyOffHoursRecommendationsAndRecommendationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/account/${queryArg.accountId}/weekly-off-hours-recommendations/${queryArg.recommendationId}`,
        }),
      }),
    patchUsersMeAccountByAccountIdRecommendationsResourcesAndResourceId:
      build.mutation<
        PatchUsersMeAccountByAccountIdRecommendationsResourcesAndResourceIdApiResponse,
        PatchUsersMeAccountByAccountIdRecommendationsResourcesAndResourceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/account/${queryArg.accountId}/recommendations/resources/${queryArg.resourceId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getUsersMeOrganisationsCurrentDimensions: build.query<
      GetUsersMeOrganisationsCurrentDimensionsApiResponse,
      GetUsersMeOrganisationsCurrentDimensionsApiArg
    >({
      query: () => ({ url: `/users/me/organisations/current/dimensions` }),
    }),
    postUsersMeOrganisationsCurrentDimensions: build.mutation<
      PostUsersMeOrganisationsCurrentDimensionsApiResponse,
      PostUsersMeOrganisationsCurrentDimensionsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dimensions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentDimensionsByDimensionId: build.query<
      GetUsersMeOrganisationsCurrentDimensionsByDimensionIdApiResponse,
      GetUsersMeOrganisationsCurrentDimensionsByDimensionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}`,
      }),
    }),
    putUsersMeOrganisationsCurrentDimensionsByDimensionId: build.mutation<
      PutUsersMeOrganisationsCurrentDimensionsByDimensionIdApiResponse,
      PutUsersMeOrganisationsCurrentDimensionsByDimensionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeOrganisationsCurrentDimensionsByDimensionId: build.mutation<
      DeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdApiResponse,
      DeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}`,
        method: "DELETE",
      }),
    }),
    getUsersMeOrganisationsCurrentDimensionsByDimensionIdCategories:
      build.query<
        GetUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesApiResponse,
        GetUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}/categories`,
        }),
      }),
    postUsersMeOrganisationsCurrentDimensionsByDimensionIdCategories:
      build.mutation<
        PostUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesApiResponse,
        PostUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}/categories`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    getUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryId:
      build.query<
        GetUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdApiResponse,
        GetUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}/categories/${queryArg.categoryId}`,
        }),
      }),
    putUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryId:
      build.mutation<
        PutUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdApiResponse,
        PutUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}/categories/${queryArg.categoryId}`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    deleteUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryId:
      build.mutation<
        DeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdApiResponse,
        DeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}/categories/${queryArg.categoryId}`,
          method: "DELETE",
        }),
      }),
    getUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCosts:
      build.query<
        GetUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsApiResponse,
        GetUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}/dimension-shared-costs`,
        }),
      }),
    postUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCosts:
      build.mutation<
        PostUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsApiResponse,
        PostUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}/dimension-shared-costs`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    getUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostId:
      build.query<
        GetUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdApiResponse,
        GetUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}/dimension-shared-costs/${queryArg.sharedCostId}`,
        }),
      }),
    putUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostId:
      build.mutation<
        PutUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdApiResponse,
        PutUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}/dimension-shared-costs/${queryArg.sharedCostId}`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    deleteUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostId:
      build.mutation<
        DeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdApiResponse,
        DeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dimensions/${queryArg.dimensionId}/dimension-shared-costs/${queryArg.sharedCostId}`,
          method: "DELETE",
        }),
      }),
    postUsersMeWebhookIntegrationsTests: build.mutation<
      PostUsersMeWebhookIntegrationsTestsApiResponse,
      PostUsersMeWebhookIntegrationsTestsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/webhook-integrations/tests`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getV2UsersMeOrganisationsCurrentUsers: build.query<
      GetV2UsersMeOrganisationsCurrentUsersApiResponse,
      GetV2UsersMeOrganisationsCurrentUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/me/organisations/current/users`,
        params: { role: queryArg.role, statuses: queryArg.statuses },
      }),
    }),
    getUsersMeOrganisationsCurrentChart: build.query<
      GetUsersMeOrganisationsCurrentChartApiResponse,
      GetUsersMeOrganisationsCurrentChartApiArg
    >({
      query: () => ({ url: `/users/me/organisations/current/chart` }),
    }),
    postUsersMeOrganisationsCurrentChart: build.mutation<
      PostUsersMeOrganisationsCurrentChartApiResponse,
      PostUsersMeOrganisationsCurrentChartApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/chart`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentChartByChartId: build.query<
      GetUsersMeOrganisationsCurrentChartByChartIdApiResponse,
      GetUsersMeOrganisationsCurrentChartByChartIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/chart/${queryArg.chartId}`,
      }),
    }),
    patchUsersMeOrganisationsCurrentChartByChartId: build.mutation<
      PatchUsersMeOrganisationsCurrentChartByChartIdApiResponse,
      PatchUsersMeOrganisationsCurrentChartByChartIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/chart/${queryArg.chartId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeOrganisationsCurrentChartByChartId: build.mutation<
      DeleteUsersMeOrganisationsCurrentChartByChartIdApiResponse,
      DeleteUsersMeOrganisationsCurrentChartByChartIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/chart/${queryArg.chartId}`,
        method: "DELETE",
      }),
    }),
    postUsersMeAccountsByTypeResources: build.mutation<
      PostUsersMeAccountsByTypeResourcesApiResponse,
      PostUsersMeAccountsByTypeResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/${queryArg["type"]}-resources`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeProvidersByProviderAccountsResourcesVisibilities: build.query<
      GetUsersMeProvidersByProviderAccountsResourcesVisibilitiesApiResponse,
      GetUsersMeProvidersByProviderAccountsResourcesVisibilitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/providers/${queryArg.provider}/accounts/resources/visibilities`,
        params: { account_ids: queryArg.accountIds },
      }),
    }),
    postUsersMeAskAiQuestions: build.mutation<
      PostUsersMeAskAiQuestionsApiResponse,
      PostUsersMeAskAiQuestionsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/ask-ai/questions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeAskAiChatCreate: build.query<
      GetUsersMeAskAiChatCreateApiResponse,
      GetUsersMeAskAiChatCreateApiArg
    >({
      query: () => ({ url: `/users/me/ask-ai/chat/create` }),
    }),
    getUsersMeOrganisationsCurrentResourcesRightSizingRecommendations:
      build.query<
        GetUsersMeOrganisationsCurrentResourcesRightSizingRecommendationsApiResponse,
        GetUsersMeOrganisationsCurrentResourcesRightSizingRecommendationsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resources/right-sizing-recommendations`,
          params: { is_dismissed: queryArg.isDismissed },
        }),
      }),
    getUsersMeAccountsByAccountIdRightSizingRecommendationsAndRecommendationId:
      build.query<
        GetUsersMeAccountsByAccountIdRightSizingRecommendationsAndRecommendationIdApiResponse,
        GetUsersMeAccountsByAccountIdRightSizingRecommendationsAndRecommendationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/accounts/${queryArg.accountId}/right-sizing-recommendations/${queryArg.recommendationId}`,
          params: {
            number_of_metrics_data_points: queryArg.numberOfMetricsDataPoints,
          },
        }),
      }),
    getUsersMeOrganisationsCurrentFilterSets: build.query<
      GetUsersMeOrganisationsCurrentFilterSetsApiResponse,
      GetUsersMeOrganisationsCurrentFilterSetsApiArg
    >({
      query: () => ({ url: `/users/me/organisations/current/filter-sets` }),
    }),
    postUsersMeOrganisationsCurrentFilterSetsV2: build.mutation<
      PostUsersMeOrganisationsCurrentFilterSetsV2ApiResponse,
      PostUsersMeOrganisationsCurrentFilterSetsV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/filter-sets/v2`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentCostAllocationTags: build.query<
      GetUsersMeOrganisationsCurrentCostAllocationTagsApiResponse,
      GetUsersMeOrganisationsCurrentCostAllocationTagsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/cost-allocation-tags`,
        params: { tag_key: queryArg.tagKey, account_ids: queryArg.accountIds },
      }),
    }),
    getUsersMeOrganisationsCurrentResourceExplorerProvidersByProviderTagValues:
      build.query<
        GetUsersMeOrganisationsCurrentResourceExplorerProvidersByProviderTagValuesApiResponse,
        GetUsersMeOrganisationsCurrentResourceExplorerProvidersByProviderTagValuesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resource-explorer/providers/${queryArg.provider}/tag-values`,
          params: {
            tag_key: queryArg.tagKey,
            account_ids: queryArg.accountIds,
          },
        }),
      }),
    postUsersMeOrganisationsCurrentTrackedResources: build.mutation<
      PostUsersMeOrganisationsCurrentTrackedResourcesApiResponse,
      PostUsersMeOrganisationsCurrentTrackedResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/tracked-resources`,
        method: "POST",
        body: queryArg.body,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    getV2UsersMeOrganisationsCurrentResourceExplorerHierarchy: build.query<
      GetV2UsersMeOrganisationsCurrentResourceExplorerHierarchyApiResponse,
      GetV2UsersMeOrganisationsCurrentResourceExplorerHierarchyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/me/organisations/current/resource-explorer/hierarchy`,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    patchV2UsersMeOrganisationsCurrentResourceExplorerHierarchy: build.mutation<
      PatchV2UsersMeOrganisationsCurrentResourceExplorerHierarchyApiResponse,
      PatchV2UsersMeOrganisationsCurrentResourceExplorerHierarchyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/me/organisations/current/resource-explorer/hierarchy`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentResourceExplorerViews: build.query<
      GetUsersMeOrganisationsCurrentResourceExplorerViewsApiResponse,
      GetUsersMeOrganisationsCurrentResourceExplorerViewsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/resource-explorer/views`,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    postV2UsersMeOrganisationsCurrentResourceExplorerViews: build.mutation<
      PostV2UsersMeOrganisationsCurrentResourceExplorerViewsApiResponse,
      PostV2UsersMeOrganisationsCurrentResourceExplorerViewsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/me/organisations/current/resource-explorer/views`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postV3UsersMeOrganisationsCurrentResourceExplorerFolders: build.mutation<
      PostV3UsersMeOrganisationsCurrentResourceExplorerFoldersApiResponse,
      PostV3UsersMeOrganisationsCurrentResourceExplorerFoldersApiArg
    >({
      query: (queryArg) => ({
        url: `/v3/users/me/organisations/current/resource-explorer/folders`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResourceExplorerResources:
      build.query<
        GetUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResourceExplorerResourcesApiResponse,
        GetUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResourceExplorerResourcesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/accounts/${queryArg.accountId}/providers/${queryArg.provider}/resource-explorer/resources`,
          headers: { "Content-Type": queryArg["Content-Type"] },
          params: { resource_id: queryArg.resourceId },
        }),
      }),
    deleteUsersMeOrganisationsCurrentFilterSetsByFilterSetId: build.mutation<
      DeleteUsersMeOrganisationsCurrentFilterSetsByFilterSetIdApiResponse,
      DeleteUsersMeOrganisationsCurrentFilterSetsByFilterSetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/filter-sets/${queryArg.filterSetId}`,
        method: "DELETE",
      }),
    }),
    postUsersMeOrganisationsCurrentWidgetsResourceExplorer: build.mutation<
      PostUsersMeOrganisationsCurrentWidgetsResourceExplorerApiResponse,
      PostUsersMeOrganisationsCurrentWidgetsResourceExplorerApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/widgets/resource-explorer`,
        method: "POST",
        body: queryArg.resourceExplorerFilterSchema,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    getUsersMeOrganisationsCurrentBillingTotalCost: build.query<
      GetUsersMeOrganisationsCurrentBillingTotalCostApiResponse,
      GetUsersMeOrganisationsCurrentBillingTotalCostApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/billing/total-cost`,
      }),
    }),
    postUsersMeOrganisationsCurrentReportsOneTime: build.mutation<
      PostUsersMeOrganisationsCurrentReportsOneTimeApiResponse,
      PostUsersMeOrganisationsCurrentReportsOneTimeApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/reports/one-time`,
        method: "POST",
        body: queryArg.oneTimeReport,
      }),
    }),
    postUsersMeOrganisationsCurrentResourceExplorer: build.mutation<
      PostUsersMeOrganisationsCurrentResourceExplorerApiResponse,
      PostUsersMeOrganisationsCurrentResourceExplorerApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/resource-explorer`,
        method: "POST",
        body: queryArg.resourceExplorerFilterSchema,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    getUsersMeOrganisationsCurrentWidgetsByWidgetIdSummary: build.query<
      GetUsersMeOrganisationsCurrentWidgetsByWidgetIdSummaryApiResponse,
      GetUsersMeOrganisationsCurrentWidgetsByWidgetIdSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/widgets/${queryArg.widgetId}/summary`,
        params: { language: queryArg.language },
      }),
    }),
    postUsersMeOrganisationsCurrentResourceExplorerSummary: build.mutation<
      PostUsersMeOrganisationsCurrentResourceExplorerSummaryApiResponse,
      PostUsersMeOrganisationsCurrentResourceExplorerSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/resource-explorer-summary`,
        method: "POST",
        body: queryArg.resourceExplorerFilterSchema,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    postUsersMeOrganisationsCurrentResourceExplorerAnomaliesSummary:
      build.mutation<
        PostUsersMeOrganisationsCurrentResourceExplorerAnomaliesSummaryApiResponse,
        PostUsersMeOrganisationsCurrentResourceExplorerAnomaliesSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resource-explorer-anomalies-summary`,
          method: "POST",
          body: queryArg.resourceExplorerFilterSchema,
          headers: { "Content-Type": queryArg["Content-Type"] },
        }),
      }),
    getUsersMeOrganisationsCurrentResourceExplorerAnomalyByAnomalyId:
      build.query<
        GetUsersMeOrganisationsCurrentResourceExplorerAnomalyByAnomalyIdApiResponse,
        GetUsersMeOrganisationsCurrentResourceExplorerAnomalyByAnomalyIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resource-explorer-anomaly/${queryArg.anomalyId}`,
          params: { language: queryArg.language },
        }),
      }),
    postUsersMeOrganisationsCurrentResourceExplorerGranularCosts:
      build.mutation<
        PostUsersMeOrganisationsCurrentResourceExplorerGranularCostsApiResponse,
        PostUsersMeOrganisationsCurrentResourceExplorerGranularCostsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resource-explorer/granular-costs`,
          method: "POST",
          body: queryArg.resourceExplorerFilterSchema,
          headers: { "Content-Type": queryArg["Content-Type"] },
        }),
      }),
    postUsersMeOrganisationsCurrentWidgetsResourceExplorerLiveUsageTotalCost:
      build.mutation<
        PostUsersMeOrganisationsCurrentWidgetsResourceExplorerLiveUsageTotalCostApiResponse,
        PostUsersMeOrganisationsCurrentWidgetsResourceExplorerLiveUsageTotalCostApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/widgets/resource-explorer/live-usage-total-cost`,
          method: "POST",
          body: queryArg.resourceExplorerFilterSchema,
          headers: { "Content-Type": queryArg["Content-Type"] },
        }),
      }),
    getUsersMeOrganisationsCurrentResourceExplorerPossibleFilters: build.query<
      GetUsersMeOrganisationsCurrentResourceExplorerPossibleFiltersApiResponse,
      GetUsersMeOrganisationsCurrentResourceExplorerPossibleFiltersApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/resource-explorer/possible-filters`,
        params: { providers_only: queryArg.providersOnly },
      }),
    }),
    getUsersMeOrganisationsCurrentResourceExplorerPossibleGroupings:
      build.query<
        GetUsersMeOrganisationsCurrentResourceExplorerPossibleGroupingsApiResponse,
        GetUsersMeOrganisationsCurrentResourceExplorerPossibleGroupingsApiArg
      >({
        query: () => ({
          url: `/users/me/organisations/current/resource-explorer/possible-groupings`,
        }),
      }),
    getUsersMeOrganisationsCurrentResourceExplorerPossibleColumns: build.query<
      GetUsersMeOrganisationsCurrentResourceExplorerPossibleColumnsApiResponse,
      GetUsersMeOrganisationsCurrentResourceExplorerPossibleColumnsApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/resource-explorer/possible-columns`,
      }),
    }),
    getUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValues:
      build.query<
        GetUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValuesApiResponse,
        GetUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValuesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resource-explorer/filters/${queryArg.filterProvider}/${queryArg.filterType}/values`,
          params: { key: queryArg.key },
        }),
      }),
    postUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsv:
      build.mutation<
        PostUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsvApiResponse,
        PostUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsvApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/widgets/resource-explorer/download/csv`,
          method: "POST",
          body: queryArg.resourceExplorerFilterSchema,
          headers: { "Content-Type": queryArg["Content-Type"] },
        }),
      }),
    getUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsv:
      build.query<
        GetUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsvApiResponse,
        GetUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsvApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/widgets/resource-explorer/download/csv`,
          params: { hash: queryArg.hash },
        }),
      }),
    postUsersMeOrganisationsCurrentResourceExplorerGranularCostsDownloadCsv:
      build.mutation<
        PostUsersMeOrganisationsCurrentResourceExplorerGranularCostsDownloadCsvApiResponse,
        PostUsersMeOrganisationsCurrentResourceExplorerGranularCostsDownloadCsvApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resource-explorer/granular-costs/download/csv`,
          method: "POST",
          body: queryArg.resourceExplorerFilterSchema,
          headers: { "Content-Type": queryArg["Content-Type"] },
        }),
      }),
    getUsersMeOrganisationsCurrentResourceCreators: build.query<
      GetUsersMeOrganisationsCurrentResourceCreatorsApiResponse,
      GetUsersMeOrganisationsCurrentResourceCreatorsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/resource-creators`,
        params: { account_ids: queryArg.accountIds, type: queryArg["type"] },
      }),
    }),
    postUsersMeJiraIntegrationsTests: build.mutation<
      PostUsersMeJiraIntegrationsTestsApiResponse,
      PostUsersMeJiraIntegrationsTestsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/jira-integrations/tests`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUsersMeJiraIntegrationsAutoCompleteUsersData: build.mutation<
      PostUsersMeJiraIntegrationsAutoCompleteUsersDataApiResponse,
      PostUsersMeJiraIntegrationsAutoCompleteUsersDataApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/jira-integrations/auto-complete-users-data`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUsersMeJiraIntegrationsByIntegrationIdIssues: build.mutation<
      PostUsersMeJiraIntegrationsByIntegrationIdIssuesApiResponse,
      PostUsersMeJiraIntegrationsByIntegrationIdIssuesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/jira-integrations/${queryArg.integrationId}/issues`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUsersMeJiraIntegrationsProjects: build.mutation<
      PostUsersMeJiraIntegrationsProjectsApiResponse,
      PostUsersMeJiraIntegrationsProjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/jira-integrations/projects`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUsersMeJiraIntegrationsProjectsByProjectIdIssueTypes: build.mutation<
      PostUsersMeJiraIntegrationsProjectsByProjectIdIssueTypesApiResponse,
      PostUsersMeJiraIntegrationsProjectsByProjectIdIssueTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/jira-integrations/projects/${queryArg.projectId}/issue-types`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUsersMeJiraIntegrationsProjectsByProjectIdIssueTypesAndIssueTypeFields:
      build.mutation<
        PostUsersMeJiraIntegrationsProjectsByProjectIdIssueTypesAndIssueTypeFieldsApiResponse,
        PostUsersMeJiraIntegrationsProjectsByProjectIdIssueTypesAndIssueTypeFieldsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/jira-integrations/projects/${queryArg.projectId}/issue-types/${queryArg.issueType}/fields`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postUsersMeJiraIntegrationsByIntegrationIdProjects: build.mutation<
      PostUsersMeJiraIntegrationsByIntegrationIdProjectsApiResponse,
      PostUsersMeJiraIntegrationsByIntegrationIdProjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/jira-integrations/${queryArg.integrationId}/projects`,
        method: "POST",
      }),
    }),
    postUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypes:
      build.mutation<
        PostUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypesApiResponse,
        PostUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypesApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/jira-integrations/${queryArg.integrationId}/projects/${queryArg.projectId}/issue-types`,
          method: "POST",
        }),
      }),
    postUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypesIssueTypeFields:
      build.mutation<
        PostUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypesIssueTypeFieldsApiResponse,
        PostUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypesIssueTypeFieldsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/jira-integrations/${queryArg.integrationId}/projects/${queryArg.projectId}/issue-types/${queryArg.issueType}/fields`,
          method: "POST",
        }),
      }),
    getUsersMeProvidersAzureResourcesTypesByResourceTypeResourceGroups:
      build.query<
        GetUsersMeProvidersAzureResourcesTypesByResourceTypeResourceGroupsApiResponse,
        GetUsersMeProvidersAzureResourcesTypesByResourceTypeResourceGroupsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/providers/azure/resources-types/${queryArg.resourceType}/resource-groups`,
          params: { account_ids: queryArg.accountIds },
        }),
      }),
    postUsersMeJiraIntegrationsByIntegrationIdAutoCompleteUsersData:
      build.mutation<
        PostUsersMeJiraIntegrationsByIntegrationIdAutoCompleteUsersDataApiResponse,
        PostUsersMeJiraIntegrationsByIntegrationIdAutoCompleteUsersDataApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/jira-integrations/${queryArg.integrationId}/auto-complete-users-data`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postUsersMeSlackIntegrationsByIntegrationIdMessage: build.mutation<
      PostUsersMeSlackIntegrationsByIntegrationIdMessageApiResponse,
      PostUsersMeSlackIntegrationsByIntegrationIdMessageApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/slack-integrations/${queryArg.integrationId}/message`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeSlackIntegrationsByIntegrationIdConversations: build.query<
      GetUsersMeSlackIntegrationsByIntegrationIdConversationsApiResponse,
      GetUsersMeSlackIntegrationsByIntegrationIdConversationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/slack-integrations/${queryArg.integrationId}/conversations`,
        params: { search: queryArg.search },
      }),
    }),
    postUsersMeSlackInstallationAttempts: build.mutation<
      PostUsersMeSlackInstallationAttemptsApiResponse,
      PostUsersMeSlackInstallationAttemptsApiArg
    >({
      query: () => ({
        url: `/users/me/slack-installation-attempts`,
        method: "POST",
      }),
    }),
    postUsersMeEmailsMessage: build.mutation<
      PostUsersMeEmailsMessageApiResponse,
      PostUsersMeEmailsMessageApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/emails/message`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postV2UsersMeEmailsMessage: build.mutation<
      PostV2UsersMeEmailsMessageApiResponse,
      PostV2UsersMeEmailsMessageApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/me/emails/message`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeProviderConnectionsSnowflakeQuery: build.query<
      GetUsersMeProviderConnectionsSnowflakeQueryApiResponse,
      GetUsersMeProviderConnectionsSnowflakeQueryApiArg
    >({
      query: () => ({ url: `/users/me/provider-connections/snowflake/query` }),
    }),
    postOrganisationsCurrentAccountsResourceTypesStatuses: build.mutation<
      PostOrganisationsCurrentAccountsResourceTypesStatusesApiResponse,
      PostOrganisationsCurrentAccountsResourceTypesStatusesApiArg
    >({
      query: (queryArg) => ({
        url: `/organisations/current/accounts/resource-types/statuses`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeAccountsResourceTypesByResourceTypeInstanceTypes: build.query<
      GetUsersMeAccountsResourceTypesByResourceTypeInstanceTypesApiResponse,
      GetUsersMeAccountsResourceTypesByResourceTypeInstanceTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/resource-types/${queryArg.resourceType}/instance-types`,
      }),
    }),
    getUsersMeAccountsResourceTypesByResourceTypeSupportTypes: build.query<
      GetUsersMeAccountsResourceTypesByResourceTypeSupportTypesApiResponse,
      GetUsersMeAccountsResourceTypesByResourceTypeSupportTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/resource-types/${queryArg.resourceType}/support-types`,
      }),
    }),
    getUsersMeAccountsResourceTypesByResourceTypeInstanceFamilies: build.query<
      GetUsersMeAccountsResourceTypesByResourceTypeInstanceFamiliesApiResponse,
      GetUsersMeAccountsResourceTypesByResourceTypeInstanceFamiliesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/accounts/resource-types/${queryArg.resourceType}/instance-families`,
      }),
    }),
    getUsersMeCurrentPreferences: build.query<
      GetUsersMeCurrentPreferencesApiResponse,
      GetUsersMeCurrentPreferencesApiArg
    >({
      query: () => ({ url: `/users/me/current/preferences` }),
    }),
    patchUsersMeCurrentPreferenceByKey: build.mutation<
      PatchUsersMeCurrentPreferenceByKeyApiResponse,
      PatchUsersMeCurrentPreferenceByKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/current/preference/${queryArg.key}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getUsersMeCurrentPreferenceByKey: build.query<
      GetUsersMeCurrentPreferenceByKeyApiResponse,
      GetUsersMeCurrentPreferenceByKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/current/preference/${queryArg.key}`,
      }),
    }),
    getUsersMeCurrentDigestPreferences: build.query<
      GetUsersMeCurrentDigestPreferencesApiResponse,
      GetUsersMeCurrentDigestPreferencesApiArg
    >({
      query: () => ({ url: `/users/me/current/digest-preferences` }),
    }),
    patchUsersMeCurrentDigestPreferences: build.mutation<
      PatchUsersMeCurrentDigestPreferencesApiResponse,
      PatchUsersMeCurrentDigestPreferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/current/digest-preferences`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeOrganisationsCurrentBudgetsByBudgetId: build.mutation<
      DeleteUsersMeOrganisationsCurrentBudgetsByBudgetIdApiResponse,
      DeleteUsersMeOrganisationsCurrentBudgetsByBudgetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/budgets/${queryArg["budget-id"]}`,
        method: "DELETE",
      }),
    }),
    patchUsersMeOrganisationsCurrentBudgetsByBudgetId: build.mutation<
      PatchUsersMeOrganisationsCurrentBudgetsByBudgetIdApiResponse,
      PatchUsersMeOrganisationsCurrentBudgetsByBudgetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/budgets/${queryArg["budget-id"]}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentBudgetsByBudgetId: build.query<
      GetUsersMeOrganisationsCurrentBudgetsByBudgetIdApiResponse,
      GetUsersMeOrganisationsCurrentBudgetsByBudgetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/budgets/${queryArg["budget-id"]}`,
      }),
    }),
    getUsersMeOrganisationsCurrentBudgetsByBudgetIdAccumulatedCosts:
      build.query<
        GetUsersMeOrganisationsCurrentBudgetsByBudgetIdAccumulatedCostsApiResponse,
        GetUsersMeOrganisationsCurrentBudgetsByBudgetIdAccumulatedCostsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/budgets/${queryArg["budget-id"]}/accumulated-costs`,
          params: { date_from: queryArg.dateFrom, date_to: queryArg.dateTo },
        }),
      }),
    getUsersMeOrganisationsCurrentBudgetsByBudgetIdDetails: build.query<
      GetUsersMeOrganisationsCurrentBudgetsByBudgetIdDetailsApiResponse,
      GetUsersMeOrganisationsCurrentBudgetsByBudgetIdDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/budgets/${queryArg["budget-id"]}/details`,
      }),
    }),
    getUsersMeOrganisationsCurrentBudgets: build.query<
      GetUsersMeOrganisationsCurrentBudgetsApiResponse,
      GetUsersMeOrganisationsCurrentBudgetsApiArg
    >({
      query: () => ({ url: `/users/me/organisations/current/budgets` }),
    }),
    postUsersMeOrganisationsCurrentBudgets: build.mutation<
      PostUsersMeOrganisationsCurrentBudgetsApiResponse,
      PostUsersMeOrganisationsCurrentBudgetsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/budgets`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentViewsByViewIdBudgets: build.query<
      GetUsersMeOrganisationsCurrentViewsByViewIdBudgetsApiResponse,
      GetUsersMeOrganisationsCurrentViewsByViewIdBudgetsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/views/${queryArg["view-id"]}/budgets`,
      }),
    }),
    postUsersMeOrganisationsCurrentViewsByViewIdBudgets: build.mutation<
      PostUsersMeOrganisationsCurrentViewsByViewIdBudgetsApiResponse,
      PostUsersMeOrganisationsCurrentViewsByViewIdBudgetsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/views/${queryArg["view-id"]}/budgets`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentAlertsCostAnomaly: build.query<
      GetUsersMeOrganisationsCurrentAlertsCostAnomalyApiResponse,
      GetUsersMeOrganisationsCurrentAlertsCostAnomalyApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/alerts/cost-anomaly`,
      }),
    }),
    postUsersMeOrganisationsCurrentAlertsCostAnomaly: build.mutation<
      PostUsersMeOrganisationsCurrentAlertsCostAnomalyApiResponse,
      PostUsersMeOrganisationsCurrentAlertsCostAnomalyApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/alerts/cost-anomaly`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertId: build.mutation<
      DeleteUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdApiResponse,
      DeleteUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/alerts/cost-anomaly/${queryArg.alertId}`,
        method: "DELETE",
      }),
    }),
    patchUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertId: build.mutation<
      PatchUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdApiResponse,
      PatchUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/alerts/cost-anomaly/${queryArg.alertId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertId: build.query<
      GetUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdApiResponse,
      GetUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/alerts/cost-anomaly/${queryArg.alertId}`,
      }),
    }),
    getUsersMeOrganisationsCurrentAlertsUtilizationAndCoverage: build.query<
      GetUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageApiResponse,
      GetUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/alerts/utilization-and-coverage`,
      }),
    }),
    postUsersMeOrganisationsCurrentAlertsUtilizationAndCoverage: build.mutation<
      PostUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageApiResponse,
      PostUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/alerts/utilization-and-coverage`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertId:
      build.mutation<
        DeleteUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdApiResponse,
        DeleteUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/alerts/utilization-and-coverage/${queryArg.alertId}`,
          method: "DELETE",
        }),
      }),
    patchUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertId:
      build.mutation<
        PatchUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdApiResponse,
        PatchUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/alerts/utilization-and-coverage/${queryArg.alertId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertId:
      build.query<
        GetUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdApiResponse,
        GetUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/alerts/utilization-and-coverage/${queryArg.alertId}`,
        }),
      }),
    getUsersMeOrganisationsCurrentProviderOrganisations: build.query<
      GetUsersMeOrganisationsCurrentProviderOrganisationsApiResponse,
      GetUsersMeOrganisationsCurrentProviderOrganisationsApiArg
    >({
      query: () => ({
        url: `/users/me/organisations/current/provider-organisations`,
      }),
    }),
    getUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewId:
      build.query<
        GetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiResponse,
        GetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resource-explorer/views/${queryArg.resourceExplorerViewId}`,
        }),
      }),
    postUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewId:
      build.mutation<
        PostUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiResponse,
        PostUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resource-explorer/views/${queryArg.resourceExplorerViewId}`,
          method: "POST",
          body: queryArg.resourceExplorerDataOverrideFilters,
        }),
      }),
    patchUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewId:
      build.mutation<
        PatchUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiResponse,
        PatchUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resource-explorer/views/${queryArg.resourceExplorerViewId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdAverage:
      build.query<
        GetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdAverageApiResponse,
        GetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdAverageApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resource-explorer/views/${queryArg.resourceExplorerViewId}/average`,
          params: {
            date_from: queryArg.dateFrom,
            date_to: queryArg.dateTo,
            data_point: queryArg.dataPoint,
            grouping: queryArg.grouping,
            start_month_of_quarter: queryArg.startMonthOfQuarter,
            group_values: queryArg.groupValues,
          },
        }),
      }),
    deleteV2UsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewId:
      build.mutation<
        DeleteV2UsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiResponse,
        DeleteV2UsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/users/me/organisations/current/resource-explorer/views/${queryArg.resourceExplorerViewId}`,
          method: "DELETE",
        }),
      }),
    patchV2UsersMeOrganisationsCurrentResourceExplorerFoldersByResourceExplorerFolderId:
      build.mutation<
        PatchV2UsersMeOrganisationsCurrentResourceExplorerFoldersByResourceExplorerFolderIdApiResponse,
        PatchV2UsersMeOrganisationsCurrentResourceExplorerFoldersByResourceExplorerFolderIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/users/me/organisations/current/resource-explorer/folders/${queryArg.resourceExplorerFolderId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    deleteV2UsersMeOrganisationsCurrentResourceExplorerFoldersByResourceExplorerFolderId:
      build.mutation<
        DeleteV2UsersMeOrganisationsCurrentResourceExplorerFoldersByResourceExplorerFolderIdApiResponse,
        DeleteV2UsersMeOrganisationsCurrentResourceExplorerFoldersByResourceExplorerFolderIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/users/me/organisations/current/resource-explorer/folders/${queryArg.resourceExplorerFolderId}`,
          method: "DELETE",
        }),
      }),
    postUsersMeOrganisationsCurrentTaskViews: build.mutation<
      PostUsersMeOrganisationsCurrentTaskViewsApiResponse,
      PostUsersMeOrganisationsCurrentTaskViewsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/task-views`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentTaskViewsByViewId: build.query<
      GetUsersMeOrganisationsCurrentTaskViewsByViewIdApiResponse,
      GetUsersMeOrganisationsCurrentTaskViewsByViewIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/task-views/${queryArg.viewId}`,
      }),
    }),
    patchUsersMeOrganisationsCurrentTaskViewsByViewId: build.mutation<
      PatchUsersMeOrganisationsCurrentTaskViewsByViewIdApiResponse,
      PatchUsersMeOrganisationsCurrentTaskViewsByViewIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/task-views/${queryArg.viewId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeOrganisationsCurrentTaskViewsByViewId: build.mutation<
      DeleteUsersMeOrganisationsCurrentTaskViewsByViewIdApiResponse,
      DeleteUsersMeOrganisationsCurrentTaskViewsByViewIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/task-views/${queryArg.viewId}`,
        method: "DELETE",
      }),
    }),
    postUsersMeOrganisationsCurrentOpportunityViews: build.mutation<
      PostUsersMeOrganisationsCurrentOpportunityViewsApiResponse,
      PostUsersMeOrganisationsCurrentOpportunityViewsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/opportunity-views`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentOpportunityViewsByViewId: build.query<
      GetUsersMeOrganisationsCurrentOpportunityViewsByViewIdApiResponse,
      GetUsersMeOrganisationsCurrentOpportunityViewsByViewIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/opportunity-views/${queryArg.viewId}`,
      }),
    }),
    patchUsersMeOrganisationsCurrentOpportunityViewsByViewId: build.mutation<
      PatchUsersMeOrganisationsCurrentOpportunityViewsByViewIdApiResponse,
      PatchUsersMeOrganisationsCurrentOpportunityViewsByViewIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/opportunity-views/${queryArg.viewId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeOrganisationsCurrentOpportunityViewsByViewId: build.mutation<
      DeleteUsersMeOrganisationsCurrentOpportunityViewsByViewIdApiResponse,
      DeleteUsersMeOrganisationsCurrentOpportunityViewsByViewIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/opportunity-views/${queryArg.viewId}`,
        method: "DELETE",
      }),
    }),
    patchUsersMeOrganisationsCurrentFilterSetsByFilterSetIdV2: build.mutation<
      PatchUsersMeOrganisationsCurrentFilterSetsByFilterSetIdV2ApiResponse,
      PatchUsersMeOrganisationsCurrentFilterSetsByFilterSetIdV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/filter-sets/${queryArg.filterSetId}/v2`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentDashboardsPossibleWidgets: build.query<
      GetUsersMeOrganisationsCurrentDashboardsPossibleWidgetsApiResponse,
      GetUsersMeOrganisationsCurrentDashboardsPossibleWidgetsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dashboards/possible-widgets`,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    getUsersMeOrganisationsCurrentDashboards: build.query<
      GetUsersMeOrganisationsCurrentDashboardsApiResponse,
      GetUsersMeOrganisationsCurrentDashboardsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dashboards`,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    postV2UsersMeOrganisationsCurrentDashboards: build.mutation<
      PostV2UsersMeOrganisationsCurrentDashboardsApiResponse,
      PostV2UsersMeOrganisationsCurrentDashboardsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/me/organisations/current/dashboards`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postV2UsersMeOrganisationsCurrentDashboardFolders: build.mutation<
      PostV2UsersMeOrganisationsCurrentDashboardFoldersApiResponse,
      PostV2UsersMeOrganisationsCurrentDashboardFoldersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/me/organisations/current/dashboard/folders`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    patchUsersMeOrganisationsCurrentDashboardFoldersByFolderId: build.mutation<
      PatchUsersMeOrganisationsCurrentDashboardFoldersByFolderIdApiResponse,
      PatchUsersMeOrganisationsCurrentDashboardFoldersByFolderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dashboard/folders/${queryArg.folderId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeOrganisationsCurrentDashboardFoldersByFolderId: build.mutation<
      DeleteUsersMeOrganisationsCurrentDashboardFoldersByFolderIdApiResponse,
      DeleteUsersMeOrganisationsCurrentDashboardFoldersByFolderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dashboard/folders/${queryArg.folderId}`,
        method: "DELETE",
      }),
    }),
    deleteV2UsersMeOrganisationsCurrentDashboardsFoldersByFolderId:
      build.mutation<
        DeleteV2UsersMeOrganisationsCurrentDashboardsFoldersByFolderIdApiResponse,
        DeleteV2UsersMeOrganisationsCurrentDashboardsFoldersByFolderIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/users/me/organisations/current/dashboards/folders/${queryArg.folderId}`,
          method: "DELETE",
        }),
      }),
    patchUsersMeOrganisationsCurrentDashboardsByDashboardId: build.mutation<
      PatchUsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse,
      PatchUsersMeOrganisationsCurrentDashboardsByDashboardIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dashboards/${queryArg.dashboardId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    putUsersMeOrganisationsCurrentDashboardsByDashboardId: build.mutation<
      PutUsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse,
      PutUsersMeOrganisationsCurrentDashboardsByDashboardIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dashboards/${queryArg.dashboardId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentDashboardsByDashboardId: build.query<
      GetUsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse,
      GetUsersMeOrganisationsCurrentDashboardsByDashboardIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dashboards/${queryArg.dashboardId}`,
      }),
    }),
    deleteV2UsersMeOrganisationsCurrentDashboardsByDashboardId: build.mutation<
      DeleteV2UsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse,
      DeleteV2UsersMeOrganisationsCurrentDashboardsByDashboardIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/me/organisations/current/dashboards/${queryArg.dashboardId}`,
        method: "DELETE",
      }),
    }),
    postUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgets:
      build.mutation<
        PostUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsApiResponse,
        PostUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dashboards/${queryArg.dashboardId}/widgets`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    patchUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetId:
      build.mutation<
        PatchUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdApiResponse,
        PatchUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dashboards/${queryArg.dashboardId}/widgets/${queryArg.widgetId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    deleteUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetId:
      build.mutation<
        DeleteUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdApiResponse,
        DeleteUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dashboards/${queryArg.dashboardId}/widgets/${queryArg.widgetId}`,
          method: "DELETE",
        }),
      }),
    putUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetId:
      build.mutation<
        PutUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdApiResponse,
        PutUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/dashboards/${queryArg.dashboardId}/widgets/${queryArg.widgetId}`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    patchUsersMeOrganisationsCurrentDashboardHierarchy: build.mutation<
      PatchUsersMeOrganisationsCurrentDashboardHierarchyApiResponse,
      PatchUsersMeOrganisationsCurrentDashboardHierarchyApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dashboard/hierarchy`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchV2UsersMeOrganisationsCurrentDashboardHierarchy: build.mutation<
      PatchV2UsersMeOrganisationsCurrentDashboardHierarchyApiResponse,
      PatchV2UsersMeOrganisationsCurrentDashboardHierarchyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/me/organisations/current/dashboard/hierarchy`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentTaskViewsHierarchy: build.query<
      GetUsersMeOrganisationsCurrentTaskViewsHierarchyApiResponse,
      GetUsersMeOrganisationsCurrentTaskViewsHierarchyApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/task-views/hierarchy`,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    patchUsersMeOrganisationsCurrentTaskViewsHierarchy: build.mutation<
      PatchUsersMeOrganisationsCurrentTaskViewsHierarchyApiResponse,
      PatchUsersMeOrganisationsCurrentTaskViewsHierarchyApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/task-views/hierarchy`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchy: build.query<
      GetUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchyApiResponse,
      GetUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchyApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/savings-opportunities/hierarchy`,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    patchUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchy:
      build.mutation<
        PatchUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchyApiResponse,
        PatchUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchyApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/savings-opportunities/hierarchy`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getV2UsersMeOrganisationsCurrentDashboardsHierarchy: build.query<
      GetV2UsersMeOrganisationsCurrentDashboardsHierarchyApiResponse,
      GetV2UsersMeOrganisationsCurrentDashboardsHierarchyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/me/organisations/current/dashboards/hierarchy`,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
    postUsersMeOrganisationsCurrentWidgetsSavingsOpportunities: build.mutation<
      PostUsersMeOrganisationsCurrentWidgetsSavingsOpportunitiesApiResponse,
      PostUsersMeOrganisationsCurrentWidgetsSavingsOpportunitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/users me/organisations/current/widgets/savings-opportunities`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentWidgetsSavingsOpportunitiesByWidgetId:
      build.query<
        GetUsersMeOrganisationsCurrentWidgetsSavingsOpportunitiesByWidgetIdApiResponse,
        GetUsersMeOrganisationsCurrentWidgetsSavingsOpportunitiesByWidgetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/widgets/savings-opportunities/${queryArg.widgetId}`,
        }),
      }),
    getUsersMeOrganisationsCurrentWidgetsCommitmentsUtilization: build.query<
      GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationApiResponse,
      GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/widgets/commitments-utilization`,
        params: {
          provider_organisation_id: queryArg.providerOrganisationId,
          date_label: queryArg.dateLabel,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          grouping: queryArg.grouping,
          commitment_type: queryArg.commitmentType,
          trend_type: queryArg.trendType,
          provider: queryArg.provider,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationByWidgetId:
      build.query<
        GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationByWidgetIdApiResponse,
        GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationByWidgetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/widgets/commitments-utilization/${queryArg.widgetId}`,
        }),
      }),
    getUsersMeOrganisationsCurrentWidgetsCoverage: build.query<
      GetUsersMeOrganisationsCurrentWidgetsCoverageApiResponse,
      GetUsersMeOrganisationsCurrentWidgetsCoverageApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/widgets/coverage`,
        params: {
          provider_organisation_id: queryArg.providerOrganisationId,
          date_label: queryArg.dateLabel,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          grouping: queryArg.grouping,
          commitment_type: queryArg.commitmentType,
          trend_type: queryArg.trendType,
          provider: queryArg.provider,
        },
      }),
    }),
    postUsersMeOrganisationsCurrentCoverage: build.mutation<
      PostUsersMeOrganisationsCurrentCoverageApiResponse,
      PostUsersMeOrganisationsCurrentCoverageApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/coverage`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentWidgetsCoverageByWidgetId: build.query<
      GetUsersMeOrganisationsCurrentWidgetsCoverageByWidgetIdApiResponse,
      GetUsersMeOrganisationsCurrentWidgetsCoverageByWidgetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/widgets/coverage/${queryArg.widgetId}`,
      }),
    }),
    getUsersMeOrganisationsCurrentWidgetsNormalizedCost: build.query<
      GetUsersMeOrganisationsCurrentWidgetsNormalizedCostApiResponse,
      GetUsersMeOrganisationsCurrentWidgetsNormalizedCostApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/widgets/normalized-cost`,
        params: {
          view_id: queryArg.viewId,
          date_label: queryArg.dateLabel,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          forecast_option: queryArg.forecastOption,
          trend_type: queryArg.trendType,
          chart_type: queryArg.chartType,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentWidgetsNormalizedCostByWidgetId: build.query<
      GetUsersMeOrganisationsCurrentWidgetsNormalizedCostByWidgetIdApiResponse,
      GetUsersMeOrganisationsCurrentWidgetsNormalizedCostByWidgetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/widgets/normalized-cost/${queryArg.widgetId}`,
      }),
    }),
    getUsersMeOrganisationsCurrentWidgetsCostBreakdown: build.query<
      GetUsersMeOrganisationsCurrentWidgetsCostBreakdownApiResponse,
      GetUsersMeOrganisationsCurrentWidgetsCostBreakdownApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/widgets/cost-breakdown`,
        params: {
          view_id: queryArg.viewId,
          date_label: queryArg.dateLabel,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          data_point: queryArg.dataPoint,
          grouping: queryArg.grouping,
          group_values: queryArg.groupValues,
          forecast_option: queryArg.forecastOption,
          chart_type: queryArg.chartType,
          trend_type: queryArg.trendType,
          series: queryArg.series,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetId: build.query<
      GetUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetIdApiResponse,
      GetUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/widgets/cost-breakdown/${queryArg.widgetId}`,
        params: {
          category_id: queryArg.categoryId,
          date_label: queryArg.dateLabel,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentWidgetsTextByWidgetId: build.query<
      GetUsersMeOrganisationsCurrentWidgetsTextByWidgetIdApiResponse,
      GetUsersMeOrganisationsCurrentWidgetsTextByWidgetIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/widgets/text/${queryArg.widgetId}`,
      }),
    }),
    getUsersMeOrganisationsCurrentWidgetsLargestCostChanges: build.query<
      GetUsersMeOrganisationsCurrentWidgetsLargestCostChangesApiResponse,
      GetUsersMeOrganisationsCurrentWidgetsLargestCostChangesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/widgets/largest-cost-changes`,
        params: {
          view_id: queryArg.viewId,
          date_label: queryArg.dateLabel,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          grouping: queryArg.grouping,
          group_values: queryArg.groupValues,
          items_count: queryArg.itemsCount,
          min_percent_change: queryArg.minPercentChange,
          min_cost_change: queryArg.minCostChange,
          price_direction: queryArg.priceDirection,
          sort_by: queryArg.sortBy,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentWidgetsLargestCostChangesByWidgetId:
      build.query<
        GetUsersMeOrganisationsCurrentWidgetsLargestCostChangesByWidgetIdApiResponse,
        GetUsersMeOrganisationsCurrentWidgetsLargestCostChangesByWidgetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/widgets/largest-cost-changes/${queryArg.widgetId}`,
          params: {
            category_id: queryArg.categoryId,
            date_label: queryArg.dateLabel,
            date_from: queryArg.dateFrom,
            date_to: queryArg.dateTo,
            date_type: queryArg.dateType,
            date_value: queryArg.dateValue,
            date_unit: queryArg.dateUnit,
          },
        }),
      }),
    getUsersMeOrganisationsCurrentWidgetsCostAndUsageSummary: build.query<
      GetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryApiResponse,
      GetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/widgets/cost-and-usage-summary`,
        params: {
          view_id: queryArg.viewId,
          date_label: queryArg.dateLabel,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          date_type: queryArg.dateType,
          date_value: queryArg.dateValue,
          date_unit: queryArg.dateUnit,
          trend_type: queryArg.trendType,
          visualization: queryArg.visualization,
        },
      }),
    }),
    getUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryByWidgetId:
      build.query<
        GetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryByWidgetIdApiResponse,
        GetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryByWidgetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/widgets/cost-and-usage-summary/${queryArg.widgetId}`,
          params: {
            category_id: queryArg.categoryId,
            date_label: queryArg.dateLabel,
            date_from: queryArg.dateFrom,
            date_to: queryArg.dateTo,
            date_type: queryArg.dateType,
            date_value: queryArg.dateValue,
            date_unit: queryArg.dateUnit,
          },
        }),
      }),
    getUsersMeRdsStorageTypes: build.query<
      GetUsersMeRdsStorageTypesApiResponse,
      GetUsersMeRdsStorageTypesApiArg
    >({
      query: () => ({ url: `/users/me/rds-storage-types` }),
    }),
    postUsersMeRdsSnapshotSourceNames: build.mutation<
      PostUsersMeRdsSnapshotSourceNamesApiResponse,
      PostUsersMeRdsSnapshotSourceNamesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/rds-snapshot-source-names`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeRdsSnapshotTypes: build.query<
      GetUsersMeRdsSnapshotTypesApiResponse,
      GetUsersMeRdsSnapshotTypesApiArg
    >({
      query: () => ({ url: `/users/me/rds-snapshot-types` }),
    }),
    getUsersMeEbsSnapshotStatuses: build.query<
      GetUsersMeEbsSnapshotStatusesApiResponse,
      GetUsersMeEbsSnapshotStatusesApiArg
    >({
      query: () => ({ url: `/users/me/ebs-snapshot-statuses` }),
    }),
    postUsersMeEbsSnapshotVolumeIds: build.mutation<
      PostUsersMeEbsSnapshotVolumeIdsApiResponse,
      PostUsersMeEbsSnapshotVolumeIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/ebs-snapshot-volume-ids`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeDynamoDbBackupSourceClasses: build.query<
      GetUsersMeDynamoDbBackupSourceClassesApiResponse,
      GetUsersMeDynamoDbBackupSourceClassesApiArg
    >({
      query: () => ({ url: `/users/me/dynamo_db_backup_source-classes` }),
    }),
    getUsersMeDynamoDbTableStatuses: build.query<
      GetUsersMeDynamoDbTableStatusesApiResponse,
      GetUsersMeDynamoDbTableStatusesApiArg
    >({
      query: () => ({ url: `/users/me/dynamo_db_table-statuses` }),
    }),
    getUsersMeDynamoDbTableCapacityModes: build.query<
      GetUsersMeDynamoDbTableCapacityModesApiResponse,
      GetUsersMeDynamoDbTableCapacityModesApiArg
    >({
      query: () => ({ url: `/users/me/dynamo_db_table-capacity-modes` }),
    }),
    getUsersMeNatGatewayIpAddresses: build.query<
      GetUsersMeNatGatewayIpAddressesApiResponse,
      GetUsersMeNatGatewayIpAddressesApiArg
    >({
      query: () => ({ url: `/users/me/nat_gateway-ip-addresses` }),
    }),
    getUsersMeNatGatewayVpc: build.query<
      GetUsersMeNatGatewayVpcApiResponse,
      GetUsersMeNatGatewayVpcApiArg
    >({
      query: () => ({ url: `/users/me/nat_gateway-vpc` }),
    }),
    getUsersMeEcsWorkloadCapacityProviders: build.query<
      GetUsersMeEcsWorkloadCapacityProvidersApiResponse,
      GetUsersMeEcsWorkloadCapacityProvidersApiArg
    >({
      query: () => ({ url: `/users/me/ecs_workload-capacity-providers` }),
    }),
    getUsersMeOrganisationsCurrentResourceExplorerViewsByViewIdWidget:
      build.query<
        GetUsersMeOrganisationsCurrentResourceExplorerViewsByViewIdWidgetApiResponse,
        GetUsersMeOrganisationsCurrentResourceExplorerViewsByViewIdWidgetApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/resource-explorer/views/${queryArg.viewId}/widget`,
        }),
      }),
    getUsersMeExecutionLogsSources: build.query<
      GetUsersMeExecutionLogsSourcesApiResponse,
      GetUsersMeExecutionLogsSourcesApiArg
    >({
      query: () => ({ url: `/users/me/execution-logs/sources` }),
    }),
    postUsersMeOrganisationsCurrentMinimumAvailableDate: build.mutation<
      PostUsersMeOrganisationsCurrentMinimumAvailableDateApiResponse,
      PostUsersMeOrganisationsCurrentMinimumAvailableDateApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/minimum-available-date`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    patchUsersMeRightSizingRecommendations: build.mutation<
      PatchUsersMeRightSizingRecommendationsApiResponse,
      PatchUsersMeRightSizingRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/right-sizing-recommendations`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchUsersMeDailyOffHoursRecommendations: build.mutation<
      PatchUsersMeDailyOffHoursRecommendationsApiResponse,
      PatchUsersMeDailyOffHoursRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/daily-off-hours-recommendations`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchUsersMeWeeklyOffHoursRecommendations: build.mutation<
      PatchUsersMeWeeklyOffHoursRecommendationsApiResponse,
      PatchUsersMeWeeklyOffHoursRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/weekly-off-hours-recommendations`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchUsersMeResourcesRightSizingRecommendations: build.mutation<
      PatchUsersMeResourcesRightSizingRecommendationsApiResponse,
      PatchUsersMeResourcesRightSizingRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/resources/right-sizing-recommendations`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchUsersMeResourcesDailyOffHoursRecommendations: build.mutation<
      PatchUsersMeResourcesDailyOffHoursRecommendationsApiResponse,
      PatchUsersMeResourcesDailyOffHoursRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/resources/daily-off-hours-recommendations`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchUsersMeResourcesWeeklyOffHoursRecommendations: build.mutation<
      PatchUsersMeResourcesWeeklyOffHoursRecommendationsApiResponse,
      PatchUsersMeResourcesWeeklyOffHoursRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/resources/weekly-off-hours-recommendations`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentDismissedResources: build.query<
      GetUsersMeOrganisationsCurrentDismissedResourcesApiResponse,
      GetUsersMeOrganisationsCurrentDismissedResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/dismissed-resources`,
        params: {
          group: queryArg.group,
          recommendation_type: queryArg.recommendationType,
        },
      }),
    }),
    patchUsersMeOrganisationsCurrentRecommendationsDailyOffHours:
      build.mutation<
        PatchUsersMeOrganisationsCurrentRecommendationsDailyOffHoursApiResponse,
        PatchUsersMeOrganisationsCurrentRecommendationsDailyOffHoursApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/recommendations/daily-off-hours`,
          method: "PATCH",
          body: queryArg.restoreRecommendationRequest,
        }),
      }),
    patchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHours:
      build.mutation<
        PatchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHoursApiResponse,
        PatchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHoursApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/recommendations/weekly-off-hours`,
          method: "PATCH",
          body: queryArg.restoreRecommendationRequest,
        }),
      }),
    patchUsersMeOrganisationsCurrentRecommendationsDailyOffHoursByResource:
      build.mutation<
        PatchUsersMeOrganisationsCurrentRecommendationsDailyOffHoursByResourceApiResponse,
        PatchUsersMeOrganisationsCurrentRecommendationsDailyOffHoursByResourceApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/recommendations/daily-off-hours-by-resource`,
          method: "PATCH",
          body: queryArg.restoreRecommendationByResourceRequest,
        }),
      }),
    patchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHoursByResource:
      build.mutation<
        PatchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHoursByResourceApiResponse,
        PatchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHoursByResourceApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/recommendations/weekly-off-hours-by-resource`,
          method: "PATCH",
          body: queryArg.restoreRecommendationByResourceRequest,
        }),
      }),
    patchUsersMeOrganisationsCurrentRecommendationsRightSizing: build.mutation<
      PatchUsersMeOrganisationsCurrentRecommendationsRightSizingApiResponse,
      PatchUsersMeOrganisationsCurrentRecommendationsRightSizingApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/recommendations/right-sizing`,
        method: "PATCH",
        body: queryArg.restoreRecommendationRequest,
      }),
    }),
    patchUsersMeOrganisationsCurrentRecommendationsRightSizingByResource:
      build.mutation<
        PatchUsersMeOrganisationsCurrentRecommendationsRightSizingByResourceApiResponse,
        PatchUsersMeOrganisationsCurrentRecommendationsRightSizingByResourceApiArg
      >({
        query: (queryArg) => ({
          url: `/users/me/organisations/current/recommendations/right-sizing-by-resource`,
          method: "PATCH",
          body: queryArg.restoreRecommendationByResourceRequest,
        }),
      }),
    getUsersMeOrganisationsCurrentProvidersByProviderTagKeys: build.query<
      GetUsersMeOrganisationsCurrentProvidersByProviderTagKeysApiResponse,
      GetUsersMeOrganisationsCurrentProvidersByProviderTagKeysApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/providers/${queryArg.provider}/tag-keys`,
      }),
    }),
    patchUsersMeOrganisationsCurrentProvidersByProviderTagKeys: build.mutation<
      PatchUsersMeOrganisationsCurrentProvidersByProviderTagKeysApiResponse,
      PatchUsersMeOrganisationsCurrentProvidersByProviderTagKeysApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/providers/${queryArg.provider}/tag-keys`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentReports: build.query<
      GetUsersMeOrganisationsCurrentReportsApiResponse,
      GetUsersMeOrganisationsCurrentReportsApiArg
    >({
      query: () => ({ url: `/users/me/organisations/current/reports` }),
    }),
    postUsersMeOrganisationsCurrentReports: build.mutation<
      PostUsersMeOrganisationsCurrentReportsApiResponse,
      PostUsersMeOrganisationsCurrentReportsApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/reports`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsersMeOrganisationsCurrentReportsByReportId: build.query<
      GetUsersMeOrganisationsCurrentReportsByReportIdApiResponse,
      GetUsersMeOrganisationsCurrentReportsByReportIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/reports/${queryArg.reportId}`,
      }),
    }),
    putUsersMeOrganisationsCurrentReportsByReportId: build.mutation<
      PutUsersMeOrganisationsCurrentReportsByReportIdApiResponse,
      PutUsersMeOrganisationsCurrentReportsByReportIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/reports/${queryArg.reportId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    patchUsersMeOrganisationsCurrentReportsByReportId: build.mutation<
      PatchUsersMeOrganisationsCurrentReportsByReportIdApiResponse,
      PatchUsersMeOrganisationsCurrentReportsByReportIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/reports/${queryArg.reportId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deleteUsersMeOrganisationsCurrentReportsByReportId: build.mutation<
      DeleteUsersMeOrganisationsCurrentReportsByReportIdApiResponse,
      DeleteUsersMeOrganisationsCurrentReportsByReportIdApiArg
    >({
      query: (queryArg) => ({
        url: `/users/me/organisations/current/reports/${queryArg.reportId}`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as cloudChiprApi };
export type GetUsersMeApiResponse =
  /** status 200 A JSON object of logged in user */ User;
export type GetUsersMeApiArg = {
  /** Content-type */
  "Content-Type"?: string;
};
export type PatchUsersMeApiResponse =
  /** status 200 A JSON object of logged in user */ User;
export type PatchUsersMeApiArg = {
  /** Content-type */
  "Content-Type"?: string;
  body: {
    /** The customer name */
    name?: string | null;
    email?: string | null;
    company_name?: string | null;
    position?: string | null;
    use_mfa?: boolean | null;
  };
};
export type PutUsersMeApiResponse = /** status 200 OK */ User;
export type PutUsersMeApiArg = {
  body: {
    auth_key?: string;
    email?: string;
    name?: string | null;
  };
};
export type DeleteUsersMeApiResponse = /** status 204 No Content */ void;
export type DeleteUsersMeApiArg = void;
export type PatchUsersMeCelebrationPreferenceApiResponse =
  /** status 200 No Content */ void;
export type PatchUsersMeCelebrationPreferenceApiArg = {
  body: {
    celebration_popup_enabled?: boolean;
  };
};
export type PostUsersMeOrganisationsCurrentAccountsByAccountIdRecommendationsStatusApiResponse =
  /** status 200 RecommendationState */ AccountRecommendationState;
export type PostUsersMeOrganisationsCurrentAccountsByAccountIdRecommendationsStatusApiArg =
  {
    accountId: string;
  };
export type GetUsersMeOrganisationsCurrentRecommendationsStatusApiResponse =
  /** status 200 Recommendations state */ AccountRecommendationState[];
export type GetUsersMeOrganisationsCurrentRecommendationsStatusApiArg = void;
export type PostUsersMeOrganisationsCurrentUsersApiResponse =
  /** status 201 Created */ User;
export type PostUsersMeOrganisationsCurrentUsersApiArg = {
  body: {
    email: string;
    role: UserRole;
  };
};
export type PostUsersMeInvitationRequestsApiResponse =
  /** status 201 Created */ User;
export type PostUsersMeInvitationRequestsApiArg = void;
export type GetUsersMeOrganisationsCurrentInvitationRequestsApiResponse =
  /** status 200 ok */ User[];
export type GetUsersMeOrganisationsCurrentInvitationRequestsApiArg = void;
export type DeleteUsersMeOrganisationsCurrentInvitationRequestsByUserIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentInvitationRequestsByUserIdApiArg =
  {
    /** User Id */
    userId: string;
  };
export type PostUsersMeOrganisationsCurrentUsersByUserIdReInvitationsApiResponse =
  /** status 204 No Content */ void;
export type PostUsersMeOrganisationsCurrentUsersByUserIdReInvitationsApiArg = {
  userId: string;
};
export type GetUsersMeOrganisationsCurrentUsersByUserIdApiResponse =
  /** status 200 ok */ User;
export type GetUsersMeOrganisationsCurrentUsersByUserIdApiArg = {
  userId: string;
};
export type PatchUsersMeOrganisationsCurrentUsersByUserIdApiResponse =
  /** status 200 ok */ User;
export type PatchUsersMeOrganisationsCurrentUsersByUserIdApiArg = {
  userId: string;
  body: {
    role: UserRole;
    assignments?:
      | {
          role_id?: string;
          filter?: FilterTreeNode;
        }[]
      | null;
  };
};
export type DeleteUsersMeOrganisationsCurrentUsersByUserIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentUsersByUserIdApiArg = {
  userId: string;
};
export type GetUsersMeOrganisationsCurrentTasksPropertiesApiResponse =
  /** status 200 Task properties list */ {
    statuses: TaskStatus[];
    environments: TaskEnvironment[];
    actions: TaskAction[];
    priorities: TaskPriority[];
    owners: TaskOwner[];
  };
export type GetUsersMeOrganisationsCurrentTasksPropertiesApiArg = void;
export type PutUsersMeOrganisationsCurrentTasksPropertiesStatusesApiResponse =
  unknown;
export type PutUsersMeOrganisationsCurrentTasksPropertiesStatusesApiArg = {
  body: {
    properties: {
      id?: string | null;
      name: string;
      color: string;
      category?: TaskStatusCategory;
    }[];
  };
};
export type PutUsersMeOrganisationsCurrentTasksPropertiesPrioritiesApiResponse =
  unknown;
export type PutUsersMeOrganisationsCurrentTasksPropertiesPrioritiesApiArg = {
  body: {
    properties: {
      id?: string | null;
      name: string;
      color: string;
    }[];
  };
};
export type PutUsersMeOrganisationsCurrentTasksPropertiesEnvironmentsApiResponse =
  unknown;
export type PutUsersMeOrganisationsCurrentTasksPropertiesEnvironmentsApiArg = {
  body: {
    properties: {
      id?: string | null;
      name: string;
      color: string;
    }[];
  };
};
export type PutUsersMeOrganisationsCurrentTasksPropertiesOwnersApiResponse =
  unknown;
export type PutUsersMeOrganisationsCurrentTasksPropertiesOwnersApiArg = {
  body: {
    properties: {
      id?: string | null;
      name: string;
      color: string;
    }[];
  };
};
export type PutUsersMeOrganisationsCurrentTasksPropertiesActionsApiResponse =
  unknown;
export type PutUsersMeOrganisationsCurrentTasksPropertiesActionsApiArg = {
  body: {
    properties: {
      id?: string | null;
      name: string;
      color: string;
    }[];
  };
};
export type PostUsersMeOrganisationsCurrentTasksApiResponse =
  /** status 201 Created */ Task[];
export type PostUsersMeOrganisationsCurrentTasksApiArg = {
  body: {
    target: ResourceTargetRequest | OpportunityTargetRequest;
    status_id: string;
    priority_id?: string | null;
    action_id?: string | null;
    environment_id?: string | null;
    owner_id?: string | null;
    assignees?: string[] | null;
    due_date?: NullableDate;
    description?: string | null;
  };
};
export type GetUsersMeOrganisationsCurrentTasksApiResponse =
  /** status 200 Tasks list */ Task[];
export type GetUsersMeOrganisationsCurrentTasksApiArg = void;
export type PatchUsersMeOrganisationsCurrentTasksApiResponse = unknown;
export type PatchUsersMeOrganisationsCurrentTasksApiArg = {
  body: {
    task_ids: string[];
    status_id?: string | null;
    priority_id?: {
      value: string | null;
    } | null;
    environment_id?: {
      value: string | null;
    } | null;
    owner_id?: {
      value: string | null;
    } | null;
    action_id?: {
      value: string | null;
    } | null;
    due_date?: {
      value: NullableDate;
    } | null;
    description?: {
      value: string | null;
    } | null;
    assignees?: {
      value: string[] | null;
    } | null;
    name?: string | null;
  };
};
export type PutUsersMeOrganisationsCurrentTasksApiResponse = unknown;
export type PutUsersMeOrganisationsCurrentTasksApiArg = {
  body: {
    task_ids: string[];
  };
};
export type GetUsersMeOrganisationsCurrentTasksByTaskIdActivitiesApiResponse =
  /** status 200 Task activity list */ TaskActivity[];
export type GetUsersMeOrganisationsCurrentTasksByTaskIdActivitiesApiArg = {
  taskId: string;
};
export type PostUsersMeOrganisationsCurrentTasksByTaskIdCommentsApiResponse =
  /** status 201 Created */ TaskActivity[];
export type PostUsersMeOrganisationsCurrentTasksByTaskIdCommentsApiArg = {
  taskId: string;
  body: {
    comment: string;
  };
};
export type PatchUsersMeOrganisationsCurrentTasksByTaskIdCommentsAndCommentIdApiResponse =
  /** status 201 Accepted */ TaskActivity;
export type PatchUsersMeOrganisationsCurrentTasksByTaskIdCommentsAndCommentIdApiArg =
  {
    taskId: string;
    commentId: string;
    body: {
      comment: string;
    };
  };
export type DeleteUsersMeOrganisationsCurrentTasksByTaskIdCommentsAndCommentIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentTasksByTaskIdCommentsAndCommentIdApiArg =
  {
    taskId: string;
    commentId: string;
  };
export type PostUsersMeAccountAttemptsApiResponse =
  /** status 201 A JSON object of account attempt */ AccountAttempt;
export type PostUsersMeAccountAttemptsApiArg = {
  /** Content-type */
  "Content-Type"?: string;
  body: {
    type?: ProviderType;
    access_type?: ProviderAccessType;
  };
};
export type GetUsersMeAccountAttemptsByAccountAttemptIdApiResponse =
  /** status 200 A JSON object of Account attempt */ AccountAttempt;
export type GetUsersMeAccountAttemptsByAccountAttemptIdApiArg = {
  /** Content-type */
  "Content-Type"?: string;
  /** Account Attempt Id */
  accountAttemptId: string;
};
export type PatchProvidersAwsAccountAttemptsByAccountAttemptIdApiResponse =
  /** status 200 A JSON object of account */ Account;
export type PatchProvidersAwsAccountAttemptsByAccountAttemptIdApiArg = {
  /** Content-type */
  "Content-Type"?: string;
  /** Account Attempt Id */
  accountAttemptId: string;
  body: {
    /** This is confirmation token that must be checked againt */
    provider_confirmation_token: string;
    /** Cloud provider account id */
    provider_account_id: string;
    /** Cloud provider organisation id */
    provider_organisation_id?: string | null;
    /** Cloud provider account id */
    provider_root_account_id: string;
    provider_account_name?: string;
    provider_region?: string | null;
  };
};
export type PostProvidersAwsCfnTemplatesApiResponse =
  /** status 200 A JSON object of cfn template */ object;
export type PostProvidersAwsCfnTemplatesApiArg = {
  /** Content-type */
  "Content-Type"?: string;
  /** Account provider access type */
  accessType?: ProviderAccessType;
  /** For sub account role */
  forSubAccountRole?: boolean;
};
export type PatchUsersMeProvidersAzureAccountAttemptsByAccountAttemptIdApiResponse =
  /** status 200 OK */ AccountAttempt;
export type PatchUsersMeProvidersAzureAccountAttemptsByAccountAttemptIdApiArg =
  {
    /** Content-type */
    "Content-Type"?: string;
    /** Account Attempt Id */
    accountAttemptId: string;
    body: {
      tenant_id: string;
    };
  };
export type GetUsersMeAccountsApiResponse =
  /** status 200 A JSON object of user providers */ Accounts;
export type GetUsersMeAccountsApiArg = {
  /** Content-type */
  "Content-Type"?: string;
  /** Account status */
  statuses?: string;
  /** Account provider type */
  type?: ProviderType;
  /** Account provider access type */
  accessType?: ProviderAccessType;
};
export type GetUsersMeAccountsByAccountIdApiResponse =
  /** status 200 A JSON object of logged in user */ Account;
export type GetUsersMeAccountsByAccountIdApiArg = {
  /** Content-type */
  "Content-Type"?: string;
  /** Account Id */
  accountId: string;
};
export type PatchUsersMeAccountsByAccountIdApiResponse =
  /** status 200 A JSON object of account */ Account;
export type PatchUsersMeAccountsByAccountIdApiArg = {
  /** Content-type */
  "Content-Type"?: string;
  /** Account Id */
  accountId: string;
};
export type DeleteUsersMeAccountsByAccountIdApiResponse =
  /** status 200 OK */ Account;
export type DeleteUsersMeAccountsByAccountIdApiArg = {
  /** Account Id */
  accountId: string;
};
export type PatchUsersMeProvidersByProviderAccountsAndAccountIdAccessModeApiResponse =
  /** status 200 Account response */ Account;
export type PatchUsersMeProvidersByProviderAccountsAndAccountIdAccessModeApiArg =
  {
    /** Content-type */
    "Content-Type"?: string;
    /** Cloud Provider */
    provider: CloudProvider;
    /** Account Id */
    accountId: string;
    body: {
      access_type: ProviderAccessType;
    };
  };
export type PostUsersMeAccountsByAccountIdFiltersApiResponse =
  /** status 201 Example response */ {
    id: string;
    account_id: string;
    filters: ResourceFilter[];
    created_at: Date;
    filter_set_id: string | null;
  };
export type PostUsersMeAccountsByAccountIdFiltersApiArg = {
  /** Account Id */
  accountId: string;
  body: ResourceFilter[];
};
export type PostUsersMeAccountsByAccountIdFiltersV2ApiResponse =
  /** status 201 Account filter response */ {
    account_id: string;
    filters: ResourceFilters[];
    filter_set_id: string | null;
  };
export type PostUsersMeAccountsByAccountIdFiltersV2ApiArg = {
  /** Account Id */
  accountId: string;
  body: {
    filters?: ResourceFilter[];
    filter_set_id?: string;
  };
};
export type GetUsersMeAccountsByAccountIdFiltersCurrentApiResponse =
  /** status 200 Example response */ {
    id: string;
    account_id: string;
    filters: ResourceFilter[];
    created_at: Date;
    filter_set_id: string | null;
  };
export type GetUsersMeAccountsByAccountIdFiltersCurrentApiArg = {
  /** Account Id */
  accountId: string;
};
export type GetUsersMeAccountsByAccountIdFiltersCurrentV2ApiResponse =
  /** status 200 Account filter response */ {
    account_id: string;
    filters: ResourceFilters[];
    filter_set_id: string | null;
  };
export type GetUsersMeAccountsByAccountIdFiltersCurrentV2ApiArg = {
  /** Account Id */
  accountId: string;
};
export type GetUsersMeAccountsByAccountIdCostsApiResponse =
  /** status 200 OK */ AccountCost[];
export type GetUsersMeAccountsByAccountIdCostsApiArg = {
  /** Account Id */
  accountId: string;
  dataPoint?: "hourly" | "daily" | "weekly" | "monthly";
  dateFrom?: string;
  dateTo?: string;
};
export type GetUsersMeOrganisationsCurrentProvidersByProviderBillingStatusApiResponse =
  /** status 200 OK */ ProviderBillingStatus;
export type GetUsersMeOrganisationsCurrentProvidersByProviderBillingStatusApiArg =
  {
    /** Cloud Provider */
    provider: CloudProvider;
  };
export type GetV2UsersMeOrganisationsCurrentProvidersByProviderBillingStatusApiResponse =
  /** status 200 OK */ OrganisationBillingStatus;
export type GetV2UsersMeOrganisationsCurrentProvidersByProviderBillingStatusApiArg =
  {
    /** Cloud Provider */
    provider: CloudProvider;
  };
export type GetUsersMeOrganisationsCurrentProvidersByProviderBillingCurrentApiResponse =
  /** status 200 OK */ OrganisationBillingCurrent[];
export type GetUsersMeOrganisationsCurrentProvidersByProviderBillingCurrentApiArg =
  {
    /** Cloud Provider */
    provider: CloudProvider;
  };
export type GetUsersMeOrganisationsCurrentResourcesDailyOffHoursRecommendationsApiResponse =
  /** status 200 OK */ OrganisationDailyOffHoursRecommendation[];
export type GetUsersMeOrganisationsCurrentResourcesDailyOffHoursRecommendationsApiArg =
  {
    /** Resource group */
    group?: "compute" | "database";
    /** Flag for getting dismissed recommendations */
    isDismissed?: boolean;
  };
export type GetUsersMeOrganisationsCurrentResourcesWeeklyOffHoursRecommendationsApiResponse =
  /** status 200 OK */ OrganisationWeeklyOffHoursRecommendation[];
export type GetUsersMeOrganisationsCurrentResourcesWeeklyOffHoursRecommendationsApiArg =
  {
    /** Resource group */
    group?: "compute" | "database";
    /** Flag for getting dismissed recommendations */
    isDismissed?: boolean;
  };
export type PostV3UsersMeExecutionLogsApiResponse =
  /** status 200 Example response V3 */ {
    total_items?: number;
    items?: ExecutionLogV3[];
    total_pages?: number;
    current_page?: number;
  };
export type PostV3UsersMeExecutionLogsApiArg = {
  body: {
    page?: number | null;
    size?: number | null;
    account_ids: string[] | null;
    date_from?: NullableDate;
    date_to?: NullableDate;
    search?: string | null;
    state?: "succeed" | "failed" | "skipped";
    states?: ("succeed" | "failed" | "skipped")[] | null;
    source?: ("manual" | "workflow" | "off_hours")[] | null;
    action?: ("terminate" | "stop" | "start" | "snapshot_and_delete")[] | null;
    executed_by?: string[] | null;
    execution_log_ids?: string[] | null;
  };
};
export type PostUsersMeExecutionLogsDetailsApiResponse = /** status 200 OK */ {
  total_price: number;
  operation_time: number;
};
export type PostUsersMeExecutionLogsDetailsApiArg = {
  body: {
    page?: number | null;
    size?: number | null;
    account_ids: string[] | null;
    date_from?: NullableDate;
    date_to?: NullableDate;
    search?: string | null;
    state?: "succeed" | "failed" | "skipped";
    states?: ("succeed" | "failed" | "skipped")[] | null;
    source?: ("manual" | "workflow" | "off_hours")[] | null;
    action?: ("terminate" | "stop" | "start" | "snapshot_and_delete")[] | null;
    executed_by?: string[] | null;
    execution_log_ids?: string[] | null;
  };
};
export type GetUsersMeExecutionLogsMinimumAvailableDateApiResponse =
  /** status 200 OK */ MinimumAvailableDate;
export type GetUsersMeExecutionLogsMinimumAvailableDateApiArg = void;
export type GetV3UsersMeExecutionLogsByExecutionIdApiResponse =
  /** status 200 OK */ ExecutionLogV3;
export type GetV3UsersMeExecutionLogsByExecutionIdApiArg = {
  executionId: string;
};
export type PostUsersMeOrganisationsCurrentByTypeResourcesTagKeysApiResponse =
  /** status 200 Ok */ string[];
export type PostUsersMeOrganisationsCurrentByTypeResourcesTagKeysApiArg = {
  /** Resource Type */
  type:
    | "ec2"
    | "ebs"
    | "elb"
    | "eip"
    | "rds"
    | "elc"
    | "s3"
    | "vm"
    | "disk"
    | "lb"
    | "ip"
    | "sql"
    | "az_disk"
    | "az_ip"
    | "az_lb"
    | "az_vm"
    | "az_sql"
    | "asg"
    | "mig"
    | "mig_vm"
    | "asg_ec2"
    | "eks"
    | "eks_ec2"
    | "node_group"
    | "az_vmss"
    | "az_vmss_vm"
    | "gke"
    | "node_pool"
    | "gke_vm"
    | "az_aks"
    | "az_node_pool"
    | "az_aks_vm"
    | "rds_snapshot"
    | "ebs_snapshot"
    | "rds_snapshot_source"
    | "dynamo_db_table"
    | "dynamo_db_backup"
    | "dynamo_db_backup_source"
    | "dax_cluster"
    | "nat_gateway"
    | "ecs"
    | "ecs_workload"
    | "kubernetes_node"
    | "kubernetes_namespace"
    | "kubernetes_deployment"
    | "kubernetes_stateful_set"
    | "kubernetes_daemon_set"
    | "kubernetes_replica_set"
    | "kubernetes_job"
    | "kubernetes_pod";
  body: {
    account_ids: string[];
  };
};
export type GetUsersMeOrganisationsCurrentByTypeResourcesPlatformsApiResponse =
  /** status 200 Ok */ string[];
export type GetUsersMeOrganisationsCurrentByTypeResourcesPlatformsApiArg = {
  type: "ec2" | "vm" | "az_vm";
};
export type GetUsersMeOrganisationsCurrentByTypeResourcesTypesApiResponse =
  /** status 200 Ok */ string[];
export type GetUsersMeOrganisationsCurrentByTypeResourcesTypesApiArg = {
  type: "ebs" | "disk" | "az_disk";
};
export type GetResourceTypesByTypeAndFilterKeyTypeApiResponse =
  /** status 200 Ok */ string[];
export type GetResourceTypesByTypeAndFilterKeyTypeApiArg = {
  type: ResourceType;
  filterKeyType: FilterKeyType;
};
export type PostUsersMeOrganisationsCurrentByTypeResourcesTagValuesApiResponse =
  /** status 200 Ok */ string[];
export type PostUsersMeOrganisationsCurrentByTypeResourcesTagValuesApiArg = {
  /** Resource Type */
  type:
    | "ec2"
    | "ebs"
    | "elb"
    | "eip"
    | "rds"
    | "elc"
    | "s3"
    | "vm"
    | "disk"
    | "lb"
    | "ip"
    | "sql"
    | "az_disk"
    | "az_ip"
    | "az_lb"
    | "az_vm"
    | "az_sql"
    | "asg"
    | "mig"
    | "mig_vm"
    | "asg_ec2"
    | "eks"
    | "eks_ec2"
    | "node_group"
    | "az_vmss"
    | "az_vmss_vm"
    | "gke"
    | "node_pool"
    | "gke_vm"
    | "az_aks"
    | "az_node_pool"
    | "az_aks_vm"
    | "rds_snapshot"
    | "ebs_snapshot"
    | "rds_snapshot_source"
    | "dynamo_db_table"
    | "dynamo_db_backup"
    | "dynamo_db_backup_source"
    | "dax_cluster"
    | "nat_gateway"
    | "ecs"
    | "ecs_workload"
    | "kubernetes_node"
    | "kubernetes_namespace"
    | "kubernetes_deployment"
    | "kubernetes_stateful_set"
    | "kubernetes_daemon_set"
    | "kubernetes_replica_set"
    | "kubernetes_job"
    | "kubernetes_pod";
  body: {
    account_ids: string[];
    key: string;
  };
};
export type GetUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResourcesApiResponse =
  /** status 200 Ok */
  | Asg
  | Ebs
  | EbsSnapshot
  | Ec2
  | Eip
  | Eks
  | Elb
  | Elc
  | Rds
  | RdsSnapshot
  | S3
  | AzAks
  | AzDisk
  | AzIp
  | AzLb
  | AzSql
  | AzVm
  | AzVmss
  | Disk
  | Gke
  | Ip
  | Lb
  | Mig
  | Sql
  | Vm
  | RdsSnapshotSource
  | DynamoDbTable
  | DynamoDbBackupSource
  | DaxCluster
  | NatGateway
  | Ecs
  | EcsWorkload
  | EcsWorkloadTask;
export type GetUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResourcesApiArg =
  {
    /** Content-type */
    "Content-Type"?: string;
    /** Cloud Provider */
    provider: "gcp" | "aws" | "azure" | "kubernetes" | "global";
    /** Account Id */
    accountId: string;
    resourceId: string;
  };
export type PostUsersMeV2OrganisationsCurrentByTypeResourcesApiResponse =
  /** status 200 Ok */
  | FilteredAsgResources
  | FilteredEbsResources
  | FilteredEbsSnapshotResourcesV2
  | FilteredEc2Resources
  | FilteredEipResources
  | FilteredEksResources
  | FilteredElbResources
  | FilteredElcResources
  | FilteredRdsResources
  | FilteredRdsSnapshotResourcesV2
  | FilteredS3Resources
  | FilteredAzAksResources
  | FilteredAzDiskResources
  | FilteredAzIpResources
  | FilteredAzLbResources
  | FilteredAzSqlResources
  | FilteredAzVmResources
  | FilteredAzVmssResources
  | FilteredDiskResources
  | FilteredGkeResources
  | FilteredIpResources
  | FilteredLbResources
  | FilteredMigResources
  | FilteredSqlResources
  | FilteredVmResources
  | FilteredRdsSnapshotSourceResources
  | FilteredDynamoDbTableResources
  | FilteredDynamoDbBackupSourceResources
  | FilteredDaxClusterResources
  | FilteredNatGatewayResources
  | FilteredEcsResources
  | FilteredEcsWorkloadResources
  | FilteredEcsWorkloadTaskResources;
export type PostUsersMeV2OrganisationsCurrentByTypeResourcesApiArg = {
  /** Resource Type */
  type:
    | "ec2"
    | "ebs"
    | "elb"
    | "eip"
    | "rds"
    | "elc"
    | "s3"
    | "vm"
    | "disk"
    | "lb"
    | "ip"
    | "sql"
    | "az_disk"
    | "az_ip"
    | "az_lb"
    | "az_vm"
    | "az_sql"
    | "asg"
    | "mig"
    | "mig_vm"
    | "asg_ec2"
    | "eks"
    | "eks_ec2"
    | "node_group"
    | "az_vmss"
    | "az_vmss_vm"
    | "gke"
    | "node_pool"
    | "gke_vm"
    | "az_aks"
    | "az_node_pool"
    | "az_aks_vm"
    | "rds_snapshot"
    | "ebs_snapshot"
    | "rds_snapshot_source"
    | "dynamo_db_table"
    | "dynamo_db_backup"
    | "dynamo_db_backup_source"
    | "dax_cluster"
    | "nat_gateway"
    | "ecs"
    | "ecs_workload"
    | "kubernetes_node"
    | "kubernetes_namespace"
    | "kubernetes_deployment"
    | "kubernetes_stateful_set"
    | "kubernetes_daemon_set"
    | "kubernetes_replica_set"
    | "kubernetes_job"
    | "kubernetes_pod";
  body: {
    load_resources?: boolean;
    account_ids: string[];
    filter: ResourceFilters;
  };
};
export type GetUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeProviderUniqueIdentifierMetricsApiResponse =
  /** status 200 A JSON object of Resource metrics */ ResourceMetrics;
export type GetUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeProviderUniqueIdentifierMetricsApiArg =
  {
    accountId: AccountId;
    resourceType: ResourceType;
    providerUniqueIdentifier: string;
  };
export type PostUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeMetricsApiResponse =
  /** status 200 A JSON object of Resource metrics */ ResourceMetrics;
export type PostUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeMetricsApiArg =
  {
    accountId: AccountId;
    resourceType: ResourceType;
    body: {
      provider_unique_identifier?: string;
    };
  };
export type GetUsersMeOrganisationsCurrentKubernetesByResourceTypeFiltersAndFilterTypeValuesApiResponse =
  /** status 200 A JSON object of Kubernetes Possible Filter Values */ PossibleFilterValues;
export type GetUsersMeOrganisationsCurrentKubernetesByResourceTypeFiltersAndFilterTypeValuesApiArg =
  {
    resourceType: ResourceType;
    filterType: ResourceExplorerDynamicFilterItemType;
    key?: string;
  };
export type PostUsersMeOrganisationsCurrentKubernetesByTypeResourcesApiResponse =
  /** status 200 Ok */
  | FilteredKubernetesNodeResources
  | FilteredKubernetesPodResources
  | FilteredKubernetesDeploymentResources
  | FilteredKubernetesNamespaceResources
  | FilteredKubernetesDaemonSetResources
  | FilteredKubernetesReplicaSetResources
  | FilteredKubernetesStatefulSetResources
  | FilteredKubernetesJobResources;
export type PostUsersMeOrganisationsCurrentKubernetesByTypeResourcesApiArg = {
  /** Resource Type */
  type:
    | "ec2"
    | "ebs"
    | "elb"
    | "eip"
    | "rds"
    | "elc"
    | "s3"
    | "vm"
    | "disk"
    | "lb"
    | "ip"
    | "sql"
    | "az_disk"
    | "az_ip"
    | "az_lb"
    | "az_vm"
    | "az_sql"
    | "asg"
    | "mig"
    | "mig_vm"
    | "asg_ec2"
    | "eks"
    | "eks_ec2"
    | "node_group"
    | "az_vmss"
    | "az_vmss_vm"
    | "gke"
    | "node_pool"
    | "gke_vm"
    | "az_aks"
    | "az_node_pool"
    | "az_aks_vm"
    | "rds_snapshot"
    | "ebs_snapshot"
    | "rds_snapshot_source"
    | "dynamo_db_table"
    | "dynamo_db_backup"
    | "dynamo_db_backup_source"
    | "dax_cluster"
    | "nat_gateway"
    | "ecs"
    | "ecs_workload"
    | "kubernetes_node"
    | "kubernetes_namespace"
    | "kubernetes_deployment"
    | "kubernetes_stateful_set"
    | "kubernetes_daemon_set"
    | "kubernetes_replica_set"
    | "kubernetes_job"
    | "kubernetes_pod";
  body: {
    load_resources?: boolean;
    filter: FilterTreeNode;
  };
};
export type GetUsersMeOrganisationsCurrentKubernetesClustersApiResponse =
  /** status 200 ok */ KubernetesCluster[];
export type GetUsersMeOrganisationsCurrentKubernetesClustersApiArg = void;
export type GetUsersMeOrganisationsCurrentKubernetesByTypeAndResourceIdMetricsApiResponse =
  /** status 200 A JSON object of Resource metrics */ ResourceMetrics;
export type GetUsersMeOrganisationsCurrentKubernetesByTypeAndResourceIdMetricsApiArg =
  {
    /** Resource Type */
    type:
      | "ec2"
      | "ebs"
      | "elb"
      | "eip"
      | "rds"
      | "elc"
      | "s3"
      | "vm"
      | "disk"
      | "lb"
      | "ip"
      | "sql"
      | "az_disk"
      | "az_ip"
      | "az_lb"
      | "az_vm"
      | "az_sql"
      | "asg"
      | "mig"
      | "mig_vm"
      | "asg_ec2"
      | "eks"
      | "eks_ec2"
      | "node_group"
      | "az_vmss"
      | "az_vmss_vm"
      | "gke"
      | "node_pool"
      | "gke_vm"
      | "az_aks"
      | "az_node_pool"
      | "az_aks_vm"
      | "rds_snapshot"
      | "ebs_snapshot"
      | "rds_snapshot_source"
      | "dynamo_db_table"
      | "dynamo_db_backup"
      | "dynamo_db_backup_source"
      | "dax_cluster"
      | "nat_gateway"
      | "ecs"
      | "ecs_workload"
      | "kubernetes_node"
      | "kubernetes_namespace"
      | "kubernetes_deployment"
      | "kubernetes_stateful_set"
      | "kubernetes_daemon_set"
      | "kubernetes_replica_set"
      | "kubernetes_job"
      | "kubernetes_pod";
    resourceId: string;
  };
export type GetUsersMeDynamoDbBackupTypesApiResponse =
  /** status 200 ok */ DynamoDbBackupType[];
export type GetUsersMeDynamoDbBackupTypesApiArg = void;
export type PostUsersMeDynamoDbBackupTableNamesApiResponse =
  /** status 200 ok */ string[];
export type PostUsersMeDynamoDbBackupTableNamesApiArg = {
  body: {
    account_ids?: string[];
  };
};
export type GetUsersMeByTypeStorageTiersApiResponse =
  /** status 200 ok */ StorageTier[];
export type GetUsersMeByTypeStorageTiersApiArg = {
  /** Resource Type */
  type:
    | "ec2"
    | "ebs"
    | "elb"
    | "eip"
    | "rds"
    | "elc"
    | "s3"
    | "vm"
    | "disk"
    | "lb"
    | "ip"
    | "sql"
    | "az_disk"
    | "az_ip"
    | "az_lb"
    | "az_vm"
    | "az_sql"
    | "asg"
    | "mig"
    | "mig_vm"
    | "asg_ec2"
    | "eks"
    | "eks_ec2"
    | "node_group"
    | "az_vmss"
    | "az_vmss_vm"
    | "gke"
    | "node_pool"
    | "gke_vm"
    | "az_aks"
    | "az_node_pool"
    | "az_aks_vm"
    | "rds_snapshot"
    | "ebs_snapshot"
    | "rds_snapshot_source"
    | "dynamo_db_table"
    | "dynamo_db_backup"
    | "dynamo_db_backup_source"
    | "dax_cluster"
    | "nat_gateway"
    | "ecs"
    | "ecs_workload"
    | "kubernetes_node"
    | "kubernetes_namespace"
    | "kubernetes_deployment"
    | "kubernetes_stateful_set"
    | "kubernetes_daemon_set"
    | "kubernetes_replica_set"
    | "kubernetes_job"
    | "kubernetes_pod";
};
export type PutUsersMeAccountsByAccountIdResourcesApiResponse =
  /** status 200 Example response */ {
    execution_id?: string;
  };
export type PutUsersMeAccountsByAccountIdResourcesApiArg = {
  accountId: string;
  body: {
    type?: string;
    id?: string;
    action?: "terminate" | "stop" | "start" | "reboot";
    snapshot?: boolean;
  }[];
};
export type PatchUsersMeAccountsByAccountIdResourcesApiResponse =
  /** status 200 OK */ {
    resources: {
      type: string;
      id: string;
      is_protected: boolean;
      protected_by: string | null;
    }[];
  };
export type PatchUsersMeAccountsByAccountIdResourcesApiArg = {
  accountId: string;
  body: {
    type?: string;
    id?: string;
    is_protected?: boolean;
  }[];
};
export type GetProvidersByProviderRegionsApiResponse =
  /** status 200 OK */ Regions;
export type GetProvidersByProviderRegionsApiArg = {
  /** Cloud Provider */
  provider: CloudProvider;
};
export type GetProvidersByProviderFiltersApiResponse =
  /** status 200 Provider filters */ Filters;
export type GetProvidersByProviderFiltersApiArg = {
  /** Cloud Provider */
  provider: CloudProvider;
};
export type GetV2PlansApiResponse = /** status 200 OK */ {
  free?: Plan[];
  pro?: Plan[];
  advanced?: Plan[];
};
export type GetV2PlansApiArg = void;
export type PostUsersMeOrganisationsCurrentGcpBillingExportDataApiResponse =
  /** status 201 Created */ GcpBillingExportData;
export type PostUsersMeOrganisationsCurrentGcpBillingExportDataApiArg = {
  body: {
    project_id: string;
    dataset: string;
    table: string;
  };
};
export type GetUsersMeOrganisationsCurrentGcpBillingExportDataApiResponse =
  /** status 200 OK */ GcpBillingExportData[];
export type GetUsersMeOrganisationsCurrentGcpBillingExportDataApiArg = void;
export type GetUsersMeSubscriptionsCurrentApiResponse =
  /** status 200 OK */ Subscription;
export type GetUsersMeSubscriptionsCurrentApiArg = void;
export type PostUsersMeSchedulesApiResponse =
  /** status 201 Created */ Schedule;
export type PostUsersMeSchedulesApiArg = {
  body: {
    name: string;
    start_date_time: NullableDate;
    end_date_time: NullableDate;
    cron: string | null;
    account_ids: string[];
    regions: string[];
    filter: ResourceFiltersWithAction[];
    action: ScheduleActionType;
    integrations?: NestedIntegration[] | null;
    notifications?:
      | (
          | NotificationEmail
          | NotificationSlack
          | NotificationWebhook
          | NotificationJira
        )[]
      | null;
    time_zone: string;
    min_threshold?: number | null;
    is_snoozed?: boolean | null;
    grace_period?: GracePeriod;
    emails?: Emails;
    weekly_schedule_interval?: number | null;
    daily_schedule_interval?: number | null;
    status?: ScheduleStatus;
    description?: string | null;
  };
};
export type GetUsersMeSchedulesApiResponse =
  /** status 200 Example response */ Schedule[];
export type GetUsersMeSchedulesApiArg = {
  accountId?: string;
};
export type GetUsersMeSchedulesByScheduleIdApiResponse =
  /** status 200 OK */ Schedule;
export type GetUsersMeSchedulesByScheduleIdApiArg = {
  scheduleId: string;
};
export type PatchUsersMeSchedulesByScheduleIdApiResponse =
  /** status 200 OK */ Schedule;
export type PatchUsersMeSchedulesByScheduleIdApiArg = {
  scheduleId: string;
  body: {
    name?: string | null;
    start_date_time?: NullableDate;
    end_date_time: NullableDate;
    cron: string | null;
    regions: string[] | null;
    filter?: ResourceFiltersWithAction[] | null;
    action: ScheduleActionType;
    status?: ScheduleStatus;
    integrations?: NestedIntegration[] | null;
    notifications?:
      | (
          | NotificationEmail
          | NotificationSlack
          | NotificationWebhook
          | NotificationJira
        )[]
      | null;
    account_ids: string[];
    time_zone?: string;
    min_threshold?: number | null;
    is_snoozed?: boolean | null;
    grace_period?: GracePeriod;
    emails?: Emails;
    weekly_schedule_interval?: number | null;
    daily_schedule_interval?: number | null;
    description?: string | null;
  };
};
export type GetUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdApiResponse =
  /** status 200 OK */ WorkflowLight;
export type GetUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdApiArg = {
  workflowId: string;
  batchId: string;
};
export type GetUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdResourcesApiResponse =
  /** status 200 OK */ AllFilteredResources[];
export type GetUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdResourcesApiArg = {
  workflowId: string;
  batchId: string;
};
export type PostUsersMeOrganisationsCurrentByProviderAndValidationFilterTypeValidValuesApiResponse =
  /** status 200 Ok */ ValidatedFilterValues;
export type PostUsersMeOrganisationsCurrentByProviderAndValidationFilterTypeValidValuesApiArg =
  {
    provider: string;
    validationFilterType: string;
    tagKey?: string;
    /** Content-type */
    "Content-Type"?: string;
    body: {
      filter_values?: string[];
    };
  };
export type PostUsersMeOrganisationsCurrentBillingPortalApiResponse =
  /** status 201 Example response */ {
    link?: string;
  };
export type PostUsersMeOrganisationsCurrentBillingPortalApiArg = void;
export type PostUsersMeOrganisationsCurrentBillingPortalPlansByPlanIdApiResponse =
  /** status 201 Example response */ {
    link?: string;
  };
export type PostUsersMeOrganisationsCurrentBillingPortalPlansByPlanIdApiArg = {
  planId: string;
};
export type GetUsersMeOrganisationsCurrentApiResponse =
  /** status 200 OK */ Organisation;
export type GetUsersMeOrganisationsCurrentApiArg = void;
export type PatchUsersMeOrganisationsCurrentApiResponse =
  /** status 200 OK */ Organisation;
export type PatchUsersMeOrganisationsCurrentApiArg = {
  body: {
    name?: string | null;
    email?: string | null;
    access_enabled?: boolean | null;
  };
};
export type PostUsersMeOffHoursSchedulesApiResponse =
  /** status 201 Created */ OffHoursSchedule;
export type PostUsersMeOffHoursSchedulesApiArg = {
  body: {
    name: string;
    start_date_time: NullableDate;
    end_date_time: NullableDate;
    start_cron: string | null;
    stop_cron: string | null;
    account_ids: string[];
    regions: string[];
    filter: ResourceFiltersWithAction[];
    integrations?: NestedIntegration[] | null;
    notifications?:
      | (
          | NotificationEmail
          | NotificationSlack
          | NotificationWebhook
          | NotificationJira
        )[]
      | null;
    action: OffHoursScheduleActionType;
    time_zone: string;
    min_threshold?: number | null;
    emails?: Emails;
    status?: ("active" | "inactive") | null;
    description?: string | null;
  };
};
export type GetUsersMeOffHoursSchedulesApiResponse =
  /** status 200 Example response */ OffHoursSchedule[];
export type GetUsersMeOffHoursSchedulesApiArg = {
  accountId?: string;
};
export type GetUsersMeOffHoursSchedulesByScheduleIdApiResponse =
  /** status 200 OK */ OffHoursSchedule;
export type GetUsersMeOffHoursSchedulesByScheduleIdApiArg = {
  scheduleId: string;
};
export type PatchUsersMeOffHoursSchedulesByScheduleIdApiResponse =
  /** status 200 OK */ OffHoursSchedule;
export type PatchUsersMeOffHoursSchedulesByScheduleIdApiArg = {
  scheduleId: string;
  body: {
    name?: string;
    start_date_time?: NullableDate;
    end_date_time: NullableDate;
    start_cron: string | null;
    stop_cron: string | null;
    regions: string[];
    filter?: ResourceFiltersWithAction[];
    status?: string | null;
    action: OffHoursScheduleActionType;
    integrations?: NestedIntegration[] | null;
    notifications?:
      | (
          | NotificationEmail
          | NotificationSlack
          | NotificationWebhook
          | NotificationJira
        )[]
      | null;
    account_ids: string[];
    time_zone?: string;
    min_threshold?: number | null;
    emails?: Emails;
    description?: string | null;
  };
};
export type GetUsersMeFeaturesApiResponse = /** status 200 OK */ Feature[];
export type GetUsersMeFeaturesApiArg = void;
export type PostUsersMeFeaturesApiResponse =
  /** status 201 A JSON object of account attempt */ Feature[];
export type PostUsersMeFeaturesApiArg = {
  body: {
    /** The key of feature user has seen */
    feature_key?: string | null;
    /** List of feature keys */
    feature_keys?: string[] | null;
  };
};
export type GetUsersMeProvidersAwsAccountsByAccountIdMissingPermissionsApiResponse =
  /** status 200 A JSON array of missing aws permissions */ AccountMissingPermissions;
export type GetUsersMeProvidersAwsAccountsByAccountIdMissingPermissionsApiArg =
  {
    accountId: string;
  };
export type GetUsersMeProvidersGcpAccountsByAccountIdMissingRolesApiResponse =
  /** status 200 A JSON array of missing gcp roles */ AccountMissingPermissions;
export type GetUsersMeProvidersGcpAccountsByAccountIdMissingRolesApiArg = {
  accountId: string;
};
export type GetUsersMeProvidersGcpAccountsByAccountIdMissingRolesOptionsApiResponse =
  /** status 200 Gcp account missing role options */ {
    /** Gcp project id */
    project_id: string;
    /** Gcp service account */
    service_account: string;
  };
export type GetUsersMeProvidersGcpAccountsByAccountIdMissingRolesOptionsApiArg =
  {
    accountId: string;
  };
export type GetUsersMeProvidersGcpAccountsByAccountIdMissingApisApiResponse =
  /** status 200 A JSON array of missing gcp apis */ AccountMissingPermissions;
export type GetUsersMeProvidersGcpAccountsByAccountIdMissingApisApiArg = {
  accountId: string;
};
export type GetUsersMeProvidersAzureAccountsByAccountIdMissingRolesApiResponse =
  /** status 200 Example response */ {
    name?: string;
    title?: string;
  }[];
export type GetUsersMeProvidersAzureAccountsByAccountIdMissingRolesApiArg = {
  accountId: string;
};
export type GetUsersMeProvidersAzureAccountsByAccountIdMissingRolesOptionsApiResponse =
  /** status 200 Azure account missing role options */ {
    /** Azure subscription id */
    subscription_id: string;
    /** Azure subscription name */
    subscription_name: string;
    /** Azure service principal id */
    service_principal_id: string;
    /** Azure service principal name */
    service_principal_name: string;
    /** Azure tenant id */
    tenant_id: string;
  };
export type GetUsersMeProvidersAzureAccountsByAccountIdMissingRolesOptionsApiArg =
  {
    accountId: string;
  };
export type PatchUsersMeAccountsByAccountIdPermissionsApiResponse =
  /** status 200 Updated missing permissions */ object;
export type PatchUsersMeAccountsByAccountIdPermissionsApiArg = {
  accountId: string;
};
export type GetUsersMeIntegrationsApiResponse =
  /** status 200 OK */ Integration[];
export type GetUsersMeIntegrationsApiArg = {
  /** Integration type in query */
  type?: "webhook" | "slack" | "email" | "jira";
};
export type GetUsersMeProviderConnectionsSnowflakeApiResponse =
  /** status 200 OK */ SnowflakeConnection[];
export type GetUsersMeProviderConnectionsSnowflakeApiArg = void;
export type PostUsersMeProviderConnectionsSnowflakeApiResponse =
  /** status 201 Created */ SnowflakeConnection;
export type PostUsersMeProviderConnectionsSnowflakeApiArg = {
  body: {
    name: string;
    account_identifier: string;
    service_account: string;
    private_key_id: string;
  };
};
export type DeleteUsersMeIntegrationsByIntegrationIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeIntegrationsByIntegrationIdApiArg = {
  integrationId: string;
};
export type PostUsersMeByTypeIntegrationsApiResponse =
  /** status 201 Created */ Integration;
export type PostUsersMeByTypeIntegrationsApiArg = {
  type: string;
  body: {
    name: string;
    emails?: string[] | null;
    token?: string | null;
    channel?: string | null;
    url?: string | null;
    content_type?: string | null;
    api_token?: string | null;
    jira_email?: string | null;
    default_project_key?: string | null;
    default_issue_type_id?: string | null;
    conversation?: SlackConversation;
    conversations?: SlackConversation[] | null;
  };
};
export type GetUsersMeByTypeIntegrationsAndIntegrationIdApiResponse =
  /** status 200 OK */ Integration;
export type GetUsersMeByTypeIntegrationsAndIntegrationIdApiArg = {
  type: string;
  integrationId: string;
};
export type PutUsersMeByTypeIntegrationsAndIntegrationIdApiResponse =
  /** status 200 OK */ void;
export type PutUsersMeByTypeIntegrationsAndIntegrationIdApiArg = {
  type: string;
  integrationId: string;
  body: {
    name?: string | null;
    emails?: string[] | null;
    channel?: string | null;
    url?: string | null;
    content_type?: string | null;
    default_project_key?: string | null;
    default_issue_type_id?: string | null;
    jira_email?: string | null;
    conversation?: NullableSlackConversation;
    conversations?: SlackConversation[] | null;
  };
};
export type GetUsersMeProviderConnectionsSnowflakeByIdApiResponse =
  /** status 200 OK */ SnowflakeConnection;
export type GetUsersMeProviderConnectionsSnowflakeByIdApiArg = {
  id: string;
};
export type DeleteUsersMeProviderConnectionsSnowflakeByIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeProviderConnectionsSnowflakeByIdApiArg = {
  id: string;
};
export type PostUsersMeSlackIntegrationsByIntegrationIdTestMessagesApiResponse =
  /** status 200 OK */ void;
export type PostUsersMeSlackIntegrationsByIntegrationIdTestMessagesApiArg = {
  integrationId: string;
  body: {
    name?: string | null;
    emails?: string[] | null;
    channel?: string | null;
    url?: string | null;
    content_type?: string | null;
    default_project_key?: string | null;
    default_issue_type_id?: string | null;
    jira_email?: string | null;
    conversation?: NullableSlackConversation;
    conversations?: SlackConversation[] | null;
  };
};
export type PostUsersMeProvidersAwsAccountsByAccountIdCfnChangeSetsApiResponse =
  /** status 201 Example response */ {
    link?: string;
  };
export type PostUsersMeProvidersAwsAccountsByAccountIdCfnChangeSetsApiArg = {
  accountId: string;
};
export type PostUsersMeProvidersAwsAccountsByAccountIdCfnChangeAccessModeChangeSetsApiResponse =
  /** status 201 Example response */ {
    link?: string;
  };
export type PostUsersMeProvidersAwsAccountsByAccountIdCfnChangeAccessModeChangeSetsApiArg =
  {
    accountId: string;
  };
export type PostUsersMeProvidersAwsSubAccountsByAccountIdApiResponse =
  /** status 201 Example response */ {
    cli_command?: string;
    console_link?: string;
  };
export type PostUsersMeProvidersAwsSubAccountsByAccountIdApiArg = {
  accountId: string;
  body: {
    access_type: ProviderAccessType;
  };
};
export type GetUsersMeOrganisationsCurrentProvidersByProviderTotalSavedAmountApiResponse =
  /** status 200 Example response */ {
    amount?: number;
  };
export type GetUsersMeOrganisationsCurrentProvidersByProviderTotalSavedAmountApiArg =
  {
    /** Cloud Provider */
    provider: CloudProvider;
  };
export type GetUsersMeOrganisationsCurrentSsoOptionsCurrentApiResponse =
  /** status 200 Example response */ {
    sso_url: string;
    sp_entity_id: string;
  };
export type GetUsersMeOrganisationsCurrentSsoOptionsCurrentApiArg = void;
export type PostUsersMeOrganisationsCurrentSsoApiResponse =
  /** status 201 Created */ void;
export type PostUsersMeOrganisationsCurrentSsoApiArg = {
  body: {
    type?: "okta" | "azure_ad";
    /** IdP mestadata, xml content  */
    metadata?: string;
  };
};
export type DeleteUsersMeOrganisationsCurrentSsoCurrentApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentSsoCurrentApiArg = void;
export type PostUsersMeOrganisationsCurrentRolesApiResponse =
  /** status 201 Created */ Role;
export type PostUsersMeOrganisationsCurrentRolesApiArg = {
  body: {
    name: string;
    description?: string | null;
    permissions: PermissionName[];
  };
};
export type GetUsersMeOrganisationsCurrentRolesApiResponse =
  /** status 200 Example roles response */ Role[];
export type GetUsersMeOrganisationsCurrentRolesApiArg = void;
export type PatchUsersMeOrganisationsCurrentRolesByRoleIdApiResponse =
  /** status 200 OK */ Role;
export type PatchUsersMeOrganisationsCurrentRolesByRoleIdApiArg = {
  roleId: string;
  body: {
    name?: string;
    description?: string | null;
    permissions?: PermissionName[];
  };
};
export type GetUsersMeOrganisationsCurrentRolesByRoleIdApiResponse =
  /** status 200 OK */ Role;
export type GetUsersMeOrganisationsCurrentRolesByRoleIdApiArg = {
  roleId: string;
};
export type DeleteUsersMeOrganisationsCurrentRolesByRoleIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentRolesByRoleIdApiArg = {
  roleId: string;
};
export type PatchUsersMeOrganisationsCurrentAssignmentsByAssignmentIdApiResponse =
  /** status 200 OK */ Assignment;
export type PatchUsersMeOrganisationsCurrentAssignmentsByAssignmentIdApiArg = {
  assignmentId: string;
  body: {
    role_id?: string | null;
    filter?: NullableFilterTreeNode;
  };
};
export type GetPermissionsApiResponse = /** status 200 OK */ Permissions;
export type GetPermissionsApiArg = void;
export type GetUsersMeOrganisationsCurrentSettingsApiResponse =
  /** status 200 Example response */ {
    smart_tag_ttl?: SmartTagTtlSetting;
    quarter_starts_from_month?: QuarterStartsFromMonthSetting;
  };
export type GetUsersMeOrganisationsCurrentSettingsApiArg = void;
export type GetUsersMeOrganisationsCurrentSettingsByKeyApiResponse =
  /** status 200 OK */ SmartTagTtlSetting | QuarterStartsFromMonthSetting;
export type GetUsersMeOrganisationsCurrentSettingsByKeyApiArg = {
  key: string;
};
export type PatchUsersMeOrganisationsCurrentSettingsByKeyApiResponse =
  /** status 200 OK */ SmartTagTtlSetting | QuarterStartsFromMonthSetting;
export type PatchUsersMeOrganisationsCurrentSettingsByKeyApiArg = {
  key: string;
  body: {
    value?: string;
  };
};
export type PostUsersMeOrganisationsCurrentSavingsPlansRecommendationsSummaryApiResponse =
  /** status 200 OK */ SavingsPlanRecommendationSummary;
export type PostUsersMeOrganisationsCurrentSavingsPlansRecommendationsSummaryApiArg =
  {
    body: {
      provider_organisation_id?: string | null;
    };
  };
export type PostAiSavingsOpportunitiesApiResponse =
  /** status 200 OK */ AiSavingsOpportunity;
export type PostAiSavingsOpportunitiesApiArg = {
  body: {
    type?: "all" | "kubernetes" | "right_service";
    days?: number;
  };
};
export type GetOrganisationsCurrentSavingsOpportunitiesApiResponse =
  /** status 200 OK */ SavingsOpportunity[];
export type GetOrganisationsCurrentSavingsOpportunitiesApiArg = {
  resourceId?: string;
};
export type PostOrganisationsCurrentSavingsOpportunitiesApiResponse =
  /** status 200 Savings opportunity with pagination response */ {
    total_items?: number;
    rows?: (SavingsOpportunity | SavingsOpportunityGroups)[];
    total_pages?: number;
    current_page?: number;
    monthly_savings?: number;
  };
export type PostOrganisationsCurrentSavingsOpportunitiesApiArg = {
  body: {
    filterModel: FilterModel;
    sortModel?: SortModel;
    rowGroupCols?: RowGroupCol[];
    groupKeys?: (string | null)[];
    startRow: number;
    endRow: number;
  };
};
export type GetOrganisationsCurrentSavingsOpportunitiesAiApiResponse =
  /** status 200 OK */ KubernetesAiSavingsOpportunity[];
export type GetOrganisationsCurrentSavingsOpportunitiesAiApiArg = void;
export type GetUsersMeOrganisationsCurrentSavingsPlansPotentialSavingsApiResponse =
  /** status 200 OK */ CommitmentRecommendationsPotentialSavings;
export type GetUsersMeOrganisationsCurrentSavingsPlansPotentialSavingsApiArg = {
  providerOrganisationId?: string;
};
export type GetV2UsersMeOrganisationsCurrentSavingsPlansPotentialSavingsApiResponse =
  /** status 200 OK */ SavingsPlanPotentialSavings;
export type GetV2UsersMeOrganisationsCurrentSavingsPlansPotentialSavingsApiArg =
  {
    providerOrganisationId?: string;
  };
export type GetUsersMeOrganisationsCurrentReservationsPotentialSavingsApiResponse =
  /** status 200 OK */ ReservationPotentialSavings;
export type GetUsersMeOrganisationsCurrentReservationsPotentialSavingsApiArg = {
  providerOrganisationId?: string;
};
export type GetUsersMeOrganisationsCurrentCommitmentsPotentialSavingsApiResponse =
  /** status 200 OK */ {
    savings_plan_parameters: SavingsPlanRecommendationsParameters;
    reservation_parameters: ReservationRecommendationsParameters;
    reservations_total_amount: number;
    savings_plan_total_amount: number;
    savings_amount: number;
  };
export type GetUsersMeOrganisationsCurrentCommitmentsPotentialSavingsApiArg = {
  providerOrganisationId?: string;
};
export type GetUsersMeOrganisationsCurrentSavingsPlansUtilizationRecommendationsApiResponse =
  /** status 200 OK */ SavingsPlanUtilizationRecommendation[];
export type GetUsersMeOrganisationsCurrentSavingsPlansUtilizationRecommendationsApiArg =
  {
    savingsPlanId: string;
  };
export type GetUsersMeOrganisationsCurrentSavingsPlansRecommendationsApiResponse =
  /** status 200 OK */ SavingsPlanRecommendation[];
export type GetUsersMeOrganisationsCurrentSavingsPlansRecommendationsApiArg = {
  providerOrganisationId?: string;
  accountId?: string;
  resourceType?: CommitmentResourceType;
  region?: string;
  instanceFamily?: string;
};
export type GetUsersMeOrganisationsCurrentReservationsUtilizationRecommendationsApiResponse =
  /** status 200 OK */ ReservationUtilizationRecommendation[];
export type GetUsersMeOrganisationsCurrentReservationsUtilizationRecommendationsApiArg =
  {
    reservationId: string;
  };
export type GetUsersMeOrganisationsCurrentReservationsRecommendationsApiResponse =
  /** status 200 OK */ ReservationRecommendation[];
export type GetUsersMeOrganisationsCurrentReservationsRecommendationsApiArg = {
  providerOrganisationId?: string;
  accountId?: string;
  resourceType?: CommitmentResourceType;
  region?: string;
  instanceType?: string;
  platform?: string;
};
export type GetUsersMeOrganisationsCurrentSavingsPlansApiResponse =
  /** status 200 OK */ SavingsPlanData;
export type GetUsersMeOrganisationsCurrentSavingsPlansApiArg = {
  providerOrganisationId?: string;
  dateFrom?: Date;
  dateTo?: Date;
  dateLabel?: DateLabel;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  dataGranularity?: DateDataPoint;
  coverageGrouping?: SavingsPlanCoverageGrouping;
  loadChartData?: boolean;
  loadTableData?: boolean;
  loadTotals?: boolean;
};
export type GetUsersMeOrganisationsCurrentReservationsApiResponse =
  /** status 200 OK */ ReservationData;
export type GetUsersMeOrganisationsCurrentReservationsApiArg = {
  providerOrganisationId?: string;
  dateFrom?: Date;
  dateTo?: Date;
  dateLabel?: DateLabel;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  dataGranularity?: DateDataPoint;
  coverageGrouping?: SavingsPlanCoverageGrouping;
  loadChartData?: boolean;
  loadTableData?: boolean;
  loadTotals?: boolean;
};
export type GetUsersMeOrganisationsCurrentAzureReservationsApiResponse =
  /** status 200 OK */ AzureCommitmentData;
export type GetUsersMeOrganisationsCurrentAzureReservationsApiArg = {
  dateFrom?: Date;
  dateTo?: Date;
  dateLabel?: DateLabel;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  dataGranularity?: DateDataPoint;
  coverageGrouping?: SavingsPlanCoverageGrouping;
  loadChartData?: boolean;
  loadTableData?: boolean;
  loadTotals?: boolean;
};
export type GetUsersMeOrganisationsCurrentAzureSavingsPlansApiResponse =
  /** status 200 OK */ AzureCommitmentData;
export type GetUsersMeOrganisationsCurrentAzureSavingsPlansApiArg = {
  dateFrom?: Date;
  dateTo?: Date;
  dateLabel?: DateLabel;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  dataGranularity?: DateDataPoint;
  coverageGrouping?: SavingsPlanCoverageGrouping;
  loadChartData?: boolean;
  loadTableData?: boolean;
  loadTotals?: boolean;
};
export type GetUsersMeOrganisationsCurrentCommitmentsApiResponse =
  /** status 200 OK */ CommitmentOverview;
export type GetUsersMeOrganisationsCurrentCommitmentsApiArg = {
  providerOrganisationId?: string;
  dateFrom?: Date;
  dateTo?: Date;
  dateLabel?: DateLabel;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
};
export type GetUsersMeOrganisationsCurrentAzureCommitmentsApiResponse =
  /** status 200 OK */ CommitmentOverview;
export type GetUsersMeOrganisationsCurrentAzureCommitmentsApiArg = {
  dateFrom?: Date;
  dateTo?: Date;
  dateLabel?: DateLabel;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
};
export type GetUsersMeOrganisationsCurrentSavingsPlansMinimumAvailableDateApiResponse =
  /** status 200 OK */ MinimumAvailableDate;
export type GetUsersMeOrganisationsCurrentSavingsPlansMinimumAvailableDateApiArg =
  void;
export type GetUsersMeOrganisationsCurrentReservationsDataApiResponse =
  /** status 200 OK */ ReservationFilteredData;
export type GetUsersMeOrganisationsCurrentReservationsDataApiArg = {
  providerOrganisationId?: string;
  type: CommitmentFilterType;
  dateFrom?: Date;
  dateTo?: Date;
  dateLabel?: DateLabel;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  coverageGrouping?: SavingsPlanCoverageGrouping;
  resourceType?: CommitmentResourceType;
  instanceType?: string;
  region?: string;
  platform?: string;
  accountId?: string;
  commitmentId?: string;
  commitmentType?: CommitmentType;
  dataGranularity?: DateDataPoint;
};
export type GetUsersMeOrganisationsCurrentAzureReservationsDataApiResponse =
  /** status 200 OK */ AzureCommitmentFilteredData;
export type GetUsersMeOrganisationsCurrentAzureReservationsDataApiArg = {
  providerOrganisationId?: string;
  type: CommitmentFilterType;
  dateFrom?: Date;
  dateTo?: Date;
  dateLabel?: DateLabel;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  coverageGrouping?: SavingsPlanCoverageGrouping;
  resourceType?: string;
  productName?: string;
  region?: string;
  unitOfMeasure?: string;
  accountId?: string;
  commitmentId?: string;
  dataGranularity?: DateDataPoint;
};
export type GetUsersMeOrganisationsCurrentAzureSavingsPlansDataApiResponse =
  /** status 200 OK */ AzureCommitmentFilteredData;
export type GetUsersMeOrganisationsCurrentAzureSavingsPlansDataApiArg = {
  providerOrganisationId?: string;
  type: CommitmentFilterType;
  dateFrom?: Date;
  dateTo?: Date;
  dateLabel?: DateLabel;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  coverageGrouping?: SavingsPlanCoverageGrouping;
  resourceType?: string;
  productName?: string;
  region?: string;
  unitOfMeasure?: string;
  accountId?: string;
  commitmentId?: string;
  dataGranularity?: DateDataPoint;
};
export type GetUsersMeOrganisationsCurrentSavingsPlansDataApiResponse =
  /** status 200 OK */ SavingsPlanFilteredData;
export type GetUsersMeOrganisationsCurrentSavingsPlansDataApiArg = {
  providerOrganisationId?: string;
  type: CommitmentFilterType;
  dateFrom?: Date;
  dateTo?: Date;
  dateLabel?: DateLabel;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  coverageGrouping?: SavingsPlanCoverageGrouping;
  resourceType?: CommitmentResourceType;
  instanceFamily?: string;
  region?: string;
  accountId?: string;
  savingsPlanId?: string;
  commitmentId?: string;
  commitmentType?: CommitmentType;
  dataGranularity?: DateDataPoint;
};
export type PostUsersMeSchedulesNextRunDateApiResponse = /** status 200 OK */ {
  next_run_date_time: Date;
  future_run_dates?: FutureRunDate[] | null;
};
export type PostUsersMeSchedulesNextRunDateApiArg = {
  body: {
    cron: string;
    start_date_time: NullableDate;
    end_date_time?: NullableDate;
    schedule_frequency?: ScheduleFrequency;
    schedule_interval?: number;
    time_zone: string;
  };
};
export type PostUsersMeOffHoursSchedulesNextRunDateApiResponse =
  /** status 200 OK */ {
    next_start_run_date_time: Date;
    next_stop_run_date_time: NullableDate;
  };
export type PostUsersMeOffHoursSchedulesNextRunDateApiArg = {
  body: {
    start_cron: string;
    stop_cron: string;
    start_date_time: NullableDate;
    end_date_time?: NullableDate;
    time_zone: string;
  };
};
export type GetUsersMeAccountsByAccountIdAndTypeResourcesMetadataApiResponse =
  /** status 200 OK */ {
    total_cost?: number;
    most_used_region?: Region;
    average_age?: string;
  };
export type GetUsersMeAccountsByAccountIdAndTypeResourcesMetadataApiArg = {
  accountId: string;
  /** Resource Type */
  type:
    | "ec2"
    | "ebs"
    | "elb"
    | "eip"
    | "rds"
    | "elc"
    | "s3"
    | "vm"
    | "disk"
    | "lb"
    | "ip"
    | "sql"
    | "az_disk"
    | "az_ip"
    | "az_lb"
    | "az_vm"
    | "az_sql"
    | "asg"
    | "mig"
    | "mig_vm"
    | "asg_ec2"
    | "eks"
    | "eks_ec2"
    | "node_group"
    | "az_vmss"
    | "az_vmss_vm"
    | "gke"
    | "node_pool"
    | "gke_vm"
    | "az_aks"
    | "az_node_pool"
    | "az_aks_vm"
    | "rds_snapshot"
    | "ebs_snapshot"
    | "rds_snapshot_source"
    | "dynamo_db_table"
    | "dynamo_db_backup"
    | "dynamo_db_backup_source"
    | "dax_cluster"
    | "nat_gateway"
    | "ecs"
    | "ecs_workload"
    | "kubernetes_node"
    | "kubernetes_namespace"
    | "kubernetes_deployment"
    | "kubernetes_stateful_set"
    | "kubernetes_daemon_set"
    | "kubernetes_replica_set"
    | "kubernetes_job"
    | "kubernetes_pod";
};
export type GetUsersMeAccountsByAccountIdMetadataApiResponse =
  /** status 200 Example response */ {
    spending: number;
    total_saved: number;
    estimated_waste: number;
    most_expensive_resource_type: ResourceType;
    total_spending: number;
    average_age: string;
    most_used_region?: Region;
  };
export type GetUsersMeAccountsByAccountIdMetadataApiArg = {
  accountId: string;
};
export type GetUsersMeOrganisationsCurrentApiKeysApiResponse =
  /** status 200 Example response */ ApiKey[];
export type GetUsersMeOrganisationsCurrentApiKeysApiArg = void;
export type PostUsersMeOrganisationsCurrentApiKeysApiResponse =
  /** status 201 Example response */ {
    id: string;
    organisation_id: string;
    api_key: string;
    name: string;
    created_at: string;
    expires_at: string;
    last_used_at: string | null;
  };
export type PostUsersMeOrganisationsCurrentApiKeysApiArg = {
  body: {
    name: string;
    expires_in_days: number;
  };
};
export type DeleteUsersMeOrganisationsCurrentApiKeysByKeyIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentApiKeysByKeyIdApiArg = {
  keyId: string;
};
export type GetUsersMeAccountByAccountIdDailyOffHoursRecommendationsAndRecommendationIdApiResponse =
  /** status 200 OK */ OrganisationDailyOffHoursRecommendation2;
export type GetUsersMeAccountByAccountIdDailyOffHoursRecommendationsAndRecommendationIdApiArg =
  {
    recommendationId: string;
    accountId: string;
  };
export type GetUsersMeAccountByAccountIdWeeklyOffHoursRecommendationsAndRecommendationIdApiResponse =
  /** status 200 OK */ OrganisationWeeklyOffHoursRecommendation2;
export type GetUsersMeAccountByAccountIdWeeklyOffHoursRecommendationsAndRecommendationIdApiArg =
  {
    recommendationId: string;
    accountId: string;
  };
export type PatchUsersMeAccountByAccountIdRecommendationsResourcesAndResourceIdApiResponse =
  /** status 200 OK */ void;
export type PatchUsersMeAccountByAccountIdRecommendationsResourcesAndResourceIdApiArg =
  {
    accountId: string;
    resourceId: string;
    body: {
      dismissed: boolean;
    };
  };
export type GetUsersMeOrganisationsCurrentDimensionsApiResponse =
  /** status 200 OK */ DimensionWithCosts[];
export type GetUsersMeOrganisationsCurrentDimensionsApiArg = void;
export type PostUsersMeOrganisationsCurrentDimensionsApiResponse =
  /** status 201 OK */ Dimension;
export type PostUsersMeOrganisationsCurrentDimensionsApiArg = {
  body: {
    name?: string;
  };
};
export type GetUsersMeOrganisationsCurrentDimensionsByDimensionIdApiResponse =
  /** status 200 OK */ Dimension;
export type GetUsersMeOrganisationsCurrentDimensionsByDimensionIdApiArg = {
  dimensionId: string;
};
export type PutUsersMeOrganisationsCurrentDimensionsByDimensionIdApiResponse =
  /** status 200 OK */ Dimension;
export type PutUsersMeOrganisationsCurrentDimensionsByDimensionIdApiArg = {
  dimensionId: string;
  body: {
    name?: string;
  };
};
export type DeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdApiArg = {
  dimensionId: string;
};
export type GetUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesApiResponse =
  /** status 200 OK */ Category[];
export type GetUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesApiArg =
  {
    dimensionId: string;
  };
export type PostUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesApiResponse =
  /** status 201 OK */ Category;
export type PostUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesApiArg =
  {
    dimensionId: string;
    body: {
      id?: string;
      name: string | null;
      filter: CategoryFilter;
    };
  };
export type GetUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdApiResponse =
  /** status 200 OK */ Category;
export type GetUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdApiArg =
  {
    dimensionId: string;
    categoryId: string;
  };
export type PutUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdApiResponse =
  /** status 200 OK */ Category;
export type PutUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdApiArg =
  {
    dimensionId: string;
    categoryId: string;
    body: {
      name?: string;
      type?: "account_based" | "filter_based";
      filter?: CategoryFilter;
    };
  };
export type DeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdApiArg =
  {
    dimensionId: string;
    categoryId: string;
  };
export type GetUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsApiResponse =
  /** status 200 OK */ DimensionSharedCost[];
export type GetUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsApiArg =
  {
    dimensionId: string;
  };
export type PostUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsApiResponse =
  /** status 201 Created */ DimensionSharedCost;
export type PostUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsApiArg =
  {
    dimensionId: string;
    body: {
      id: string;
      name: string;
      filter_tree: FilterTreeNode;
      distribution_type: DistributionType;
      share_amounts?: ShareAmount[];
    };
  };
export type GetUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdApiResponse =
  /** status 200 OK */ DimensionSharedCost;
export type GetUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdApiArg =
  {
    dimensionId: string;
    sharedCostId: string;
  };
export type PutUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdApiResponse =
  /** status 200 OK */ DimensionSharedCost;
export type PutUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdApiArg =
  {
    dimensionId: string;
    sharedCostId: string;
    body: {
      id: string;
      name: string;
      filter_tree: FilterTreeNode;
      distribution_type: DistributionType;
      share_amounts?: ShareAmount[];
    };
  };
export type DeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdApiArg =
  {
    dimensionId: string;
    sharedCostId: string;
  };
export type PostUsersMeWebhookIntegrationsTestsApiResponse =
  /** status 200 OK */ void;
export type PostUsersMeWebhookIntegrationsTestsApiArg = {
  body: {
    url?: string;
    content_type?: string;
  };
};
export type GetV2UsersMeOrganisationsCurrentUsersApiResponse =
  /** status 200 OK */ User[];
export type GetV2UsersMeOrganisationsCurrentUsersApiArg = {
  /** User role */
  role?: "owner" | "admin";
  statuses?: string;
};
export type GetUsersMeOrganisationsCurrentChartApiResponse =
  /** status 200 OK */ Chart[];
export type GetUsersMeOrganisationsCurrentChartApiArg = void;
export type PostUsersMeOrganisationsCurrentChartApiResponse =
  /** status 201 Created */ Chart;
export type PostUsersMeOrganisationsCurrentChartApiArg = {
  body: {
    name: string;
    payload: object;
  };
};
export type GetUsersMeOrganisationsCurrentChartByChartIdApiResponse =
  /** status 200 OK */ Chart;
export type GetUsersMeOrganisationsCurrentChartByChartIdApiArg = {
  chartId: string;
};
export type PatchUsersMeOrganisationsCurrentChartByChartIdApiResponse =
  /** status 200 OK */ Chart;
export type PatchUsersMeOrganisationsCurrentChartByChartIdApiArg = {
  chartId: string;
  body: {
    name?: string;
    payload?: object;
  };
};
export type DeleteUsersMeOrganisationsCurrentChartByChartIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentChartByChartIdApiArg = {
  chartId: string;
};
export type PostUsersMeAccountsByTypeResourcesApiResponse =
  /** status 200 Example response */ {
    account_id: string;
    provider_account_id: string;
    provider_account_name: string | null;
    resources: {
      id: string;
      provider_unique_identifier: string;
      name: string | null;
    }[];
  }[];
export type PostUsersMeAccountsByTypeResourcesApiArg = {
  /** Resource Type */
  type:
    | "ec2"
    | "ebs"
    | "elb"
    | "eip"
    | "rds"
    | "elc"
    | "s3"
    | "vm"
    | "disk"
    | "lb"
    | "ip"
    | "sql"
    | "az_disk"
    | "az_ip"
    | "az_lb"
    | "az_vm"
    | "az_sql"
    | "asg"
    | "mig"
    | "mig_vm"
    | "asg_ec2"
    | "eks"
    | "eks_ec2"
    | "node_group"
    | "az_vmss"
    | "az_vmss_vm"
    | "gke"
    | "node_pool"
    | "gke_vm"
    | "az_aks"
    | "az_node_pool"
    | "az_aks_vm"
    | "rds_snapshot"
    | "ebs_snapshot"
    | "rds_snapshot_source"
    | "dynamo_db_table"
    | "dynamo_db_backup"
    | "dynamo_db_backup_source"
    | "dax_cluster"
    | "nat_gateway"
    | "ecs"
    | "ecs_workload"
    | "kubernetes_node"
    | "kubernetes_namespace"
    | "kubernetes_deployment"
    | "kubernetes_stateful_set"
    | "kubernetes_daemon_set"
    | "kubernetes_replica_set"
    | "kubernetes_job"
    | "kubernetes_pod";
  /** Fetch resources by account id list */
  body: {
    account_ids: string[];
  };
};
export type GetUsersMeProvidersByProviderAccountsResourcesVisibilitiesApiResponse =
  /** status 200 OK */ AccountsVisibilities[];
export type GetUsersMeProvidersByProviderAccountsResourcesVisibilitiesApiArg = {
  /** Cloud Provider */
  provider: CloudProvider;
  /** Account ids */
  accountIds: string;
};
export type PostUsersMeAskAiQuestionsApiResponse =
  /** status 200 OK */ AskAiAnswer;
export type PostUsersMeAskAiQuestionsApiArg = {
  body: {
    question: string;
    chat_id?: string;
  };
};
export type GetUsersMeAskAiChatCreateApiResponse =
  /** status 200 Chat created successfully */ AskAiCreateChatResponse;
export type GetUsersMeAskAiChatCreateApiArg = void;
export type GetUsersMeOrganisationsCurrentResourcesRightSizingRecommendationsApiResponse =
  /** status 200 OK */ RightSizingRecommendation[];
export type GetUsersMeOrganisationsCurrentResourcesRightSizingRecommendationsApiArg =
  {
    /** Flag for getting dismissed recommendations */
    isDismissed?: boolean;
  };
export type GetUsersMeAccountsByAccountIdRightSizingRecommendationsAndRecommendationIdApiResponse =
  /** status 200 OK */ RightSizingRecommendationDetails;
export type GetUsersMeAccountsByAccountIdRightSizingRecommendationsAndRecommendationIdApiArg =
  {
    accountId: string;
    recommendationId: string;
    numberOfMetricsDataPoints?: number;
  };
export type GetUsersMeOrganisationsCurrentFilterSetsApiResponse =
  /** status 200 OK */ FilterSet[];
export type GetUsersMeOrganisationsCurrentFilterSetsApiArg = void;
export type PostUsersMeOrganisationsCurrentFilterSetsV2ApiResponse =
  /** status 201 Created */ FilterSet;
export type PostUsersMeOrganisationsCurrentFilterSetsV2ApiArg = {
  body: {
    name: string;
    filters: ResourceFilters[];
    cloud_provider: ProviderType;
    priority_account_id?: string | null;
    accounts_to_apply?: string[] | null;
  };
};
export type GetUsersMeOrganisationsCurrentCostAllocationTagsApiResponse =
  /** status 200 Ok */ string[];
export type GetUsersMeOrganisationsCurrentCostAllocationTagsApiArg = {
  /** Cost allocation tag key */
  tagKey: string;
  /** Provider Account ids */
  accountIds: string;
};
export type GetUsersMeOrganisationsCurrentResourceExplorerProvidersByProviderTagValuesApiResponse =
  /** status 200 Ok */ string[];
export type GetUsersMeOrganisationsCurrentResourceExplorerProvidersByProviderTagValuesApiArg =
  {
    /** Cloud Provider */
    provider: "gcp" | "aws" | "azure" | "kubernetes" | "global";
    /** Cost allocation tag key */
    tagKey: string;
    /** Provider Account ids */
    accountIds: string;
  };
export type PostUsersMeOrganisationsCurrentTrackedResourcesApiResponse =
  /** status 200 Tracked resource */ {
    account_ids: string[];
    resource_type: ResourceType;
    resource_ids: string[];
  }[];
export type PostUsersMeOrganisationsCurrentTrackedResourcesApiArg = {
  /** Content-type */
  "Content-Type"?: string;
  body: LoadTrackedResourcesForView | LoadTrackedResourcesForCategories;
};
export type GetV2UsersMeOrganisationsCurrentResourceExplorerHierarchyApiResponse =
  /** status 200 Ok */ {
    visible_only_to_me?: (ResourceExplorer | ReFolderV2)[];
    visible_to_everyone?: (ResourceExplorer | ReFolderV2)[];
  };
export type GetV2UsersMeOrganisationsCurrentResourceExplorerHierarchyApiArg = {
  /** Content-type */
  "Content-Type"?: string;
};
export type PatchV2UsersMeOrganisationsCurrentResourceExplorerHierarchyApiResponse =
  /** status 200 Ok */ ResourceExplorer | ReFolderV2;
export type PatchV2UsersMeOrganisationsCurrentResourceExplorerHierarchyApiArg =
  {
    body: {
      id: string;
      type?: "dashboard" | "folder" | "view";
      parent_id?: string;
      index?: number;
      visibility: "visible_only_to_me" | "visible_to_everyone";
    };
  };
export type GetUsersMeOrganisationsCurrentResourceExplorerViewsApiResponse =
  /** status 200 Ok */ ResourceExplorer[];
export type GetUsersMeOrganisationsCurrentResourceExplorerViewsApiArg = {
  /** Content-type */
  "Content-Type"?: string;
};
export type PostV2UsersMeOrganisationsCurrentResourceExplorerViewsApiResponse =
  /** status 201 Created */ ResourceExplorer;
export type PostV2UsersMeOrganisationsCurrentResourceExplorerViewsApiArg = {
  body: {
    name: string;
    filter_tree?: FilterTreeNode;
    data?: ResourceExplorerData;
    visibility: ("visible_only_to_me" | "visible_to_everyone") | null;
    chart_settings?: ChartSettings;
  };
};
export type PostV3UsersMeOrganisationsCurrentResourceExplorerFoldersApiResponse =
  /** status 201 Created */ ReFolderV2;
export type PostV3UsersMeOrganisationsCurrentResourceExplorerFoldersApiArg = {
  body: {
    name: string;
    visibility: ("visible_only_to_me" | "visible_to_everyone") | null;
  };
};
export type GetUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResourceExplorerResourcesApiResponse =
  /** status 200 Ok */ ResourceExplorerResourceDetail;
export type GetUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResourceExplorerResourcesApiArg =
  {
    /** Content-type */
    "Content-Type"?: string;
    /** Cloud Provider */
    provider: "gcp" | "aws" | "azure" | "kubernetes" | "global";
    /** Account Id */
    accountId: string;
    resourceId: string;
  };
export type DeleteUsersMeOrganisationsCurrentFilterSetsByFilterSetIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentFilterSetsByFilterSetIdApiArg = {
  filterSetId: string;
};
export type PostUsersMeOrganisationsCurrentWidgetsResourceExplorerApiResponse =
  /** status 200 Ok */ ResourceExplorerWidget;
export type PostUsersMeOrganisationsCurrentWidgetsResourceExplorerApiArg = {
  /** Content-type */
  "Content-Type"?: string;
  resourceExplorerFilterSchema: ResourceExplorerFilterSchema;
};
export type GetUsersMeOrganisationsCurrentBillingTotalCostApiResponse =
  /** status 200 Ok */ BillingTotalCost;
export type GetUsersMeOrganisationsCurrentBillingTotalCostApiArg = void;
export type PostUsersMeOrganisationsCurrentReportsOneTimeApiResponse =
  /** status 200 OK */ void;
export type PostUsersMeOrganisationsCurrentReportsOneTimeApiArg = {
  oneTimeReport: OneTimeReport;
};
export type PostUsersMeOrganisationsCurrentResourceExplorerApiResponse =
  /** status 200 Ok */ ResourceExplorerWidget;
export type PostUsersMeOrganisationsCurrentResourceExplorerApiArg = {
  /** Content-type */
  "Content-Type"?: string;
  resourceExplorerFilterSchema: ResourceExplorerFilterSchema;
};
export type GetUsersMeOrganisationsCurrentWidgetsByWidgetIdSummaryApiResponse =
  /** status 200 Ok */ ResourceExplorerInsights;
export type GetUsersMeOrganisationsCurrentWidgetsByWidgetIdSummaryApiArg = {
  widgetId: string;
  language?: string;
};
export type PostUsersMeOrganisationsCurrentResourceExplorerSummaryApiResponse =
  /** status 200 Ok */ ResourceExplorerInsights;
export type PostUsersMeOrganisationsCurrentResourceExplorerSummaryApiArg = {
  /** Content-type */
  "Content-Type"?: string;
  resourceExplorerFilterSchema: ResourceExplorerFilterSchema;
};
export type PostUsersMeOrganisationsCurrentResourceExplorerAnomaliesSummaryApiResponse =
  /** status 200 Ok */ ResourceExplorerAnomaliesInsights;
export type PostUsersMeOrganisationsCurrentResourceExplorerAnomaliesSummaryApiArg =
  {
    /** Content-type */
    "Content-Type"?: string;
    resourceExplorerFilterSchema: ResourceExplorerFilterSchema;
  };
export type GetUsersMeOrganisationsCurrentResourceExplorerAnomalyByAnomalyIdApiResponse =
  /** status 200 Ok */ ResourceExplorerAnomalyInsights;
export type GetUsersMeOrganisationsCurrentResourceExplorerAnomalyByAnomalyIdApiArg =
  {
    /** Anomaly Id */
    anomalyId: string;
    language?: string;
  };
export type PostUsersMeOrganisationsCurrentResourceExplorerGranularCostsApiResponse =
  /** status 200 Ok */ ResourceExplorerGranularCost;
export type PostUsersMeOrganisationsCurrentResourceExplorerGranularCostsApiArg =
  {
    /** Content-type */
    "Content-Type"?: string;
    resourceExplorerFilterSchema: ResourceExplorerFilterSchema;
  };
export type PostUsersMeOrganisationsCurrentWidgetsResourceExplorerLiveUsageTotalCostApiResponse =
  /** status 200 Ok */ number;
export type PostUsersMeOrganisationsCurrentWidgetsResourceExplorerLiveUsageTotalCostApiArg =
  {
    /** Content-type */
    "Content-Type"?: string;
    resourceExplorerFilterSchema: ResourceExplorerFilterSchema;
  };
export type GetUsersMeOrganisationsCurrentResourceExplorerPossibleFiltersApiResponse =
  /** status 200 A JSON object of Resource Explorer Possible Filters */ ResourceExplorerPossibleFiltersV2;
export type GetUsersMeOrganisationsCurrentResourceExplorerPossibleFiltersApiArg =
  {
    /** Providers Only */
    providersOnly?: boolean;
  };
export type GetUsersMeOrganisationsCurrentResourceExplorerPossibleGroupingsApiResponse =
  /** status 200 A JSON object of Resource Explorer Possible Filters */ ResourceExplorerPossibleGroupings;
export type GetUsersMeOrganisationsCurrentResourceExplorerPossibleGroupingsApiArg =
  void;
export type GetUsersMeOrganisationsCurrentResourceExplorerPossibleColumnsApiResponse =
  /** status 200 A JSON object of Resource Explorer Possible Columns */ ResourceExplorerPossibleColumns;
export type GetUsersMeOrganisationsCurrentResourceExplorerPossibleColumnsApiArg =
  void;
export type GetUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValuesApiResponse =
  /** status 200 A JSON object of Resource Explorer Possible Filter Values */ PossibleFilterValues;
export type GetUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValuesApiArg =
  {
    filterProvider: ResourceExplorerFilterProvider;
    filterType: ResourceExplorerDynamicFilterItemType;
    key?: string;
  };
export type PostUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsvApiResponse =
  /** status 200 Ok */ {
    hash?: string;
  };
export type PostUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsvApiArg =
  {
    /** Content-type */
    "Content-Type"?: string;
    resourceExplorerFilterSchema: ResourceExplorerFilterSchema;
  };
export type GetUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsvApiResponse =
  /** status 200 Ok */ {
    url?: string;
  };
export type GetUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsvApiArg =
  {
    hash?: string;
  };
export type PostUsersMeOrganisationsCurrentResourceExplorerGranularCostsDownloadCsvApiResponse =
  /** status 200 Ok */ {
    hash?: string;
  };
export type PostUsersMeOrganisationsCurrentResourceExplorerGranularCostsDownloadCsvApiArg =
  {
    /** Content-type */
    "Content-Type"?: string;
    resourceExplorerFilterSchema: ResourceExplorerFilterSchema;
  };
export type GetUsersMeOrganisationsCurrentResourceCreatorsApiResponse =
  /** status 200 OK */ string[];
export type GetUsersMeOrganisationsCurrentResourceCreatorsApiArg = {
  accountIds: string;
  /** Resource Type */
  type:
    | "ec2"
    | "ebs"
    | "elb"
    | "eip"
    | "rds"
    | "elc"
    | "s3"
    | "vm"
    | "disk"
    | "lb"
    | "ip"
    | "sql"
    | "az_disk"
    | "az_ip"
    | "az_lb"
    | "az_vm"
    | "az_sql"
    | "asg"
    | "mig"
    | "mig_vm"
    | "asg_ec2"
    | "eks"
    | "eks_ec2"
    | "node_group"
    | "az_vmss"
    | "az_vmss_vm"
    | "gke"
    | "node_pool"
    | "gke_vm"
    | "az_aks"
    | "az_node_pool"
    | "az_aks_vm"
    | "rds_snapshot"
    | "ebs_snapshot"
    | "rds_snapshot_source"
    | "dynamo_db_table"
    | "dynamo_db_backup"
    | "dynamo_db_backup_source"
    | "dax_cluster"
    | "nat_gateway"
    | "ecs"
    | "ecs_workload"
    | "kubernetes_node"
    | "kubernetes_namespace"
    | "kubernetes_deployment"
    | "kubernetes_stateful_set"
    | "kubernetes_daemon_set"
    | "kubernetes_replica_set"
    | "kubernetes_job"
    | "kubernetes_pod";
};
export type PostUsersMeJiraIntegrationsTestsApiResponse = unknown;
export type PostUsersMeJiraIntegrationsTestsApiArg = {
  body: {
    url?: string;
    email?: string;
    apiToken?: string;
  };
};
export type PostUsersMeJiraIntegrationsAutoCompleteUsersDataApiResponse =
  /** status 200 Fetch jira user autocomplete data */ {
    name: string;
    id: string;
    email: string;
    avatar: string;
  }[];
export type PostUsersMeJiraIntegrationsAutoCompleteUsersDataApiArg = {
  body: {
    api_token: string;
    url: string;
    email: string;
    auto_complete_url: string;
  };
};
export type PostUsersMeJiraIntegrationsByIntegrationIdIssuesApiResponse =
  /** status 201 Example response */ {
    link: string;
  };
export type PostUsersMeJiraIntegrationsByIntegrationIdIssuesApiArg = {
  integrationId: string;
  body: {
    resource_ids: string[];
    project_key: string;
    issue_type_id: string;
    summary: string;
    description: string | null;
    fields: {
      [key: string]: any;
    };
  };
};
export type PostUsersMeJiraIntegrationsProjectsApiResponse =
  /** status 200 Jira projects response */ {
    id: string;
    name: string;
    key: string;
    avatar: string;
  }[];
export type PostUsersMeJiraIntegrationsProjectsApiArg = {
  body: {
    api_token: string;
    url: string;
    email: string;
  };
};
export type PostUsersMeJiraIntegrationsProjectsByProjectIdIssueTypesApiResponse =
  /** status 200 Jira issue types response */ {
    /** issue type id */
    id: string;
    /** issue type name */
    name: string;
  }[];
export type PostUsersMeJiraIntegrationsProjectsByProjectIdIssueTypesApiArg = {
  /** Jira project id in query */
  projectId: string;
  body: {
    api_token: string;
    url: string;
    email: string;
  };
};
export type PostUsersMeJiraIntegrationsProjectsByProjectIdIssueTypesAndIssueTypeFieldsApiResponse =
  /** status 200 Jira issue type fields response */ {
    key: string;
    name: string;
    schema: {
      type: string;
      item_type: string | null;
      custom_type: string | null;
    };
    options:
      | (string[] | null)
      | (
          | {
              id: string;
              value: string | null;
              name: string | null;
              children:
                | {
                    id: string;
                    value: string | null;
                    name: string | null;
                  }[]
                | null;
            }[]
          | null
        );
    auto_complete_url: string | null;
  }[];
export type PostUsersMeJiraIntegrationsProjectsByProjectIdIssueTypesAndIssueTypeFieldsApiArg =
  {
    /** Jira project id in query */
    projectId: string;
    /** Jira Issue Type in query */
    issueType: string;
    body: {
      api_token: string;
      url: string;
      email: string;
    };
  };
export type PostUsersMeJiraIntegrationsByIntegrationIdProjectsApiResponse =
  /** status 200 Jira projects response */ {
    id: string;
    name: string;
    key: string;
    avatar: string;
  }[];
export type PostUsersMeJiraIntegrationsByIntegrationIdProjectsApiArg = {
  /** Integration id */
  integrationId: string;
};
export type PostUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypesApiResponse =
  /** status 200 Jira issue types response */ {
    /** issue type id */
    id: string;
    /** issue type name */
    name: string;
  }[];
export type PostUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypesApiArg =
  {
    /** Integration id */
    integrationId: string;
    /** Jira project id in query */
    projectId: string;
  };
export type PostUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypesIssueTypeFieldsApiResponse =
  /** status 200 Jira issue type fields response */ {
    key: string;
    name: string;
    schema: {
      type: string;
      item_type: string | null;
      custom_type: string | null;
    };
    options:
      | (string[] | null)
      | (
          | {
              id: string;
              value: string | null;
              name: string | null;
              children:
                | {
                    id: string;
                    value: string | null;
                    name: string | null;
                  }[]
                | null;
            }[]
          | null
        );
    auto_complete_url: string | null;
  }[];
export type PostUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypesIssueTypeFieldsApiArg =
  {
    /** Integration id */
    integrationId: string;
    /** Jira project id in query */
    projectId: string;
    /** Jira Issue Type in query */
    issueType: string;
  };
export type GetUsersMeProvidersAzureResourcesTypesByResourceTypeResourceGroupsApiResponse =
  /** status 200 OK */ string[];
export type GetUsersMeProvidersAzureResourcesTypesByResourceTypeResourceGroupsApiArg =
  {
    resourceType: "az_disk" | "az_ip" | "az_vm";
    accountIds: string;
  };
export type PostUsersMeJiraIntegrationsByIntegrationIdAutoCompleteUsersDataApiResponse =
  /** status 200 Fetch jira user autocomplete data */ {
    name: string;
    id: string;
    email: string;
    avatar: string;
  }[];
export type PostUsersMeJiraIntegrationsByIntegrationIdAutoCompleteUsersDataApiArg =
  {
    integrationId: string;
    body: {
      auto_complete_url: string;
    };
  };
export type PostUsersMeSlackIntegrationsByIntegrationIdMessageApiResponse =
  /** status 200 OK */ void;
export type PostUsersMeSlackIntegrationsByIntegrationIdMessageApiArg = {
  integrationId: string;
  body: {
    metadata?: string[] | null;
    resources: object[];
    message?: string | null;
    conversations?: SlackConversation[] | null;
    mentions?: SlackConversation[] | null;
  };
};
export type GetUsersMeSlackIntegrationsByIntegrationIdConversationsApiResponse =
  /** status 200 OK */ SlackConversation[];
export type GetUsersMeSlackIntegrationsByIntegrationIdConversationsApiArg = {
  integrationId: string;
  search?: string;
};
export type PostUsersMeSlackInstallationAttemptsApiResponse =
  /** status 201 Created */ SlackAppInstallationAttempt;
export type PostUsersMeSlackInstallationAttemptsApiArg = void;
export type PostUsersMeEmailsMessageApiResponse = /** status 201 Sent */ void;
export type PostUsersMeEmailsMessageApiArg = {
  body: {
    emails: Emails;
    resources: object[];
    message?: MessageWithSubject;
  };
};
export type PostV2UsersMeEmailsMessageApiResponse = /** status 201 Sent */ void;
export type PostV2UsersMeEmailsMessageApiArg = {
  body: {
    emails: Emails;
    resources: ResourceWithVisibility[][];
    message?: MessageWithSubject;
  };
};
export type GetUsersMeProviderConnectionsSnowflakeQueryApiResponse =
  /** status 200 OK. Save private key id and ask user to fill the form */ SnowflakeConnectionQuery;
export type GetUsersMeProviderConnectionsSnowflakeQueryApiArg = void;
export type PostOrganisationsCurrentAccountsResourceTypesStatusesApiResponse =
  /** status 201 Created */ AccountResourceTypeStatusesResponse[];
export type PostOrganisationsCurrentAccountsResourceTypesStatusesApiArg = {
  body: {
    account_ids?: string[];
  };
};
export type GetUsersMeAccountsResourceTypesByResourceTypeInstanceTypesApiResponse =
  /** status 200 OK */ string[];
export type GetUsersMeAccountsResourceTypesByResourceTypeInstanceTypesApiArg = {
  resourceType: "ec2" | "vm" | "az_vm" | "dax_cluster";
};
export type GetUsersMeAccountsResourceTypesByResourceTypeSupportTypesApiResponse =
  /** status 200 OK */ string[];
export type GetUsersMeAccountsResourceTypesByResourceTypeSupportTypesApiArg = {
  resourceType: "eks";
};
export type GetUsersMeAccountsResourceTypesByResourceTypeInstanceFamiliesApiResponse =
  /** status 200 OK */ string[];
export type GetUsersMeAccountsResourceTypesByResourceTypeInstanceFamiliesApiArg =
  {
    resourceType: "ec2" | "vm" | "az_vm";
  };
export type GetUsersMeCurrentPreferencesApiResponse =
  /** status 200 OK */ UserPreference[];
export type GetUsersMeCurrentPreferencesApiArg = void;
export type PatchUsersMeCurrentPreferenceByKeyApiResponse =
  /** status 200 OK */ UserPreference;
export type PatchUsersMeCurrentPreferenceByKeyApiArg = {
  key: string;
  body: {
    value?: string | null;
  };
};
export type GetUsersMeCurrentPreferenceByKeyApiResponse =
  /** status 200 OK */ UserPreference;
export type GetUsersMeCurrentPreferenceByKeyApiArg = {
  key: string;
};
export type GetUsersMeCurrentDigestPreferencesApiResponse =
  /** status 200 OK */ UserDigestPreferences;
export type GetUsersMeCurrentDigestPreferencesApiArg = void;
export type PatchUsersMeCurrentDigestPreferencesApiResponse =
  /** status 200 OK */ UserDigestPreferences;
export type PatchUsersMeCurrentDigestPreferencesApiArg = {
  body: {
    monthly_digest?: boolean | null;
    weekly_digest?: boolean | null;
  };
};
export type DeleteUsersMeOrganisationsCurrentBudgetsByBudgetIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentBudgetsByBudgetIdApiArg = {
  "budget-id": string;
};
export type PatchUsersMeOrganisationsCurrentBudgetsByBudgetIdApiResponse =
  /** status 200 updated */ Budget;
export type PatchUsersMeOrganisationsCurrentBudgetsByBudgetIdApiArg = {
  "budget-id": string;
  body: {
    name?: string;
    integrations?: NestedIntegration[] | null;
    notifications?:
      | (
          | NotificationEmail
          | NotificationSlack
          | NotificationWebhook
          | NotificationJira
        )[]
      | null;
    email_to?: Emails | (any | null);
    view_id?: string | null;
    thresholds?: Threshold[];
    amount?: number | null;
    planned_amounts?: number[] | null;
    type?: BudgetType;
    receive_updates?: boolean | null;
    filter_tree?: NullableFilterTreeNode;
  };
};
export type GetUsersMeOrganisationsCurrentBudgetsByBudgetIdApiResponse =
  /** status 200 get budget */ Budget;
export type GetUsersMeOrganisationsCurrentBudgetsByBudgetIdApiArg = {
  "budget-id": string;
};
export type GetUsersMeOrganisationsCurrentBudgetsByBudgetIdAccumulatedCostsApiResponse =
  /** status 200 Get budget accumulated costs */ AccumulatedCost;
export type GetUsersMeOrganisationsCurrentBudgetsByBudgetIdAccumulatedCostsApiArg =
  {
    "budget-id": string;
    dateFrom: string;
    dateTo: string;
  };
export type GetUsersMeOrganisationsCurrentBudgetsByBudgetIdDetailsApiResponse =
  /** status 200 get budget */ BudgetDetails;
export type GetUsersMeOrganisationsCurrentBudgetsByBudgetIdDetailsApiArg = {
  "budget-id": string;
};
export type GetUsersMeOrganisationsCurrentBudgetsApiResponse =
  /** status 200 OK */ Budget[];
export type GetUsersMeOrganisationsCurrentBudgetsApiArg = void;
export type PostUsersMeOrganisationsCurrentBudgetsApiResponse =
  /** status 201 Created */ Budget;
export type PostUsersMeOrganisationsCurrentBudgetsApiArg = {
  body: {
    name: string;
    start_date: string;
    end_date: string | null;
    period: BudgetPeriod;
    integrations?: NestedIntegration[] | null;
    notifications?:
      | (
          | NotificationEmail
          | NotificationSlack
          | NotificationWebhook
          | NotificationJira
        )[]
      | null;
    thresholds: Threshold[];
    amount: number | null;
    email_to?: Emails | (any | null);
    receive_updates: boolean;
    type: BudgetType;
    planned_amounts: number[] | null;
    view_id?: string | null;
    filter_tree?: NullableFilterTreeNode;
  };
};
export type GetUsersMeOrganisationsCurrentViewsByViewIdBudgetsApiResponse =
  /** status 200 Views budget */ Budget;
export type GetUsersMeOrganisationsCurrentViewsByViewIdBudgetsApiArg = {
  "view-id": string;
};
export type PostUsersMeOrganisationsCurrentViewsByViewIdBudgetsApiResponse =
  /** status 201 Created */ Budget;
export type PostUsersMeOrganisationsCurrentViewsByViewIdBudgetsApiArg = {
  "view-id": string;
  body: {
    name: string;
    start_date: string;
    end_date: string | null;
    period: BudgetPeriod;
    integrations?: NestedIntegration[] | null;
    notifications?:
      | (
          | NotificationEmail
          | NotificationSlack
          | NotificationWebhook
          | NotificationJira
        )[]
      | null;
    thresholds: Threshold[];
    amount: number | null;
    email_to?: Emails | (any | null);
    receive_updates: boolean;
    type: BudgetType;
    planned_amounts: number[] | null;
    view_id?: string | null;
    filter_tree?: NullableFilterTreeNode;
  };
};
export type GetUsersMeOrganisationsCurrentAlertsCostAnomalyApiResponse =
  /** status 200 OK */ CostAnomalyAlert[];
export type GetUsersMeOrganisationsCurrentAlertsCostAnomalyApiArg = void;
export type PostUsersMeOrganisationsCurrentAlertsCostAnomalyApiResponse =
  /** status 201 Created */ CostAnomalyAlert;
export type PostUsersMeOrganisationsCurrentAlertsCostAnomalyApiArg = {
  body: {
    name: string;
    view_id: string;
    view_link: string;
    status?: AlertStatus;
    group_by: ResourceExplorerGroupingNullable;
    notifications?:
      | (
          | NotificationEmail
          | NotificationSlack
          | NotificationWebhook
          | NotificationJira
        )[]
      | null;
    emails?: Emails;
    thresholds: ThresholdItem[] | null;
    threshold: AlertThreshold;
    time_interval: {
      time_interval?: number;
      time_interval_unit?: "days" | "weeks" | "months";
    };
  };
};
export type DeleteUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdApiArg =
  {
    alertId: string;
  };
export type PatchUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdApiResponse =
  /** status 200 updated */ CostAnomalyAlert;
export type PatchUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdApiArg = {
  alertId: string;
  body: {
    name?: string;
    notifications?:
      | (
          | NotificationEmail
          | NotificationSlack
          | NotificationWebhook
          | NotificationJira
        )[]
      | null;
    emails?: Emails;
    view_id?: string;
    view_link?: string;
    group_by?: ResourceExplorerGroupingNullable;
    status?: AlertStatus;
    thresholds?: ThresholdItem[];
    threshold?: AlertThreshold;
    time_interval?: {
      time_interval?: number;
      time_interval_unit?: "days" | "weeks" | "months";
    };
  };
};
export type GetUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdApiResponse =
  /** status 200 get alert */ CostAnomalyAlert;
export type GetUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdApiArg = {
  alertId: string;
};
export type GetUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageApiResponse =
  /** status 200 OK */ UtilizationAndCoverageAlert[];
export type GetUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageApiArg =
  void;
export type PostUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageApiResponse =
  /** status 201 Created */ UtilizationAndCoverageAlert;
export type PostUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageApiArg =
  {
    body: {
      name: string;
      provider_organisation_id?: string;
      notifications?:
        | (
            | NotificationEmail
            | NotificationSlack
            | NotificationWebhook
            | NotificationJira
          )[]
        | null;
      emails?: Emails;
      status?: AlertStatus;
      thresholds: ThresholdItem[];
      based_on:
        | "commitments_expiration"
        | "commitments_utilization"
        | "coverage";
      provider: CommitmentCloudProvider;
    };
  };
export type DeleteUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdApiArg =
  {
    alertId: string;
  };
export type PatchUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdApiResponse =
  /** status 200 updated */ UtilizationAndCoverageAlert;
export type PatchUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdApiArg =
  {
    alertId: string;
    body: {
      name?: string;
      provider_organisation_id?: string;
      notifications?:
        | (
            | NotificationEmail
            | NotificationSlack
            | NotificationWebhook
            | NotificationJira
          )[]
        | null;
      emails?: Emails;
      thresholds?: ThresholdItem[];
      status?: AlertStatus;
      based_on?:
        | "commitments_expiration"
        | "commitments_utilization"
        | "coverage";
      provider?: CommitmentCloudProvider;
    };
  };
export type GetUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdApiResponse =
  /** status 200 get alert */ UtilizationAndCoverageAlert;
export type GetUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdApiArg =
  {
    alertId: string;
  };
export type GetUsersMeOrganisationsCurrentProviderOrganisationsApiResponse =
  /** status 200 Ok */ ProviderOrganisation[];
export type GetUsersMeOrganisationsCurrentProviderOrganisationsApiArg = void;
export type GetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiResponse =
  /** status 200 Ok */ ResourceExplorer;
export type GetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiArg =
  {
    resourceExplorerViewId: string;
  };
export type PostUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiResponse =
  /** status 200 OK */ ResourceExplorerWidget;
export type PostUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiArg =
  {
    resourceExplorerViewId: string;
    resourceExplorerDataOverrideFilters: ResourceExplorerDataOverrideFilters;
  };
export type PatchUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiResponse =
  /** status 200 OK */ ResourceExplorer;
export type PatchUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiArg =
  {
    resourceExplorerViewId: string;
    body: {
      name?: string | null;
      filter_tree?: FilterTreeNode;
      data?: ResourceExplorerData;
      is_protected?: boolean;
      protection_description?: string;
      chart_settings?: ChartSettings;
    };
  };
export type GetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdAverageApiResponse =
  /** status 200 OK */ ResourceExplorerDataAverage[];
export type GetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdAverageApiArg =
  {
    resourceExplorerViewId: string;
    dateFrom?: NullableDate;
    dateTo?: NullableDate;
    dataPoint?: DateDataPoint;
    grouping?: ResourceExplorerGroupingNullable;
    startMonthOfQuarter?: number;
    groupValues?: string[];
  };
export type DeleteV2UsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteV2UsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiArg =
  {
    resourceExplorerViewId: string;
  };
export type PatchV2UsersMeOrganisationsCurrentResourceExplorerFoldersByResourceExplorerFolderIdApiResponse =
  /** status 200 OK */ ReFolderV2;
export type PatchV2UsersMeOrganisationsCurrentResourceExplorerFoldersByResourceExplorerFolderIdApiArg =
  {
    resourceExplorerFolderId: string;
    body: {
      name?: string;
    };
  };
export type DeleteV2UsersMeOrganisationsCurrentResourceExplorerFoldersByResourceExplorerFolderIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteV2UsersMeOrganisationsCurrentResourceExplorerFoldersByResourceExplorerFolderIdApiArg =
  {
    resourceExplorerFolderId: string;
  };
export type PostUsersMeOrganisationsCurrentTaskViewsApiResponse =
  /** status 201 Created */ View;
export type PostUsersMeOrganisationsCurrentTaskViewsApiArg = {
  body: {
    name: string;
    config?: {
      gridConfig?: string;
      [key: string]: any;
    };
  };
};
export type GetUsersMeOrganisationsCurrentTaskViewsByViewIdApiResponse =
  /** status 200 OK */ View;
export type GetUsersMeOrganisationsCurrentTaskViewsByViewIdApiArg = {
  viewId: string;
};
export type PatchUsersMeOrganisationsCurrentTaskViewsByViewIdApiResponse =
  /** status 200 OK */ View;
export type PatchUsersMeOrganisationsCurrentTaskViewsByViewIdApiArg = {
  viewId: string;
  body: {
    name?: string;
    config?: {
      gridConfig?: string;
      [key: string]: any;
    };
    modified_by?: string;
    is_protected?: boolean | null;
    protection_description?: string | null;
  };
};
export type DeleteUsersMeOrganisationsCurrentTaskViewsByViewIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentTaskViewsByViewIdApiArg = {
  viewId: string;
};
export type PostUsersMeOrganisationsCurrentOpportunityViewsApiResponse =
  /** status 201 Created */ View;
export type PostUsersMeOrganisationsCurrentOpportunityViewsApiArg = {
  body: {
    name: string;
    config?: {
      gridConfig?: string;
      [key: string]: any;
    };
  };
};
export type GetUsersMeOrganisationsCurrentOpportunityViewsByViewIdApiResponse =
  /** status 200 OK */ View;
export type GetUsersMeOrganisationsCurrentOpportunityViewsByViewIdApiArg = {
  viewId: string;
};
export type PatchUsersMeOrganisationsCurrentOpportunityViewsByViewIdApiResponse =
  /** status 200 OK */ View;
export type PatchUsersMeOrganisationsCurrentOpportunityViewsByViewIdApiArg = {
  viewId: string;
  body: {
    name?: string;
    config?: {
      gridConfig?: string;
      [key: string]: any;
    };
    modified_by?: string;
    is_protected?: boolean | null;
    protection_description?: string | null;
  };
};
export type DeleteUsersMeOrganisationsCurrentOpportunityViewsByViewIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentOpportunityViewsByViewIdApiArg = {
  viewId: string;
};
export type PatchUsersMeOrganisationsCurrentFilterSetsByFilterSetIdV2ApiResponse =
  /** status 200 OK */ FilterSet;
export type PatchUsersMeOrganisationsCurrentFilterSetsByFilterSetIdV2ApiArg = {
  filterSetId: string;
  body: {
    name?: string | null;
    filters?: ResourceFilters[] | null;
    cloud_provider: ProviderType;
    priority_account_id?: string | null;
    account_ids?: string[];
  };
};
export type GetUsersMeOrganisationsCurrentDashboardsPossibleWidgetsApiResponse =
  /** status 200 Possible widgets */ {
    billing_statuses: {
      provider: ProviderType;
      billing_collect_status: BillingCollectionStatus;
    }[];
    widgets: {
      type: WidgetType;
      cause_of_disabled_state: (any | null) | WidgetStateReason;
    }[];
  };
export type GetUsersMeOrganisationsCurrentDashboardsPossibleWidgetsApiArg = {
  /** Content-type */
  "Content-Type"?: string;
};
export type GetUsersMeOrganisationsCurrentDashboardsApiResponse =
  /** status 200 OK */ Dashboard[];
export type GetUsersMeOrganisationsCurrentDashboardsApiArg = {
  /** Content-type */
  "Content-Type"?: string;
};
export type PostV2UsersMeOrganisationsCurrentDashboardsApiResponse =
  /** status 201 Dashboard Details */ {
    id: string;
    name: string;
    created_at: Date;
    modified_at?: NullableDate;
    layout?: LayoutNullable;
    visibility?: "visible_to_everyone" | "visible_only_to_me";
    created_by?: EmbeddedUser;
    modified_by?: NullableEmbeddedUser;
    widgets: (
      | DashboardWidgetResourceExplorer
      | DashboardWidgetAccountsLiveUsage
      | DashboardWidgetCostBreakdown
      | DashboardWidgetCostAndUsageSummary
      | DashboardWidgetLargestCostChanges
      | DashboardWidgetCommitmentsUtilization
      | DashboardWidgetSavingsOpportunities
    )[];
    widget_reference_map?: {
      [key: string]: string;
    };
  };
export type PostV2UsersMeOrganisationsCurrentDashboardsApiArg = {
  body: {
    name: string;
    visibility: "visible_only_to_me" | "visible_to_everyone";
    widgets?: (
      | DashboardWidgetResourceExplorer
      | DashboardWidgetAccountsLiveUsage
      | DashboardWidgetCostBreakdown
      | DashboardWidgetCostAndUsageSummary
      | DashboardWidgetLargestCostChanges
      | DashboardWidgetCommitmentsUtilization
      | DashboardWidgetSavingsOpportunities
    )[];
  };
};
export type PostV2UsersMeOrganisationsCurrentDashboardFoldersApiResponse =
  /** status 201 Created */ DashboardFolder;
export type PostV2UsersMeOrganisationsCurrentDashboardFoldersApiArg = {
  body: {
    name: string;
    visibility: ("visible_only_to_me" | "visible_to_everyone") | null;
  };
};
export type PatchUsersMeOrganisationsCurrentDashboardFoldersByFolderIdApiResponse =
  /** status 200 OK */ DashboardFolder;
export type PatchUsersMeOrganisationsCurrentDashboardFoldersByFolderIdApiArg = {
  folderId: string;
  body: {
    name?: string;
  };
};
export type DeleteUsersMeOrganisationsCurrentDashboardFoldersByFolderIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentDashboardFoldersByFolderIdApiArg =
  {
    folderId: string;
  };
export type DeleteV2UsersMeOrganisationsCurrentDashboardsFoldersByFolderIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteV2UsersMeOrganisationsCurrentDashboardsFoldersByFolderIdApiArg =
  {
    folderId: string;
  };
export type PatchUsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse =
  /** status 202 Dashboard Details */ {
    id: string;
    name: string;
    created_at: Date;
    modified_at?: NullableDate;
    layout?: LayoutNullable;
    visibility?: "visible_to_everyone" | "visible_only_to_me";
    created_by?: EmbeddedUser;
    modified_by?: NullableEmbeddedUser;
    protected_by: EmbeddedUser;
    protection_details: ProtectionDetails;
    dates?: Dates;
    category_details?: CategoryDetails;
    is_home_page?: boolean;
    widgets: (
      | DashboardWidgetResourceExplorer
      | DashboardWidgetAccountsLiveUsage
      | DashboardWidgetCostBreakdown
      | DashboardWidgetCostAndUsageSummary
      | DashboardWidgetLargestCostChanges
      | DashboardWidgetCommitmentsUtilization
      | DashboardWidgetCoverage
      | DashboardWidgetText
      | DashboardWidgetSavingsOpportunities
      | DashboardWidgetNormalizedCost
    )[];
  };
export type PatchUsersMeOrganisationsCurrentDashboardsByDashboardIdApiArg = {
  dashboardId: string;
  body: {
    name: string | null;
    is_protected?: boolean;
    protection_description?: string;
    is_home_page?: boolean | null;
    layout?: LayoutNullable;
    dates?: NullableDates;
    category_id?: string | null;
    dimension_id?: string | null;
  };
};
export type PutUsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse =
  /** status 202 Dashboard Details */ {
    id: string;
    name: string;
    created_at: Date;
    modified_at?: NullableDate;
    layout?: LayoutNullable;
    visibility?: "visible_to_everyone" | "visible_only_to_me";
    created_by?: EmbeddedUser;
    modified_by?: NullableEmbeddedUser;
    protected_by: EmbeddedUser;
    protection_details: ProtectionDetails;
    dates?: Dates;
    category_details?: CategoryDetails;
    is_home_page?: boolean;
    widgets: (
      | DashboardWidgetResourceExplorer
      | DashboardWidgetAccountsLiveUsage
      | DashboardWidgetCostBreakdown
      | DashboardWidgetCostAndUsageSummary
      | DashboardWidgetLargestCostChanges
      | DashboardWidgetCommitmentsUtilization
      | DashboardWidgetCoverage
      | DashboardWidgetText
      | DashboardWidgetSavingsOpportunities
      | DashboardWidgetNormalizedCost
    )[];
  };
export type PutUsersMeOrganisationsCurrentDashboardsByDashboardIdApiArg = {
  dashboardId: string;
  body: {
    name: string;
    is_protected: boolean;
    protection_description: string;
    is_home_page?: boolean;
    layout: Layout;
    dates: Dates;
    category_details: CategoryDetails;
  };
};
export type GetUsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse =
  /** status 200 Dashboard Details */ {
    id: string;
    name: string;
    created_at: Date;
    modified_at?: NullableDate;
    layout?: LayoutNullable;
    visibility?: "visible_to_everyone" | "visible_only_to_me";
    created_by?: EmbeddedUser;
    modified_by?: NullableEmbeddedUser;
    protected_by: EmbeddedUser;
    protection_details: ProtectionDetails;
    dates?: Dates;
    category_details?: CategoryDetails;
    is_home_page?: boolean;
    widgets: (
      | DashboardWidgetResourceExplorer
      | DashboardWidgetAccountsLiveUsage
      | DashboardWidgetCostBreakdown
      | DashboardWidgetCostAndUsageSummary
      | DashboardWidgetLargestCostChanges
      | DashboardWidgetCommitmentsUtilization
      | DashboardWidgetCoverage
      | DashboardWidgetText
      | DashboardWidgetSavingsOpportunities
      | DashboardWidgetNormalizedCost
    )[];
  };
export type GetUsersMeOrganisationsCurrentDashboardsByDashboardIdApiArg = {
  dashboardId: string;
};
export type DeleteV2UsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse =
  /** status 204 Example response */ {
    message?: string;
  };
export type DeleteV2UsersMeOrganisationsCurrentDashboardsByDashboardIdApiArg = {
  dashboardId: string;
};
export type PostUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsApiResponse =
  /** status 201 Created */
  | DashboardWidgetResourceExplorer
  | DashboardWidgetAccountsLiveUsage
  | DashboardWidgetCostBreakdown
  | DashboardWidgetCostAndUsageSummary
  | DashboardWidgetLargestCostChanges
  | DashboardWidgetCommitmentsUtilization
  | DashboardWidgetText
  | DashboardWidgetCoverage
  | DashboardWidgetSavingsOpportunities
  | DashboardWidgetNormalizedCost;
export type PostUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsApiArg =
  {
    dashboardId: string;
    body: {
      widget:
        | DashboardWidgetResourceExplorer2
        | DashboardWidgetAccountsLiveUsage2
        | DashboardWidgetCostBreakdownRequest
        | DashboardWidgetCostAndUsageSummaryRequest
        | DashboardWidgetLargestCostChangesRequest
        | DashboardWidgetCommitmentsUtilizationRequest
        | DashboardWidgetCoverageRequest
        | DashboardWidgetTextRequest
        | DashboardWidgetSavingsOpportunitiesRequest
        | DashboardWidgetNormalizedCostRequest;
    };
  };
export type PatchUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdApiResponse =
  /** status 202 Accepted */
  | DashboardWidgetResourceExplorer
  | DashboardWidgetAccountsLiveUsage
  | DashboardWidgetCostBreakdown
  | DashboardWidgetCostAndUsageSummary
  | DashboardWidgetLargestCostChanges
  | DashboardWidgetCommitmentsUtilization
  | DashboardWidgetText
  | DashboardWidgetCoverage
  | DashboardWidgetSavingsOpportunities
  | DashboardWidgetNormalizedCost;
export type PatchUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdApiArg =
  {
    dashboardId: string;
    widgetId: string;
    body: {
      widget:
        | DashboardWidgetAccountsLiveUsagePatchRequest
        | DashboardWidgetCostBreakdownPatchRequest
        | DashboardWidgetCostAndUsageSummaryPatchRequest
        | DashboardWidgetLargestCostChangesPatchRequest
        | DashboardWidgetCommitmentsUtilizationPatchRequest
        | DashboardWidgetCoveragePatchRequest
        | DashboardWidgetTextPatchRequest
        | DashboardWidgetSavingsOpportunitiesPatchRequest
        | DashboardWidgetNormalizedCostPatchRequest;
    };
  };
export type DeleteUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdApiResponse =
  /** status 204 Example response */ {
    message?: string;
  };
export type DeleteUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdApiArg =
  {
    dashboardId: string;
    widgetId: string;
  };
export type PutUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdApiResponse =
  /** status 202 Accepted */
  | DashboardWidgetResourceExplorer
  | DashboardWidgetAccountsLiveUsage
  | DashboardWidgetCostBreakdown
  | DashboardWidgetCostAndUsageSummary
  | DashboardWidgetLargestCostChanges
  | DashboardWidgetCommitmentsUtilization
  | DashboardWidgetText
  | DashboardWidgetCoverage
  | DashboardWidgetSavingsOpportunities
  | DashboardWidgetNormalizedCost;
export type PutUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdApiArg =
  {
    dashboardId: string;
    widgetId: string;
    body: {
      widget:
        | UpdateDashboardWidgetAccountsLiveUsage
        | UpdateDashboardWidgetCostBreakdownRequest
        | UpdateDashboardWidgetCostAndUsageSummaryRequest
        | UpdateDashboardWidgetLargestCostChangesRequest
        | UpdateDashboardWidgetCommitmentsUtilizationRequest
        | UpdateDashboardWidgetCoverageRequest
        | UpdateDashboardWidgetTextRequest
        | UpdateDashboardWidgetSavingsOpportunitiesRequest
        | UpdateDashboardWidgetNormalizedCostRequest;
    };
  };
export type PatchUsersMeOrganisationsCurrentDashboardHierarchyApiResponse =
  /** status 200 Ok */ (Dashboard | DashboardFolder)[];
export type PatchUsersMeOrganisationsCurrentDashboardHierarchyApiArg = {
  body: {
    id: string;
    parent_id?: string;
    index?: number;
  };
};
export type PatchV2UsersMeOrganisationsCurrentDashboardHierarchyApiResponse =
  /** status 200 Ok */ Dashboard | DashboardFolder;
export type PatchV2UsersMeOrganisationsCurrentDashboardHierarchyApiArg = {
  body: {
    id: string;
    type?: "dashboard" | "folder" | "view";
    parent_id?: string;
    index?: number;
    visibility: "visible_only_to_me" | "visible_to_everyone";
  };
};
export type GetUsersMeOrganisationsCurrentTaskViewsHierarchyApiResponse =
  /** status 200 Ok */ {
    hierarchy?: View[];
  };
export type GetUsersMeOrganisationsCurrentTaskViewsHierarchyApiArg = {
  /** Content-type */
  "Content-Type"?: string;
};
export type PatchUsersMeOrganisationsCurrentTaskViewsHierarchyApiResponse =
  /** status 200 Ok */ View;
export type PatchUsersMeOrganisationsCurrentTaskViewsHierarchyApiArg = {
  body: {
    id: string;
    type?: "view";
    parent_id?: string;
    index?: number;
  };
};
export type GetUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchyApiResponse =
  /** status 200 Ok */ {
    hierarchy?: View[];
  };
export type GetUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchyApiArg =
  {
    /** Content-type */
    "Content-Type"?: string;
  };
export type PatchUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchyApiResponse =
  /** status 200 Ok */ View;
export type PatchUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchyApiArg =
  {
    body: {
      id: string;
      type?: "view";
      parent_id?: string;
      index?: number;
    };
  };
export type GetV2UsersMeOrganisationsCurrentDashboardsHierarchyApiResponse =
  /** status 200 Ok */ {
    visible_only_to_me?: (Dashboard | DashboardFolder)[];
    visible_to_everyone?: (Dashboard | DashboardFolder)[];
  };
export type GetV2UsersMeOrganisationsCurrentDashboardsHierarchyApiArg = {
  /** Content-type */
  "Content-Type"?: string;
};
export type PostUsersMeOrganisationsCurrentWidgetsSavingsOpportunitiesApiResponse =
  /** status 201 Savings Opportunities Widget Response */ {
    savings_opportunities: SavingsOpportunity[];
    total_cost: number;
    savings_opportunities_cost: number;
  };
export type PostUsersMeOrganisationsCurrentWidgetsSavingsOpportunitiesApiArg = {
  body: {
    filter_tree?: FilterTreeNode;
    grouping?: SavingsOpportunityGrouping;
    opportunity_types?: SavingsOpportunityType[];
  };
};
export type GetUsersMeOrganisationsCurrentWidgetsSavingsOpportunitiesByWidgetIdApiResponse =
  /** status 200 Savings Opportunities Widget Response */ {
    savings_opportunities: SavingsOpportunity[];
    total_cost: number;
    savings_opportunities_cost: number;
  };
export type GetUsersMeOrganisationsCurrentWidgetsSavingsOpportunitiesByWidgetIdApiArg =
  {
    widgetId: string;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationApiResponse =
  /** status 200 Commitments Utilization Widget Response */ {
    utilization: AmountWithPercentageResponse;
    commitments: number;
    net_savings: number;
    utilization_trend?: number | null;
    commitments_trend?: number | null;
    net_savings_trend?: number | null;
    groups: CommitmentsGroupResponse[];
    current_period_date_details?: DateDetails;
    previous_period_date_details?: DateDetails;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationApiArg =
  {
    providerOrganisationId?: string;
    dateLabel?: DateLabelNullable;
    dateFrom?: NullableDate;
    dateTo?: NullableDate;
    dateType?: DateType;
    dateValue?: number | null;
    dateUnit?: DateUnit;
    grouping?: CommitmentsUtilizationGrouping;
    commitmentType?: CommitmentUtilizationType;
    trendType?: TrendType;
    provider?: CommitmentCloudProvider;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationByWidgetIdApiResponse =
  /** status 200 Commitments Utilization Widget Response */ {
    utilization: AmountWithPercentageResponse;
    commitments: number;
    net_savings: number;
    utilization_trend?: number | null;
    commitments_trend?: number | null;
    net_savings_trend?: number | null;
    groups: CommitmentsGroupResponse[];
    current_period_date_details?: DateDetails;
    previous_period_date_details?: DateDetails;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationByWidgetIdApiArg =
  {
    widgetId: string;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCoverageApiResponse =
  /** status 200 Coverage Widget Response */ {
    covered: AmountWithPercentageResponse;
    not_covered: number;
    net_savings: number;
    real_cost: number;
    covered_trend?: number | null;
    not_covered_trend?: number | null;
    net_savings_trend?: number | null;
    real_cost_trend?: number | null;
    groups: CoverageGroupResponse[];
    current_period_date_details?: DateDetails;
    previous_period_date_details?: DateDetails;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCoverageApiArg = {
  providerOrganisationId?: string;
  dateLabel?: DateLabelNullable;
  dateFrom?: NullableDate;
  dateTo?: NullableDate;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  grouping?: CoverageGrouping;
  commitmentType?: CommitmentUtilizationType;
  trendType?: TrendType;
  provider?: CommitmentCloudProvider;
};
export type PostUsersMeOrganisationsCurrentCoverageApiResponse =
  /** status 200 Coverage Response */ {
    coverage: CoverageBreakdown;
    spend_covered?: number;
    on_demand_spend: number;
    net_savings: number;
    granular_data: {
      date: Date;
      coverage: CoverageBreakdown;
    }[];
    grouped_coverage?: CommitmentCoverageData[];
  };
export type PostUsersMeOrganisationsCurrentCoverageApiArg = {
  body: {
    account_id: string;
    cloud_provider: CloudProvider;
    filter_tree?: FilterTreeNode;
    dates: Dates;
    data_granularity: DateDataPoint;
  };
};
export type GetUsersMeOrganisationsCurrentWidgetsCoverageByWidgetIdApiResponse =
  /** status 200 Coverage Widget Response */ {
    covered: AmountWithPercentageResponse;
    not_covered: number;
    net_savings: number;
    real_cost: number;
    covered_trend?: number | null;
    not_covered_trend?: number | null;
    net_savings_trend?: number | null;
    real_cost_trend?: number | null;
    groups: CoverageGroupResponse[];
    current_period_date_details?: DateDetails;
    previous_period_date_details?: DateDetails;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCoverageByWidgetIdApiArg = {
  widgetId: string;
};
export type GetUsersMeOrganisationsCurrentWidgetsNormalizedCostApiResponse =
  /** status 200 Cost Breakdown Widget Response */ {
    regular_cost: NormalizedWidgetAggregatedCost[];
    normalized: NormalizedWidgetAggregatedCost[];
    total_cost: number;
    trend: number;
    average_normalized_monthly_cost: number;
    forecasted_costs: ForecastedCostRe;
    trend_type: TrendType;
    cost_type: CostType;
  };
export type GetUsersMeOrganisationsCurrentWidgetsNormalizedCostApiArg = {
  viewId: string;
  dateLabel?: DateLabelNullable;
  dateFrom?: NullableDate;
  dateTo?: NullableDate;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  forecastOption: ForecastOption;
  trendType?: TrendType;
  chartType: ChartType;
};
export type GetUsersMeOrganisationsCurrentWidgetsNormalizedCostByWidgetIdApiResponse =
  /** status 200 Cost Breakdown Widget Response */ {
    regular_cost: NormalizedWidgetAggregatedCost[];
    normalized: NormalizedWidgetAggregatedCost[];
    total_cost: number;
    trend: number;
    average_normalized_monthly_cost: number;
    forecasted_costs: ForecastedCostRe;
    trend_type: TrendType;
    cost_type: CostType;
  };
export type GetUsersMeOrganisationsCurrentWidgetsNormalizedCostByWidgetIdApiArg =
  {
    widgetId: string;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCostBreakdownApiResponse =
  /** status 200 Cost Breakdown Widget Response */ {
    data: ResourceExplorerChartData[];
    total: ResourceExplorerGridTotal[];
    total_cost: number;
    previous_period_total_cost: number;
    average_daily_cost_details: AverageDailyCostDetails;
    average_monthly_cost_details: AverageMonthlyCostDetails;
    live_usage_total_cost: number;
    total_cost_date_details: ResourceExplorerCostsDateDetails;
    previous_period_cost_date_details: ResourceExplorerCostsDateDetails;
    forecasted_costs: ForecastedCostRe;
    trend_type?: TrendType;
    cost_type: CostType;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCostBreakdownApiArg = {
  viewId: string;
  dateLabel?: DateLabelNullable;
  dateFrom?: NullableDate;
  dateTo?: NullableDate;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  dataPoint?: DateDataPoint;
  grouping?: ResourceExplorerGroupingNullable;
  groupValues?: string[];
  forecastOption: ForecastOption;
  chartType: ChartType;
  trendType?: TrendType;
  series?: number | null;
};
export type GetUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetIdApiResponse =
  /** status 200 Cost Breakdown Widget Response */ {
    data: ResourceExplorerChartData[];
    total: ResourceExplorerGridTotal[];
    total_cost: number;
    previous_period_total_cost: number;
    average_daily_cost_details: AverageDailyCostDetails;
    average_monthly_cost_details: AverageMonthlyCostDetails;
    live_usage_total_cost: number;
    total_cost_date_details: ResourceExplorerCostsDateDetails;
    previous_period_cost_date_details: ResourceExplorerCostsDateDetails;
    forecasted_costs: ForecastedCostRe;
    trend_type?: TrendType;
    cost_type: CostType;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetIdApiArg =
  {
    widgetId: string;
    categoryId?: string;
    dateLabel?: DateLabelNullable;
    dateFrom?: NullableDate;
    dateTo?: NullableDate;
    dateType?: DateType;
    dateValue?: number | null;
    dateUnit?: DateUnit;
  };
export type GetUsersMeOrganisationsCurrentWidgetsTextByWidgetIdApiResponse =
  /** status 200 Text Widget Response */ {
    text: string;
  };
export type GetUsersMeOrganisationsCurrentWidgetsTextByWidgetIdApiArg = {
  widgetId: string;
};
export type GetUsersMeOrganisationsCurrentWidgetsLargestCostChangesApiResponse =
  /** status 200 Largest Cost Changes Widget Response */ {
    total: ResourceExplorerGridTotal[];
    previous_period_cost_date_details: ResourceExplorerCostsDateDetails;
    current_period_cost_date_details: ResourceExplorerCostsDateDetails;
  };
export type GetUsersMeOrganisationsCurrentWidgetsLargestCostChangesApiArg = {
  viewId: string;
  dateLabel?: DateLabelNullable;
  dateFrom?: NullableDate;
  dateTo?: NullableDate;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  grouping?: ResourceExplorerGroupingNullable;
  groupValues?: string[];
  itemsCount?: number | null;
  minPercentChange?: number | null;
  minCostChange?: number | null;
  priceDirection?: PriceDirection;
  sortBy?: SortBy;
};
export type GetUsersMeOrganisationsCurrentWidgetsLargestCostChangesByWidgetIdApiResponse =
  /** status 200 Largest Cost Changes Widget Response */ {
    total: ResourceExplorerGridTotal[];
    previous_period_cost_date_details: ResourceExplorerCostsDateDetails;
    current_period_cost_date_details: ResourceExplorerCostsDateDetails;
  };
export type GetUsersMeOrganisationsCurrentWidgetsLargestCostChangesByWidgetIdApiArg =
  {
    widgetId: string;
    categoryId?: string;
    dateLabel?: DateLabelNullable;
    dateFrom?: NullableDate;
    dateTo?: NullableDate;
    dateType?: DateType;
    dateValue?: number | null;
    dateUnit?: DateUnit;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryApiResponse =
  /** status 200 Cost And Usage Summary Widget Response */ {
    total_cost: number;
    previous_period_total_cost: number;
    average_daily_cost_details: AverageDailyCostDetails;
    average_monthly_cost_details: AverageMonthlyCostDetails;
    live_usage_total_cost: number;
    total_cost_date_details: ResourceExplorerCostsDateDetails;
    previous_period_cost_date_details: ResourceExplorerCostsDateDetails;
    forecasted_costs: ForecastedCostRe;
    trend_type?: TrendType;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryApiArg = {
  viewId: string;
  dateLabel?: DateLabelNullable;
  dateFrom?: NullableDate;
  dateTo?: NullableDate;
  dateType?: DateType;
  dateValue?: number | null;
  dateUnit?: DateUnit;
  trendType?: TrendType;
  visualization?: WidgetCostAndUsageSummaryVisualization;
};
export type GetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryByWidgetIdApiResponse =
  /** status 200 Cost And Usage Summary Widget Response */ {
    total_cost: number;
    previous_period_total_cost: number;
    average_daily_cost_details: AverageDailyCostDetails;
    average_monthly_cost_details: AverageMonthlyCostDetails;
    live_usage_total_cost: number;
    total_cost_date_details: ResourceExplorerCostsDateDetails;
    previous_period_cost_date_details: ResourceExplorerCostsDateDetails;
    forecasted_costs: ForecastedCostRe;
    trend_type?: TrendType;
  };
export type GetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryByWidgetIdApiArg =
  {
    widgetId: string;
    categoryId?: string;
    dateLabel?: DateLabelNullable;
    dateFrom?: NullableDate;
    dateTo?: NullableDate;
    dateType?: DateType;
    dateValue?: number | null;
    dateUnit?: DateUnit;
  };
export type GetUsersMeRdsStorageTypesApiResponse =
  /** status 200 OK */ string[];
export type GetUsersMeRdsStorageTypesApiArg = void;
export type PostUsersMeRdsSnapshotSourceNamesApiResponse =
  /** status 200 OK */ string[];
export type PostUsersMeRdsSnapshotSourceNamesApiArg = {
  body: {
    account_ids: string[];
  };
};
export type GetUsersMeRdsSnapshotTypesApiResponse =
  /** status 200 OK */ string[];
export type GetUsersMeRdsSnapshotTypesApiArg = void;
export type GetUsersMeEbsSnapshotStatusesApiResponse =
  /** status 200 OK */ string[];
export type GetUsersMeEbsSnapshotStatusesApiArg = void;
export type PostUsersMeEbsSnapshotVolumeIdsApiResponse =
  /** status 200 OK */ string[];
export type PostUsersMeEbsSnapshotVolumeIdsApiArg = {
  body: {
    account_ids: string[];
  };
};
export type GetUsersMeDynamoDbBackupSourceClassesApiResponse =
  /** status 200 OK */ string[];
export type GetUsersMeDynamoDbBackupSourceClassesApiArg = void;
export type GetUsersMeDynamoDbTableStatusesApiResponse =
  /** status 200 OK */ string[];
export type GetUsersMeDynamoDbTableStatusesApiArg = void;
export type GetUsersMeDynamoDbTableCapacityModesApiResponse =
  /** status 200 OK */ string[];
export type GetUsersMeDynamoDbTableCapacityModesApiArg = void;
export type GetUsersMeNatGatewayIpAddressesApiResponse =
  /** status 200 OK */ IpAddresses[];
export type GetUsersMeNatGatewayIpAddressesApiArg = void;
export type GetUsersMeNatGatewayVpcApiResponse = /** status 200 OK */ string[];
export type GetUsersMeNatGatewayVpcApiArg = void;
export type GetUsersMeEcsWorkloadCapacityProvidersApiResponse =
  /** status 200 OK */ string[];
export type GetUsersMeEcsWorkloadCapacityProvidersApiArg = void;
export type GetUsersMeOrganisationsCurrentResourceExplorerViewsByViewIdWidgetApiResponse =
  /** status 200 OK */ ResourceExplorerWidget;
export type GetUsersMeOrganisationsCurrentResourceExplorerViewsByViewIdWidgetApiArg =
  {
    viewId: string;
  };
export type GetUsersMeExecutionLogsSourcesApiResponse =
  /** status 200 OK */ CommandLogSource[];
export type GetUsersMeExecutionLogsSourcesApiArg = void;
export type PostUsersMeOrganisationsCurrentMinimumAvailableDateApiResponse =
  /** status 200 OK */ MinimumAvailableDate;
export type PostUsersMeOrganisationsCurrentMinimumAvailableDateApiArg = {
  body: {
    cloud_providers: ProviderType[];
  };
};
export type PatchUsersMeRightSizingRecommendationsApiResponse =
  /** status 204 Example response */ {
    message?: string;
  };
export type PatchUsersMeRightSizingRecommendationsApiArg = {
  body: {
    recommendation_ids: string[];
    dismiss_period: DismissPeriod;
  };
};
export type PatchUsersMeDailyOffHoursRecommendationsApiResponse =
  /** status 204 Example response */ {
    message?: string;
  };
export type PatchUsersMeDailyOffHoursRecommendationsApiArg = {
  body: {
    recommendation_ids: string[];
    dismiss_period: DismissPeriod;
  };
};
export type PatchUsersMeWeeklyOffHoursRecommendationsApiResponse =
  /** status 204 Example response */ {
    message?: string;
  };
export type PatchUsersMeWeeklyOffHoursRecommendationsApiArg = {
  body: {
    recommendation_ids: string[];
    dismiss_period: DismissPeriod;
  };
};
export type PatchUsersMeResourcesRightSizingRecommendationsApiResponse =
  /** status 204 Example response */ {
    message?: string;
  };
export type PatchUsersMeResourcesRightSizingRecommendationsApiArg = {
  body: {
    resource_identifier: string;
    account_id: string;
  };
};
export type PatchUsersMeResourcesDailyOffHoursRecommendationsApiResponse =
  /** status 204 Example response */ {
    message?: string;
  };
export type PatchUsersMeResourcesDailyOffHoursRecommendationsApiArg = {
  body: {
    resource_identifier: string;
    account_id: string;
  };
};
export type PatchUsersMeResourcesWeeklyOffHoursRecommendationsApiResponse =
  /** status 204 Example response */ {
    message?: string;
  };
export type PatchUsersMeResourcesWeeklyOffHoursRecommendationsApiArg = {
  body: {
    resource_identifier: string;
    account_id: string;
  };
};
export type GetUsersMeOrganisationsCurrentDismissedResourcesApiResponse =
  /** status 200 Response for getting dismissed Resources */ {
    id: string;
    account?: EmbeddedAccount;
    name: string | null;
    provider_unique_identifier: string;
    type: string;
    dismissed_by: string | null;
    resource_identifier: string;
    tags: Tag[];
    resource_type: ResourceType;
  }[];
export type GetUsersMeOrganisationsCurrentDismissedResourcesApiArg = {
  /** Resource group */
  group?: "compute" | "database";
  /** Recommendation type */
  recommendationType?: "off_hours" | "right_sizing";
};
export type PatchUsersMeOrganisationsCurrentRecommendationsOffHoursApiResponse =
  /** status 200 Example response */ {
    message?: string;
  };
export type PatchUsersMeOrganisationsCurrentRecommendationsOffHoursApiArg = {
  restoreRecommendationRequest: RestoreRecommendationRequest;
};
export type PatchUsersMeOrganisationsCurrentRecommendationsDailyOffHoursApiResponse =
  /** status 200 Example response */ {
    message?: string;
  };
export type PatchUsersMeOrganisationsCurrentRecommendationsDailyOffHoursApiArg =
  {
    restoreRecommendationRequest: RestoreRecommendationRequest;
  };
export type PatchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHoursApiResponse =
  /** status 200 Example response */ {
    message?: string;
  };
export type PatchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHoursApiArg =
  {
    restoreRecommendationRequest: RestoreRecommendationRequest;
  };
export type PatchUsersMeOrganisationsCurrentRecommendationsDailyOffHoursByResourceApiResponse =
  /** status 200 Example response */ {
    message?: string;
  };
export type PatchUsersMeOrganisationsCurrentRecommendationsDailyOffHoursByResourceApiArg =
  {
    restoreRecommendationByResourceRequest: RestoreRecommendationByResourceRequest;
  };
export type PatchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHoursByResourceApiResponse =
  /** status 200 Example response */ {
    message?: string;
  };
export type PatchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHoursByResourceApiArg =
  {
    restoreRecommendationByResourceRequest: RestoreRecommendationByResourceRequest;
  };
export type PatchUsersMeOrganisationsCurrentRecommendationsRightSizingApiResponse =
  /** status 200 Example response */ {
    message?: string;
  };
export type PatchUsersMeOrganisationsCurrentRecommendationsRightSizingApiArg = {
  restoreRecommendationRequest: RestoreRecommendationRequest;
};
export type PatchUsersMeOrganisationsCurrentRecommendationsRightSizingByResourceApiResponse =
  /** status 200 Example response */ {
    message?: string;
  };
export type PatchUsersMeOrganisationsCurrentRecommendationsRightSizingByResourceApiArg =
  {
    restoreRecommendationByResourceRequest: RestoreRecommendationByResourceRequest;
  };
export type GetUsersMeOrganisationsCurrentProvidersByProviderTagKeysApiResponse =
  /** status 200 OK */ TagKey[];
export type GetUsersMeOrganisationsCurrentProvidersByProviderTagKeysApiArg = {
  /** Cloud Provider */
  provider: "gcp" | "aws" | "azure" | "kubernetes" | "global";
};
export type PatchUsersMeOrganisationsCurrentProvidersByProviderTagKeysApiResponse =
  /** status 200 OK */ TagKey[];
export type PatchUsersMeOrganisationsCurrentProvidersByProviderTagKeysApiArg = {
  /** Cloud Provider */
  provider: "gcp" | "aws" | "azure" | "kubernetes" | "global";
  body: {
    key?: string;
  };
};
export type GetUsersMeOrganisationsCurrentReportsApiResponse =
  /** status 200 OK */ Report[];
export type GetUsersMeOrganisationsCurrentReportsApiArg = void;
export type PostUsersMeOrganisationsCurrentReportsApiResponse =
  /** status 201 Created */ Report;
export type PostUsersMeOrganisationsCurrentReportsApiArg = {
  body: {
    name?: string;
    source_id?: string;
    source_type?: "view" | "dashboard";
    export_file_types?: ("pdf" | "csv")[];
    time_zone?: string;
    schedule?:
      | DailySchedule
      | WeeklySchedule
      | MonthlyByDaySchedule
      | MonthlyByWeekdaySchedule;
    notifications?: Notifications;
    emails?: Emails;
  };
};
export type GetUsersMeOrganisationsCurrentReportsByReportIdApiResponse =
  /** status 200 OK */ Report;
export type GetUsersMeOrganisationsCurrentReportsByReportIdApiArg = {
  reportId: string;
};
export type PutUsersMeOrganisationsCurrentReportsByReportIdApiResponse =
  /** status 200 OK */ Report;
export type PutUsersMeOrganisationsCurrentReportsByReportIdApiArg = {
  reportId: string;
  body: {
    name?: string;
    source_id?: string;
    source_type?: "view" | "dashboard";
    export_file_types?: ("pdf" | "csv")[];
    time_zone?: string;
    schedule?:
      | DailySchedule
      | WeeklySchedule
      | MonthlyByDaySchedule
      | MonthlyByWeekdaySchedule;
    notifications?: Notifications;
    emails?: Emails;
  };
};
export type PatchUsersMeOrganisationsCurrentReportsByReportIdApiResponse =
  /** status 200 OK */ Report;
export type PatchUsersMeOrganisationsCurrentReportsByReportIdApiArg = {
  reportId: string;
  body: {
    name?: string | null;
    source_id?: string | null;
    source_type?: ("view" | "dashboard") | null;
    export_file_types?: ("pdf" | "csv")[] | null;
    time_zone?: string | null;
    schedule?:
      | (
          | DailySchedule
          | WeeklySchedule
          | MonthlyByDaySchedule
          | MonthlyByWeekdaySchedule
        )
      | null;
    status?: ("active" | "paused") | null;
    notifications?: Notifications;
    emails?: Emails;
  };
};
export type DeleteUsersMeOrganisationsCurrentReportsByReportIdApiResponse =
  /** status 204 No Content */ void;
export type DeleteUsersMeOrganisationsCurrentReportsByReportIdApiArg = {
  reportId: string;
};
export type UserRole =
  | "owner"
  | "super_admin"
  | "admin"
  | "viewer"
  | "payment_method_admin"
  | "workflow_resources_protector"
  | "viewer_protector"
  | "billing_explorer_admin";
export type Date = string;
export type NullableDate = string | null;
export type UserStatus =
  | "active"
  | "pending"
  | "deleted"
  | "awaiting_invitation"
  | "in_review";
export type EmbeddedUserGroup = {
  id: string;
  name: string;
  description: string | null;
};
export type UserProfile = {
  picture?: string | null;
  color?: string | null;
} | null;
export type User = {
  /** User identifier */
  id: string;
  role: UserRole;
  /** The customer name */
  name: string | null;
  email: string | null;
  company_name: string | null;
  position: string | null;
  invited_by: {
    id: string;
    role: UserRole;
    name?: string | null;
  } | null;
  created_at: Date;
  last_time_logged_in_at?: NullableDate;
  use_mfa?: boolean;
  status?: UserStatus;
  groups?: EmbeddedUserGroup[];
  show_celebration_popup: boolean;
  profile?: UserProfile;
};
export type ProviderType = "aws" | "gcp" | "azure" | "kubernetes";
export type RecommendationState =
  | "enabled"
  | "disabled"
  | "not_detected"
  | "missing_permission";
export type AccountRecommendationState = {
  account_id: string;
  provider: ProviderType;
  status: RecommendationState;
};
export type FilterGroupNode = {
  node_type: "group";
  operator: "and" | "or" | "not";
  items: FilterTreeNode[];
};
export type ResourceExplorerDynamicFilterItemType =
  | "account"
  | "region"
  | "service"
  | "charge_type"
  | "product_family"
  | "instance_family"
  | "instance_type"
  | "tag"
  | "resource_id"
  | "credit"
  | "credit_type"
  | "marketplace_service"
  | "cloud_provider"
  | "dimension_id"
  | "category"
  | "environment"
  | "cluster"
  | "namespace"
  | "node"
  | "usage_type"
  | "pricing_term"
  | "description"
  | "parent_resource_id"
  | "type"
  | "deployment"
  | "workload_name"
  | "workload_type"
  | "organisation"
  | "group"
  | "resource_group"
  | "tag_key"
  | "tag_value"
  | "has_task"
  | "task_status"
  | "name"
  | "platform"
  | "age";
export type ResourceExplorerFilterProvider =
  | "aws"
  | "gcp"
  | "azure"
  | "confluent"
  | "mongo"
  | "dimensions"
  | "kubernetes"
  | "snowflake"
  | "datadog"
  | "eks"
  | "global";
export type KeyValuePair = {
  key?: string;
  value: string | string[];
};
export type MetricFilterValue = {
  statistics: string;
  since_value: number;
  since_unit: "hours" | "days";
  value: number;
};
export type FilterOperatorType =
  | "equal"
  | "not_equal"
  | "greater_than"
  | "greater_than_equal_to"
  | "less_than"
  | "less_than_equal_to"
  | "exists"
  | "does_not_exist"
  | "contains"
  | "does_not_contain"
  | "exclude_all"
  | "include_all"
  | "is_empty"
  | "is_not_empty"
  | "is_absent"
  | "is_not_absent"
  | "in"
  | "is_true"
  | "is_false"
  | "is_expired"
  | "is_invalid"
  | "does_never_expire"
  | "not_in"
  | "is_running"
  | "is_stopped"
  | "no_data"
  | "is_available"
  | "is_deleted"
  | "starts_with"
  | "ends_with";
export type FilterItemNode = {
  node_type: "item";
  type: ResourceExplorerDynamicFilterItemType;
  filter_provider: ResourceExplorerFilterProvider;
  value?:
    | (number | null)
    | (string | null)
    | KeyValuePair
    | MetricFilterValue
    | (string[] | null);
  operator: FilterOperatorType;
};
export type FilterTreeNode = FilterGroupNode | FilterItemNode;
export type TaskStatusCategory = "to_do" | "in_progress" | "completed";
export type TaskStatus = {
  id: string;
  name: string;
  color: string;
  category: TaskStatusCategory;
};
export type TaskEnvironment = {
  id: string;
  name: string;
  color: string;
};
export type TaskAction = {
  id: string;
  name: string;
  color: string;
};
export type TaskPriority = {
  id: string;
  name: string;
  color: string;
};
export type TaskOwner = {
  id: string;
  name: string;
  color: string;
};
export type NullableUserStatus =
  | ("active" | "pending" | "deleted" | "awaiting_invitation" | "in_review")
  | null;
export type EmbeddedUser = {
  id: string;
  name: string | null;
  email: string | null;
  status: NullableUserStatus;
  profile?: UserProfile;
};
export type NullableEmbeddedUser = {
  id: string;
  name: string | null;
  email: string | null;
  status: NullableUserStatus;
  profile?: UserProfile;
} | null;
export type TargetState = ("not_found" | "live") | null;
export type ProviderAccessType = "read" | "read_write";
export type EmbeddedAccount = {
  id: string;
  provider: ProviderType;
  provider_access_type?: ProviderAccessType;
  provider_account_id: string;
  provider_account_name: string;
  is_provider_root_account?: boolean;
  filter_set_id?: string | null;
};
export type Tag = {
  key: string;
  value: string;
};
export type ResourceType =
  | "ec2"
  | "ebs"
  | "elb"
  | "eip"
  | "rds"
  | "vm"
  | "disk"
  | "lb"
  | "ip"
  | "sql"
  | "elc"
  | "az_disk"
  | "az_ip"
  | "az_lb"
  | "az_vm"
  | "az_sql"
  | "s3"
  | "asg"
  | "mig"
  | "mig_vm"
  | "asg_ec2"
  | "eks_ec2"
  | "eks"
  | "node_group"
  | "az_vmss"
  | "az_vmss_vm"
  | "gke"
  | "node_pool"
  | "gke_vm"
  | "az_aks"
  | "az_node_pool"
  | "az_aks_vm"
  | "rds_snapshot"
  | "ebs_snapshot"
  | "rds_snapshot_source"
  | "dynamo_db_table"
  | "dynamo_db_backup"
  | "dynamo_db_backup_source"
  | "dax_cluster"
  | "nat_gateway"
  | "ecs"
  | "ecs_workload"
  | "kubernetes_node"
  | "kubernetes_namespace"
  | "kubernetes_deployment"
  | "kubernetes_stateful_set"
  | "kubernetes_daemon_set"
  | "kubernetes_replica_set"
  | "kubernetes_job"
  | "kubernetes_pod";
export type LiveResourceLinkResponse = {
  account_id?: string;
  provider_identifier?: string;
  resource_type?: ResourceType;
} | null;
export type ResourceCreationData = {
  creator?: string;
  timestamp?: Date;
} | null;
export type ListingPrice = {
  monthly: number;
  daily: number;
  hourly: number;
};
export type BillingCost = {
  start_point: Date;
  total: number;
  daily_costs: string;
} | null;
export type ResourceTarget = {
  id: string;
  provider_identifier: string;
  state: TargetState;
  name: string;
  account: EmbeddedAccount;
  tags: Tag[];
  live_resource_link_response: LiveResourceLinkResponse;
  resource_type: ResourceType;
  price_per_month: string | null;
  region: string;
  link: string;
  creation_data: ResourceCreationData;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type ImplementationEffort =
  | "very_low"
  | "low"
  | "high"
  | "very_high"
  | "medium";
export type NullableListingPrice = {
  monthly: number;
  daily: number;
  hourly: number;
};
export type OpportunityTarget = {
  id: string;
  state: TargetState;
  account: EmbeddedAccount;
  tags: Tag[];
  live_resource_link_response: LiveResourceLinkResponse;
  action_type:
    | "off_hours"
    | "rightsizing"
    | "upgrade"
    | "migrate_to_graviton"
    | "stop"
    | "delete"
    | "live_filtered_resource";
  implementation_effort: ImplementationEffort;
  region: string;
  price_per_month: number;
  cloud_provider: ProviderType;
  based_on_past: number;
  estimated_monthly_price: number;
  monthly_savings: number | null;
  description: string | null;
  resource_type?: ResourceType;
  provider_identifier: string;
  resource_arn: string | null;
  current_type: string | null;
  recommended_type: string | null;
  forecasted_end_of_month?: number | null;
  listing_price?: NullableListingPrice;
  billing_cost?: BillingCost;
};
export type Target = ResourceTarget | OpportunityTarget;
export type TaskSource = "live_usage" | "opportunity";
export type Task = {
  id: string;
  name: string;
  description: string | null;
  status: TaskStatus;
  environment: TaskEnvironment & (any | null);
  action: TaskAction & (any | null);
  priority: TaskPriority & (any | null);
  owner: TaskOwner & (any | null);
  due_date: string | null;
  created_at: Date;
  created_by: EmbeddedUser;
  modified_by: NullableEmbeddedUser;
  modified_at: NullableDate;
  target: Target;
  assignees: EmbeddedUser[] | null;
  source: TaskSource;
  comments_count?: number | null;
};
export type ResourceTargetRequest = {
  type?: "resource";
  resources?: {
    resource_type: ResourceType;
    ids: string[];
  }[];
};
export type OpportunityTargetRequest = {
  type?: "opportunity";
  ids?: string[];
};
export type TaskActivityType = "comment" | "update";
export type TaskActivityPropertyType =
  | "due_date"
  | "assignee"
  | "name"
  | "comment"
  | "task"
  | "status"
  | "action"
  | "environment"
  | "priority"
  | "owner";
export type DueDateActivityValue = {
  type: TaskActivityPropertyType;
  date: string;
};
export type AssigneeActivityValue = {
  type: TaskActivityPropertyType;
  assignee: EmbeddedUser;
};
export type NameActivityValue = {
  type: TaskActivityPropertyType;
  name: string;
};
export type CommentActivityValue = {
  type: TaskActivityPropertyType;
  comment: string;
};
export type CreationActivityValue = {
  type?: TaskActivityPropertyType;
  value?: string | null;
};
export type StatusActivityValue = {
  type: TaskActivityPropertyType;
  id: string;
  name: string;
  color: string;
  category: TaskStatusCategory;
};
export type ActionActivityValue = {
  type: TaskActivityPropertyType;
  id: string;
  name: string;
  color: string;
};
export type EnvironmentActivityValue = {
  type: TaskActivityPropertyType;
  id: string;
  name: string;
  color: string;
};
export type PriorityActivityValue = {
  type: TaskActivityPropertyType;
  id: string;
  name: string;
  color: string;
};
export type OwnerActivityValue = {
  type: TaskActivityPropertyType;
  id: string;
  name: string;
  color: string;
};
export type ActivityValue =
  | DueDateActivityValue
  | AssigneeActivityValue
  | NameActivityValue
  | CommentActivityValue
  | CreationActivityValue
  | StatusActivityValue
  | ActionActivityValue
  | EnvironmentActivityValue
  | PriorityActivityValue
  | OwnerActivityValue;
export type TaskActivity = {
  id: string;
  type: TaskActivityType;
  created_at: Date;
  created_by: EmbeddedUser;
  updated_value?: ActivityValue;
  previous_value?: ActivityValue;
};
export type PermissionName = string;
export type PermissionGroup =
  | "user_management"
  | "automation"
  | "account_management"
  | "resource_management"
  | "integration"
  | "resource_explorer"
  | "dashboard"
  | "budget"
  | "alert"
  | "commitment"
  | "subscription"
  | "sso"
  | "api_key"
  | "task_management";
export type Permission = {
  name: PermissionName;
  description: string | null;
  group: PermissionGroup;
};
export type Role = {
  id: string;
  name: string;
  description: string | null;
  permissions: Permission[];
  is_default: boolean;
  created_by: EmbeddedUser;
  modified_by: NullableEmbeddedUser;
  created_at: Date;
  modified_at: NullableDate;
};
export type Assignment = {
  role: Role;
  filter: FilterTreeNode;
  created_by: NullableEmbeddedUser;
  modified_by: NullableEmbeddedUser;
  created_at: Date;
  modified_at: NullableDate;
};
export type UserGroup = {
  name: string;
  description: string | null;
  users: EmbeddedUser[];
  assignments?: Assignment[];
  created_by: EmbeddedUser;
  modified_by: NullableEmbeddedUser;
  created_at: Date;
  modified_at: NullableDate;
};
export type AccountAttemptId = string;
export type AccountAttemptStatus =
  | "started"
  | "confirmed"
  | "failed"
  | "closed";
export type AccountAttemptStatusDetailsAwsStarted = {
  cli_command: string;
  console_link: string;
  terraform: string;
};
export type AccountAttemptStatusDetailsGcpStarted = {
  service_account: string;
};
export type AccountAttemptStatusDetailsAzureStarted = {
  service_principal: string;
  tenant_id?: string | null;
};
export type AccountAttemptStatusDetailsStarted =
  | (
      | AccountAttemptStatusDetailsAwsStarted
      | AccountAttemptStatusDetailsGcpStarted
      | AccountAttemptStatusDetailsAzureStarted
    )
  | null;
export type AccountAttemptStatusDetailsFailed = {
  /** The fail reason will be null, if status is not failed */
  reason: string;
} | null;
export type AccountAttemptStatusDetailsClosed = {
  /** The fail reason will be null, if status is not failed */
  account_id: string;
} | null;
export type AccountAttempt = {
  id: AccountAttemptId;
  type: ProviderType;
  access_type: ProviderAccessType;
  user_id: string;
  status: AccountAttemptStatus;
  status_details: {
    started?: AccountAttemptStatusDetailsStarted;
    failed?: AccountAttemptStatusDetailsFailed;
    closed?: AccountAttemptStatusDetailsClosed;
  } | null;
  account_id: string | null;
  created_at: Date;
};
export type AccountId = string;
export type AccountStatus =
  | "initial_pulling"
  | "connected"
  | "failed"
  | "deleted"
  | "deleting"
  | "deactivated"
  | "connected_for_billing"
  | "inactive"
  | "missing_sub_account_role";
export type ProviderAccountId = string | null;
export type AccountAwsProviderDetails = {
  aws?: {
    is_root?: boolean;
    organisation_id?: string | null;
  };
};
export type AccountGcpProviderDetails = {
  gcp?: {
    project_id: string | null;
    service_account: string;
  };
};
export type AccountAzureProviderDetails = {
  azure?: {
    subscription_id: string;
    subscription_name: string;
    service_principal: string;
    tenant_id: string;
  };
};
export type Billing = {
  last_month_total_cost: number;
  last_month_total_cost_start_date: Date;
  last_month_total_cost_end_date: Date;
  last_month_trend: number;
};
export type PermissionType = "api" | "role" | "iam_permission" | "permission";
export type AccountMissingPermissions = {
  /** name of permission */
  name: string;
  /** title of permission */
  title: string | null;
  /** url of permission */
  url: string;
  type: PermissionType;
}[];
export type Account = {
  id: AccountId;
  type: ProviderType;
  access_type: ProviderAccessType;
  status: AccountStatus;
  provider_account_id: ProviderAccountId;
  provider_account_name?: string | null;
  /** Provoder organisation id */
  provider_organisation_account_id: string | null;
  /** Whether the account is root or not */
  is_provider_root_account: boolean;
  is_sub_account: boolean;
  /** Account parent id */
  parent_id: string | null;
  /** Account parent id */
  user_id: string;
  created_at: Date;
  outdated: boolean;
  last_resource_updated_date: NullableDate;
  ems: number;
  total_monthly_saved_costs: number;
  total_costs: number;
  permission_failed_for_all_resources: boolean;
  provider_details:
    | AccountAwsProviderDetails
    | AccountGcpProviderDetails
    | AccountAzureProviderDetails;
  is_billing_collection_in_progress: boolean;
  has_satisfied_permissions: boolean;
  last_month_total_cost: number | null;
  billing: Billing;
  group_id?: string | null;
  /** Applied filter set id */
  filter_set_id: string | null;
  missing_permissions: AccountMissingPermissions;
};
export type Accounts = Account[] | null;
export type CloudProvider =
  | "gcp"
  | "aws"
  | "azure"
  | "kubernetes"
  | "eks"
  | "confluent"
  | "datadog"
  | "snowflake"
  | "mongo";
export type FilterKeyType =
  | "launch_time"
  | "cpu"
  | "network_in"
  | "network_out"
  | "tag"
  | "attachments"
  | "volume_age"
  | "database_connections"
  | "instances"
  | "instance_ids"
  | "association_ids"
  | "region"
  | "in_use"
  | "total_connections"
  | "cloudchipr_ttl"
  | "provider_unique_identifier"
  | "name"
  | "is_public"
  | "size"
  | "creation_date"
  | "creator"
  | "unused_since"
  | "issues"
  | "resource_group"
  | "instance_type"
  | "storage_type"
  | "state"
  | "instance_family"
  | "type"
  | "snapshot_id"
  | "source_name"
  | "volume_id"
  | "storage_tier"
  | "snapshot_status"
  | "billable"
  | "requests"
  | "label"
  | "read_usage"
  | "write_usage"
  | "rcu_reservation"
  | "wcu_reservation"
  | "status"
  | "capacity_mode"
  | "table"
  | "cpu_reservation"
  | "memory_reservation"
  | "memory"
  | "nodes_count"
  | "node_type"
  | "protected_by"
  | "ip_addresses"
  | "vpc"
  | "nat_gateway_id"
  | "processed_data"
  | "registered_container_instances"
  | "start_date"
  | "storage"
  | "capacity_provider"
  | "task_count"
  | "ecs_workload_pid"
  | "resource_unique_identifier"
  | "memory_available"
  | "support_type"
  | "support_type_expiration"
  | "desired_capacity"
  | "min_capacity"
  | "max_capacity"
  | "scheme"
  | "processed_bytes"
  | "encryption"
  | "ebs_optimized"
  | "has_public_ip"
  | "public_access"
  | "has_task"
  | "task_status"
  | "table_class"
  | "snapshots_price_ratio"
  | "cpu_core"
  | "cpu_utilization"
  | "memory_utilization"
  | "memory_bytes"
  | "has_lifecycle_rule"
  | "platform"
  | "disk_type"
  | "total_cpu"
  | "architecture"
  | "total_memory";
export type FilterStatisticsType = "sum" | "maximum" | "minimum" | "average";
export type Unit = "hours" | "days";
export type Since = {
  value?: number;
  unit?: Unit;
};
export type MetricOfFilterItem = {
  statistics_type?: FilterStatisticsType;
  since?: Since;
};
export type FilterItem = {
  key: FilterKeyType;
  value?: (number | null) | (string | null) | Tag | (string[] | null);
  operator: FilterOperatorType;
  metric?: MetricOfFilterItem;
};
export type ExecutionLogAction = "terminate" | "stop" | "start";
export type ResourceFilter = {
  type: ResourceType;
  filters: FilterItem[];
  or_filters?: FilterItem[][];
  action?: ExecutionLogAction;
  snapshot?: boolean;
};
export type FilterItemWithType = {
  type: ResourceType;
  filter: FilterItem;
};
export type FilterGroup = (number | FilterGroup)[];
export type ResourceFilters = {
  type: ResourceType;
  filter_items: FilterItemWithType[];
  filter_groups: (number | FilterGroup)[];
  operators: ("and" | "or")[];
};
export type GlobalFilterItem = {
  filter: FilterItem;
};
export type GlobalResourceFilters = {
  filter_items: GlobalFilterItem[];
  filter_groups: (number | FilterGroup)[];
  operators: ("and" | "or")[];
};
export type AccountCost = {
  timestamp: Date;
  type: string;
  cost: number;
  ems: number;
  default_ems: number;
};
export type ProviderBillingStatus = {
  is_initial_billing_collection_in_progress: boolean | null;
  is_billing_collection_in_progress: boolean;
  billing_collection_problems:
    | {
        account_name?: string;
        problems?: string[];
      }[]
    | null;
};
export type BillingCollectionStatus =
  | "new"
  | "missing_setup"
  | "waiting_for_cloud_provider"
  | "collecting"
  | "analysing"
  | "error"
  | "missing_data"
  | "active";
export type BillingAccountStatus = {
  account_id?: string;
  status?: BillingCollectionStatus;
  name?: string | null;
  provider_account_id?: string;
  problem_message?: string | null;
};
export type OrganisationBillingStatus = {
  organisation_id?: string;
  cloud_provider?: CloudProvider;
  status?: BillingCollectionStatus;
  billing_account_statuses?: BillingAccountStatus[];
};
export type OrganisationBillingCurrent = {
  compute: number;
  storage: number;
  databases: number;
  networking: number;
  containers: number;
};
export type Tags = Tag[];
export type OrganisationDailyOffHoursRecommendation = {
  id: string;
  resource_id: string;
  account_id: string;
  account: EmbeddedAccount;
  from_hour: number;
  to_hour: number;
  number_of_off_hours: number;
  provider_unique_identifier: string;
  resource_name?: string | null;
  tags?: Tags;
  potential_saving: number;
  region: string;
  resource_type: ResourceType;
  type: string;
  dismiss_until_date: string | null;
  is_forever_dismissed: boolean;
  dismissed_by: string | null;
  is_dismissed_by_resource: boolean;
  resource_identifier: string;
};
export type OrganisationWeeklyOffHoursRecommendation = {
  id: string;
  resource_id: string;
  account_id: string;
  account: EmbeddedAccount;
  provider_unique_identifier: string;
  resource_name?: string | null;
  tags?: Tags;
  potential_saving: number;
  region: string;
  resource_type: ResourceType;
  from_hour: number;
  to_hour: number;
  from_day:
    | "monday"
    | "tuesday"
    | "wednesday"
    | "thursday"
    | "friday"
    | "saturday"
    | "sunday";
  to_day:
    | "monday"
    | "tuesday"
    | "wednesday"
    | "thursday"
    | "friday"
    | "saturday"
    | "sunday";
  number_of_off_hours: number;
  type: string;
  dismiss_until_date: string | null;
  is_forever_dismissed: boolean;
  dismissed_by: string | null;
  is_dismissed_by_resource: boolean;
  resource_identifier: string;
};
export type AccountLight = {
  id: string;
  provider: ProviderType;
  provider_account_id: string;
  provider_account_name: string;
  provider_access_type: ProviderAccessType;
  filter_set_id: string | null;
};
export type ResourceAction = "stop" | "start" | "terminate" | "reboot";
export type ResourceActionExecution = {
  type: ResourceType;
  action?: ResourceAction;
  resources: {
    name: string;
    state?: "succeeded" | "failed" | "skipped";
  }[];
};
export type LastExecution = {
  succeeded: number;
  failed: number;
  skipped: number;
  status: "failed" | "succeeded" | "skipped";
  results?: ResourceActionExecution[];
};
export type ExecutionLogV3 = {
  id: string;
  monthly_price: number | null;
  accounts: AccountLight[];
  response: {
    type: ResourceType;
    resources: {
      action: ResourceAction | (any | null);
      price_per_month: number | null;
      provider_unique_identifier: string;
      name: string;
      account: AccountLight;
      region: string;
      snapshot: boolean | null;
      tags: Tags | (any | null);
      log: string | null;
      succeded: boolean | null;
      state: ("succeed" | "failed" | "skipped") | null;
    }[];
  }[];
  created_at: Date;
  source: {
    source: ("manual" | "scheduler" | "workflow" | "off_hours") | null;
    metadata: {
      id: string | null;
      name: string | null;
    };
  };
  last_execution: LastExecution;
};
export type MinimumAvailableDate = {
  minimum_available_date: NullableDate;
};
export type ResourceState =
  | "stopping"
  | "running"
  | "stopped"
  | "stopped_allocated";
export type InlineResourceMetric = {
  daily: string;
  hourly: string;
};
export type ComputeInlineMetrics = {
  daily_start_point?: NullableDate;
  hourly_start_point?: NullableDate;
  cpu_max?: InlineResourceMetric;
  mem_used_percent_max?: InlineResourceMetric;
  mem_available_percent_min?: InlineResourceMetric;
};
export type Recommendations = {
  right_sizing_recommendations: {
    id: string;
    potential_savings: number;
  }[];
  off_hours_recommendations: {
    id: string;
    potential_savings: number;
  }[];
};
export type ResourceIssues = {
  id: string;
  issue_provider_id: string;
  type: "jira";
  link: string;
  key: string;
  status: {
    description: string;
    name: string;
    color_name: string;
  };
}[];
export type UnusedSince = {
  is_used: boolean;
  timestamp?: NullableDate;
};
export type UpcomingAction = {
  schedule_id: string;
  schedule_name: string;
  schedule_type: string;
  action_date: Date;
} | null;
export type NullableEmbeddedTask = EmbeddedTask | null;
export type BillingExplorerResourceIdentifier = string[];
export type Attachment = {
  id?: string;
  device?: string;
  status?: ("attached" | "detached") | null;
  attach_time?: string;
};
export type Ec2 = {
  id: string;
  resource_state: ResourceState | (any | null);
  image_id: string;
  instance_id: string;
  is_spot_instance: boolean;
  name?: string;
  type: string;
  inline_metrics?: ComputeInlineMetrics;
  cpu_value: number | null;
  network_in_value: number | null;
  network_out_value: number | null;
  created_at: NullableDate;
  price_per_month: number;
  availability_zone: string;
  region: string;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason?: string | null;
  provider_status: string;
  provider_unique_identifier: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data?: ResourceCreationData;
  recommendations: Recommendations;
  issues: ResourceIssues;
  all_time_spent: number | null;
  unused_since: UnusedSince;
  is_stopped: boolean;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  protected_by: string | null;
  ebs_optimized: ("enabled" | "disabled" | "unsupported") | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  attachments?: Attachment[];
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
  platform: string;
  total_cpu: number;
  total_memory: number;
};
export type Asg = {
  id: string;
  provider_unique_identifier: string;
  name: string;
  instances_count: number;
  desired_capacity: number;
  max_capacity: number;
  min_capacity: number;
  price_per_month: number;
  region: string;
  instances: Ec2[];
  created_at: NullableDate;
  resource_type: ResourceType;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  recommendations: Recommendations;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  protected_by: string | null;
  public_ip?: "enabled" | "disabled";
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type Ebs = {
  id: string;
  volume_id: string;
  size: number;
  state: string;
  name: string;
  type: string;
  price_per_month: number;
  availability_zone: string;
  created_at: NullableDate;
  region: string;
  has_attachments: boolean;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  provider_unique_identifier: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  unused_since: UnusedSince;
  issues: ResourceIssues;
  recommendations?: Recommendations;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  protected_by: string | null;
  is_encrypted: boolean | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  attachments?: Attachment[];
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type StorageTier = "archive" | "standard" | "warm" | "cold";
export type Billable = "yes" | "no" | "analyzing";
export type EbsSnapshot = {
  id: string;
  provider_unique_identifier: string;
  snapshot_id: string;
  name: string;
  storage_tier: StorageTier;
  volume_size: string;
  status: string;
  volume_id: string;
  is_encrypted: boolean;
  progress: string;
  region: string;
  created_at: NullableDate;
  price_per_month: number;
  marked_for_deletion: boolean;
  cleanup_failure_reason: string | null;
  is_protected: boolean;
  is_successfully_archived: boolean;
  tags: Tags;
  resource_type: ResourceType;
  is_snapshot_used: boolean;
  used_by_image: string | null;
  total_siblings: number;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  unused_since: UnusedSince;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  billable: Billable;
  protected_by: string | null;
  task?: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type Eip = {
  id: string;
  ip: string;
  price_per_month: number;
  region: string;
  name: string;
  tags: Tags;
  created_at: NullableDate;
  allocation_id: string | null;
  association_id: string | null;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  instance_id: string | null;
  provider_unique_identifier: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  unused_since: UnusedSince;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type ResourceSupportType = "extended" | "standard";
export type EksUpgradePolicy = "extended" | "standard";
export type Label = {
  key: string;
  value: string;
};
export type EksEc2 = {
  id: string;
  provider_unique_identifier: string;
  instance_id: string;
  image_id: string;
  is_spot_instance: boolean;
  type: string;
  inline_metrics?: ComputeInlineMetrics;
  cpu_value: number | null;
  network_in_value: number | null;
  network_out_value: number | null;
  availability_zone: string;
  created_at: NullableDate;
  price_per_month: number;
  region: string;
  account_id: string;
  marked_for_deletion: boolean;
  cleanup_failure_reason: string | null;
  is_successfully_deleted: boolean;
  is_protected: boolean;
  creation_data: ResourceCreationData;
  tags: Tags;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  all_time_spent: number | null;
  is_stopped: boolean;
  unused_since: UnusedSince;
  resource_state: ResourceState | (any | null);
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type NodeGroupType = "eks_node_group" | "karpenter_node_pool";
export type NodeGroup = {
  id: string;
  name: string;
  price_per_month: number;
  created_at: NullableDate;
  region: string;
  resource_type: ResourceType;
  account_id: string;
  provider_unique_identifier: string;
  cleanup_failure_reason: string | null;
  is_protected: boolean;
  instances_count: number;
  is_successfully_deleted: boolean;
  creation_data: ResourceCreationData;
  tags: Tags;
  labels: Label[];
  instances: EksEc2[];
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  issues?: ResourceIssues;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
  type: NodeGroupType;
};
export type Eks = {
  id: string;
  provider_unique_identifier: string;
  marked_for_deletion: boolean;
  name: string;
  cluster_id: string;
  instances_count: number;
  node_count: number;
  version?: string;
  support_type: ResourceSupportType;
  support_type_expiration?: NullableDate;
  upgrade_policy: EksUpgradePolicy;
  price_per_month: number;
  created_at: NullableDate;
  region: string;
  account_id: string;
  cleanup_failure_reason: string | null;
  is_protected: boolean;
  is_successfully_deleted: boolean;
  creation_data: ResourceCreationData;
  tags: Tags;
  instances: NodeGroup[];
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  issues?: ResourceIssues;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type ElbInlineMetrics = {
  daily_start_point?: NullableDate;
  hourly_start_point?: NullableDate;
  processed_bytes?: InlineResourceMetric;
};
export type Elb = {
  id: string;
  type: string;
  load_balancer_name: string;
  load_balancer_arn: string | null;
  price_per_month: number;
  dns_name: string;
  created_at: NullableDate;
  region: string;
  name: string;
  has_attachments: boolean;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  provider_unique_identifier: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  unused_since: UnusedSince;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  protected_by: string | null;
  scheme: ("internet_facing" | "internal") | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  targets: string[];
  inline_metrics: ElbInlineMetrics;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type Metric = {
  timestamp: string;
  average: number;
  maximum: number;
  minimum: number;
  sum: number;
  unit: string;
};
export type Elc = {
  id: string;
  cluster_id: string;
  price_per_month: number;
  instance_type: string;
  cache_type: string;
  nodes_count: number;
  connections: Metric[];
  connections_by_hours?: Metric[];
  connections_value?: number | null;
  cpu: Metric[];
  cpu_by_hours?: Metric[];
  cpu_value?: number | null;
  created_at: NullableDate;
  region: string;
  name: string;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  provider_unique_identifier: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  issues?: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type DatabaseInlineMetrics = {
  daily_start_point?: NullableDate;
  hourly_start_point?: NullableDate;
  cpu_max?: InlineResourceMetric;
  total_connection_sum?: InlineResourceMetric;
};
export type Rds = {
  id: string;
  db_id: string;
  price_per_month: number;
  instance_type: string;
  storage_type: string;
  inline_metrics?: DatabaseInlineMetrics;
  database_connections: Metric[];
  connections: Metric[];
  connections_by_hours?: Metric[];
  connections_value?: number | null;
  cpu: Metric[];
  cpu_by_hours?: Metric[];
  cpu_value?: number | null;
  db_type: string;
  name: string;
  created_at: NullableDate;
  availability_zone: string;
  status?: string | null;
  resource_state: ResourceState | (any | null);
  provider_status: string;
  region: string;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  provider_unique_identifier: string;
  cluster_id?: string | null;
  nodes_count?: number | null;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  recommendations: Recommendations;
  issues: ResourceIssues;
  all_time_spent: number | null;
  unused_since: UnusedSince;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  protected_by: string | null;
  is_encrypted: boolean | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  support_type: ResourceSupportType;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type RdsSnapshot = {
  region: string;
  price_per_month: number;
  created_by: string;
  created_at: NullableDate;
  db_type: "instance" | "cluster";
  storage_type: string;
  storage: string;
  type: ("manual" | "automated" | "awsbackup") | null;
  engine: string;
  name: string;
  source_name: string;
  total_siblings?: number;
  is_encrypted: boolean;
  zone: string;
  tags: Tags;
  resource_type: ResourceType;
  id: string;
  provider_unique_identifier: string;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  recommendations: Recommendations;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  billable: Billable;
  is_aurora: boolean;
  protected_by?: string | null;
  is_public: boolean | null;
  task?: NullableEmbeddedTask;
  billing_explorer_resource_identifier?: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type DataStorageInlineMetrics = {
  daily_start_point?: NullableDate;
  hourly_start_point?: NullableDate;
  all_request_sum?: InlineResourceMetric;
};
export type S3 = {
  id: string;
  provider_unique_identifier: string;
  name: string;
  lifecycle_rule_names?: string[] | null;
  created_at: NullableDate;
  region: string;
  size: number;
  is_public: boolean | null;
  public_access: string | null;
  inline_metrics?: DataStorageInlineMetrics;
  last_modified?: NullableDate;
  tags: Tags;
  price_per_month: number;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason?: string | null;
  requests_value: number | null;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  issues?: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type AzAksVm = {
  id: string;
  type: string;
  name: string;
  inline_metrics?: ComputeInlineMetrics;
  cpu_value: number | null;
  network_in_value: number | null;
  network_out_value: number | null;
  provider_unique_identifier: string;
  is_stopped: boolean;
  availability_zone: string;
  created_at: NullableDate;
  price_per_month: number;
  region: string | null;
  marked_for_deletion: boolean;
  cleanup_failure_reason: string | null;
  is_successfully_deleted: boolean;
  is_protected: boolean;
  creation_data: ResourceCreationData;
  tags: Tags;
  provider_status: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  all_time_spent: number | null;
  resource_state: ResourceState | (any | null);
  unused_since: UnusedSince;
  mode: string;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  issues?: ResourceIssues;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type AzNodePool = {
  id: string;
  name: string;
  mode?: string;
  price_per_month: number;
  created_at: NullableDate;
  region: string;
  account_id?: string;
  provider_unique_identifier: string;
  cleanup_failure_reason: string | null;
  is_protected: boolean;
  is_successfully_deleted: boolean;
  creation_data: ResourceCreationData;
  tags: Tags;
  instances_count: number;
  instances: AzAksVm[];
  marked_for_deletion: boolean;
  resource_type: ResourceType;
  link: string;
  not_allowed_actions: string[];
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  issues?: ResourceIssues;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type AzAks = {
  id: string;
  provider_unique_identifier: string;
  name: string;
  node_pool_count: number;
  nodes_count: number;
  marked_for_deletion: boolean;
  price_per_month: number;
  created_at: NullableDate;
  region: string;
  cleanup_failure_reason: string | null;
  is_protected: boolean;
  creation_data: ResourceCreationData;
  tags: Tag[];
  is_successfully_deleted: boolean;
  node_pools: AzNodePool[];
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  all_time_spent: number | null;
  issues: ResourceIssues;
  pricing_tier: string;
  total_available_cpus: number;
  total_available_memory: string;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  protected_by: string | null;
  resource_group: string;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type AzDisk = {
  id: string;
  provider_unique_identifier: string;
  name: string;
  size: number;
  sku: string;
  resource_group: string;
  has_attachments: boolean;
  created_at: NullableDate;
  price_per_month: number;
  region: string;
  tags: Tag[];
  marked_for_deletion: boolean;
  cleanup_failure_reason: string;
  is_protected: boolean;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  unused_since: UnusedSince;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type AzIp = {
  id: string;
  provider_unique_identifier: string;
  ip: string;
  name: string;
  resource_group: string;
  is_in_use: boolean;
  price_per_month: number;
  region: string;
  tags: Tag[];
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  unused_since: UnusedSince;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type AzLb = {
  id: string;
  provider_unique_identifier: string;
  name: string;
  sku: string;
  has_backend: boolean;
  number_of_rules: number;
  created_at: NullableDate;
  price_per_month: number;
  region: string;
  tags: Tag[];
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  unused_since: UnusedSince;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  protected_by: string | null;
  resource_group: string;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type AzSql = {
  id: string;
  type?: string;
  provider_unique_identifier: string;
  pricing_tier: string;
  instance_type: string;
  number_of_replicas: number;
  db_name: string;
  inline_metrics?: DatabaseInlineMetrics;
  cpu_value?: number | null;
  cpu_by_hours: Metric[];
  connections_by_hours: Metric[];
  connections_value?: number | null;
  created_at: NullableDate;
  price_per_month: number;
  region: string;
  name: string;
  tags: Tag[];
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  recommendations: Recommendations;
  issues: ResourceIssues;
  all_time_spent: number | null;
  unused_since: UnusedSince;
  resource_state: ResourceState | (any | null);
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  protected_by: string | null;
  resource_group: string;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type AzVm = {
  id: string;
  provider_unique_identifier: string;
  name: string;
  size: string;
  inline_metrics?: ComputeInlineMetrics;
  cpu_value?: number | null;
  network_in_value?: number | null;
  network_out_value?: number | null;
  created_at: NullableDate;
  price_per_month: number;
  resource_group: string;
  region: string;
  tags: Tag[];
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string;
  provider_status: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  recommendations: Recommendations;
  issues: ResourceIssues;
  all_time_spent: number | null;
  unused_since: UnusedSince;
  resource_state: ResourceState | (any | null);
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
  platform: string;
  total_cpu: number;
  total_memory: number;
};
export type AzScaleCapacity = {
  default: string;
  maximum: string;
  minimum: string;
};
export type AzAutoscalingProfile = {
  name: string;
  azScaleCapacity: AzScaleCapacity;
  isDefault: string;
};
export type AzVmss = {
  id: string;
  provider_unique_identifier: string;
  name: string;
  resource_group: string;
  instances_count: number;
  desired_capacity: number;
  instances: AzVm[];
  price_per_month: number;
  orchestration_mode: string;
  scaling: string;
  autoscaling_profiles: AzAutoscalingProfile[];
  created_at: NullableDate;
  resource_type: ResourceType;
  region: string;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  recommendations: Recommendations;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type Disk = {
  id: string;
  name: string;
  provider_unique_identifier: string;
  price_per_month: number;
  type: string;
  size: number;
  state: string;
  availability_zone: string;
  region: string | null;
  tags: Tags;
  has_attachments?: boolean;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  created_at: NullableDate;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  unused_since: UnusedSince;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type GkeVm = {
  id: string;
  type: string;
  name: string;
  cpu_value: number | null;
  network_in_value: number | null;
  network_out_value: number | null;
  inline_metrics: ComputeInlineMetrics;
  provider_unique_identifier: string;
  is_stopped: boolean;
  availability_zone: string;
  created_at: NullableDate;
  price_per_month: number;
  region: string | null;
  marked_for_deletion: boolean;
  cleanup_failure_reason: string | null;
  is_successfully_deleted: boolean;
  is_protected: boolean;
  creation_data: ResourceCreationData;
  tags: Tags;
  provider_status: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  all_time_spent: number | null;
  unused_since: UnusedSince;
  resource_state: ResourceState | (any | null);
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  issues?: ResourceIssues;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type NodePool = {
  id: string;
  name: string;
  price_per_month: number;
  created_at: NullableDate;
  region: string;
  account_id?: string;
  provider_unique_identifier: string;
  cleanup_failure_reason: string | null;
  is_protected: boolean;
  is_successfully_deleted: boolean;
  creation_data: ResourceCreationData;
  tags: Tags;
  instances_count: number;
  instances: GkeVm[];
  marked_for_deletion: boolean;
  resource_type: ResourceType;
  link: string;
  not_allowed_actions: string[];
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  issues?: ResourceIssues;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type Gke = {
  id: string;
  provider_unique_identifier: string;
  name: string;
  node_pool_count: number;
  nodes_count: number;
  marked_for_deletion: boolean;
  price_per_month: number;
  created_at: NullableDate;
  region: string;
  cleanup_failure_reason: string | null;
  is_protected: boolean;
  creation_data: ResourceCreationData;
  tags: Tag[];
  is_successfully_deleted: boolean;
  node_pools: NodePool[];
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  all_time_spent: number | null;
  issues: ResourceIssues;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  support_type: ResourceSupportType;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type Ip = {
  id: string;
  ip: string;
  name?: string;
  is_in_use: boolean;
  price_per_month: number;
  region: string;
  tags: Tags;
  created_at: NullableDate;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  provider_unique_identifier: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  unused_since: UnusedSince;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type Lb = {
  id: string;
  name: string;
  load_balancer_name: string;
  price_per_month: number;
  type?: "TCP";
  global: boolean;
  created_at: NullableDate;
  has_attachments: boolean;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  provider_unique_identifier: string;
  region?: string | null;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  unused_since: UnusedSince;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type MigVm = {
  id: string;
  image_id: string;
  type: string;
  cpu: Metric[];
  cpu_by_hours: Metric[];
  cpu_value: number | null;
  network_in: Metric[];
  network_in_by_hours: Metric[];
  network_in_value: number | null;
  network_out: Metric[];
  network_out_by_hours: Metric[];
  network_out_value: number | null;
  inline_metrics: ComputeInlineMetrics;
  created_at: NullableDate;
  price_per_month: number;
  availability_zone: string;
  region: string | null;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  provider_unique_identifier: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  all_time_spent: number | null;
  unused_since: UnusedSince;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  recommendations?: Recommendations;
  issues?: ResourceIssues;
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type Mig = {
  id: string;
  provider_unique_identifier: string;
  name: string;
  instances_count: number;
  recommended_size: number;
  max_num_replicas: number;
  min_num_replicas: number;
  price_per_month: number;
  region: string;
  instances: MigVm[];
  created_at: NullableDate;
  resource_type: ResourceType;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  recommendations: Recommendations;
  issues: ResourceIssues;
  all_time_spent: number | null;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  protected_by: string | null;
  task?: NullableEmbeddedTask;
  billing_explorer_resource_identifier?: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type Sql = {
  id: string;
  multi_az: boolean;
  price_per_month: number;
  cpu_size: string;
  ram_size: string;
  storage: string;
  database_connections: Metric[];
  inline_metrics?: ComputeInlineMetrics;
  connections: Metric[];
  connections_by_hours?: Metric[];
  connections_value?: number | null;
  cpu: Metric[];
  cpu_by_hours?: Metric[];
  cpu_value?: number | null;
  type: string;
  created_at: NullableDate;
  region: string;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  provider_status: string;
  resource_type: ResourceType;
  provider_unique_identifier: string;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  recommendations: Recommendations;
  issues: ResourceIssues;
  all_time_spent: number | null;
  unused_since: UnusedSince;
  resource_state: ResourceState | (any | null);
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  protected_by: string | null;
  name: string;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  support_type: ResourceSupportType;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type Vm = {
  id: string;
  image_id: string;
  type: string;
  cpu: Metric[];
  cpu_by_hours?: Metric[];
  cpu_value?: number | null;
  network_in: Metric[];
  network_in_by_hours?: Metric[];
  network_in_value?: number | null;
  network_out: Metric[];
  network_out_by_hours?: Metric[];
  inline_metrics?: ComputeInlineMetrics;
  network_out_value?: number | null;
  created_at: NullableDate;
  price_per_month: number;
  availability_zone: string;
  region?: string | null;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  provider_status: string;
  provider_unique_identifier: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  recommendations: Recommendations;
  issues: ResourceIssues;
  all_time_spent: number | null;
  unused_since: UnusedSince;
  resource_state: ResourceState | (any | null);
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  protected_by: string | null;
  name: string;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
  platform: string;
  total_cpu: number;
  total_memory: number;
};
export type RdsSnapshotSource = {
  id: string;
  price_per_month: number;
  db_price?: number;
  db_price_ratio?: number;
  created_at: NullableDate;
  resource_type: ResourceType;
  region: string;
  db_type: "instance" | "cluster";
  engine: string;
  exists: boolean;
  snapshots_count: number;
  marked_for_deletion: boolean;
  cleanup_failure_reason: string | null;
  provider_unique_identifier: string;
  is_protected: boolean;
  billable: Billable;
  all_time_spent: number | null;
  tags: Tags;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  name: string;
  account: AccountLight;
  upcoming_actions?: UpcomingAction[];
  is_aurora: boolean;
  protected_by: string | null;
  issues?: ResourceIssues;
  task?: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type CapacityMode = {
  min_capacity_units: number | null;
  current_provisioned_units: number | null;
  max_capacity_units: number | null;
  autoscaling: boolean | null;
};
export type DynamoDbTable = {
  id: string;
  name: string;
  size: string;
  provider_status: string;
  table_class: string | null;
  replicas: number;
  capacity_mode: string;
  read_capacity_mode: CapacityMode;
  write_capacity_mode: CapacityMode;
  read_usage_value: number | null;
  write_usage_value: number | null;
  rcu_reservation_value: number | null;
  wcu_reservation_value: number | null;
  created_at: Date;
  price_per_month: number;
  region: string | null;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  provider_unique_identifier: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  issues: ResourceIssues;
  all_time_spent: number;
  account: AccountLight;
  upcoming_actions: UpcomingAction[];
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type DynamoDbBackupSource = {
  id: string;
  price_per_month: number;
  created_at: NullableDate;
  resource_type: ResourceType;
  region: string;
  marked_for_deletion: boolean;
  cleanup_failure_reason: string | null;
  provider_unique_identifier: string;
  is_protected: boolean;
  all_time_spent: number | null;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  name: string;
  account: AccountLight;
  backup_count: number;
  exists: boolean;
  table_class: string;
  status: string;
  db_price: number;
  db_price_ratio: number;
  tags: Tags;
  protected_by?: string | null;
  upcoming_actions?: UpcomingAction[];
  issues?: ResourceIssues;
  task?: NullableEmbeddedTask;
  billing_explorer_resource_identifier?: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type DaxCluster = {
  account: AccountLight;
  id: string;
  name?: string;
  node_type: string;
  node_count: number;
  cpu_reservation: number;
  memory_reservation: number;
  cpu_utilization_value: number | null;
  cache_memory_utilization_value: number | null;
  network_bytes_in_value: number | null;
  network_bytes_out_value: number | null;
  total_request_count_value: number | null;
  created_at: Date;
  price_per_month: number;
  region: string | null;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  provider_unique_identifier: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  all_time_spent: number;
  upcoming_actions: UpcomingAction[];
  protected_by: string | null;
  recommendations: Recommendations;
  issues: ResourceIssues;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
  inline_metrics?: ComputeInlineMetrics;
};
export type NetworkInlineMetrics = {
  daily_start_point?: NullableDate;
  hourly_start_point?: NullableDate;
  total_connection_sum?: InlineResourceMetric;
};
export type NatGateway = {
  id: string;
  provider_unique_identifier: string;
  nat_gateway_id: string;
  name: string;
  created_at: NullableDate;
  price_per_month: number;
  region: string;
  sub_net: string;
  vpc: string;
  connectivity_type: string;
  public_addresses: string[];
  network_interface_ids: string[];
  private_addresses: string[];
  processed_data_value: number | null;
  processed_data_days: number | null;
  active_connections_value: number | null;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  issues: ResourceIssues;
  all_time_spent: number;
  account: AccountLight;
  upcoming_actions: UpcomingAction[];
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
  inline_metrics?: NetworkInlineMetrics;
};
export type Ecs = {
  id: string;
  provider_unique_identifier: string;
  capacity_providers: number;
  instances: number;
  price_per_month: number;
  created_at: NullableDate;
  tags: Tags;
  region: string;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  all_time_spent: number;
  name: string;
  account: AccountLight;
  protected_by: string | null;
  issues: ResourceIssues;
  upcoming_actions: UpcomingAction[];
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type EcsWorkload = {
  id: string;
  provider_unique_identifier: string;
  type: string;
  started_at: NullableDate;
  cpu_value: number | null;
  cpu_reservation: number | null;
  memory_value: number | null;
  memory_reservation: number | null;
  storage: number | null;
  status: string | null;
  capacity_provider: string | null;
  task_count: number | null;
  revision: number | null;
  price_per_month: number;
  created_at: NullableDate;
  tags: Tags;
  region: string;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  all_time_spent: number;
  name: string;
  account: AccountLight;
  protected_by: string | null;
  issues: ResourceIssues;
  upcoming_actions: UpcomingAction[];
  task?: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
  inline_metrics?: ComputeInlineMetrics;
};
export type EmbeddedTask = {
  id: string;
  status_id: string;
};
export type EcsWorkloadTask = {
  id: string;
  provider_unique_identifier: string;
  started_at: NullableDate;
  cpu_reservation: number;
  memory_reservation: number;
  storage: number | null;
  service: string | null;
  group: string | null;
  cluster: string;
  revision: number | null;
  last_status: string;
  desired_status: string | null;
  health_status: string | null;
  started_by: string | null;
  price_per_month: number;
  created_at: NullableDate;
  tags: Tags;
  region: string;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  all_time_spent: number;
  name: string;
  account: AccountLight;
  protected_by: string | null;
  issues: ResourceIssues;
  upcoming_actions: UpcomingAction[];
  task: (any | null) & EmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type FilteredAsgEc2ResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Ec2;
  child_resource: any | null;
};
export type FilteredAsgEc2Resources = {
  resources: FilteredAsgEc2ResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredAsgResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Asg;
  child_resource: FilteredAsgEc2Resources | null;
};
export type FilteredAsgResources = {
  resources: FilteredAsgResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredEbsResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Ebs;
  child_resource: any | null;
};
export type FilteredEbsResources = {
  resources: FilteredEbsResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredEbsSnapshotResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: EbsSnapshot;
  child_resource: any | null;
};
export type FilteredEbsSnapshotResourcesV2 = {
  resources: FilteredEbsSnapshotResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredEc2ResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Ec2;
  child_resource: any | null;
};
export type FilteredEc2Resources = {
  resources: FilteredEc2ResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredEipResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Eip;
  child_resource: any | null;
};
export type FilteredEipResources = {
  resources: FilteredEipResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredEksEc2ResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: EksEc2;
  child_resource: any | null;
};
export type FilteredEksEc2Resources = {
  resources: FilteredEksEc2ResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredNodeGroupResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: NodeGroup;
  child_resource: FilteredEksEc2Resources | null;
};
export type FilteredNodeGroupResources = {
  resources: FilteredNodeGroupResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredEksResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Eks;
  child_resource: FilteredNodeGroupResources | null;
};
export type FilteredEksResources = {
  resources: FilteredEksResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredElbResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Elb;
  child_resource: any | null;
};
export type FilteredElbResources = {
  resources: FilteredElbResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredElcResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Elc;
  child_resource: any | null;
};
export type FilteredElcResources = {
  resources: FilteredElcResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredRdsResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Rds;
  child_resource: any | null;
};
export type FilteredRdsResources = {
  resources: FilteredRdsResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredRdsSnapshotResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: RdsSnapshot;
  child_resource: any | null;
};
export type FilteredRdsSnapshotResourcesV2 = {
  resources: FilteredRdsSnapshotResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredS3ResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: S3;
  child_resource: any | null;
};
export type FilteredS3Resources = {
  resources: FilteredS3ResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredAzAksVmResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: AzAksVm;
  child_resource: any | null;
};
export type FilteredAzAksVmResources = {
  resources: FilteredAzAksVmResourceItem;
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredAzNodePoolResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: NodePool;
  child_resource: FilteredAzAksVmResources | null;
};
export type FilteredAzNodePoolResources = {
  resources: FilteredAzNodePoolResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredAzAksResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: AzAks;
  child_resource: FilteredAzNodePoolResources | null;
};
export type FilteredAzAksResources = {
  resources: FilteredAzAksResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredAzDiskResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: AzDisk;
  child_resource: any | null;
};
export type FilteredAzDiskResources = {
  resources: FilteredAzDiskResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredAzIpResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: AzIp;
  child_resource: any | null;
};
export type FilteredAzIpResources = {
  resources: FilteredAzIpResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredAzLbResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: AzLb;
  child_resource: any | null;
};
export type FilteredAzLbResources = {
  resources: FilteredAzLbResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredAzSqlResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: AzSql;
  child_resource: any | null;
};
export type FilteredAzSqlResources = {
  resources: FilteredAzSqlResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredAzVmResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: AzVm;
  child_resource: any | null;
};
export type FilteredAzVmResources = {
  resources: FilteredAzVmResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredAzVmssResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: AzVmss;
  child_resource: any | null;
};
export type FilteredAzVmssResources = {
  resources: FilteredAzVmssResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredDiskResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Disk;
  child_resource: any | null;
};
export type FilteredDiskResources = {
  resources: FilteredDiskResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredGkeVmResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: GkeVm;
  child_resource: any | null;
};
export type FilteredGkeVmResources = {
  resources: FilteredGkeVmResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredNodePoolResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: NodePool;
  child_resource: FilteredGkeVmResources | null;
};
export type FilteredNodePoolResources = {
  resources: FilteredNodePoolResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredGkeResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Gke;
  child_resource: FilteredNodePoolResources | null;
};
export type FilteredGkeResources = {
  resources: FilteredGkeResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredIpResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Ip;
  child_resource: any | null;
};
export type FilteredIpResources = {
  resources: FilteredIpResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredLbResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Lb;
  child_resource: any | null;
};
export type FilteredLbResources = {
  resources: FilteredLbResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredMigVmResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: MigVm;
  child_resource: any | null;
};
export type FilteredMigVmResources = {
  resources: FilteredMigVmResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredMigResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Mig;
  child_resource: FilteredMigVmResources | null;
};
export type FilteredMigResources = {
  resources: FilteredMigResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredSqlResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Sql;
  child_resource: any | null;
};
export type FilteredSqlResources = {
  resources: FilteredSqlResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredVmResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Vm;
  child_resource: any | null;
};
export type FilteredVmResources = {
  resources: FilteredVmResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredRdsSnapshotSourceResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: RdsSnapshotSource;
  child_resource: FilteredRdsSnapshotResourcesV2 | null;
};
export type FilteredRdsSnapshotSourceResources = {
  resources: FilteredRdsSnapshotSourceResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredDynamoDbTableResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: DynamoDbTable;
  child_resource: any | null;
};
export type FilteredDynamoDbTableResources = {
  resources: FilteredDynamoDbTableResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type DynamoDbBackupType = "aws_backup" | "user" | "system";
export type DynamoDbBackup = {
  account: AccountLight;
  id: string;
  name: string;
  type: DynamoDbBackupType;
  storage_tier: StorageTier;
  size: string;
  table_name: string;
  created_at: Date;
  price_per_month: number;
  region: string | null;
  tags: Tags;
  marked_for_deletion: boolean;
  is_protected: boolean;
  cleanup_failure_reason: string | null;
  provider_unique_identifier: string;
  resource_type: ResourceType;
  not_allowed_actions: string[];
  link: string;
  creation_data: ResourceCreationData;
  issues: ResourceIssues;
  all_time_spent: number;
  upcoming_actions: UpcomingAction[];
  protected_by: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier: BillingExplorerResourceIdentifier;
  forecasted_end_of_month: number;
  listing_price: ListingPrice;
  billing_cost: BillingCost;
};
export type FilteredDynamoDbBackupResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: DynamoDbBackup;
  child_resource: any | null;
};
export type FilteredDynamoDbBackupResources = {
  resources: FilteredDynamoDbBackupResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredDynamoDbBackupSourceResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: DynamoDbBackupSource;
  child_resource: FilteredDynamoDbBackupResources | null;
};
export type FilteredDynamoDbBackupSourceResources = {
  resources: FilteredDynamoDbBackupSourceResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredDaxClusterResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: DaxCluster;
  child_resource: any | null;
};
export type FilteredDaxClusterResources = {
  resources: FilteredDaxClusterResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredNatGatewayResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: NatGateway;
  child_resource: any | null;
};
export type FilteredNatGatewayResources = {
  resources: FilteredNatGatewayResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredEcsWorkloadResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: EcsWorkload;
  child_resource: any | null;
};
export type FilteredEcsWorkloadResources = {
  resources: FilteredEcsWorkloadResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredEcsResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: Ecs;
  child_resource: FilteredEcsWorkloadResources | null;
};
export type FilteredEcsResources = {
  resources: FilteredEcsResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type FilteredEcsWorkloadTaskResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: EcsWorkloadTask;
  child_resource: any | null;
};
export type FilteredEcsWorkloadTaskResources = {
  resources: FilteredEcsWorkloadTaskResourceItem[];
  estimated_monthly_waste: number;
  total_resources_count: number;
  total_monthly_spending: number;
  filtered_resources_count: number;
};
export type ResourceMetricTypeObject = {
  daily?: Metric[];
  hourly?: Metric[];
} | null;
export type ResourceMetrics = {
  cpu?: ResourceMetricTypeObject;
  network_in?: ResourceMetricTypeObject;
  network_out?: ResourceMetricTypeObject;
  mem_used?: ResourceMetricTypeObject;
  mem_available?: ResourceMetricTypeObject;
  database_connections?: ResourceMetricTypeObject;
  requests?: ResourceMetricTypeObject;
};
export type PossibleFilterValue = {
  value: string;
  title: string | null;
  provider_account_id?: string;
  dimension_id?: string;
  resource_name?: string;
  resource_service_name?: string;
  resource_account_name?: string;
  dimension_status?: "in_progress" | "completed";
};
export type PossibleFilterValues = PossibleFilterValue[];
export type EmbededKubernetesCluster = {
  id: string;
  name: string;
  provider_id: string;
  provider: ProviderType;
};
export type KubernetesInlineMetrics = {
  daily_start_point?: NullableDate;
  hourly_start_point?: NullableDate;
  cpu_cores?: InlineResourceMetric;
  cpu_percent?: InlineResourceMetric;
  memory_used_bytes?: InlineResourceMetric;
  memory_used_percent?: InlineResourceMetric;
};
export type KubernetesNode = {
  id: string;
  cluster_id?: string;
  cluster: EmbededKubernetesCluster;
  name: string;
  instance_type: string;
  region: string;
  cpu_total: number;
  cpu_system_reserved: number;
  cpu_allocatable: number;
  cpu_workload_reserved: number;
  cpu_idle: number;
  memory_total: number;
  memory_system_reserved: number;
  memory_allocatable: number;
  memory_workload_reserved: number;
  memory_idle: number;
  total_monthly_cost: number;
  reserved_monthly_cost: number;
  idle_monthly_cost: number;
  pod_capacity: number;
  pod_allocatable: number;
  pod_used: number;
  labels: Tags;
  resource_type: ResourceType;
  inline_metrics?: KubernetesInlineMetrics;
  architecture: string;
};
export type FilteredKubernetesNodeResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: KubernetesNode;
};
export type FilteredKubernetesNodeResources = {
  resources: FilteredKubernetesNodeResourceItem[];
  filtered_monthly_spending: number;
  total_monthly_spending: number;
  total_resources_count: number;
  filtered_resources_count: number;
};
export type EmbededKubernetesNode = {
  id: string;
  name: string;
};
export type KubernetesPod = {
  id: string;
  cluster_id: string;
  cluster: EmbededKubernetesCluster;
  node?: EmbededKubernetesNode;
  node_id: string;
  cpu_request: number;
  memory_request: number;
  cpu_monthly_cost: number;
  ram_monthly_cost: number;
  total_monthly_cost: number;
  age_in_seconds: number;
  controlled_by_kind: string;
  controlled_by_name: string;
  labels: Tags;
  resource_type: ResourceType;
  inline_metrics: KubernetesInlineMetrics;
  name: string;
  namespace: string;
};
export type FilteredKubernetesPodResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: KubernetesPod;
};
export type FilteredKubernetesPodResources = {
  resources: FilteredKubernetesPodResourceItem[];
  filtered_monthly_spending: number;
  total_resources_count: number;
  filtered_resources_count: number;
  total_monthly_spending: number;
};
export type KubernetesDeployment = {
  id: string;
  cluster_id: string;
  cluster: EmbededKubernetesCluster;
  node_id: string;
  name: string;
  namespace: string;
  resource_version: string;
  generation: string;
  creation_timestamp: Date;
  age_in_seconds: number;
  pod_count: number;
  replicas: number;
  strategy: string;
  cpu_hourly_cost: number;
  ram_hourly_cost: number;
  total_hourly_cost: number;
  cpu_monthly_cost: number;
  ram_monthly_cost: number;
  total_monthly_cost: number;
  labels: Tags;
  resource_type: ResourceType;
  cpu_request: number;
  memory_request: number;
  inline_metrics: KubernetesInlineMetrics;
};
export type FilteredKubernetesDeploymentResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: KubernetesDeployment;
};
export type FilteredKubernetesDeploymentResources = {
  resources: FilteredKubernetesDeploymentResourceItem[];
  filtered_monthly_spending: number;
  total_resources_count: number;
  filtered_resources_count: number;
  total_monthly_spending: number;
};
export type KubernetesNamespace = {
  id: string;
  cluster_id: string;
  cluster: EmbededKubernetesCluster;
  node_id: string;
  name: string;
  resource_version: string;
  creation_timestamp: Date;
  age_in_seconds: number;
  pod_count: number;
  cpu_hourly_cost: number;
  ram_hourly_cost: number;
  total_hourly_cost: number;
  cpu_monthly_cost: number;
  ram_monthly_cost: number;
  total_monthly_cost: number;
  labels: Tags;
  resource_type: ResourceType;
};
export type FilteredKubernetesNamespaceResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: KubernetesNamespace;
};
export type FilteredKubernetesNamespaceResources = {
  resources: FilteredKubernetesNamespaceResourceItem[];
  filtered_monthly_spending: number;
  total_resources_count: number;
  filtered_resources_count: number;
  total_monthly_spending: number;
};
export type KubernetesDaemonSet = {
  id: string;
  cluster_id: string;
  cluster: EmbededKubernetesCluster;
  node_id: string;
  name: string;
  namespace: string;
  resource_version: string;
  generation: string;
  creation_timestamp: Date;
  age_in_seconds: number;
  pod_count: number;
  cpu_hourly_cost: number;
  ram_hourly_cost: number;
  total_hourly_cost: number;
  cpu_monthly_cost: number;
  ram_monthly_cost: number;
  total_monthly_cost: number;
  labels: Tags;
  resource_type: ResourceType;
  cpu_request: number;
  memory_request: number;
  inline_metrics: KubernetesInlineMetrics;
};
export type FilteredKubernetesDaemonSetResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: KubernetesDaemonSet;
};
export type FilteredKubernetesDaemonSetResources = {
  resources: FilteredKubernetesDaemonSetResourceItem[];
  filtered_monthly_spending: number;
  total_resources_count: number;
  filtered_resources_count: number;
  total_monthly_spending: number;
};
export type KubernetesReplicaSet = {
  id: string;
  cluster_id: string;
  cluster: EmbededKubernetesCluster;
  node_id: string;
  name: string;
  namespace: string;
  resource_version: string;
  generation: string;
  replicas: number;
  creation_timestamp: Date;
  age_in_seconds: number;
  pod_count: number;
  cpu_hourly_cost: number;
  ram_hourly_cost: number;
  total_hourly_cost: number;
  cpu_monthly_cost: number;
  ram_monthly_cost: number;
  total_monthly_cost: number;
  labels: Tags;
  resource_type: ResourceType;
  cpu_request: number;
  memory_request: number;
  inline_metrics: KubernetesInlineMetrics;
};
export type FilteredKubernetesReplicaSetResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: KubernetesReplicaSet;
};
export type FilteredKubernetesReplicaSetResources = {
  resources: FilteredKubernetesReplicaSetResourceItem[];
  filtered_monthly_spending: number;
  total_resources_count: number;
  filtered_resources_count: number;
  total_monthly_spending: number;
};
export type KubernetesStatefulSet = {
  id: string;
  cluster_id: string;
  cluster: EmbededKubernetesCluster;
  node_id: string;
  name: string;
  namespace: string;
  resource_version: string;
  generation: string;
  replicas: number;
  strategy: string;
  pod_management_policy: string;
  creation_timestamp: Date;
  age_in_seconds: number;
  pod_count: number;
  cpu_hourly_cost: number;
  ram_hourly_cost: number;
  total_hourly_cost: number;
  cpu_monthly_cost: number;
  ram_monthly_cost: number;
  total_monthly_cost: number;
  labels: Tags;
  resource_type: ResourceType;
  cpu_request: number;
  memory_request: number;
  inline_metrics: KubernetesInlineMetrics;
};
export type FilteredKubernetesStatefulSetResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: KubernetesStatefulSet;
};
export type FilteredKubernetesStatefulSetResources = {
  resources: FilteredKubernetesStatefulSetResourceItem[];
  filtered_monthly_spending: number;
  total_resources_count: number;
  filtered_resources_count: number;
  total_monthly_spending: number;
};
export type KubernetesJob = {
  id: string;
  cluster_id: string;
  cluster: EmbededKubernetesCluster;
  node_id: string;
  name: string;
  namespace: string;
  resource_version: string;
  generation: string;
  parallelism: string;
  backoff_limit: string;
  pod_replacement_policy: string;
  creation_timestamp: Date;
  age_in_seconds: number;
  pod_count: number;
  total_monthly_cost: number;
  labels: Tags;
  resource_type: ResourceType;
  cpu_request: number;
  memory_request: number;
  inline_metrics: KubernetesInlineMetrics;
};
export type FilteredKubernetesJobResourceItem = {
  id: string;
  resource_type: ResourceType;
  resource: KubernetesJob;
};
export type FilteredKubernetesJobResources = {
  resources: FilteredKubernetesJobResourceItem[];
  filtered_monthly_spending: number;
  total_resources_count: number;
  filtered_resources_count: number;
  total_monthly_spending: number;
};
export type KubernetesCluster = {
  id: string;
  type: "kubernetes";
  cluster_id: string;
  cluster_profile: string;
  name: string;
  project?: string;
  provider: ProviderType;
  provisioner: string;
  region: string;
  version: string;
  total_monthly_cost: number;
  idle_monthly_cost: number;
  reserved_monthly_cost: number;
  cpu_usage: number;
  cpu_request: number;
  cpu_total: number;
  memory_usage: number;
  memory_request: number;
  memory_total: number;
  last_updated_date: Date;
};
export type Region = {
  name: string;
  key: string;
};
export type Regions = Region[] | null;
export type Operator = {
  key: FilterOperatorType;
  primary_label: string;
  secondary_label?: string | null;
};
export type FilterItemTemplate = {
  key: FilterKeyType;
  label: string;
  info?: string | null;
  icon?: string | null;
  value_type?:
    | (
        | "number"
        | "string"
        | "array"
        | "string_list"
        | "number_list"
        | "date"
        | "number_optional"
        | "kv_string_list"
      )
    | null;
  min?: string | number | string[] | number[] | (any | null);
  max?: string | number | string[] | number[] | (any | null);
  allowed_operators: FilterOperatorType[];
  operators: Operator[];
};
export type Filters = {
  type: ResourceType;
  label: string;
  filters: FilterItemTemplate[];
  child_filters?: Filters | null;
}[];
export type GlobalFilters = FilterItemTemplate[];
export type Plan = {
  id: string;
  name: string;
  name_key?: string;
  price: number;
  yearly: boolean;
  most_popular?: boolean;
  details?: {
    monthly_cloud_spend_range?: string;
    options?: {
      title?: string;
      availability?: boolean;
    }[];
  } | null;
};
export type GcpBillingExportData = {
  id: string;
  service_account: string;
  project_id: string;
  table: string;
  dataset: string;
};
export type Subscription = {
  id: string;
  plan: Plan;
  activation_date: Date;
  expiration_date: Date;
  status: "new" | "active" | "overdue" | "trailing";
  trial: boolean;
  has_payment_method_attached: boolean;
  type: "aws_marketplace" | "stripe";
};
export type NestedIntegration = {
  id: string;
  type: "webhook" | "jira" | "slack" | "email";
  metadata?: string[] | null;
};
export type Emails = {
  to: string[];
  cc?: string[] | null;
  bcc?: string[] | null;
  subject?: string | null;
  custom_message?: string | null;
};
export type NotificationEmail = Emails & {
  type: "email";
  integration_id?: string | null;
  custom_message?: string | null;
};
export type SlackConversation = {
  id: string;
  name: string;
  display_name: string;
  type: "public_channel" | "private_channel" | "member";
};
export type NotificationSlack = {
  type: "slack";
  integration_id: string;
  channels: string[] | null;
  conversations?: SlackConversation[] | null;
  mentions?: SlackConversation[] | null;
  custom_message?: string | null;
};
export type NotificationWebhook = {
  type: "webhook";
  integration_id: string;
  custom_message?: string | null;
};
export type NotificationJira = {
  type: "jira";
  integration_id: string;
  custom_message?: string | null;
};
export type ScheduleAccount = {
  id: string;
  provider_account_id: string;
  provider_account_name: string | null;
  provider: ProviderType;
  status: AccountStatus;
};
export type ResourceFiltersWithAction = {
  action?: ("terminate" | "stop" | "start" | "reboot") | null;
  snapshot?: boolean | null;
  filter: ResourceFilters;
};
export type ScheduleActionType = "notify" | "clean_and_notify";
export type ScheduleStatus = "active" | "inactive" | "deleted";
export type FutureRunDate = {
  date: Date;
  should_execute: boolean;
};
export type GracePeriod = {
  /** grace period in seconds */
  period?: number;
  notifications?: (
    | NotificationEmail
    | NotificationSlack
    | NotificationWebhook
    | NotificationJira
  )[];
} | null;
export type Schedule = {
  id: string;
  integrations?: NestedIntegration[] | null;
  notifications?:
    | (
        | NotificationEmail
        | NotificationSlack
        | NotificationWebhook
        | NotificationJira
      )[]
    | null;
  name: string;
  start_date_time: Date;
  end_date_time: NullableDate;
  cron: string | null;
  accounts: ScheduleAccount[];
  filter: ResourceFiltersWithAction[];
  regions: string[];
  action: ScheduleActionType;
  status: ScheduleStatus;
  time_zone: string;
  metadata: {
    next_run_at: NullableDate;
    state: "normal" | "paused" | "complete" | "error" | "blocked";
    future_run_dates: FutureRunDate[] | null;
  };
  min_threshold?: number | null;
  grace_period?: GracePeriod;
  emails: Emails | (any | null);
  is_snoozed?: boolean | null;
  weekly_schedule_interval: number | null;
  daily_schedule_interval: number | null;
  description: string | null;
  cloud_provider: ProviderType | null;
  last_execution?: LastExecution | null;
  created_by: EmbeddedUser;
  created_at: Date;
  modified_by: NullableEmbeddedUser;
  modified_at: NullableDate;
};
export type WorkflowLight = {
  id: string;
  name: string;
  start_date_time: Date;
  end_date_time: NullableDate;
  cron: string | null;
  status: ScheduleStatus;
  action: ScheduleActionType;
  metadata?: {
    next_run_at: NullableDate;
  };
  time_zone: string;
  accounts: ScheduleAccount[];
  grace_period?: GracePeriod;
  is_snoozed?: boolean | null;
};
export type AllFilteredResources = {
  resources:
    | FilteredAsgResources
    | FilteredEbsResources
    | FilteredEbsSnapshotResourcesV2
    | FilteredEc2Resources
    | FilteredEipResources
    | FilteredEksResources
    | FilteredElbResources
    | FilteredElcResources
    | FilteredRdsResources
    | FilteredRdsSnapshotResourcesV2
    | FilteredS3Resources
    | FilteredAzAksResources
    | FilteredAzDiskResources
    | FilteredAzIpResources
    | FilteredAzLbResources
    | FilteredAzSqlResources
    | FilteredAzVmResources
    | FilteredAzVmssResources
    | FilteredDiskResources
    | FilteredGkeResources
    | FilteredIpResources
    | FilteredLbResources
    | FilteredMigResources
    | FilteredSqlResources
    | FilteredVmResources
    | FilteredRdsSnapshotSourceResources
    | FilteredDynamoDbTableResources
    | FilteredDynamoDbBackupSourceResources
    | FilteredDaxClusterResources
    | FilteredNatGatewayResources
    | FilteredEcsResources
    | FilteredEcsWorkloadResources
    | FilteredEcsWorkloadTaskResources;
  resource_type: ResourceType;
  action?: ExecutionLogAction;
  snapshot?: boolean | null;
};
export type ValidatedFilterValues = {
  valid: string[];
  invalid: string[];
};
export type SsoConnectionType = ("okta" | "azure_ad") | null;
export type Organisation = {
  id?: string;
  name?: string;
  email?: string;
  restriction_violation?:
    | ("account_max_spending_exceeded" | "max_number_of_accounts_exceeded")
    | null;
  restriction_violation_apply_date?: NullableDate;
  restriction_violation_effective_from_date?: NullableDate;
  has_sso_setup: boolean;
  sso_connection_type?: SsoConnectionType;
  created_at?: Date;
  access_enabled?: boolean;
};
export type OffHoursScheduleActionType = "notify" | "silent";
export type OffHoursSchedule = {
  id: string;
  integrations?: NestedIntegration[] | null;
  notifications?:
    | (
        | NotificationEmail
        | NotificationSlack
        | NotificationWebhook
        | NotificationJira
      )[]
    | null;
  emails: Emails | (any | null);
  name: string;
  start_date_time: Date;
  end_date_time: NullableDate;
  start_cron: string | null;
  stop_cron: string | null;
  accounts: ScheduleAccount[];
  filter?: ResourceFiltersWithAction[];
  regions: string[];
  status: ScheduleStatus;
  action: OffHoursScheduleActionType;
  metadata: {
    next_start_run_at: string;
    next_stop_run_at: string;
    start_state: "normal" | "paused" | "complete" | "error" | "blocked";
    stop_state: "normal" | "paused" | "complete" | "error" | "blocked";
  };
  time_zone: string;
  min_threshold: number | null;
  description: string | null;
  cloud_provider: ProviderType | null;
  created_by?: EmbeddedUser;
  created_at?: Date;
  modified_by?: NullableEmbeddedUser;
  modified_at?: NullableDate;
};
export type Feature = {
  /** The key of feature */
  feature_key: string;
  created_at: Date;
};
export type SlackConversationResponse = {
  id: string;
  name: string;
  display_name: string;
  type: "public_channel" | "private_channel" | "member";
  issue?: string | null;
};
export type Integration = {
  id: string;
  organisation_id: string;
  name: string;
  type: "webhook" | "jira" | "slack" | "email";
  emails?: string[] | null;
  token?: string | null;
  channel?: string | null;
  channels?: string[] | null;
  workspace_id?: string | null;
  url?: string | null;
  content_type?: string | null;
  api_token?: string | null;
  default_project_key?: string | null;
  default_issue_type_id?: string | null;
  jira_email?: string | null;
  metadata: {
    emails?: string[];
    channel?: string | null;
    conversation?: SlackConversationResponse;
  } | null;
  conversation?: SlackConversationResponse | null;
  conversations?: SlackConversationResponse[] | null;
  created_at: Date;
  modified_at: NullableDate;
  created_by: EmbeddedUser;
  modified_by: NullableEmbeddedUser;
};
export type SnowflakeConnection = {
  id: string;
  user_id: string;
  account_identifier?: string;
  service_account?: string;
  name: string;
  created_at: NullableDate;
  created_by: NullableEmbeddedUser;
  status: "active" | "inactive" | "error";
  last_collected?: NullableDate;
};
export type NullableSlackConversation = {
  id: string;
  name: string;
  display_name: string;
  type: "public_channel" | "private_channel" | "member";
} | null;
export type NullableFilterTreeNode = (FilterGroupNode | FilterItemNode) | null;
export type Permissions = Permission[];
export type SmartTagTtlSetting = {
  type: string;
  value: string;
  default_value: string;
  options: any[] | null;
};
export type QuarterStartsFromMonthSetting = {
  type: string;
  value: string;
  default_value: string;
  options: any[] | null;
};
export type SavingsPlanTermInYears = "one_year" | "three_years";
export type CommitmentPaymentOption =
  | "no_upfront"
  | "partial_upfront"
  | "all_upfront"
  | "monthly"
  | "upfront";
export type LookbackPeriod = "seven_days" | "thirty_days" | "sixty_days";
export type SavingsPlanType = "sage_maker" | "compute" | "ec2_instance";
export type SavingsPlanAccountScope = "payer" | "linked";
export type SavingsPlanRecommendation = {
  term_in_years: SavingsPlanTermInYears;
  payment_option: CommitmentPaymentOption;
  hourly_commitment: number;
  estimated_coverage: number;
  estimated_monthly_savings: number;
  estimated_savings_percentage: number;
  estimated_on_demand_spend_over_look_back_period: number;
  estimated_covered_usage_over_look_back_period: number;
  region: string | null;
  instance_family: string | null;
  action_url: string;
  account: EmbeddedAccount;
  lookback_period: LookbackPeriod;
  savings_plan_type: SavingsPlanType;
  account_scope: SavingsPlanAccountScope;
};
export type SavingsPlanRecommendationSummary = {
  recommendations: SavingsPlanRecommendation[];
};
export type AiSavingsOpportunity = {
  AI?: {
    [key: string]: {
      columnDefs?: {
        headerName?: string;
        field?: string;
      }[];
      rowData?: object[];
    };
  }[];
  NON_AI?: {
    [key: string]: {
      columnDefs?: {
        headerName?: string;
        field?: string;
      }[];
      rowData?: object[];
    };
  }[];
};
export type RightSizingAttributes = {
  link?: string | null;
};
export type SavingsOpportunity = {
  id: string;
  action_type:
    | "off_hours"
    | "rightsizing"
    | "upgrade"
    | "migrate_to_graviton"
    | "stop"
    | "delete"
    | "live_filtered_resource";
  service: ResourceType;
  cloud_provider: ProviderType;
  resource_type: string;
  resource_arn: string | null;
  recommended_type: string;
  resource_id?: string | null;
  resource_name?: string | null;
  implementation_effort: ImplementationEffort;
  based_on_past?: number | null;
  region: string;
  account: EmbeddedAccount;
  current_monthly_price: number;
  estimated_monthly_price: number;
  monthly_savings: number | null;
  currency_code: "usd";
  tags?: Tags;
  description: string | null;
  metadata: RightSizingAttributes | null;
  recommendation_id: string | null;
  is_stopped: boolean | null;
  filter_set_id?: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier?: BillingExplorerResourceIdentifier;
  forecasted_end_of_month?: number | null;
  listing_price?: NullableListingPrice;
  billing_cost?: BillingCost;
};
export type SavingsOpportunityGroups = {
  name?: string | null;
  count?: number;
  monthly_savings?: number;
};
export type BaseFilterModel = {
  operator?: ("and" | "or") | null;
  conditions?: BaseFilterModel[] | null;
};
export type TextFilterModel = BaseFilterModel & {
  filterType: "text";
  type:
    | "contains"
    | "notContains"
    | "equals"
    | "notEqual"
    | "startsWith"
    | "endsWith";
  filter: string;
};
export type NumberFilterModel = BaseFilterModel & {
  filterType: "number";
  type:
    | "equals"
    | "notEqual"
    | "lessThan"
    | "lessThanOrEqual"
    | "greaterThan"
    | "greaterThanOrEqual";
  filter: number;
};
export type DateFilterModel = BaseFilterModel & {
  filterType: "date";
  type:
    | "equals"
    | "notEqual"
    | "lessThan"
    | "greaterThan"
    | "inRange"
    | "blank"
    | "notBlank";
  dateFrom: string;
  dateTo?: string;
};
export type SetFilterModel = BaseFilterModel & {
  filterType: "set";
  /** List of values selected by the user. */
  values: string[];
};
export type MultiFilterModel = BaseFilterModel & {
  filterType: "multi";
  filterModels: (
    | TextFilterModel
    | NumberFilterModel
    | DateFilterModel
    | SetFilterModel
    | null
  )[];
};
export type FilterModel = {
  [key: string]:
    | TextFilterModel
    | NumberFilterModel
    | DateFilterModel
    | SetFilterModel
    | MultiFilterModel;
};
export type SortModel = {
  colId: string;
  sort: "asc" | "desc";
}[];
export type RowGroupCol = {
  id: string;
  field: string;
};
export type EmbeddedCluster = {
  id: string;
  cluster_id?: string;
  cluster_profile?: string;
  name?: string;
  account_name?: string;
};
export type KubernetesAiSavingsOpportunity = {
  id: string;
  action_type:
    | "off_hours"
    | "rightsizing"
    | "upgrade"
    | "migrate_to_graviton"
    | "stop"
    | "delete"
    | "live_filtered_resource";
  service: ResourceType;
  cloud_provider: ProviderType;
  resource_type: string;
  resource_arn: string | null;
  recommended_type: string;
  resource_id?: string | null;
  resource_name?: string | null;
  implementation_effort: ImplementationEffort;
  based_on_past?: number | null;
  region: string;
  cluster: EmbeddedCluster;
  current_monthly_price: number;
  estimated_monthly_price: number;
  monthly_savings: number | null;
  currency_code: "usd";
  tags?: Tags;
  description: string | null;
  metadata: RightSizingAttributes | null;
  recommendation_id: string | null;
  is_stopped: boolean | null;
  filter_set_id?: string | null;
  task: NullableEmbeddedTask;
  billing_explorer_resource_identifier?: BillingExplorerResourceIdentifier;
  forecasted_end_of_month?: number | null;
  listing_price?: NullableListingPrice;
  billing_cost?: BillingCost;
};
export type ReservationType =
  | "ec2"
  | "rds"
  | "elasticache"
  | "opensearch"
  | "redshift"
  | "virtual_machines"
  | "sql_databases"
  | "suse_linux"
  | "cosmos_db"
  | "red_hat"
  | "sql_data_warehouse"
  | "vmware_cloud_simple"
  | "red_hat_osa"
  | "databricks"
  | "app_service"
  | "managed_disk"
  | "block_blob"
  | "redis_cache"
  | "azure_data_explorer"
  | "my_sql"
  | "maria_db"
  | "postre_sql"
  | "dedicated_host"
  | "sap_hana"
  | "sql_azure_hybrid_benefit"
  | "avs"
  | "data_factory"
  | "net_app_storage"
  | "azure_files"
  | "sql_edge"
  | "virtual_machine_software";
export type CommitmentRecommendationsPotentialSavings = {
  savings_amount: number | null;
  recommendation_parameters: {
    account_scope: SavingsPlanAccountScope;
    type: SavingsPlanType | ReservationType;
    payment_option: CommitmentPaymentOption;
    term_in_years: SavingsPlanTermInYears;
    look_back_period: LookbackPeriod;
  };
};
export type SavingsPlanRecommendationsParameters = {
  account_scope: SavingsPlanAccountScope;
  types?: SavingsPlanType[];
  payment_option: CommitmentPaymentOption;
  term_in_years: SavingsPlanTermInYears;
  look_back_period: LookbackPeriod;
};
export type SavingsPlanPotentialSavings = {
  savings_amount: number | null;
  recommendation_parameters: SavingsPlanRecommendationsParameters;
};
export type ReservationOfferingClass = "convertible" | "standard";
export type ReservationRecommendationsParameters = {
  account_scope: SavingsPlanAccountScope;
  types?: ReservationType[];
  payment_option: CommitmentPaymentOption;
  term_in_years: SavingsPlanTermInYears;
  look_back_period: LookbackPeriod;
  offering_class: ReservationOfferingClass;
};
export type ReservationPotentialSavings = {
  savings_amount: number | null;
  recommendation_parameters: ReservationRecommendationsParameters;
};
export type SavingsPlanUtilizationRecommendation = {
  estimated_utilization: number;
  current_utilization: number;
  current_hourly_commitment: number;
  recommended_hourly_commitment: number;
  savings_plan_end_date: Date;
  estimated_monthly_savings: number;
  recommended_start_date: Date;
  link: string;
};
export type CommitmentResourceType =
  | "ec2"
  | "fargate"
  | "lambda"
  | "sagemaker"
  | "eks"
  | "elasticache"
  | "redshift"
  | "rds"
  | "opensearch";
export type ReservationUtilizationRecommendation = {
  estimated_utilization: number;
  current_utilization: number;
  current_instance_count: number;
  recommended_instance_count: number;
  reservation_end_date: Date;
  platform: string | null;
  estimated_monthly_savings: number;
  recommended_start_date: Date;
  link: string;
};
export type ReservationRecommendation = {
  term_in_years: SavingsPlanTermInYears;
  payment_option: CommitmentPaymentOption;
  instance_count: number;
  estimated_monthly_savings: number;
  region: string;
  instance_family: string | null;
  instance_type: string;
  platform: string | null;
  account: EmbeddedAccount;
  lookback_period: LookbackPeriod;
  reservation_type: ReservationType;
  account_scope: SavingsPlanAccountScope;
  offering_class: ReservationOfferingClass;
};
export type CommitmentState = "active" | "expired" | "expires_soon";
export type SavingsPlan = {
  id: string;
  provider_unique_id: string;
  type: SavingsPlanType;
  account: EmbeddedAccount;
  region: string;
  payment_option: CommitmentPaymentOption;
  used_commitment_to_date: number | null;
  total_commitment_to_date: number | null;
  net_savings_to_date: number | null;
  total_commitment: number;
  duration_in_years: number;
  tags: Tags;
  start_date: Date;
  end_date: Date;
  state: CommitmentState;
  ec2_instance_family: string | null;
  url: string;
  hourly_commitment: number;
  has_recommendation: boolean;
};
export type CommitmentType = "savings_plan" | "reservation";
export type SavingsPlanCoverageData = {
  account: {
    id?: string;
    provider_account_id?: string;
    name?: string | null;
    is_management_account?: boolean | null;
  } | null;
  covered_usage: number;
  uncovered_usage: number;
  coverage: number;
  total_coverage?: number;
  net_savings: number;
  savings_plan: {
    provider_id: string;
    id: string;
    type: CommitmentType;
  } | null;
  resource_type: {
    resource_type: CommitmentResourceType;
    region: string | null;
    instance_family: string | null;
  } | null;
};
export type SavingsPlanUtilizationAndCoverage = {
  savings_plans: SavingsPlan[];
  coverage_data: SavingsPlanCoverageData[];
  utilization_total_percent: number | null;
  coverage_total_percent: number | null;
};
export type CommitmentDateGranularDataPointValue = {
  percent: number | null;
  amount: number | null;
};
export type CommitmentDateGranularDataPoint = {
  date: Date;
  coverage: CommitmentDateGranularDataPointValue;
  utilization: CommitmentDateGranularDataPointValue;
};
export type CommitmentDateGranularData = {
  data: CommitmentDateGranularDataPoint[];
  uncovered_usage: number | null;
  total_commitment: number | null;
  total_commitment_in_hours?: number | null;
  total_coverage: CommitmentDateGranularDataPointValue;
  total_utilization: CommitmentDateGranularDataPointValue;
};
export type CommitmentDataAggregatedTotals = {
  total_spend: number | null;
  average_coverage: number | null;
  total_net_savings: number | null;
  real_cost: number | null;
  not_covered: number | null;
};
export type SavingsPlanData = {
  utilization_and_coverage: SavingsPlanUtilizationAndCoverage;
  date_granular_data: CommitmentDateGranularData;
  totals: CommitmentDataAggregatedTotals;
  date_from: Date;
  date_to: Date;
};
export type DateLabel =
  | "year_to_date"
  | "month_to_date"
  | "last_one_month"
  | "last_three_months"
  | "last_six_months"
  | "past_fourteen_days"
  | "past_seven_days"
  | "past_thirty_days"
  | "past_forty_five_days"
  | "past_ninety_days"
  | "past_one_hundred_eighty_days"
  | "last_twelve_months"
  | "quarter_to_date"
  | "last_quarter";
export type DateType = "past" | "last";
export type DateUnit = "day" | "week" | "month" | "year";
export type DateDataPoint =
  | "daily"
  | "monthly"
  | "weekly"
  | "yearly"
  | "quarterly";
export type SavingsPlanCoverageGrouping =
  | "resource_type"
  | "account"
  | "commitment"
  | "region";
export type ReservationCommitmentAmount = {
  cost: number;
  units: number;
};
export type Reservation = {
  id: string;
  provider_unique_id: string;
  type: ReservationType;
  account: EmbeddedAccount;
  region: string;
  payment_option: CommitmentPaymentOption;
  used_commitment_to_date: ReservationCommitmentAmount | null;
  total_commitment_to_date: ReservationCommitmentAmount | null;
  net_savings_to_date: number | null;
  total_commitment: number;
  instance_type: string;
  instance_count: number;
  platform: string;
  offering_class: ReservationOfferingClass;
  tags: Tags;
  start_date: Date;
  end_date: Date;
  state: CommitmentState;
  has_recommendation: boolean;
};
export type ReservationCoverageData = {
  account: {
    id?: string;
    provider_account_id?: string;
    name?: string | null;
    is_management_account?: boolean | null;
  } | null;
  covered_hours: number;
  covered_usage: number;
  uncovered_usage: number;
  coverage: number;
  total_coverage?: number;
  net_savings: number;
  reservation?: {
    provider_id: string;
    id: string;
    type: CommitmentType;
  } | null;
  resource_type: {
    resource_type: CommitmentResourceType;
    region: string | null;
    instance_type: string | null;
    platform: string | null;
  } | null;
};
export type ReservationUtilizationAndCoverage = {
  reservations: Reservation[];
  coverage_data: ReservationCoverageData[];
  utilization_total_percent: number | null;
  coverage_total_percent: number | null;
};
export type ReservationData = {
  utilization_and_coverage: ReservationUtilizationAndCoverage;
  date_granular_data: CommitmentDateGranularData;
  totals: CommitmentDataAggregatedTotals;
  date_from: Date;
  date_to: Date;
};
export type AzureCommitmentScope = {
  id: string | null;
  name: string | null;
  type: "single" | "shared" | "management_group";
};
export type AzureSavingsPlan = {
  id: string;
  provider_unique_id: string;
  type: SavingsPlanType;
  scope: AzureCommitmentScope;
  region: string;
  payment_option: CommitmentPaymentOption;
  used_commitment_to_date: ReservationCommitmentAmount | null;
  total_commitment_to_date: ReservationCommitmentAmount | null;
  net_savings_to_date: number | null;
  total_commitment: number;
  product_name: string;
  start_date: Date;
  end_date: Date;
  state: CommitmentState;
  has_recommendation: boolean;
};
export type AzureReservation = {
  id: string;
  provider_unique_id: string;
  type: ReservationType;
  scope: AzureCommitmentScope;
  region: string;
  payment_option: CommitmentPaymentOption;
  used_commitment_to_date: ReservationCommitmentAmount | null;
  total_commitment_to_date: ReservationCommitmentAmount | null;
  net_savings_to_date: number | null;
  total_commitment: number;
  instance_count: number;
  product_name: string;
  start_date: Date;
  end_date: Date;
  state: CommitmentState;
  has_recommendation: boolean;
};
export type AzureCommitmentCoverageData = {
  account: {
    id?: string;
    provider_account_id?: string;
    name?: string | null;
    is_management_account?: boolean | null;
  } | null;
  covered_units?: number | null;
  uncovered_units?: number | null;
  covered_usage: number;
  uncovered_usage: number;
  coverage: number;
  total_coverage?: number;
  net_savings: number;
  commitment: {
    provider_id: string;
    id: string;
    unit_of_measure: string;
    type: CommitmentType;
  } | null;
  resource_type: {
    resource_type: string;
    region: string;
    product_name: string;
    unit_of_measure: string;
  } | null;
  region: {
    name: string;
  } | null;
};
export type AzureCommitmentUtilizationAndCoverage = {
  commitments: (AzureSavingsPlan | AzureReservation)[];
  coverage_data: AzureCommitmentCoverageData[];
  utilization_total_percent: number | null;
  coverage_total_percent: number | null;
};
export type AzureCommitmentData = {
  utilization_and_coverage: AzureCommitmentUtilizationAndCoverage;
  date_granular_data: CommitmentDateGranularData;
  totals: CommitmentDataAggregatedTotals;
  date_from: Date;
  date_to: Date;
};
export type CommitmentCostBreakdown = {
  total: number;
  savings_plan: number;
  reservation: number;
} | null;
export type ResourceTypeCoverage = {
  resource_type: CommitmentResourceType;
  uncovered_usage: number;
  coverage: number;
};
export type EffectiveSavingsRate = {
  savings_rate: number | null;
  trend: number | null;
};
export type DateDetails = {
  date_from: Date;
  date_to: Date;
};
export type CommitmentOverview = {
  real_cost: number | null;
  total_not_covered: number | null;
  total_commitments: number | null;
  commitment_cost_breakdown: CommitmentCostBreakdown;
  savings_plan_total_commitments: number | null;
  reservation_total_commitments: number | null;
  total_net_savings: number | null;
  net_savings_breakdown: CommitmentCostBreakdown;
  total_utilization: number | null;
  used_commitment_breakdown: CommitmentCostBreakdown;
  total_coverage: number | null;
  covered_cost_breakdown: CommitmentCostBreakdown;
  coverage: ResourceTypeCoverage[];
  commitments: {
    name: string;
    net_savings: number | null;
    used_commitment_to_date: number | null;
    total_commitment_to_date: number | null;
  }[];
  effective_savings_rate: EffectiveSavingsRate;
  current_period_dates: DateDetails;
  previous_period_dates: DateDetails;
};
export type CommitmentDateGranularDataNullablePoint = {
  date: Date;
  coverage: CommitmentDateGranularDataPointValue & (any | null);
  utilization: CommitmentDateGranularDataPointValue & (any | null);
};
export type CommitmentCoverageMetadata = {
  covered_usage: number | null;
  covered_usage_in_hours?: number | null;
  coverage: number | null;
  uncovered_usage: number | null;
  net_savings?: number | null;
};
export type CommitmentUtilizationMetadata = {
  used_commitment: number | null;
  used_commitment_in_hours?: number | null;
  utilization: number | null;
  covered_usage: number | null;
  net_savings: number | null;
};
export type ReservationFilteredData = {
  data: CommitmentDateGranularDataNullablePoint[];
  metadata: CommitmentCoverageMetadata | CommitmentUtilizationMetadata;
  coverage_data: ReservationCoverageData[];
};
export type CommitmentFilterType =
  | "resource_type"
  | "account"
  | "savings_plan"
  | "commitment"
  | "region";
export type AzureCommitmentCoverageMetadata = {
  covered_usage: number | null;
  covered_usage_in_units?: number | null;
  coverage: number | null;
  uncovered_usage: number | null;
  net_savings?: number | null;
};
export type AzureCommitmentUtilizationMetadata = {
  used_commitment: number | null;
  used_commitment_in_units?: number | null;
  utilization: number | null;
  covered_usage: number | null;
  net_savings: number | null;
};
export type AzureCommitmentFilteredData = {
  data: CommitmentDateGranularDataNullablePoint[];
  metadata:
    | AzureCommitmentCoverageMetadata
    | AzureCommitmentUtilizationMetadata;
  coverage_data: AzureCommitmentCoverageData[];
};
export type SavingsPlanFilteredData = {
  data: CommitmentDateGranularDataNullablePoint[];
  metadata: CommitmentCoverageMetadata | CommitmentUtilizationMetadata;
  coverage_data: SavingsPlanCoverageData[];
};
export type ScheduleFrequency = "hourly" | "daily" | "weekly" | "monthly";
export type ApiKey = {
  id: string;
  organisation_id: string;
  api_key: string;
  name: string;
  created_at: string;
  expires_at: string;
  last_used_at: string | null;
};
export type MetricType = "cpu" | "database_connections";
export type Metrics = {
  type: MetricType;
  threshold: number;
  metrics: Metric[];
};
export type OrganisationDailyOffHoursRecommendation2 = {
  id: string;
  resource_id: string;
  account_id: string;
  account: EmbeddedAccount;
  from_hour: number;
  to_hour: number;
  number_of_off_hours: number;
  provider_unique_identifier: string;
  resource_name?: string | null;
  tags?: Tags;
  potential_saving: number;
  region: string;
  resource_type: ResourceType;
  metrics: Metrics[];
  type: string;
  dismiss_until_date: string | null;
  is_forever_dismissed: boolean;
  dismissed_by: string | null;
  is_dismissed_by_resource: boolean;
  resource_identifier: string;
};
export type OrganisationWeeklyOffHoursRecommendation2 = {
  id: string;
  resource_id: string;
  account_id: string;
  account: EmbeddedAccount;
  provider_unique_identifier: string;
  resource_name?: string | null;
  tags?: Tags;
  potential_saving: number;
  region: string;
  resource_type: ResourceType;
  from_hour: number;
  to_hour: number;
  from_day:
    | "monday"
    | "tuesday"
    | "wednesday"
    | "thursday"
    | "friday"
    | "saturday"
    | "sunday";
  to_day:
    | "monday"
    | "tuesday"
    | "wednesday"
    | "thursday"
    | "friday"
    | "saturday"
    | "sunday";
  number_of_off_hours: number;
  metrics: Metrics[];
  type: string;
  dismiss_until_date: string | null;
  is_forever_dismissed: boolean;
  dismissed_by: string | null;
  is_dismissed_by_resource: boolean;
  resource_identifier: string;
};
export type CategoryFilter = {
  filter_tree: FilterTreeNode;
};
export type CategoryWithCosts = {
  id: string;
  name: string;
  total_cost: number;
  filtered_resource_costs: number;
  type?: "account_based" | "filter_based";
  filters?: CategoryFilter;
};
export type DimensionWithCosts = {
  id: string;
  name: string;
  status: "in_progress" | "completed";
  categories: CategoryWithCosts[];
  total_cost: number;
  filtered_resource_costs: number;
};
export type Category = {
  id: string;
  name: string;
  type?: "account_based" | "filter_based";
  filter: CategoryFilter;
};
export type Dimension = {
  id: string;
  name: string;
  created_by?: NullableEmbeddedUser;
  created_at?: NullableDate;
  modified_by?: NullableEmbeddedUser;
  modified_at?: NullableDate;
  categories: Category[];
};
export type DistributionType = "even" | "manual";
export type ShareAmount = {
  category_id: string;
  share_amount: number;
};
export type DimensionSharedCost = {
  id: string;
  name: string;
  filter_tree: FilterTreeNode;
  distribution_type: DistributionType;
  created_by?: NullableEmbeddedUser;
  created_at?: NullableDate;
  modified_by?: NullableEmbeddedUser;
  modified_at?: NullableDate;
  share_amounts?: ShareAmount[];
};
export type Chart = {
  id?: string;
  name?: string;
  organisation_id?: string;
  created_at?: Date;
  updated_at?: Date;
  payload?: object;
};
export type ResourceVisibility = {
  type: ResourceType;
  visibilities: {
    show: boolean;
    actions: {
      delete: boolean | null;
      snapshot_and_delete: boolean | null;
      stop: boolean | null;
      start: boolean | null;
      reboot?: boolean | null;
    };
  };
};
export type AccountsVisibilities = {
  account_id: string;
  accounts_visibilities: ResourceVisibility[];
};
export type AskAiAnswer = {
  answer?: string;
  interaction_id?: string;
  charts?: any[];
  csv_paths?: string[];
  tables?: any;
};
export type AskAiCreateChatResponse = {
  chat_id: string;
};
export type RecommendationTarget =
  | "same_instance_family"
  | "cross_instance_family";
export type RightSizingRecommendation = {
  id: string;
  organisation_id: string;
  provider_unique_identifier: string;
  current_machine_type: string;
  recommended_machine_type: string;
  potential_saving: number;
  created_date: string;
  account: EmbeddedAccount;
  resource_name: string | null;
  resource_type: ResourceType;
  spending: number;
  cpu_max: number;
  tags: Tag[];
  region: string;
  current_vcpus: number;
  recommended_vcpus: number;
  link: string;
  dismiss_until_date: string | null;
  is_forever_dismissed: boolean;
  dismissed_by: string | null;
  is_dismissed_by_resource: boolean;
  resource_identifier: string;
  is_default: boolean | null;
  recommendation_target: RecommendationTarget | null;
};
export type RightSizingRecommendationDetails = {
  id: string;
  organisation_id: string;
  provider_unique_identifier: string;
  current_machine_type: string;
  recommended_machine_type: string;
  potential_saving: number;
  created_date: string;
  account: EmbeddedAccount;
  resource_name: string | null;
  resource_type: ResourceType;
  spending: number;
  cpu: Metric[];
  cpu_max: number;
  tags: Tag[];
  region: string;
  link: string;
  current_vcpus: number;
  recommended_vcpus: number;
  dismiss_until_date: string | null;
  is_forever_dismissed: boolean;
  dismissed_by: string | null;
  is_dismissed_by_resource: boolean;
  resource_identifier: string;
  is_default: boolean | null;
  recommendation_target: RecommendationTarget | null;
};
export type FilterSetSource = "cloudchipr" | "user";
export type FilterSet = {
  id: string;
  name: string;
  organisation_id: string;
  filters: ResourceFilters[];
  created_at: string;
  source: FilterSetSource;
  created_by: string | null;
  cloud_provider: ProviderType;
  is_default: boolean;
  accounts: EmbeddedAccount[];
};
export type LoadTrackedResourcesFor = "view" | "category";
export type DateLabelNullable = DateLabel | null;
export type Dates = {
  from?: NullableDate;
  to?: NullableDate;
  label?: DateLabelNullable;
  type?: DateType;
  value?: number;
  unit?: DateUnit;
};
export type ResourceExplorerGroupingNullable =
  | (
      | "service"
      | "marketplace_service"
      | "cost_allocation_tag"
      | "tag_key"
      | "charge_type"
      | "account"
      | "region"
      | "resource"
      | "product_family"
      | "instance_family"
      | "instance_type"
      | "credit_type"
      | "cloud_provider"
      | "cost_allocation_tag_value"
      | "tag_value"
      | "category"
      | "category_v2"
      | "none"
      | "environment"
      | "cluster"
      | "namespace"
      | "usage_type"
      | "pricing_term"
      | "description"
      | "parent_resource_id"
      | "type"
      | "deployment"
      | "workload_name"
      | "workload_type"
      | "organisation"
      | "group"
      | "node"
      | "resource_group"
      | "service_type"
      | "warehouse"
      | "platform"
    )
  | null;
export type XAxisGranularity =
  | "date"
  | "account"
  | "service"
  | "region"
  | "product_family"
  | "charge_type"
  | "instance_type"
  | "instance_family"
  | "environment"
  | "marketplace_service";
export type TrendType = "period_over_period" | "month_over_month";
export type CostType =
  | "unblended"
  | "blended"
  | "amortized"
  | "net_unblended"
  | "net_amortized";
export type ResourceExplorerFilterSchema = {
  date_label?: DateLabelNullable;
  date_from?: NullableDate;
  date_to?: NullableDate;
  dates?: Dates;
  data_point: DateDataPoint;
  group_by?: ResourceExplorerGroupingNullable;
  axis_granularity?: XAxisGranularity;
  group_values?: string[];
  filter_tree?: FilterTreeNode;
  scope_filter_tree?: FilterTreeNode;
  load_quarterly_forecast_for_grouping_items?: boolean;
  load_monthly_forecast_for_grouping_items?: boolean;
  trend_type?: TrendType;
  cost_type?: CostType;
  series?: number;
  csv_columns?: string[];
  language?: string;
  csv_tag_keys?: string[];
  csv_dimensions?: string[];
  mode?:
    | "summary"
    | "anomaly_detector"
    | "anomaly_explainer"
    | "anomaly_detection_and_summary";
};
export type LoadTrackedResourcesForView = {
  load_for: LoadTrackedResourcesFor;
  filters: ResourceExplorerFilterSchema;
};
export type LoadTrackedResourcesForCategories = {
  load_for: LoadTrackedResourcesFor;
  category_ids: string[];
  date_from?: Date;
  date_to?: Date;
};
export type ForecastOption = "month" | "quarter";
export type ResourceExplorerData = {
  date_label: DateLabelNullable;
  cost_type?: CostType;
  from_date: NullableDate;
  to_date: NullableDate;
  data_point: DateDataPoint;
  dates?: Dates;
  grouping: ResourceExplorerGroupingNullable;
  axis_granularity?: XAxisGranularity;
  group_values?: string[];
  forecast_option: ForecastOption;
  trend_type?: TrendType;
};
export type ThresholdTrigger = "actual" | "forecasted";
export type BudgetPeriod =
  | "daily"
  | "monthly"
  | "quarterly"
  | "annually"
  | "custom";
export type BudgetType = "fixed" | "planned";
export type Budget = {
  id: string;
  name: string;
  amount: number | null;
  view: {
    id: string;
    name: string;
  } | null;
  thresholds: {
    percent: number;
    amount: number;
    trigger: ThresholdTrigger;
  }[];
  period: BudgetPeriod;
  forecast: number;
  used: number;
  email_to: Emails | (any | null);
  notifications:
    | (
        | NotificationEmail
        | NotificationSlack
        | NotificationWebhook
        | NotificationJira
      )[]
    | null;
  start_date: string;
  end_date: string | null;
  created_by: NullableEmbeddedUser;
  created_at: NullableDate;
  modified_by: NullableEmbeddedUser;
  modified_at: NullableDate;
  receive_updates: boolean;
  type: BudgetType;
  planned_amounts: number[] | null;
  is_expired: boolean;
  filter_tree: NullableFilterTreeNode;
};
export type ProtectionDetails = {
  is_protected: boolean | null;
  description: string | null;
};
export type ChartSettings = {
  series: number;
  scale: "linear" | "logarithmic";
  show_trendline: boolean;
  show_legends?: boolean;
  show_data_labels: boolean;
  show_budget_line: boolean;
  display_forecast: boolean;
  cumulative_line: boolean;
  selected_budget_id?: string | null;
};
export type ResourceExplorer = {
  id: string;
  filter_tree?: FilterTreeNode;
  cloud_provider: ProviderType;
  cloud_providers?: ProviderType[];
  metadata: object;
  is_default: boolean;
  name: string;
  created_by: EmbeddedUser;
  modified_by: NullableEmbeddedUser;
  created_at: Date;
  modified_at?: NullableDate;
  data: ResourceExplorerData;
  budget: Budget | null;
  budgets?: Budget[] | null;
  visibility: "visible_to_everyone" | "visible_only_to_me";
  protected_by: EmbeddedUser;
  protection_details: ProtectionDetails;
  chart_settings: ChartSettings;
};
export type ReFolderV2 = {
  id: string;
  name: string;
  organisation_id: string;
  created_at?: Date;
  modified_at?: NullableDate;
  created_by?: EmbeddedUser;
  modified_by?: NullableEmbeddedUser;
  items?: ResourceExplorer[];
};
export type ResourceExplorerResourceDetail = {
  id: string;
  account: EmbeddedAccount;
  region: Region;
  tags: Tags;
};
export type ResourceExplorerChartDataItem = {
  field?: string;
  label?: string | null;
  cost?: number;
};
export type ResourceExplorerChartData = {
  value?: string;
  items?: ResourceExplorerChartDataItem[];
};
export type AFlexibleKeyValueMapContainingMetadataAboutTheRow = {
  [key: string]: string;
};
export type CostByDate = {
  cost: number;
  date: Date;
};
export type ForecastedCost = {
  cost: number;
  forecast_option: ForecastOption;
  trend: number | null;
  date_from: Date;
  date_to: Date;
  previous_period_from: Date;
  previous_period_to: Date;
  daily_costs: CostByDate[];
};
export type NullableForecastedCost = (any | null) & ForecastedCost;
export type ResourceExplorerGridTotal = {
  field: string;
  label?: string | null;
  total_cost: number;
  previous_period_total_cost: number | null;
  period_total_cost_difference: number | null;
  trend: number | null;
  cloud_provider: ProviderType;
  metadata: AFlexibleKeyValueMapContainingMetadataAboutTheRow;
  live_usage_cost?: number | null;
  monthly_forecast: NullableForecastedCost;
  quarterly_forecast: NullableForecastedCost;
};
export type AverageDailyCostDetails = {
  from_date: Date;
  to_date: Date;
  average_daily_cost: number | null;
  trend: number | null;
};
export type AverageMonthlyCostDetails = {
  from_date: Date;
  to_date: Date;
  average_monthly_cost: number | null;
  trend: number | null;
};
export type ResourceExplorerCostsDateDetails = {
  from_date: Date;
  to_date: Date;
};
export type ForecastedCostRe = ForecastedCost[];
export type ResourceExplorerWidget = {
  data: ResourceExplorerChartData[];
  total: ResourceExplorerGridTotal[];
  total_cost: number;
  previous_period_total_cost: number | null;
  average_daily_cost_details: AverageDailyCostDetails;
  average_monthly_cost_details: AverageMonthlyCostDetails;
  live_usage_total_cost: number;
  total_cost_date_details: ResourceExplorerCostsDateDetails;
  previous_period_cost_date_details: ResourceExplorerCostsDateDetails;
  forecasted_costs: ForecastedCostRe;
  trend_type?: TrendType;
  cost_type: CostType;
};
export type BillingTotalCost = {
  total_cost: number;
};
export type ReportSourceType = "view" | "dashboard";
export type ReportFileType = "pdf" | "csv";
export type Notifications =
  | (
      | NotificationEmail
      | NotificationSlack
      | NotificationWebhook
      | NotificationJira
    )[]
  | null;
export type OneTimeReport = {
  source_type?: ReportSourceType;
  source_id?: string;
  file_types?: ReportFileType[];
  notifications?: Notifications;
  emails?: Emails;
  subject?: string;
  override_filter_tree?: FilterTreeNode;
  override_dates?: Dates;
  override_grouping?: ResourceExplorerGroupingNullable;
  include_explain_ai?: boolean;
};
export type RepresentsASingleCostSpike = {
  id: string;
  spike_date: string;
  spike_date_total_cost: number;
  change: number;
  trend_percentage: number;
  explanation: string;
};
export type RepresentsACostTrend = {
  id: string;
  start_date: string;
  end_date: string;
  explanation: string;
  trend_percentage: number;
  change: number;
  start_date_total_cost: number;
};
export type ContainerForSpikeAndTrendDetails = {
  spikes: RepresentsASingleCostSpike[];
  increase_trends: RepresentsACostTrend[];
  decrease_trends: RepresentsACostTrend[];
};
export type AnExplanationObjectForASpecificCloudProvider = {
  cloud_provider: ProviderType;
  explainer: ContainerForSpikeAndTrendDetails;
};
export type ResourceExplorerInsights = {
  summary: string;
  anomalies?: AnExplanationObjectForASpecificCloudProvider[];
};
export type ResourceExplorerAnomaliesInsightBreakdown = {
  total: number | null;
  type?: "spikes" | "increaseTrends" | "decreaseTrends";
};
export type ResourceExplorerAnomaliesInsights = {
  total: number | null;
  anomalies?: ResourceExplorerAnomaliesInsightBreakdown[];
};
export type ResourceExplorerAnomalyInsights = {
  summary: string;
};
export type ResourceExplorerGridGranularData = {
  value: string;
  total_cost: number | null;
  trend: number | null;
};
export type ResourceExplorerGridGranular = {
  field: string;
  label?: string | null;
  total_cost: number;
  trend: number | null;
  cloud_provider: ProviderType;
  metadata: AFlexibleKeyValueMapContainingMetadataAboutTheRow;
  rows?: ResourceExplorerGridGranularData[];
};
export type ResourceExplorerGranularCost = {
  columns: string[];
  data: ResourceExplorerGridGranular[];
};
export type ResourceExplorerFilterOperatorV2 = {
  key?: FilterOperatorType;
  label?: string;
};
export type ResourceExplorerPossibleFilterV2 = {
  key: ResourceExplorerDynamicFilterItemType;
  label: string;
  operators: ResourceExplorerFilterOperatorV2[];
  filter_provider?: ResourceExplorerFilterProvider;
};
export type ResourceExplorerPossibleFiltersV2 =
  ResourceExplorerPossibleFilterV2[];
export type ResourceExplorerGrouping =
  | "service"
  | "marketplace_service"
  | "cost_allocation_tag"
  | "tag_key"
  | "charge_type"
  | "account"
  | "region"
  | "resource"
  | "product_family"
  | "instance_family"
  | "instance_type"
  | "credit_type"
  | "cloud_provider"
  | "cost_allocation_tag_value"
  | "tag_value"
  | "category"
  | "category_v2"
  | "none"
  | "environment"
  | "cluster"
  | "namespace"
  | "usage_type"
  | "pricing_term"
  | "description"
  | "parent_resource_id"
  | "type"
  | "deployment"
  | "workload_name"
  | "workload_type"
  | "organisation"
  | "group"
  | "node"
  | "resource_group"
  | "service_type"
  | "warehouse"
  | "platform";
export type ResourceExplorerGroupingLabel = {
  singular?: string | null;
  plural?: string | null;
};
export type ResourceExplorerPossibleGrouping = {
  key?: ResourceExplorerGrouping;
  filter_provider?: ResourceExplorerFilterProvider;
  parent_label?: string;
  next_grouping?: ResourceExplorerGrouping;
  label?: ResourceExplorerGroupingLabel;
  filter_key?: ResourceExplorerDynamicFilterItemType;
  filter_type?: string;
  possible_groupings?: ResourceExplorerGrouping[];
  has_nested?: boolean;
};
export type ResourceExplorerPossibleGroupings =
  ResourceExplorerPossibleGrouping[];
export type ResourceExplorerPossibleColumn = {
  key: string;
  provider: ResourceExplorerFilterProvider;
  label: string;
  description: string;
  is_always_included: boolean;
};
export type ResourceExplorerPossibleColumns = ResourceExplorerPossibleColumn[];
export type SlackAppInstallationAttempt = {
  /** Slack app installation link */
  link?: string;
};
export type AppInstallationAttempt = {
  /** App installation link */
  link?: string;
};
export type AppInstallationType = "SLACK" | "TEAM";
export type MessageWithSubject = {
  subject?: string | null;
  body?: string | null;
} | null;
export type ResourceWithVisibility = {
  key: string;
  value: object | null;
  is_visible?: boolean;
};
export type SnowflakeConnectionQuery = {
  /** Query for user to execute manually */
  query?: string;
  /** this key id should be passed to creation endpoint */
  private_key_id?: string;
};
export type ResourceTypeStatusesResponse = {
  resource_type: ResourceType;
  last_collection_date?: string;
  last_collection_failed?: boolean;
};
export type AccountResourceTypeStatusesResponse = {
  account_id: string;
  resource_types?: ResourceTypeStatusesResponse[];
};
export type UserPreference = {
  id: string;
  key: string;
  value: string | null;
};
export type UserDigestPreferences = {
  monthly_digest: boolean;
  weekly_digest: boolean;
};
export type Threshold = {
  percent: number;
  trigger: ThresholdTrigger;
};
export type BudgetCosts = {
  date?: Date;
  cost?: number;
};
export type AccumulatedCost = {
  used?: number;
  forecast?: number | null;
  costs?: BudgetCosts[];
};
export type CostHistory = {
  date?: Date;
  used?: number;
};
export type BudgetDetails = {
  id: string;
  name: string;
  amount: number | null;
  view: {
    id: string;
    name: string;
  } | null;
  thresholds: {
    percent: number;
    amount: number;
    trigger: ThresholdTrigger;
  }[];
  period: BudgetPeriod;
  forecast: number;
  used: number;
  email_to: Emails | (any | null);
  notifications:
    | (
        | NotificationEmail
        | NotificationSlack
        | NotificationWebhook
        | NotificationJira
      )[]
    | null;
  start_date: string;
  end_date: string | null;
  created_by: NullableEmbeddedUser;
  created_at: NullableDate;
  modified_by: NullableEmbeddedUser;
  modified_at: NullableDate;
  receive_updates: boolean;
  type: BudgetType;
  planned_amounts: number[] | null;
  is_expired: boolean;
  filter_tree: NullableFilterTreeNode;
  cost_history: CostHistory[];
};
export type AlertStatus = "active" | "inactive";
export type ThresholdItem = {
  amount?: number | null;
  unit?: "day" | "percent" | "cost";
};
export type AlertThreshold = {
  operator?: "and" | "or";
  threshold_items?: ThresholdItem[];
} | null;
export type CostAnomalyAlert = {
  id: string;
  name: string;
  grouping: ResourceExplorerGroupingNullable;
  group_values?: string[];
  status: AlertStatus;
  created_by: EmbeddedUser;
  created_at: Date;
  modified_by: NullableEmbeddedUser;
  modified_at: NullableDate;
  view_id: string;
  threshold: AlertThreshold;
  thresholds: ThresholdItem[];
  notifications?:
    | (
        | NotificationEmail
        | NotificationSlack
        | NotificationWebhook
        | NotificationJira
      )[]
    | null;
  emails?: Emails;
  time_interval: {
    time_interval?: number;
    time_interval_unit?: "days" | "weeks" | "months";
  };
};
export type CommitmentCloudProvider = "aws" | "azure";
export type UtilizationAndCoverageAlert = {
  id: string;
  name: string;
  organisation_id: string;
  provider_organisation_id: string;
  created_by: EmbeddedUser;
  created_at: Date;
  modified_by: NullableEmbeddedUser;
  modified_at: NullableDate;
  thresholds: ThresholdItem[];
  notifications?:
    | (
        | NotificationEmail
        | NotificationSlack
        | NotificationWebhook
        | NotificationJira
      )[]
    | null;
  status: AlertStatus;
  emails?: Emails;
  based_on: "commitments_expiration" | "commitments_utilization" | "coverage";
  provider: CommitmentCloudProvider;
};
export type ProviderOrganisation = {
  organization_id: string | null;
  name: string | null;
  cloud_provider: ProviderType;
  has_savings_plan: boolean;
  owned_commitment_types: CommitmentType[];
  accounts: EmbeddedAccount[];
};
export type DateDataPointNullable = DateDataPoint | null;
export type PriceDirectionNullable = ("increasing" | "decreasing") | null;
export type SortByNullable = ("sort_by_percentage" | "sort_by_amount") | null;
export type MultiCloudFilter = {
  cloud_provider: ProviderType;
  filter: string;
};
export type TrendTypeNullable = TrendType | null;
export type ResourceExplorerDataOverrideFilters = {
  from_date?: NullableDate;
  to_date?: NullableDate;
  date_label?: DateLabelNullable;
  data_point?: DateDataPointNullable;
  dates?: Dates;
  axis_granularity?: XAxisGranularity;
  grouping?: ResourceExplorerGroupingNullable;
  price_direction?: PriceDirectionNullable;
  sort_by?: SortByNullable;
  items_count?: number | null;
  group_values?: string[];
  filters?: MultiCloudFilter[];
  min_cost_change?: number | null;
  min_percentage_change?: number | null;
  only_summary?: boolean | null;
  load_detailed_previous_period_data?: boolean | null;
  load_quarterly_forecast_for_grouping_items?: boolean;
  load_monthly_forecast_for_grouping_items?: boolean;
  trend_type?: TrendTypeNullable;
  series?: number;
};
export type ResourceExplorerDataAverage = {
  field: string;
  average_cost: number;
  total: number;
  previous_period_cost?: number | null;
  trend?: number | null;
  cloud_provider: ProviderType;
};
export type View = {
  id: string;
  name: string;
  config?: {
    gridConfig?: string;
    [key: string]: any;
  };
  created_by: EmbeddedUser;
  modified_by?: NullableEmbeddedUser;
  protected_by?: NullableEmbeddedUser;
  protection_details?: ProtectionDetails;
};
export type WidgetType =
  | "resource_explorer"
  | "accounts_live_usage"
  | "cost_comparison"
  | "cost_breakdown"
  | "cost_and_usage_summary"
  | "largest_cost_changes"
  | "commitments_utilization"
  | "coverage"
  | "savings_opportunity"
  | "text"
  | "normalized_cost";
export type WidgetStateReason = "billing_error";
export type Dashboard = {
  id: string;
  name: string;
  is_default: boolean;
  is_home_page: boolean;
  created_by?: EmbeddedUser;
  modified_by?: NullableEmbeddedUser;
  created_at: Date;
  modified_at?: NullableDate;
  protected_by: EmbeddedUser;
  protection_details: ProtectionDetails;
  visibility: "visible_only_to_me" | "visible_to_everyone";
};
export type LayoutNullable = object | null;
export type DashboardWidgetResourceExplorer = {
  id: string;
  reference_id?: string;
  name: string;
  type: WidgetType;
  layout: LayoutNullable;
  resource_explorer_view_id?: string | null;
};
export type DashboardWidgetAccountsLiveUsage = {
  id: string;
  reference_id?: string;
  name: string;
  type: WidgetType;
  layout: LayoutNullable;
  account_ids: string[];
};
export type ChartType =
  | "stack"
  | "horizontal_stack_bar"
  | "stacked_column"
  | "area"
  | "column"
  | "line"
  | "bar"
  | "pie"
  | "table"
  | "numeral";
export type WidgetCostBreakdownAggregation = {
  total_cost?: boolean;
  live_filtered?: boolean;
  daily_average?: boolean;
  forecasted_cost?: boolean;
};
export type ChartBaseType = "cost" | "percent";
export type WidgetCostBreakdownVisualization = {
  chart_type?: ChartType;
  chart_base_type?: ChartBaseType;
  trend?: boolean;
  forecasted_cost?: boolean;
  account_column?: boolean;
  region_column?: boolean;
  previous_period_cost?: boolean;
  series?: number;
  scale?: "linear" | "logarithmic";
  show_legends?: boolean;
  show_data_labels?: boolean;
  display_forecast?: boolean;
  cumulative_line?: boolean;
};
export type DashboardWidgetCostBreakdown = {
  id: string;
  reference_id?: string;
  name: string;
  type: WidgetType;
  layout: LayoutNullable;
  created_by: string | null;
  view_id?: string | null;
  date_from: NullableDate;
  date_to: NullableDate;
  date_label: DateLabelNullable;
  date_granularity: DateDataPointNullable;
  grouping: ResourceExplorerGroupingNullable;
  group_values?: string[];
  chart_type: ChartType;
  trend_type?: TrendType;
  filter: string[];
  aws_filter: string[];
  gcp_filter: string[];
  azure_filter: string[];
  forecast_option: ForecastOption;
  dates?: Dates;
  aggregation: WidgetCostBreakdownAggregation;
  visualization: WidgetCostBreakdownVisualization;
  inherit_dates: boolean;
};
export type WidgetCostAndUsageSummaryVisualization = {
  chart_type?: ChartType;
};
export type DashboardWidgetCostAndUsageSummary = {
  id: string;
  reference_id?: string;
  name: string;
  type: WidgetType;
  layout: LayoutNullable;
  created_by: string | null;
  view_id?: string | null;
  trend_type?: TrendType;
  date_label: DateLabelNullable;
  date_from: NullableDate;
  date_to: NullableDate;
  filter: string[];
  date_granularity: DateDataPointNullable;
  grouping: ResourceExplorerGroupingNullable;
  group_values?: string[];
  dates: Dates;
  visualization: WidgetCostAndUsageSummaryVisualization;
  inherit_dates: boolean;
};
export type PriceDirection = "increasing" | "decreasing";
export type DashboardWidgetLargestCostChanges = {
  id: string;
  reference_id?: string;
  name: string;
  type: WidgetType;
  layout: LayoutNullable;
  created_by: string;
  view_id?: string | null;
  date_label: DateLabelNullable;
  date_from: NullableDate;
  date_to: NullableDate;
  date_granularity: DateDataPointNullable;
  grouping: ResourceExplorerGroupingNullable;
  group_values: string[];
  filter: string[] | null;
  price_direction: PriceDirection;
  sort_by: SortByNullable;
  items_count: number;
  min_cost_change: number | null;
  min_percentage_change: number | null;
  dates: Dates;
  inherit_dates: boolean;
};
export type CommitmentsUtilizationGrouping =
  | "ungrouped"
  | "commitment_type"
  | "id";
export type CommitmentUtilizationType = "savings_plan" | "reservation" | "all";
export type WidgetCommitmentsUtilizationAggregation = {
  net_savings?: boolean;
  utilization?: boolean;
  commitments?: boolean;
};
export type WidgetCommitmentsUtilizationVisualization = {
  chart_type?: ChartType;
  chart_base_type?: ChartBaseType;
  net_savings?: boolean;
  utilization?: boolean;
  commitment?: boolean;
  scale?: "linear" | "logarithmic";
  show_legends?: boolean;
  show_data_labels?: boolean;
};
export type DashboardWidgetCommitmentsUtilization = {
  id: string;
  reference_id?: string;
  name: string;
  provider_organisation_id?: string;
  type: WidgetType;
  layout: LayoutNullable;
  created_by: string | null;
  grouping: CommitmentsUtilizationGrouping;
  commitment_type: CommitmentUtilizationType;
  trend_type: TrendType;
  dates?: Dates;
  aggregation: WidgetCommitmentsUtilizationAggregation;
  visualization: WidgetCommitmentsUtilizationVisualization;
  inherit_dates: boolean;
  provider?: CommitmentCloudProvider;
};
export type SavingsOpportunityGrouping =
  | "recommendation"
  | "opportunity_type"
  | "cloud_provider"
  | "account"
  | "service"
  | "region"
  | "resource_type"
  | "resource_id";
export type SavingsOpportunityType =
  | "off_hours"
  | "rightsizing"
  | "upgrade"
  | "migrate_to_graviton"
  | "stop"
  | "delete"
  | "live_filtered_resource";
export type WidgetSavingsOpportunitiesAggregation = {
  total_savings?: boolean;
  savings_opportunities?: boolean;
};
export type WidgetSavingsOpportunitiesVisualization = {
  chart_type?: ChartType;
  description?: boolean;
  service?: boolean;
  resource_type?: boolean;
  recommended_type?: boolean;
  resource_id?: boolean;
  region?: boolean;
  implementation_effort?: boolean;
  based_on_past?: boolean;
  tags?: boolean;
  current_monthly_price?: boolean;
};
export type DashboardWidgetSavingsOpportunities = {
  id: string;
  reference_id?: string;
  name: string;
  type: WidgetType;
  layout?: LayoutNullable;
  created_by?: string | null;
  grouping?: SavingsOpportunityGrouping;
  opportunity_types?: SavingsOpportunityType[];
  aggregation?: WidgetSavingsOpportunitiesAggregation;
  visualization?: WidgetSavingsOpportunitiesVisualization;
  inherit_dates?: boolean;
};
export type DashboardFolder = {
  id: string;
  name: string;
  organisation_id: string;
  created_at?: Date;
  modified_at?: NullableDate;
  created_by?: EmbeddedUser;
  modified_by?: NullableEmbeddedUser;
  items?: Dashboard[];
};
export type CategoryDetails = {
  category_id: string | null;
  dimension_id: string | null;
} | null;
export type CoverageGrouping =
  | "resource_type"
  | "account"
  | "region"
  | "ungrouped";
export type WidgetCoverageAggregation = {
  net_savings?: boolean;
  covered?: boolean;
  not_covered?: boolean;
  real_cost?: boolean;
};
export type WidgetCoverageVisualization = {
  chart_type?: ChartType;
  chart_base_type?: ChartBaseType;
  coverage?: boolean;
  covered?: boolean;
  not_covered?: boolean;
  scale?: "linear" | "logarithmic";
  show_legends?: boolean;
  show_data_labels?: boolean;
};
export type DashboardWidgetCoverage = {
  id: string;
  reference_id?: string;
  name: string;
  provider_organisation_id?: string;
  type: WidgetType;
  layout: LayoutNullable;
  created_by: string | null;
  grouping: CoverageGrouping;
  commitment_type: CommitmentUtilizationType;
  trend_type: TrendType;
  dates?: Dates;
  aggregation: WidgetCoverageAggregation;
  visualization: WidgetCoverageVisualization;
  inherit_dates: boolean;
  provider?: CommitmentCloudProvider;
};
export type DashboardWidgetText = {
  id: string;
  reference_id?: string;
  name: string;
  text: string;
  type: WidgetType;
  layout: LayoutNullable;
  created_by: string | null;
};
export type WidgetNormalizedCostAggregation = {
  actual_total_cost?: boolean;
  average_normalized_monthly_cost?: boolean;
  forecasted_month_end_cost?: boolean;
};
export type WidgetNormalizedCostVisualization = {
  chart_type?: ChartType;
  show_legends?: boolean;
  actual_total_cost?: boolean;
  normalized_total_cost?: boolean;
  scale?: "linear" | "logarithmic";
};
export type DashboardWidgetNormalizedCost = {
  id: string;
  reference_id?: string;
  view_id: string;
  name: string;
  type: WidgetType;
  layout: LayoutNullable;
  created_by: string | null;
  trend_type: TrendType;
  forecast_option: ForecastOption;
  dates: Dates;
  aggregation: WidgetNormalizedCostAggregation;
  visualization: WidgetNormalizedCostVisualization;
  inherit_dates: boolean;
};
export type NullableDates = Dates | null;
export type Layout = {
  id?: string;
};
export type DashboardWidgetResourceExplorer2 = {
  name: string;
  type: WidgetType;
  layout: LayoutNullable;
  resource_explorer_view_id: string;
};
export type DashboardWidgetAccountsLiveUsage2 = {
  name: string;
  type: WidgetType;
  layout: LayoutNullable;
  account_ids: string[];
};
export type DashboardWidgetCostBreakdownRequest = {
  name: string;
  layout?: LayoutNullable;
  view_id: string;
  date_label?: DateLabelNullable;
  date_to?: NullableDate;
  date_from?: NullableDate;
  date_granularity?: DateDataPointNullable;
  dates?: Dates;
  grouping?: ResourceExplorerGroupingNullable;
  group_values?: string[];
  chart_type: ChartType;
  filter?: string[];
  aws_filter?: string[];
  gcp_filter?: string[];
  azure_filter?: string[];
  type: WidgetType;
  forecast_option?: ForecastOption;
  trend_type?: TrendType;
  aggregation?: WidgetCostBreakdownAggregation;
  visualization?: WidgetCostBreakdownVisualization;
  inherit_dates?: boolean;
};
export type DashboardWidgetCostAndUsageSummaryRequest = {
  name: string;
  layout?: LayoutNullable;
  view_id: string;
  date_label?: DateLabelNullable;
  date_from?: NullableDate;
  date_to?: NullableDate;
  date_granularity?: DateDataPointNullable;
  dates?: Dates;
  grouping?: ResourceExplorerGroupingNullable;
  group_values?: string[];
  filter?: string[];
  type: WidgetType;
  trend_type?: TrendType;
  visualization?: WidgetCostAndUsageSummaryVisualization;
  inherit_dates?: boolean;
};
export type SortBy = "sort_by_percentage" | "sort_by_amount";
export type DashboardWidgetLargestCostChangesRequest = {
  name: string;
  view_id: string;
  items_count: number;
  layout?: LayoutNullable;
  date_label?: DateLabelNullable;
  date_from?: NullableDate;
  date_to?: NullableDate;
  date_granularity?: DateDataPointNullable;
  dates?: Dates;
  grouping?: ResourceExplorerGroupingNullable;
  group_values?: string[];
  filter?: string[];
  price_direction?: PriceDirection;
  sort_by?: SortBy;
  min_cost_change?: number;
  min_percentage_change?: number;
  type: WidgetType;
  inherit_dates?: boolean;
};
export type DashboardWidgetCommitmentsUtilizationRequest = {
  name: string;
  provider_organisation_id?: string | null;
  layout?: LayoutNullable;
  dates?: Dates;
  grouping?: CommitmentsUtilizationGrouping;
  commitment_type?: CommitmentUtilizationType;
  type: WidgetType;
  trend_type?: TrendType;
  aggregation?: WidgetCommitmentsUtilizationAggregation;
  visualization?: WidgetCommitmentsUtilizationVisualization;
  inherit_dates?: boolean;
  provider?: CommitmentCloudProvider;
};
export type DashboardWidgetCoverageRequest = {
  name: string;
  provider_organisation_id?: string | null;
  layout?: LayoutNullable;
  dates?: Dates;
  grouping?: CoverageGrouping;
  commitment_type?: CommitmentUtilizationType;
  type: WidgetType;
  trend_type?: TrendType;
  aggregation?: WidgetCoverageAggregation;
  visualization?: WidgetCoverageVisualization;
  inherit_dates?: boolean;
  provider?: CommitmentCloudProvider;
};
export type DashboardWidgetTextRequest = {
  name: string;
  layout?: LayoutNullable;
  type: WidgetType;
  text: string;
};
export type DashboardWidgetSavingsOpportunitiesRequest = {
  name: string;
  type: WidgetType;
  filter_tree?: FilterTreeNode;
  grouping?: SavingsOpportunityGrouping;
  opportunity_types?: SavingsOpportunityType[];
  layout?: LayoutNullable;
  aggregation?: WidgetSavingsOpportunitiesAggregation;
  visualization?: WidgetSavingsOpportunitiesVisualization;
  inherit_dates?: boolean;
};
export type DashboardWidgetNormalizedCostRequest = {
  name: string;
  view_id?: string;
  layout?: LayoutNullable;
  dates?: Dates;
  type: WidgetType;
  trend_type?: TrendType;
  forecast_option?: ForecastOption;
  aggregation?: WidgetNormalizedCostAggregation;
  visualization?: WidgetNormalizedCostVisualization;
  inherit_dates?: boolean;
};
export type DashboardWidgetAccountsLiveUsagePatchRequest = {
  account_ids?: string[];
  name?: string;
  type?: WidgetType;
  layout?: Layout;
};
export type DashboardWidgetCostBreakdownPatchRequest = {
  name?: string;
  layout?: Layout;
  view_id?: string;
  date_label?: DateLabel;
  date_from?: Date;
  dateTo?: Date;
  date_granularity?: DateDataPoint;
  dates?: Dates;
  grouping?: ResourceExplorerGroupingNullable;
  trend_type?: TrendTypeNullable;
  group_values?: string[];
  chart_type?: ChartType;
  filter?: string[];
  aws_filter?: string[];
  gcp_filter?: string[];
  azure_filter?: string[];
  forecast_option?: ForecastOption;
  type?: WidgetType;
  aggregation?: WidgetCostBreakdownAggregation;
  visualization?: WidgetCostBreakdownVisualization;
  inherit_dates?: boolean;
};
export type DashboardWidgetCostAndUsageSummaryPatchRequest = {
  name?: string;
  layout?: Layout;
  view_id?: string;
  date_label?: DateLabel;
  date_from?: Date;
  date_to?: Date;
  date_granularity?: DateDataPoint;
  dates?: Dates;
  grouping?: ResourceExplorerGroupingNullable;
  trend_type?: TrendTypeNullable;
  group_values?: string[];
  filter?: string[];
  type?: WidgetType;
  visualization?: WidgetCostBreakdownVisualization;
  inherit_dates?: boolean;
};
export type DashboardWidgetLargestCostChangesPatchRequest = {
  name?: string;
  layout?: Layout;
  view_id?: string;
  date_label?: DateLabel;
  date_from?: Date;
  date_to?: Date;
  date_granularity?: DateDataPoint;
  dates?: Dates;
  grouping?: ResourceExplorerGroupingNullable;
  group_values?: string[];
  filter?: string[];
  price_direction?: PriceDirection;
  sort_by?: SortBy;
  items_count?: number;
  min_cost_change?: number;
  min_percentage_change?: number;
  type?: WidgetType;
  inherit_dates?: boolean;
};
export type DashboardWidgetCommitmentsUtilizationPatchRequest = {
  name?: string;
  provider_organisation_id?: string | null;
  layout?: Layout;
  dates?: Dates;
  grouping?: CommitmentsUtilizationGrouping;
  trend_type?: TrendTypeNullable;
  commitment_type?: CommitmentUtilizationType;
  type?: WidgetType;
  aggregation?: WidgetCostBreakdownAggregation;
  visualization?: WidgetCostBreakdownVisualization;
  inherit_dates?: boolean;
  provider?: CommitmentCloudProvider;
};
export type DashboardWidgetCoveragePatchRequest = {
  name?: string;
  provider_organisation_id?: string | null;
  layout?: Layout;
  dates?: Dates;
  grouping?: CoverageGrouping;
  trend_type?: TrendTypeNullable;
  commitment_type?: CommitmentUtilizationType;
  type?: WidgetType;
  aggregation?: WidgetCoverageAggregation;
  visualization?: WidgetCoverageVisualization;
  inherit_dates?: boolean;
  provider?: CommitmentCloudProvider;
};
export type DashboardWidgetTextPatchRequest = {
  name?: string;
  layout?: Layout;
  type?: WidgetType;
  text?: string;
};
export type DashboardWidgetSavingsOpportunitiesPatchRequest = {
  name?: string;
  layout?: Layout;
  filter_tree?: FilterTreeNode;
  grouping?: SavingsOpportunityGrouping;
  opportunity_types?: SavingsOpportunityType[];
  aggregation?: WidgetSavingsOpportunitiesAggregation;
  visualization?: WidgetCostBreakdownVisualization;
  inherit_dates?: boolean;
};
export type DashboardWidgetNormalizedCostPatchRequest = {
  name?: string;
  view_id?: string;
  layout?: LayoutNullable;
  dates?: Dates;
  type?: WidgetType;
  trend_type?: TrendType;
  forecast_option?: ForecastOption;
  aggregation?: WidgetNormalizedCostAggregation;
  visualization?: WidgetNormalizedCostVisualization;
  inherit_dates?: boolean;
};
export type UpdateDashboardWidgetAccountsLiveUsage = {
  name: string | null;
  type: WidgetType;
  layout: LayoutNullable;
  account_ids: string[];
};
export type UpdateDashboardWidgetCostBreakdownRequest = {
  name: string;
  view_id: string;
  date_label: DateLabel;
  date_from: NullableDate;
  date_to: NullableDate;
  layout: LayoutNullable;
  date_granularity: DateDataPointNullable;
  dates?: Dates;
  grouping: ResourceExplorerGroupingNullable;
  group_values: string[];
  chart_type: ChartType;
  trend_type?: TrendType;
  filter: string[] | null;
  aws_filter: string[] | null;
  gcp_filter: string[] | null;
  azure_filter: string[] | null;
  type: WidgetType;
  forecast_option: ForecastOption;
  aggregation: WidgetCostBreakdownAggregation;
  visualization: WidgetCostBreakdownVisualization;
  inherit_dates: boolean;
};
export type UpdateDashboardWidgetCostAndUsageSummaryRequest = {
  name: string;
  layout: LayoutNullable;
  date_label: DateLabelNullable;
  date_from: NullableDate;
  date_to: NullableDate;
  date_granularity: DateDataPointNullable;
  dates?: Dates;
  grouping: ResourceExplorerGroupingNullable;
  trend_type?: TrendType;
  group_values: string[] | null;
  filter: string[] | null;
  type: WidgetType;
  view_id: string;
  visualization: WidgetCostAndUsageSummaryVisualization;
  inherit_dates: boolean;
};
export type UpdateDashboardWidgetLargestCostChangesRequest = {
  view_id: string;
  name: string;
  date_label: DateLabelNullable;
  date_from: NullableDate;
  date_to: NullableDate;
  date_granularity: DateDataPointNullable;
  dates?: Dates;
  grouping: ResourceExplorerGroupingNullable;
  group_values: string[] | null;
  filter: string[] | null;
  price_direction: PriceDirection;
  sort_by: SortBy;
  items_count: number;
  min_cost_change: number | null;
  min_percentage_change: number | null;
  type: WidgetType;
  layout: LayoutNullable;
  inherit_dates: boolean;
};
export type UpdateDashboardWidgetCommitmentsUtilizationRequest = {
  name: string;
  provider_organisation_id?: string;
  layout: LayoutNullable;
  dates?: Dates;
  grouping: CommitmentsUtilizationGrouping;
  trend_type?: TrendType;
  type: WidgetType;
  commitment_type: CommitmentUtilizationType;
  aggregation: WidgetCommitmentsUtilizationAggregation;
  visualization: WidgetCommitmentsUtilizationVisualization;
  inherit_dates?: boolean;
  provider?: CommitmentCloudProvider;
};
export type UpdateDashboardWidgetCoverageRequest = {
  name: string;
  provider_organisation_id?: string;
  layout: LayoutNullable;
  dates?: Dates;
  grouping: CommitmentsUtilizationGrouping;
  trend_type?: TrendType;
  type: WidgetType;
  commitment_type: CommitmentUtilizationType;
  aggregation: WidgetCoverageAggregation;
  visualization: WidgetCoverageVisualization;
  inherit_dates: boolean;
  provider?: CommitmentCloudProvider;
};
export type UpdateDashboardWidgetTextRequest = {
  name: string;
  layout: LayoutNullable;
  type: WidgetType;
  text: string;
};
export type UpdateDashboardWidgetSavingsOpportunitiesRequest = {
  name: string;
  type: WidgetType;
  filter_tree: FilterTreeNode;
  grouping: SavingsOpportunityGrouping;
  opportunity_types: SavingsOpportunityType[];
  layout: LayoutNullable;
  aggregation: WidgetSavingsOpportunitiesAggregation;
  visualization: WidgetSavingsOpportunitiesVisualization;
  inherit_dates: boolean;
};
export type UpdateDashboardWidgetNormalizedCostRequest = {
  name: string;
  view_id: string;
  layout: LayoutNullable;
  dates?: Dates;
  type: WidgetType;
  trend_type: TrendType;
  forecast_option: ForecastOption;
  aggregation: WidgetNormalizedCostAggregation;
  visualization: WidgetNormalizedCostVisualization;
  inherit_dates: boolean;
};
export type AmountWithPercentageResponse = {
  amount?: number;
  percentage?: number;
};
export type CommitmentsGroupResponse = {
  name?: string;
  utilization?: AmountWithPercentageResponse;
  waste?: AmountWithPercentageResponse;
  net_savings?: number | null;
};
export type CommitmentAccount = {
  id?: string;
  provider_account_id?: string;
  name?: string | null;
  is_management_account?: boolean | null;
} | null;
export type CoverageGroupResponse = {
  net_savings?: number | null;
  name?: string | CommitmentAccount;
  coverage?: AmountWithPercentageResponse;
  on_demand?: AmountWithPercentageResponse;
  savings_plan?: AmountWithPercentageResponse;
  reservation?: AmountWithPercentageResponse;
};
export type CoverageBreakdown = {
  savings_plan?: AmountWithPercentageResponse;
  reservation?: AmountWithPercentageResponse;
  on_demand?: AmountWithPercentageResponse;
  total?: AmountWithPercentageResponse;
};
export type CommitmentCoverageData = {
  account: {
    id?: string;
    provider_account_id?: string;
    name?: string | null;
    is_management_account?: boolean | null;
  } | null;
  covered_usage: number;
  uncovered_usage: number;
  coverage: number;
  total_coverage?: number;
  net_savings: number;
  commitment: {
    provider_id: string;
    id: string;
    type: CommitmentType;
  } | null;
  resource_type: {
    resource_type: CommitmentResourceType;
    region: string | null;
    instance_family: string | null;
  } | null;
};
export type NormalizedWidgetAggregatedCost = {
  value: string;
  cost: number;
  trend?: number;
};
export type IpAddresses = {
  type: string;
  ip: string;
};
export type CommandLogSource = {
  source: string | null;
  name: string | null;
};
export type DismissPeriod =
  | "for_seven_days"
  | "for_one_month"
  | "for_three_months"
  | "forever";
export type RestoreRecommendationRequest = {
  account_ids: string[];
  recommendation_ids: string[];
};
export type RestoreRecommendationByResourceRequest = {
  account_ids: string[];
  resource_identifiers: string[];
};
export type TagKey = {
  key: string;
  is_active: boolean;
};
export type DailySchedule = {
  time: string;
  interval: number;
  frequency: "daily";
};
export type WeeklySchedule = {
  time: string;
  interval: number;
  frequency: "weekly";
  week_days: (
    | "monday"
    | "tuesday"
    | "wednesday"
    | "thursday"
    | "friday"
    | "saturday"
    | "sunday"
  )[];
};
export type MonthlyByDaySchedule = {
  time: string;
  interval: number;
  frequency: "monthly_by_day";
  day_of_month: number;
};
export type MonthlyByWeekdaySchedule = {
  time: string;
  interval: number;
  frequency: "monthly_by_weekday";
  week_day:
    | "monday"
    | "tuesday"
    | "wednesday"
    | "thursday"
    | "friday"
    | "saturday"
    | "sunday";
  number_of_week: number;
};
export type Report = {
  id?: string;
  name?: string;
  source_id?: string;
  source_type?: "view" | "dashboard";
  export_file_types?: ("pdf" | "csv")[];
  time_zone?: string;
  schedule?:
    | DailySchedule
    | WeeklySchedule
    | MonthlyByDaySchedule
    | MonthlyByWeekdaySchedule;
  status?: "active" | "paused";
  notifications?: Notifications;
  last_execution_date?: NullableDate;
  next_execution_date?: NullableDate;
  emails?: Emails;
  created_by?: EmbeddedUser;
  modified_by?: NullableEmbeddedUser;
  created_at?: Date;
  modified_at?: NullableDate;
};
export const {
  useGetUsersMeQuery,
  usePatchUsersMeMutation,
  usePutUsersMeMutation,
  useDeleteUsersMeMutation,
  usePatchUsersMeCelebrationPreferenceMutation,
  usePostUsersMeOrganisationsCurrentAccountsByAccountIdRecommendationsStatusMutation,
  useGetUsersMeOrganisationsCurrentRecommendationsStatusQuery,
  usePostUsersMeOrganisationsCurrentUsersMutation,
  usePostUsersMeInvitationRequestsMutation,
  useGetUsersMeOrganisationsCurrentInvitationRequestsQuery,
  useDeleteUsersMeOrganisationsCurrentInvitationRequestsByUserIdMutation,
  usePostUsersMeOrganisationsCurrentUsersByUserIdReInvitationsMutation,
  useGetUsersMeOrganisationsCurrentUsersByUserIdQuery,
  usePatchUsersMeOrganisationsCurrentUsersByUserIdMutation,
  useDeleteUsersMeOrganisationsCurrentUsersByUserIdMutation,
  useGetUsersMeOrganisationsCurrentTasksPropertiesQuery,
  usePutUsersMeOrganisationsCurrentTasksPropertiesStatusesMutation,
  usePutUsersMeOrganisationsCurrentTasksPropertiesPrioritiesMutation,
  usePutUsersMeOrganisationsCurrentTasksPropertiesEnvironmentsMutation,
  usePutUsersMeOrganisationsCurrentTasksPropertiesOwnersMutation,
  usePutUsersMeOrganisationsCurrentTasksPropertiesActionsMutation,
  usePostUsersMeOrganisationsCurrentTasksMutation,
  useGetUsersMeOrganisationsCurrentTasksQuery,
  usePatchUsersMeOrganisationsCurrentTasksMutation,
  usePutUsersMeOrganisationsCurrentTasksMutation,
  useGetUsersMeOrganisationsCurrentTasksByTaskIdActivitiesQuery,
  usePostUsersMeOrganisationsCurrentTasksByTaskIdCommentsMutation,
  usePatchUsersMeOrganisationsCurrentTasksByTaskIdCommentsAndCommentIdMutation,
  useDeleteUsersMeOrganisationsCurrentTasksByTaskIdCommentsAndCommentIdMutation,
  usePostUsersMeAccountAttemptsMutation,
  useGetUsersMeAccountAttemptsByAccountAttemptIdQuery,
  usePatchProvidersAwsAccountAttemptsByAccountAttemptIdMutation,
  usePostProvidersAwsCfnTemplatesMutation,
  usePatchUsersMeProvidersAzureAccountAttemptsByAccountAttemptIdMutation,
  useGetUsersMeAccountsQuery,
  useGetUsersMeAccountsByAccountIdQuery,
  usePatchUsersMeAccountsByAccountIdMutation,
  useDeleteUsersMeAccountsByAccountIdMutation,
  usePatchUsersMeProvidersByProviderAccountsAndAccountIdAccessModeMutation,
  usePostUsersMeAccountsByAccountIdFiltersMutation,
  usePostUsersMeAccountsByAccountIdFiltersV2Mutation,
  useGetUsersMeAccountsByAccountIdFiltersCurrentQuery,
  useGetUsersMeAccountsByAccountIdFiltersCurrentV2Query,
  useGetUsersMeAccountsByAccountIdCostsQuery,
  useGetUsersMeOrganisationsCurrentProvidersByProviderBillingStatusQuery,
  useGetV2UsersMeOrganisationsCurrentProvidersByProviderBillingStatusQuery,
  useGetUsersMeOrganisationsCurrentProvidersByProviderBillingCurrentQuery,
  useGetUsersMeOrganisationsCurrentResourcesDailyOffHoursRecommendationsQuery,
  useGetUsersMeOrganisationsCurrentResourcesWeeklyOffHoursRecommendationsQuery,
  usePostV3UsersMeExecutionLogsMutation,
  usePostUsersMeExecutionLogsDetailsMutation,
  useGetUsersMeExecutionLogsMinimumAvailableDateQuery,
  useGetV3UsersMeExecutionLogsByExecutionIdQuery,
  usePostUsersMeOrganisationsCurrentByTypeResourcesTagKeysMutation,
  useGetUsersMeOrganisationsCurrentByTypeResourcesPlatformsQuery,
  useGetUsersMeOrganisationsCurrentByTypeResourcesTypesQuery,
  useGetResourceTypesByTypeAndFilterKeyTypeQuery,
  usePostUsersMeOrganisationsCurrentByTypeResourcesTagValuesMutation,
  useGetUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResourcesQuery,
  usePostUsersMeV2OrganisationsCurrentByTypeResourcesMutation,
  useGetUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeProviderUniqueIdentifierMetricsQuery,
  usePostUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeMetricsMutation,
  useGetUsersMeOrganisationsCurrentKubernetesByResourceTypeFiltersAndFilterTypeValuesQuery,
  usePostUsersMeOrganisationsCurrentKubernetesByTypeResourcesMutation,
  useGetUsersMeOrganisationsCurrentKubernetesClustersQuery,
  useGetUsersMeOrganisationsCurrentKubernetesByTypeAndResourceIdMetricsQuery,
  useGetUsersMeDynamoDbBackupTypesQuery,
  usePostUsersMeDynamoDbBackupTableNamesMutation,
  useGetUsersMeByTypeStorageTiersQuery,
  usePutUsersMeAccountsByAccountIdResourcesMutation,
  usePatchUsersMeAccountsByAccountIdResourcesMutation,
  useGetProvidersByProviderRegionsQuery,
  useGetProvidersByProviderFiltersQuery,
  useGetV2PlansQuery,
  usePostUsersMeOrganisationsCurrentGcpBillingExportDataMutation,
  useGetUsersMeOrganisationsCurrentGcpBillingExportDataQuery,
  useGetUsersMeSubscriptionsCurrentQuery,
  usePostUsersMeSchedulesMutation,
  useGetUsersMeSchedulesQuery,
  useGetUsersMeSchedulesByScheduleIdQuery,
  usePatchUsersMeSchedulesByScheduleIdMutation,
  useGetUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdQuery,
  useGetUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdResourcesQuery,
  usePostUsersMeOrganisationsCurrentByProviderAndValidationFilterTypeValidValuesMutation,
  usePostUsersMeOrganisationsCurrentBillingPortalMutation,
  usePostUsersMeOrganisationsCurrentBillingPortalPlansByPlanIdMutation,
  useGetUsersMeOrganisationsCurrentQuery,
  usePatchUsersMeOrganisationsCurrentMutation,
  usePostUsersMeOffHoursSchedulesMutation,
  useGetUsersMeOffHoursSchedulesQuery,
  useGetUsersMeOffHoursSchedulesByScheduleIdQuery,
  usePatchUsersMeOffHoursSchedulesByScheduleIdMutation,
  useGetUsersMeFeaturesQuery,
  usePostUsersMeFeaturesMutation,
  useGetUsersMeProvidersAwsAccountsByAccountIdMissingPermissionsQuery,
  useGetUsersMeProvidersGcpAccountsByAccountIdMissingRolesQuery,
  useGetUsersMeProvidersGcpAccountsByAccountIdMissingRolesOptionsQuery,
  useGetUsersMeProvidersGcpAccountsByAccountIdMissingApisQuery,
  useGetUsersMeProvidersAzureAccountsByAccountIdMissingRolesQuery,
  useGetUsersMeProvidersAzureAccountsByAccountIdMissingRolesOptionsQuery,
  usePatchUsersMeAccountsByAccountIdPermissionsMutation,
  useGetUsersMeIntegrationsQuery,
  useGetUsersMeProviderConnectionsSnowflakeQuery,
  usePostUsersMeProviderConnectionsSnowflakeMutation,
  useDeleteUsersMeIntegrationsByIntegrationIdMutation,
  usePostUsersMeByTypeIntegrationsMutation,
  useGetUsersMeByTypeIntegrationsAndIntegrationIdQuery,
  usePutUsersMeByTypeIntegrationsAndIntegrationIdMutation,
  useGetUsersMeProviderConnectionsSnowflakeByIdQuery,
  useDeleteUsersMeProviderConnectionsSnowflakeByIdMutation,
  usePostUsersMeSlackIntegrationsByIntegrationIdTestMessagesMutation,
  usePostUsersMeProvidersAwsAccountsByAccountIdCfnChangeSetsMutation,
  usePostUsersMeProvidersAwsAccountsByAccountIdCfnChangeAccessModeChangeSetsMutation,
  useGetUsersMeOrganisationsCurrentProvidersByProviderTotalSavedAmountQuery,
  useGetUsersMeOrganisationsCurrentSsoOptionsCurrentQuery,
  usePostUsersMeOrganisationsCurrentSsoMutation,
  useDeleteUsersMeOrganisationsCurrentSsoCurrentMutation,
  usePostUsersMeOrganisationsCurrentRolesMutation,
  useGetUsersMeOrganisationsCurrentRolesQuery,
  usePatchUsersMeOrganisationsCurrentRolesByRoleIdMutation,
  useGetUsersMeOrganisationsCurrentRolesByRoleIdQuery,
  useDeleteUsersMeOrganisationsCurrentRolesByRoleIdMutation,
  usePatchUsersMeOrganisationsCurrentAssignmentsByAssignmentIdMutation,
  useGetPermissionsQuery,
  useGetUsersMeOrganisationsCurrentSettingsQuery,
  useGetUsersMeOrganisationsCurrentSettingsByKeyQuery,
  usePatchUsersMeOrganisationsCurrentSettingsByKeyMutation,
  usePostUsersMeOrganisationsCurrentSavingsPlansRecommendationsSummaryMutation,
  usePostAiSavingsOpportunitiesMutation,
  useGetOrganisationsCurrentSavingsOpportunitiesQuery,
  usePostOrganisationsCurrentSavingsOpportunitiesMutation,
  useGetUsersMeOrganisationsCurrentSavingsPlansPotentialSavingsQuery,
  useGetV2UsersMeOrganisationsCurrentSavingsPlansPotentialSavingsQuery,
  useGetUsersMeOrganisationsCurrentReservationsPotentialSavingsQuery,
  useGetUsersMeOrganisationsCurrentCommitmentsPotentialSavingsQuery,
  useGetUsersMeOrganisationsCurrentSavingsPlansUtilizationRecommendationsQuery,
  useGetUsersMeOrganisationsCurrentSavingsPlansRecommendationsQuery,
  useGetUsersMeOrganisationsCurrentReservationsUtilizationRecommendationsQuery,
  useGetUsersMeOrganisationsCurrentReservationsRecommendationsQuery,
  useGetUsersMeOrganisationsCurrentSavingsPlansQuery,
  useGetUsersMeOrganisationsCurrentReservationsQuery,
  useGetUsersMeOrganisationsCurrentAzureReservationsQuery,
  useGetUsersMeOrganisationsCurrentAzureSavingsPlansQuery,
  useGetUsersMeOrganisationsCurrentCommitmentsQuery,
  useGetUsersMeOrganisationsCurrentSavingsPlansMinimumAvailableDateQuery,
  useGetUsersMeOrganisationsCurrentReservationsDataQuery,
  useGetUsersMeOrganisationsCurrentAzureReservationsDataQuery,
  useGetUsersMeOrganisationsCurrentAzureSavingsPlansDataQuery,
  useGetUsersMeOrganisationsCurrentSavingsPlansDataQuery,
  usePostUsersMeSchedulesNextRunDateMutation,
  usePostUsersMeOffHoursSchedulesNextRunDateMutation,
  useGetUsersMeAccountsByAccountIdAndTypeResourcesMetadataQuery,
  useGetUsersMeAccountsByAccountIdMetadataQuery,
  useGetUsersMeOrganisationsCurrentApiKeysQuery,
  usePostUsersMeOrganisationsCurrentApiKeysMutation,
  useDeleteUsersMeOrganisationsCurrentApiKeysByKeyIdMutation,
  useGetUsersMeAccountByAccountIdDailyOffHoursRecommendationsAndRecommendationIdQuery,
  useGetUsersMeAccountByAccountIdWeeklyOffHoursRecommendationsAndRecommendationIdQuery,
  usePatchUsersMeAccountByAccountIdRecommendationsResourcesAndResourceIdMutation,
  useGetUsersMeOrganisationsCurrentDimensionsQuery,
  usePostUsersMeOrganisationsCurrentDimensionsMutation,
  useGetUsersMeOrganisationsCurrentDimensionsByDimensionIdQuery,
  usePutUsersMeOrganisationsCurrentDimensionsByDimensionIdMutation,
  useDeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdMutation,
  useGetUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesQuery,
  usePostUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesMutation,
  useGetUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdQuery,
  usePutUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdMutation,
  useDeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdCategoriesAndCategoryIdMutation,
  useGetUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsQuery,
  usePostUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsMutation,
  useGetUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdQuery,
  usePutUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdMutation,
  useDeleteUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostIdMutation,
  usePostUsersMeWebhookIntegrationsTestsMutation,
  useGetV2UsersMeOrganisationsCurrentUsersQuery,
  useGetUsersMeOrganisationsCurrentChartQuery,
  usePostUsersMeOrganisationsCurrentChartMutation,
  useGetUsersMeOrganisationsCurrentChartByChartIdQuery,
  usePatchUsersMeOrganisationsCurrentChartByChartIdMutation,
  useDeleteUsersMeOrganisationsCurrentChartByChartIdMutation,
  usePostUsersMeAccountsByTypeResourcesMutation,
  useGetUsersMeProvidersByProviderAccountsResourcesVisibilitiesQuery,
  useGetUsersMeOrganisationsCurrentResourcesRightSizingRecommendationsQuery,
  useGetUsersMeAccountsByAccountIdRightSizingRecommendationsAndRecommendationIdQuery,
  useGetUsersMeOrganisationsCurrentFilterSetsQuery,
  usePostUsersMeOrganisationsCurrentFilterSetsV2Mutation,
  useGetUsersMeOrganisationsCurrentCostAllocationTagsQuery,
  useGetUsersMeOrganisationsCurrentResourceExplorerProvidersByProviderTagValuesQuery,
  usePostUsersMeOrganisationsCurrentTrackedResourcesMutation,
  useGetV2UsersMeOrganisationsCurrentResourceExplorerHierarchyQuery,
  useGetUsersMeOrganisationsCurrentResourceExplorerViewsQuery,
  usePostV2UsersMeOrganisationsCurrentResourceExplorerViewsMutation,
  usePostV3UsersMeOrganisationsCurrentResourceExplorerFoldersMutation,
  useGetUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResourceExplorerResourcesQuery,
  useDeleteUsersMeOrganisationsCurrentFilterSetsByFilterSetIdMutation,
  usePostUsersMeOrganisationsCurrentWidgetsResourceExplorerMutation,
  useGetUsersMeOrganisationsCurrentBillingTotalCostQuery,
  usePostUsersMeOrganisationsCurrentResourceExplorerMutation,
  useGetUsersMeOrganisationsCurrentWidgetsByWidgetIdSummaryQuery,
  usePostUsersMeOrganisationsCurrentResourceExplorerSummaryMutation,
  usePostUsersMeOrganisationsCurrentResourceExplorerAnomaliesSummaryMutation,
  useGetUsersMeOrganisationsCurrentResourceExplorerAnomalyByAnomalyIdQuery,
  usePostUsersMeOrganisationsCurrentResourceExplorerGranularCostsMutation,
  usePostUsersMeOrganisationsCurrentWidgetsResourceExplorerLiveUsageTotalCostMutation,
  useGetUsersMeOrganisationsCurrentResourceExplorerPossibleFiltersQuery,
  useGetUsersMeOrganisationsCurrentResourceExplorerPossibleGroupingsQuery,
  useGetUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValuesQuery,
  usePostUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsvMutation,
  useGetUsersMeOrganisationsCurrentWidgetsResourceExplorerDownloadCsvQuery,
  usePostUsersMeOrganisationsCurrentResourceExplorerGranularCostsDownloadCsvMutation,
  useGetUsersMeOrganisationsCurrentResourceCreatorsQuery,
  usePostUsersMeJiraIntegrationsTestsMutation,
  usePostUsersMeJiraIntegrationsAutoCompleteUsersDataMutation,
  usePostUsersMeJiraIntegrationsByIntegrationIdIssuesMutation,
  usePostUsersMeJiraIntegrationsProjectsMutation,
  usePostUsersMeJiraIntegrationsProjectsByProjectIdIssueTypesMutation,
  usePostUsersMeJiraIntegrationsProjectsByProjectIdIssueTypesAndIssueTypeFieldsMutation,
  usePostUsersMeJiraIntegrationsByIntegrationIdProjectsMutation,
  usePostUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypesMutation,
  usePostUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypesIssueTypeFieldsMutation,
  useGetUsersMeProvidersAzureResourcesTypesByResourceTypeResourceGroupsQuery,
  usePostUsersMeJiraIntegrationsByIntegrationIdAutoCompleteUsersDataMutation,
  usePostUsersMeSlackIntegrationsByIntegrationIdMessageMutation,
  useGetUsersMeSlackIntegrationsByIntegrationIdConversationsQuery,
  usePostUsersMeSlackInstallationAttemptsMutation,
  usePostUsersMeEmailsMessageMutation,
  usePostV2UsersMeEmailsMessageMutation,
  useGetUsersMeProviderConnectionsSnowflakeQueryQuery,
  usePostOrganisationsCurrentAccountsResourceTypesStatusesMutation,
  useGetUsersMeAccountsResourceTypesByResourceTypeInstanceTypesQuery,
  useGetUsersMeAccountsResourceTypesByResourceTypeSupportTypesQuery,
  useGetUsersMeAccountsResourceTypesByResourceTypeInstanceFamiliesQuery,
  useGetUsersMeCurrentPreferencesQuery,
  usePatchUsersMeCurrentPreferenceByKeyMutation,
  useGetUsersMeCurrentPreferenceByKeyQuery,
  useGetUsersMeCurrentDigestPreferencesQuery,
  usePatchUsersMeCurrentDigestPreferencesMutation,
  useDeleteUsersMeOrganisationsCurrentBudgetsByBudgetIdMutation,
  usePatchUsersMeOrganisationsCurrentBudgetsByBudgetIdMutation,
  useGetUsersMeOrganisationsCurrentBudgetsByBudgetIdQuery,
  useGetUsersMeOrganisationsCurrentBudgetsQuery,
  usePostUsersMeOrganisationsCurrentBudgetsMutation,
  useGetUsersMeOrganisationsCurrentViewsByViewIdBudgetsQuery,
  usePostUsersMeOrganisationsCurrentViewsByViewIdBudgetsMutation,
  useGetUsersMeOrganisationsCurrentAlertsCostAnomalyQuery,
  usePostUsersMeOrganisationsCurrentAlertsCostAnomalyMutation,
  useDeleteUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdMutation,
  usePatchUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdMutation,
  useGetUsersMeOrganisationsCurrentAlertsCostAnomalyByAlertIdQuery,
  useGetUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageQuery,
  usePostUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageMutation,
  useDeleteUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdMutation,
  usePatchUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdMutation,
  useGetUsersMeOrganisationsCurrentAlertsUtilizationAndCoverageByAlertIdQuery,
  useGetUsersMeOrganisationsCurrentProviderOrganisationsQuery,
  useGetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdQuery,
  usePostUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdMutation,
  usePatchUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdMutation,
  useGetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdAverageQuery,
  useDeleteV2UsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdMutation,
  usePatchV2UsersMeOrganisationsCurrentResourceExplorerFoldersByResourceExplorerFolderIdMutation,
  useDeleteV2UsersMeOrganisationsCurrentResourceExplorerFoldersByResourceExplorerFolderIdMutation,
  usePostUsersMeOrganisationsCurrentTaskViewsMutation,
  useGetUsersMeOrganisationsCurrentTaskViewsByViewIdQuery,
  usePatchUsersMeOrganisationsCurrentTaskViewsByViewIdMutation,
  useDeleteUsersMeOrganisationsCurrentTaskViewsByViewIdMutation,
  usePostUsersMeOrganisationsCurrentOpportunityViewsMutation,
  useGetUsersMeOrganisationsCurrentOpportunityViewsByViewIdQuery,
  usePatchUsersMeOrganisationsCurrentOpportunityViewsByViewIdMutation,
  useDeleteUsersMeOrganisationsCurrentOpportunityViewsByViewIdMutation,
  usePatchUsersMeOrganisationsCurrentFilterSetsByFilterSetIdV2Mutation,
  useGetUsersMeOrganisationsCurrentDashboardsPossibleWidgetsQuery,
  useGetUsersMeOrganisationsCurrentDashboardsQuery,
  usePostV2UsersMeOrganisationsCurrentDashboardsMutation,
  usePostV2UsersMeOrganisationsCurrentDashboardFoldersMutation,
  usePatchUsersMeOrganisationsCurrentDashboardFoldersByFolderIdMutation,
  useDeleteUsersMeOrganisationsCurrentDashboardFoldersByFolderIdMutation,
  useDeleteV2UsersMeOrganisationsCurrentDashboardsFoldersByFolderIdMutation,
  usePatchUsersMeOrganisationsCurrentDashboardsByDashboardIdMutation,
  usePutUsersMeOrganisationsCurrentDashboardsByDashboardIdMutation,
  useGetUsersMeOrganisationsCurrentDashboardsByDashboardIdQuery,
  useDeleteV2UsersMeOrganisationsCurrentDashboardsByDashboardIdMutation,
  usePostUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsMutation,
  usePatchUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdMutation,
  useDeleteUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdMutation,
  usePutUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgetsAndWidgetIdMutation,
  usePatchUsersMeOrganisationsCurrentDashboardHierarchyMutation,
  usePatchV2UsersMeOrganisationsCurrentDashboardHierarchyMutation,
  useGetUsersMeOrganisationsCurrentTaskViewsHierarchyQuery,
  usePatchUsersMeOrganisationsCurrentTaskViewsHierarchyMutation,
  useGetUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchyQuery,
  usePatchUsersMeOrganisationsCurrentSavingsOpportunitiesHierarchyMutation,
  useGetV2UsersMeOrganisationsCurrentDashboardsHierarchyQuery,
  usePostUsersMeOrganisationsCurrentWidgetsSavingsOpportunitiesMutation,
  useGetUsersMeOrganisationsCurrentWidgetsSavingsOpportunitiesByWidgetIdQuery,
  useGetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationQuery,
  useGetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationByWidgetIdQuery,
  useGetUsersMeOrganisationsCurrentWidgetsCoverageQuery,
  usePostUsersMeOrganisationsCurrentCoverageMutation,
  useGetUsersMeOrganisationsCurrentWidgetsCoverageByWidgetIdQuery,
  useGetUsersMeOrganisationsCurrentWidgetsNormalizedCostQuery,
  useGetUsersMeOrganisationsCurrentWidgetsNormalizedCostByWidgetIdQuery,
  useGetUsersMeOrganisationsCurrentWidgetsCostBreakdownQuery,
  useGetUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetIdQuery,
  useGetUsersMeOrganisationsCurrentWidgetsTextByWidgetIdQuery,
  useGetUsersMeOrganisationsCurrentWidgetsLargestCostChangesQuery,
  useGetUsersMeOrganisationsCurrentWidgetsLargestCostChangesByWidgetIdQuery,
  useGetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryQuery,
  useGetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryByWidgetIdQuery,
  useGetUsersMeRdsStorageTypesQuery,
  usePostUsersMeRdsSnapshotSourceNamesMutation,
  useGetUsersMeRdsSnapshotTypesQuery,
  useGetUsersMeEbsSnapshotStatusesQuery,
  usePostUsersMeEbsSnapshotVolumeIdsMutation,
  useGetUsersMeDynamoDbBackupSourceClassesQuery,
  useGetUsersMeDynamoDbTableStatusesQuery,
  useGetUsersMeDynamoDbTableCapacityModesQuery,
  useGetUsersMeNatGatewayIpAddressesQuery,
  useGetUsersMeNatGatewayVpcQuery,
  useGetUsersMeEcsWorkloadCapacityProvidersQuery,
  useGetUsersMeOrganisationsCurrentResourceExplorerViewsByViewIdWidgetQuery,
  useGetUsersMeExecutionLogsSourcesQuery,
  usePostUsersMeOrganisationsCurrentMinimumAvailableDateMutation,
  usePatchUsersMeRightSizingRecommendationsMutation,
  usePatchUsersMeDailyOffHoursRecommendationsMutation,
  usePatchUsersMeWeeklyOffHoursRecommendationsMutation,
  usePatchUsersMeResourcesRightSizingRecommendationsMutation,
  usePatchUsersMeResourcesDailyOffHoursRecommendationsMutation,
  usePatchUsersMeResourcesWeeklyOffHoursRecommendationsMutation,
  useGetUsersMeOrganisationsCurrentDismissedResourcesQuery,
  usePatchUsersMeOrganisationsCurrentRecommendationsDailyOffHoursMutation,
  usePatchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHoursMutation,
  usePatchUsersMeOrganisationsCurrentRecommendationsDailyOffHoursByResourceMutation,
  usePatchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHoursByResourceMutation,
  usePatchUsersMeOrganisationsCurrentRecommendationsRightSizingMutation,
  usePatchUsersMeOrganisationsCurrentRecommendationsRightSizingByResourceMutation,
  useGetUsersMeOrganisationsCurrentProvidersByProviderTagKeysQuery,
  usePatchUsersMeOrganisationsCurrentProvidersByProviderTagKeysMutation,
} = injectedRtkApi;
